var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const customEvents = {
  cartDrawer: {
    upsell: {
      dropdownChanged: "upsell:variantChange"
    }
  }
};
function hideHeader() {
  if (!!document.querySelectorAll(".page-section")) {
    let pageSections = document.querySelectorAll(".page-section");
    pageSections.forEach((page) => {
      if (!!page.getAttribute("data-hide-header")) {
        let shouldShow = page.getAttribute("data-hide-header");
        console.log(shouldShow);
        if (shouldShow === false || shouldShow === "false") {
          if (!!document.querySelector("store-header")) {
            let headerElement = document.querySelector("store-header");
            headerElement.style.display = "none";
          }
        }
      }
    });
  }
}
function changeIconWidth() {
  if (!!document.querySelectorAll(".text_content--usp")) {
    let calculateWidth = 0;
    let contentUsp = document.querySelectorAll(".text_content--usp");
    if (contentUsp.length == 3) {
      contentUsp.forEach((e) => {
        e.classList.add("text_content--full");
      });
      calculateWidth = 100 / contentUsp.length;
    } else if (contentUsp.length > 3) {
      calculateWidth = 50;
    } else {
      calculateWidth = 100 / contentUsp.length;
    }
    contentUsp.forEach((icon) => {
      icon.style.width = calculateWidth + "%";
    });
  }
}
document.addEventListener("DOMContentLoaded", function(e) {
  hideHeader();
  changeIconWidth();
});
function removeTextReview() {
  document.querySelectorAll(".product-item").forEach(function(el) {
    setTimeout(function() {
      if (!!el && !!el.querySelector(".ruk-rating-snippet-count")) {
        let reviewsCount = el.querySelector(".ruk-rating-snippet-count");
        const matchNumber = reviewsCount.innerHTML.match(/\d+/);
        if (matchNumber) {
          if (el.classList.contains("ds-product-item")) {
            reviewsCount.innerHTML = `${matchNumber[0]}`;
          } else {
            reviewsCount.innerHTML = `(${matchNumber[0]})`;
          }
        } else {
          if (!!matchNumber.input) {
            reviewsCount.innerHTML = matchNumber.input;
          }
        }
      }
    }, 3e3);
  });
}
function setReviewsCounter() {
  setTimeout(function() {
    document.querySelectorAll(".ds-product-item .ruk_rating_snippet").forEach(function(el) {
      const existingSpan = el.nextElementSibling;
      if (existingSpan && existingSpan.classList.contains("ruk-rating-snippet-reviewscouk")) {
        existingSpan.remove();
      }
      let count = el.getAttribute("data-reviewscouk");
      if (!count || count.trim() === "") {
        const ratingCountEl = el.querySelector(".ruk-rating-snippet-count");
        if (ratingCountEl) {
          const matchNumber = ratingCountEl.innerHTML.match(/\d+/);
          if (matchNumber) {
            count = matchNumber[0];
          }
        }
      }
      if (count) {
        let span = document.createElement("span");
        span.className = "ruk-rating-snippet-reviewscouk";
        span.textContent = count;
        el.insertAdjacentElement("afterend", span);
      }
    });
  }, 1e3);
}
function initRatingSnippet() {
  const config = window.ratingSnippetConfig || {
    store: "holy",
    mode: "default",
    color: "#0E1311",
    linebreak: false,
    usePolaris: true,
    showEmptyStars: false
  };
  if (typeof window.ratingSnippet === "function") {
    try {
      window.ratingSnippet("ruk_rating_snippet", config);
    } catch (e) {
      console.error("Error reinitializing ratingSnippet:", e);
    }
  } else {
    if (typeof window.loadScriptOnce === "function") {
      window.loadScriptOnce("https://widget.reviews.io/rating-snippet/dist.js", function() {
        if (typeof window.ratingSnippet === "function") {
          window.ratingSnippet("ruk_rating_snippet", config);
        }
      });
    }
  }
}
function initReviews() {
  setReviewsCounter();
  removeTextReview();
  initRatingSnippet();
}
window.addEventListener("DOMContentLoaded", function(e) {
  initReviews();
});
document.addEventListener("pagination:page-changed", function() {
  setTimeout(function() {
    initReviews();
  }, 1500);
});
async function init() {
  var _a;
  const discountCode = (_a = window == null ? void 0 : window.theme) == null ? void 0 : _a.discountApplication;
  const isCookieSet = getCookie("discount_code");
  if (!discountCode || isCookieSet) return;
  setCookie("discount_code", discountCode, 14);
  setDiscountSession(discountCode);
  window.location.reload();
  return;
}
function setDiscountSession(value) {
  sessionStorage.setItem("discount", value ? value : "FALSE");
}
function setCookie(key, value, daysToExpire = 1) {
  const expirationDate = /* @__PURE__ */ new Date();
  expirationDate.setTime(expirationDate.getTime() + daysToExpire * 24 * 60 * 60 * 1e3);
  const expires = "expires=" + expirationDate.toUTCString();
  document.cookie = key + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
}
function getCookie(key) {
  const name = key + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    const cookie = cookieArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return "";
}
init();
const selectors$8 = {
  itemImages: ".product-item__image-wrapper",
  collectionLinks: ".featured-collections .link-to-collection__featured-collection",
  buttonTabs: ".shopify-section--featured-collections .tabs-nav__item"
};
const buttonTabs = document.querySelectorAll(selectors$8.buttonTabs);
const linksToCollection = document.querySelectorAll(selectors$8.collectionLinks);
function setHeightToLinks() {
  linksToCollection.forEach((link) => {
    const neighboringElement = link.parentNode.childNodes[1].querySelector(selectors$8.itemImages);
    if (neighboringElement) {
      const neighboringElementHeight = neighboringElement.clientHeight;
      link.style.height = `${neighboringElementHeight}px`;
    }
  });
}
if (linksToCollection && buttonTabs) {
  document.addEventListener("DOMContentLoaded", setHeightToLinks);
  window.addEventListener("resize", setHeightToLinks);
  buttonTabs.forEach((button) => {
    button.addEventListener("click", () => {
      setTimeout(() => {
        setHeightToLinks();
      }, 1500);
    });
  });
}
function revealSubCategory(currIdentifier, currIndex) {
  setTimeout(() => {
    if (!!document.querySelectorAll(".category-image")) {
      document.querySelectorAll(".category-image").forEach((img) => {
        img.removeAttribute("reveal");
      });
    }
  }, 500);
  if (!!document.querySelector(".product_categories-content.is-selected")) {
    let selectedIndex = null;
    let selectedCategory = null;
    if (!!currIdentifier) {
      selectedCategory = currIdentifier;
    } else {
      selectedCategory = document.querySelector(".product_categories-content.is-selected").getAttribute("data-selected-category");
    }
    if (!!currIndex) {
      selectedIndex = currIndex;
    } else {
      selectedIndex = document.querySelector(".product_categories-content.is-selected").getAttribute("data-selected-index");
    }
    if (!!document.querySelectorAll(".product-subcategories__wrapper")) {
      let allSubcategories = document.querySelectorAll(".product-subcategories__wrapper");
      allSubcategories.forEach((subcategorie) => {
        if (!!selectedCategory) {
          if (!!subcategorie.getAttribute("data-subcategory-index") && !!subcategorie.getAttribute("data-selected-category")) {
            let subcategorieSelected = subcategorie.getAttribute("data-selected-category");
            let indexSelected = subcategorie.getAttribute("data-subcategory-index");
            if (selectedCategory === subcategorieSelected && selectedIndex == indexSelected) {
              subcategorie.classList.remove("hidden");
            } else {
              subcategorie.classList.add("hidden");
            }
          }
        }
      });
    }
    if (!!document.querySelectorAll(".product_categories-text")) {
      let allCategoriesContent = document.querySelectorAll(".product_categories-text");
      allCategoriesContent.forEach((content) => {
        if (!!selectedCategory) {
          if (!!content.getAttribute("data-selected-category") && !!content.getAttribute("data-selected-index")) {
            let categorieSelected = content.getAttribute("data-selected-category");
            let categorieIndexSelected = content.getAttribute("data-selected-index");
            if (selectedCategory === categorieSelected && selectedIndex == categorieIndexSelected) {
              content.classList.remove("hidden");
            } else {
              content.classList.add("hidden");
            }
          }
        }
      });
    }
    selectedIndex = null;
    selectedCategory = null;
  }
}
document.addEventListener("DOMContentLoaded", function(e) {
  function categoryChange() {
    if (!!document.querySelectorAll(".product-subcategories__wrapper")) {
      let subcategoriesWrapper = document.querySelectorAll(".product-subcategories__wrapper");
      handleElementsLoop(true, subcategoriesWrapper, ".category-buttons-name");
    }
    if (document.querySelectorAll(".category-main-buttons-name")) {
      let categoryMainButtons = document.querySelectorAll(".category-main-buttons-name");
      handleElementsLoop(false, categoryMainButtons);
    }
  }
  function handleElementsLoop(isSub, targetElements, targetClass) {
    if (!!targetElements) {
      targetElements.forEach((targetElement, index) => {
        if (isSub) {
          if (!!targetElement.querySelectorAll(targetClass)) {
            targetElement.querySelectorAll(targetClass).forEach((target) => {
              target.addEventListener("click", function(element) {
                handleElementClick(element, targetElement, index, true);
              });
            });
          }
        } else {
          targetElement.addEventListener("click", function(element) {
            handleElementClick(element, targetElements, index, false);
          });
        }
      });
    }
  }
  let clickedElements = [];
  function handleElementClick(element, category, index, isSub) {
    let currIdentifier = null;
    let prevIdentifier = null;
    let currentTarget = null;
    let previouslyClickedElement = null;
    let currentClickedElement = element.target;
    if (isSub) {
      previouslyClickedElement = currentClickedElement.previousElementSibling ? currentClickedElement.previousElementSibling : currentClickedElement.nextElementSibling;
      if (!!previouslyClickedElement) {
        previouslyClickedElement.classList.remove("is--selected");
        if (!!previouslyClickedElement.getAttribute("data-identifier-button")) {
          prevIdentifier = previouslyClickedElement.getAttribute("data-identifier-button");
        }
      }
      if (!!currentClickedElement) {
        currentClickedElement.classList.add("is--selected");
        if (!!currentClickedElement.getAttribute("data-identifier-button")) {
          currIdentifier = currentClickedElement.getAttribute("data-identifier-button");
        }
      }
      if (!!category && !!prevIdentifier) {
        let prevSubcategoryContent = category.querySelector(`[data-identifier="${prevIdentifier}"]`);
        if (!!prevSubcategoryContent) {
          prevSubcategoryContent.style.opacity = 0;
          prevSubcategoryContent.classList.add("hidden");
        }
      }
      if (!!category && !!currIdentifier) {
        let subcategoryContent = category.querySelector(`[data-identifier="${currIdentifier}"]`);
        if (!!subcategoryContent) {
          subcategoryContent.classList.remove("hidden");
          setTimeout(function() {
            subcategoryContent.style.opacity = 1;
          }, 100);
        }
      }
    } else {
      currentTarget = element.target;
      currentClickedElement = currentTarget;
      let currentIndex = 0;
      if (!!currentClickedElement) {
        currentClickedElement.classList.add("is--selected");
        if (!!currentClickedElement.getAttribute("data-category-name")) {
          currIdentifier = currentClickedElement.getAttribute("data-category-name");
        }
      }
      clickedElements.push(currentClickedElement);
      if (clickedElements.length > 1) {
        previouslyClickedElement = clickedElements[clickedElements.length - 2];
      } else {
        previouslyClickedElement = category[0];
      }
      if (!!previouslyClickedElement) {
        previouslyClickedElement.classList.remove("is--selected");
        if (!!previouslyClickedElement.getAttribute("data-category-name")) {
          prevIdentifier = previouslyClickedElement.getAttribute("data-category-name");
        }
      }
      if (!!prevIdentifier) {
        let prevMainCategoryContent = document.querySelector(`[data-main-category="${prevIdentifier}"]`);
        if (!!prevMainCategoryContent) {
          prevMainCategoryContent.style.opacity = 0;
          setTimeout(function() {
            prevMainCategoryContent.classList.add("hidden");
          }, 100);
        }
      }
      if (!!currIdentifier) {
        let mainCategoryContent = document.querySelector(`[data-main-category="${currIdentifier}"]`);
        if (!!mainCategoryContent) {
          mainCategoryContent.classList.remove("hidden");
          setTimeout(function() {
            mainCategoryContent.style.opacity = 1;
          }, 100);
        }
        if (document.querySelectorAll(".category-main--text").length > 0) {
          document.querySelectorAll(".category-main--text").forEach((el) => {
            el.classList.add("hidden");
            el.classList.remove("category-main-text--selected");
          });
        }
        const textInCurrent = document.querySelector(`.category-main--text[data-selected-category="${currIdentifier}"]`);
        if (textInCurrent) {
          textInCurrent.classList.remove("hidden");
          textInCurrent.classList.add("category-main-text--selected");
        }
      }
      revealSubCategory(currIdentifier, currentIndex);
    }
    currentClickedElement = null;
  }
  categoryChange();
  revealSubCategory();
});
function variantChangePortions(id, available) {
  if (available === false) {
    if (!!document.querySelector(".product-get-it-text")) {
      document.querySelector(".product-get-it-text").style.display = "none";
    }
  } else {
    if (!!document.querySelector(".product-get-it-text")) {
      document.querySelector(".product-get-it-text").style.display = "block";
    }
  }
  if (!!document.querySelector(`.price_label--serving--${id}`)) {
    let dataPortions = document.querySelector(`.price_label--serving--${id}`).getAttribute("data-portions");
    let dataPortionsPrice = document.querySelector(`.price_label--serving--${id}`).getAttribute("data-price-per-serving");
    if (!!document.querySelector(".price_label--serving--portions") && !!dataPortions) {
      document.querySelector(".price_label--serving--portions").innerHTML = dataPortions;
    }
    if (!!document.querySelector(".price_label--serving-price-portions") && !!dataPortionsPrice) {
      document.querySelector(".price_label--serving-price-portions").innerHTML = dataPortionsPrice;
    }
  }
  if (!!document.querySelector(`.portions-price-inline--variant-${id}`)) {
    let variantData = document.querySelector(`.portions-price-inline--variant-${id}`);
    let dataPortionsLabel = variantData.getAttribute("data-portions-label");
    let dataPricePerServing = variantData.getAttribute("data-price-per-serving");
    let dataOnly = variantData.getAttribute("data-only");
    let dataPerServing = variantData.getAttribute("data-per-serving");
    let portionsElements = document.querySelectorAll(".portions-price-inline__portions");
    let priceElements = document.querySelectorAll(".portions-price-inline__price");
    if (portionsElements.length > 0 && dataPortionsLabel) {
      portionsElements.forEach((el) => {
        el.setAttribute("data-portions-label", dataPortionsLabel);
        el.textContent = dataPortionsLabel;
      });
    }
    if (priceElements.length > 0 && dataPricePerServing) {
      let onlyText = dataOnly || "ONLY";
      let perServingText = dataPerServing || "PER SERVING";
      priceElements.forEach((el) => {
        el.setAttribute("data-only", onlyText);
        el.setAttribute("data-price-per-serving", dataPricePerServing);
        el.setAttribute("data-per-serving", perServingText);
        el.textContent = `${onlyText} ${dataPricePerServing} ${perServingText}`;
      });
    }
  }
}
window.addEventListener("flickity:slide-settled", function(e) {
  if (!!e.target) {
    const computedStyle = window.getComputedStyle(e.target);
    if (computedStyle.opacity != "0") {
      if (!!e.target.getAttribute("data-main-category") && e.target.querySelector(".is-selected")) {
        let mainCategory = e.target.getAttribute("data-main-category");
        let selectedIndex = e.target.querySelector(".is-selected").getAttribute("data-selected-index");
        revealSubCategory(mainCategory, selectedIndex);
      }
    }
  }
});
function changeVariantId(variantId) {
  if (!!document.querySelectorAll(".upsell-main-product")) {
    let upsellMainProduct = document.querySelectorAll(".upsell-main-product");
    upsellMainProduct.forEach((upsell) => {
      upsell.value = variantId;
    });
  }
}
document.addEventListener("variant:changed", function(e) {
  if (!!e.detail) {
    changeVariantId(e.detail.variant.id);
    variantChangePortions(e.detail.variant.id, e.detail.variant.available);
  }
});
document.addEventListener("DOMContentLoaded", function(e) {
  const zoomModal = document.getElementById("zoomModal");
  const modalImg = document.getElementById("zoomImage");
  let subCategorieImage = document.querySelectorAll(".product-subcategories-image__wrapper");
  if (!!subCategorieImage) {
    subCategorieImage.forEach((el) => {
      let imgs = el.querySelectorAll(".product-subcategories-image--zoom");
      imgs.forEach((img) => {
        img.addEventListener("click", function(e2) {
          if (!!zoomModal) {
            zoomModal.style.display = "flex";
          }
          if (!!modalImg) {
            if (!!e2.target.src) {
              modalImg.src = e2.target.src;
            }
            if (!!e2.target.getAttribute("data-src")) {
              modalImg.src = e2.target.getAttribute("data-src");
            }
          }
        });
      });
      if (!!zoomModal) {
        zoomModal.addEventListener("click", function(e2) {
          if (!!modalImg) {
            modalImg.className += " out";
            setTimeout(function() {
              zoomModal.style.display = "none";
              modalImg.className = "modal-content";
            }, 400);
          }
        });
      }
    });
  }
});
window.addEventListener("load", function(e) {
  if (!!document.querySelector(".block-swatch--slider")) {
    setTimeout(() => {
      document.querySelector(".block-swatch--slider").style.opacity = "1";
    }, 500);
  }
});
if (document.getElementById("productCategoriesBtn")) {
  const spoilerBtn = document.getElementById("productCategoriesBtn");
  const categoriesSection = document.querySelector(".shopify-section--product-categories");
  spoilerBtn.addEventListener("click", () => {
    categoriesSection.classList.toggle("reveal-active");
  });
}
const showButton = (el) => {
  if (!el) return;
  setTimeout(() => {
    el.style.display = "block";
    el.classList.remove("hidden");
  }, 150);
};
const hideButton = (el) => {
  if (!el) return;
  el.classList.add("hidden");
  setTimeout(() => {
    el.style.display = "none";
  }, 150);
};
const getHiddenBisVariantIds = () => {
  const ids = /* @__PURE__ */ new Set();
  document.querySelectorAll("[data-hidden-klaviyo]").forEach((input) => {
    if (!input.value) return;
    input.value.split(",").map((v) => v.trim()).filter(Boolean).forEach((id) => ids.add(id));
  });
  return ids;
};
const updateKlaviyoBisText = () => {
  const bisTriggerBtn = document.querySelector(".klaviyo-bis-trigger");
  const bisText = document.querySelector(".pdp-block__klaviyo-bis-text");
  if (!bisText) return;
  if (bisTriggerBtn) {
    const isButtonVisible = !bisTriggerBtn.classList.contains("hidden") && window.getComputedStyle(bisTriggerBtn).display !== "none";
    if (isButtonVisible) {
      bisText.style.display = "block";
      requestAnimationFrame(() => {
        bisText.classList.remove("is-hidden");
        bisText.classList.add("is-visible");
      });
    } else {
      bisText.classList.remove("is-visible");
      bisText.classList.add("is-hidden");
      setTimeout(() => {
        if (bisText.classList.contains("is-hidden")) {
          bisText.style.display = "none";
        }
      }, 300);
    }
  } else {
    bisText.classList.remove("is-visible");
    bisText.classList.add("is-hidden");
    setTimeout(() => {
      bisText.style.display = "none";
    }, 300);
  }
};
const updateButtonsForVariant = (variantId, isAvailable, hiddenIds) => {
  const idStr = String(variantId);
  const isInHiddenList = hiddenIds.has(idStr);
  const bisTriggerBtn = document.querySelector(".klaviyo-bis-trigger");
  const productFormAddButton = document.querySelector(".product-main--button");
  if (isAvailable) {
    showButton(productFormAddButton);
    hideButton(bisTriggerBtn);
  } else {
    if (isInHiddenList) {
      showButton(productFormAddButton);
      hideButton(bisTriggerBtn);
    } else {
      showButton(bisTriggerBtn);
      hideButton(productFormAddButton);
    }
  }
  setTimeout(() => {
    updateKlaviyoBisText();
  }, 200);
};
document.addEventListener("DOMContentLoaded", () => {
  const hiddenIds = getHiddenBisVariantIds();
  setTimeout(() => {
    updateKlaviyoBisText();
  }, 300);
  const currentInput = document.querySelector("[data-hidden-klaviyo][data-current-variant]");
  if (!currentInput) return;
  const currentVariantId = currentInput.dataset.currentVariant;
  const currentVariantAvailable = String(currentInput.dataset.currentVariantAvailable) === "true";
  updateButtonsForVariant(currentVariantId, currentVariantAvailable, hiddenIds);
});
document.addEventListener("variant:changed", function(e) {
  var _a;
  const variant = (_a = e.detail) == null ? void 0 : _a.variant;
  if (!variant) return;
  const hiddenIds = getHiddenBisVariantIds();
  const variantId = variant.id;
  const isAvailable = !!variant.available;
  updateButtonsForVariant(variantId, isAvailable, hiddenIds);
});
const selectors$7 = {
  headings: ".product-info__tab-heading",
  bodies: ".product-info__tab-body"
};
const tabHeadings = document.querySelectorAll(selectors$7.headings);
const tabBodies = document.querySelectorAll(selectors$7.bodies);
function tabResize() {
  if (tabBodies.lenght === 0) return;
  const currentTab = document.querySelector('.product-info__tab-body[data-tab-hidden="false"]');
  const contentHeight = document.querySelector('.product-info__tab-body[data-tab-hidden="false"] > :first-child');
  if (contentHeight && currentTab) {
    const currentTabHeight = contentHeight.scrollHeight;
    setTimeout(() => {
      currentTab.style.height = currentTabHeight + "px";
    }, 0);
  }
}
function tabHandler() {
  if (!tabHeadings || !tabBodies) return;
  tabHeadings.forEach(function(tabHeading) {
    tabBodies.forEach((tabBody) => {
      if (tabBody.dataset.tabHidden === "false") {
        tabBody.style.height = tabBody.clientHeight + "px";
      }
    });
    tabHeading.addEventListener("click", function() {
      const tabNumber = this.getAttribute("data-tab");
      tabHeadings.forEach((heading) => {
        heading.dataset.selected = "false";
      });
      this.dataset.selected = "true";
      tabBodies.forEach(function(tabBody) {
        tabBody.dataset.tabHidden = "true";
      });
      const currentTab = document.querySelector('.product-info__tab-body[data-tab="' + tabNumber + '"]');
      currentTab.parentNode.style.backgroundColor = currentTab.dataset.background;
      currentTab.dataset.tabHidden = "false";
      const currentTabHeight = currentTab.scrollHeight;
      setTimeout(() => {
        currentTab.style.height = currentTabHeight + "px";
      }, 0);
    });
  });
}
tabHandler();
window.addEventListener("resize", tabResize);
const CartSync = (() => {
  const taskQueue = [];
  let queueBusy = false;
  let resolveWhenStable, stableTimer;
  const STABLE_MS = 300;
  function flagCartChanged() {
    if (stableTimer) clearTimeout(stableTimer);
    stableTimer = setTimeout(() => {
      resolveWhenStable == null ? void 0 : resolveWhenStable();
      resolveWhenStable = null;
      stableTimer = null;
    }, STABLE_MS);
  }
  document.addEventListener("cart:updated", flagCartChanged, { passive: true });
  document.addEventListener("cart:refresh", flagCartChanged, { passive: true });
  document.addEventListener("variant:added", flagCartChanged, { passive: true });
  async function waitForStableCart() {
    if (resolveWhenStable) {
      return new Promise((res) => {
        const prev = resolveWhenStable;
        resolveWhenStable = () => {
          prev == null ? void 0 : prev();
          res();
        };
      });
    }
    return new Promise((res) => {
      resolveWhenStable = res;
      flagCartChanged();
    });
  }
  async function runQueued(task) {
    return new Promise((resolve2, reject) => {
      taskQueue.push({ task, resolve: resolve2, reject });
      pumpQueue();
    });
  }
  async function pumpQueue() {
    if (queueBusy) return;
    const next = taskQueue.shift();
    if (!next) return;
    queueBusy = true;
    try {
      const result = await next.task();
      next.resolve(result);
    } catch (e) {
      next.reject(e);
    } finally {
      queueBusy = false;
      if (taskQueue.length) pumpQueue();
    }
  }
  async function withCartLock(task) {
    var _a;
    if ((_a = navigator.locks) == null ? void 0 : _a.request) {
      return navigator.locks.request("cart-lock", task);
    }
    return runQueued(task);
  }
  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return res.json();
  }
  return { withCartLock, waitForStableCart, fetchCart };
})();
let upsellPipelineBusy = false;
async function addToCartOnce(items, idempotencyKey = null) {
  setButtonLoading(true);
  return CartSync.withCartLock(async () => {
    var _a, _b;
    const cart = await CartSync.fetchCart();
    if (idempotencyKey) {
      const alreadyTagged = cart.items.some(
        (it) => it.properties && it.properties._auto_key === idempotencyKey
      );
      if (alreadyTagged) return null;
    }
    const idsInCart = new Set(cart.items.map((it) => Number(it.id)));
    const allPresent = items.every((i) => idsInCart.has(Number(i.id)));
    if (allPresent) return null;
    const payload = {
      items: items.map((i) => ({
        ...i,
        properties: {
          ...i.properties || {},
          ...idempotencyKey ? { _auto_key: idempotencyKey } : {}
        }
      }))
    };
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      credentials: "same-origin"
    });
    const json = await res.json();
    (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.classList.remove("popup-opened");
    document.documentElement.dispatchEvent(
      new CustomEvent("variant:added", {
        bubbles: true,
        detail: { variant: ((_b = json == null ? void 0 : json.items) == null ? void 0 : _b[0]) || json }
      })
    );
    const freshCart = await CartSync.fetchCart();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", { bubbles: true, detail: { cart: freshCart } })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true, detail: { cart: freshCart } })
    );
    const dismissed = new Set(JSON.parse(sessionStorage.getItem("dismissedUpsellProducts")) || []);
    freshCart.items.forEach((item) => {
      var _a2;
      if ((_a2 = item.properties) == null ? void 0 : _a2._aov_product) dismissed.add(Number(item.id));
    });
    sessionStorage.setItem("dismissedUpsellProducts", JSON.stringify([...dismissed]));
    setButtonLoading(false);
    return json;
  });
}
async function runUpsellPipeline() {
  if (upsellPipelineBusy) return;
  upsellPipelineBusy = true;
  try {
    await CartSync.waitForStableCart();
    const cart = await CartSync.fetchCart();
    const nonGiftTotalCents = (cart.items || []).filter((i) => {
      var _a;
      return !i.gift_card && !(((_a = i.product) == null ? void 0 : _a.tags) || []).includes("__gift_card");
    }).reduce((sum, i) => sum + (i.final_line_price || 0), 0);
    const cartTotal = nonGiftTotalCents / 100;
    const variantIdsInCart = new Set(cart.items.map((i) => Number(i.id)));
    const nodes = Array.from(document.querySelectorAll(".productUpsell"));
    if (nodes.length === 0) return;
    let tiers = nodes.map((wrapper) => {
      const threshold = parseFloat(wrapper.getAttribute("data-threshold")) || 0;
      const isPopup = wrapper.getAttribute("data-is-popup") === "true";
      const isAuto = wrapper.getAttribute("data-auto-product") === "true";
      const productIDs = (wrapper.getAttribute("data-products") || "").split(",").filter(Boolean);
      const variantIDs = (wrapper.getAttribute("data-variants") || "").split(",").filter(Boolean);
      const concreteIds = [
        ...productIDs.map(Number).filter(Boolean),
        ...variantIDs.map(Number).filter(Boolean)
      ];
      return {
        wrapper,
        threshold,
        isPopup,
        isAuto,
        productIDs,
        variantIDs,
        concreteIds
      };
    });
    tiers.sort((a, b) => a.threshold - b.threshold);
    const dismissed = new Set(JSON.parse(sessionStorage.getItem("dismissedUpsellProducts")) || []);
    const wasDismissed = (tier) => tier.concreteIds.some((id) => dismissed.has(Number(id)));
    for (const tier of tiers) {
      if (tier.threshold <= 0) continue;
      if (cartTotal < tier.threshold) continue;
      if (wasDismissed(tier)) continue;
      const alreadyInCart = tier.concreteIds.some((id) => variantIdsInCart.has(Number(id)));
      if (alreadyInCart) continue;
      if (tier.isPopup) {
        renderUpsellPopup(tier);
        break;
      } else if (tier.isAuto) {
        const targetId = (tier.variantIDs[0] || tier.productIDs[0] || "").trim();
        if (!targetId) continue;
        const oneItem = [
          {
            id: targetId,
            quantity: 1,
            properties: {
              _aov_product: true,
              _aov_product_threshold: tier.threshold
            }
          }
        ];
        await addToCartOnce(oneItem, `auto:${targetId}:${tier.threshold}`);
        await CartSync.waitForStableCart();
        const cart2 = await CartSync.fetchCart();
        cart2.items.forEach((i) => variantIdsInCart.add(Number(i.id)));
      }
    }
  } catch (err) {
    console.error("runUpsellPipeline error:", err);
  } finally {
    upsellPipelineBusy = false;
  }
}
function setButtonLoading(loading) {
  let btns = document.querySelectorAll(".free_btn");
  if (!btns.length) return;
  btns.forEach((btn) => {
    btn.toggleAttribute("disabled", loading);
    btn.setAttribute("aria-busy", loading ? "true" : "false");
    const text = btn.querySelector(".loader-button__text");
    const spinner = btn.querySelector(".loader-button__loader");
    if (text) text.hidden = loading;
    if (spinner) spinner.hidden = !loading;
  });
}
const autoAddOnVariantSelect = /* @__PURE__ */ (() => {
  let t = null;
  return ({ id, threshold }) => {
    clearTimeout(t);
    t = setTimeout(async () => {
      var _a;
      const drawer = document.querySelector(".popover--quick-buy--upsell");
      const addBtn = drawer == null ? void 0 : drawer.querySelector(".add-free-product");
      if (!drawer || drawer.classList.contains("hidden")) return;
      if (!addBtn) return;
      if (addBtn.dataset.busy === "true") return;
      if (!id || !threshold) return;
      addBtn.dataset.busy = "true";
      try {
        const items = [
          {
            id,
            quantity: 1,
            properties: { _aov_product: true, _aov_product_threshold: threshold }
          }
        ];
        await addToCartOnce(items, `popup:${id}:${threshold}`);
        await CartSync.waitForStableCart();
        (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.classList.remove("popup-opened");
        drawer.classList.add("hidden");
        runUpsellPipeline();
      } catch (e) {
        console.error("autoAddOnVariantSelect error:", e);
      } finally {
        addBtn.dataset.busy = "false";
      }
    }, 200);
  };
})();
function renderUpsellPopup(tier) {
  var _a, _b, _c, _d;
  const drawer = document.querySelector(".popover--quick-buy--upsell");
  if (!drawer) return;
  drawer.innerHTML = "";
  const { wrapper, threshold } = tier;
  const variantOptions = wrapper.querySelectorAll("select option");
  const productTitle = ((_a = wrapper.querySelector(".free-product_title")) == null ? void 0 : _a.getAttribute("data-title")) || "";
  const el = document.createElement("div");
  el.classList.add("upsell-product");
  el.innerHTML = `
    <div class="free_info">
      <div class="free-popup-close free-popup-close-header" data-selected="${((_b = variantOptions[0]) == null ? void 0 : _b.value) || ""}">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
          <g id="close"><path id="Vector" d="M15.2649 5.73532L5.73547 15.2647M5.73547 5.73532L15.2649 15.2647" stroke="black" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/></g>
        </svg>
      </div>
      <div class="free-info--header">${window.theme.giftsHeading}</div>
      <div class="img_wrap">
        ${variantOptions.length > 0 ? [...variantOptions].map(
    (opt) => `
            <div class="upsell-variant-images" main-product="${opt.getAttribute("main-product")}" data-variant-id="${opt.value}" style="display:none;">
              <img loading="lazy" width="200" height="200" src="${opt.getAttribute("variant-image")}"/>
            </div>`
  ).join("") : ""}
      </div>
      <div class="item_right">
        <div class="title_wrap">
          <h4 class="product_title">${productTitle}</h4>
        </div>
        <div class="button_wrap">
          ${variantOptions.length > 0 ? `
            <select class="free-product__upsell-select" onchange="document.dispatchEvent(new CustomEvent('upsell:variantChange', {detail: {target: event.target}}))">
              ${[...variantOptions].map(
    (opt) => `<option value="${opt.value}" main-product="${opt.getAttribute("main-product")}" ${opt.disabled ? "disabled" : ""}>${opt.textContent}</option>`
  ).join("")}
            </select>` : ""}
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><g id="dropdown"><path id="Vector" d="M6 9L12 15L18 9" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg>
          <button type="button"  class="add-free-product free_btn button button--secondary" is="loader-button" data-selected="${((_c = variantOptions[0]) == null ? void 0 : _c.value) || ""}" data-selected-threshold="${threshold}" >
            <span class="loader-button__text">${window.theme.addToCart}</span>

            <span class="loader-button__loader" hidden>
              <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                  <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
              </div>
            </span>
          </button>
          <span class="button-separator">${window.theme.chooseOr}</span>
          <button type="button" class="free-popup-close button-continue--shopping button" data-selected="${((_d = variantOptions[0]) == null ? void 0 : _d.value) || ""}">${window.theme.continueShopping}</button>
        </div>
      </div>
    </div>
  `;
  drawer.appendChild(el);
  const first = variantOptions[0];
  if (first) {
    const imgs = drawer.querySelectorAll(".upsell-variant-images");
    imgs.forEach((img) => {
      img.style.display = Number(img.getAttribute("data-variant-id")) === Number(first.value) ? "block" : "none";
    });
  }
  setTimeout(() => {
    var _a2;
    drawer.classList.remove("hidden");
    (_a2 = document.querySelector("cart-drawer")) == null ? void 0 : _a2.classList.remove("popup-opened");
  }, 100);
  setTimeout(() => {
    var _a2;
    (_a2 = document.querySelector("cart-drawer")) == null ? void 0 : _a2.classList.add("popup-opened");
  }, 180);
  wireUpsellPopup(drawer);
}
function wireUpsellPopup(drawer) {
  const addBtn = drawer.querySelector(".add-free-product");
  if (addBtn) {
    addBtn.addEventListener("click", async (ev) => {
      var _a;
      const btn = ev.target.closest(".add-free-product");
      if (!btn || btn.dataset.busy === "true") return;
      const id = btn.getAttribute("data-selected");
      const th = btn.getAttribute("data-selected-threshold");
      if (!id || !th) return;
      btn.dataset.busy = "true";
      try {
        const items = [{ id, quantity: 1, properties: { _aov_product: true, _aov_product_threshold: th } }];
        await addToCartOnce(items, `popup:${id}:${th}`);
        await CartSync.waitForStableCart();
        (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.classList.remove("popup-opened");
        drawer.classList.add("hidden");
        runUpsellPipeline();
      } finally {
        btn.dataset.busy = "false";
      }
    });
  }
  const closeBtns = drawer.querySelectorAll(".free-popup-close");
  if (closeBtns.length) {
    closeBtns.forEach((button) => {
      button.addEventListener("click", (e) => {
        var _a;
        const btn = e.target.closest(".free-popup-close");
        const selected = btn == null ? void 0 : btn.getAttribute("data-selected");
        if (selected) {
          const dismissed = new Set(JSON.parse(sessionStorage.getItem("dismissedUpsellProducts")) || []);
          dismissed.add(Number(selected));
          sessionStorage.setItem("dismissedUpsellProducts", JSON.stringify([...dismissed]));
        }
        (_a = document.querySelector("cart-drawer")) == null ? void 0 : _a.classList.remove("popup-opened");
        if (drawer) drawer.classList.add("hidden");
      });
    });
  }
}
document.addEventListener("upsell:variantChange", (event) => {
  const sel = event.detail.target.options[event.detail.target.selectedIndex];
  if (sel == null ? void 0 : sel.value) {
    if (event.detail.target.nextElementSibling) {
      event.detail.target.nextElementSibling.value = sel.value;
      event.detail.target.nextElementSibling.id = `variant_${sel.id}`;
    }
    const imgs = document.querySelectorAll(".upsell-variant-images");
    if (imgs.length) {
      imgs.forEach((img) => {
        if (Number(img.getAttribute("main-product")) === Number(sel.getAttribute("main-product"))) {
          img.style.display = "none";
          if (Number(img.getAttribute("data-variant-id")) === Number(sel.value)) {
            img.style.display = "block";
          }
        }
      });
    }
  }
  const addBtn = document.querySelector(".add-free-product");
  if (addBtn) addBtn.setAttribute("data-selected", (sel == null ? void 0 : sel.value) || "");
  if ((sel == null ? void 0 : sel.value) && addBtn) {
    const threshold = addBtn.getAttribute("data-selected-threshold");
    autoAddOnVariantSelect({ id: sel.value, threshold });
  }
});
const scheduleUpsellCheck = /* @__PURE__ */ (() => {
  let t;
  return () => {
    clearTimeout(t);
    t = setTimeout(() => runUpsellPipeline(), 50);
  };
})();
document.addEventListener("cart:refresh", async () => {
  await CartSync.waitForStableCart();
  scheduleUpsellCheck();
});
document.addEventListener("openable-element:open", async (e) => {
  var _a;
  if (((_a = e.target) == null ? void 0 : _a.id) === "mini-cart") {
    await CartSync.waitForStableCart();
    scheduleUpsellCheck();
  }
});
document.addEventListener("DOMContentLoaded", async function() {
  var _a;
  try {
    const cart = await (await fetch("/cart.js")).json();
    if (((_a = cart.items) == null ? void 0 : _a.length) > 0) {
      const dismissed = new Set(JSON.parse(sessionStorage.getItem("dismissedUpsellProducts")) || []);
      cart.items.forEach((item) => {
        if (item.properties && item.properties["_aov_product"]) {
          dismissed.add(Number(item.id));
        }
      });
      sessionStorage.setItem("dismissedUpsellProducts", JSON.stringify([...dismissed]));
    }
  } catch (e) {
    console.error("Error fetching cart on load:", e);
  }
});
const selectors$6 = {
  carouselContainer: ".product-carousel__redesign--body",
  carouselProducts: ".product-carousel__redesign--product",
  featuredProducts: ".product.product-carousel-redesign__product",
  prevButton: '.product-carousel__redesign--button[data-action="prev"]',
  nextButton: '.product-carousel__redesign--button[data-action="next"]'
};
const carouselProducts$1 = document.querySelectorAll(selectors$6.carouselProducts);
const featuredProducts$1 = document.querySelectorAll(selectors$6.featuredProducts);
const prevButton$1 = document.querySelector(selectors$6.prevButton);
const nextButton$1 = document.querySelector(selectors$6.nextButton);
let carouselContainer$1 = document.querySelector(selectors$6.carouselContainer);
let isScrollCarouselEnabled$1 = null;
function goToNextProduct$1() {
  let currentIndex = Array.from(carouselProducts$1).findIndex((prod) => prod.getAttribute("data-selected") === "true");
  let nextIndex = (currentIndex + 1) % carouselProducts$1.length;
  updateSelection$1(nextIndex);
}
function goToPrevProduct$1() {
  let currentIndex = Array.from(carouselProducts$1).findIndex((prod) => prod.getAttribute("data-selected") === "true");
  let prevIndex = (currentIndex - 1 + carouselProducts$1.length) % carouselProducts$1.length;
  updateSelection$1(prevIndex);
}
function updateSelection$1(newIndex) {
  carouselProducts$1.forEach((prod, index) => {
    prod.setAttribute("data-selected", "false");
    featuredProducts$1[index].setAttribute("data-selected", "false");
  });
  carouselProducts$1[newIndex].setAttribute("data-selected", "true");
  featuredProducts$1[newIndex].setAttribute("data-selected", "true");
  const container = carouselProducts$1[newIndex].parentElement;
  const containerWidth = container.offsetWidth;
  const itemLeft = carouselProducts$1[newIndex].offsetLeft;
  const itemRight = itemLeft + carouselProducts$1[newIndex].offsetWidth;
  if (itemLeft < container.scrollLeft) {
    container.scrollLeft = itemLeft - 40;
  } else if (itemRight > container.scrollLeft + containerWidth) {
    container.scrollLeft = itemRight - containerWidth + 40;
  }
  window.dispatchEvent(new Event("resize", { bubbles: true }));
}
function isScrollEnabled$1(container) {
  if (container) {
    return container.scrollWidth > container.clientWidth;
  }
}
if (carouselContainer$1) {
  isScrollCarouselEnabled$1 = isScrollEnabled$1(carouselContainer$1);
  carouselContainer$1 == null ? void 0 : carouselContainer$1.setAttribute("data-scroll", isScrollCarouselEnabled$1);
}
window.addEventListener("resize", () => {
  carouselContainer$1 = document.querySelector(selectors$6.carouselContainer);
  if (carouselContainer$1) {
    isScrollCarouselEnabled$1 = isScrollEnabled$1(carouselContainer$1);
    carouselContainer$1 == null ? void 0 : carouselContainer$1.setAttribute("data-scroll", isScrollCarouselEnabled$1);
  }
});
if (carouselProducts$1 && featuredProducts$1) {
  carouselProducts$1.forEach((product, index) => {
    product.addEventListener("click", () => updateSelection$1(index));
  });
}
if (prevButton$1 && nextButton$1) {
  prevButton$1.addEventListener("click", goToPrevProduct$1);
  nextButton$1.addEventListener("click", goToNextProduct$1);
}
function changeIngredients() {
  let selectedIngredients = null;
  if (!!document.querySelectorAll(".section-ingredients-slider")) {
    document.querySelectorAll(".section-ingredients-slider").forEach((slide2) => {
      if (slide2.classList.contains("is-selected")) {
        selectedIngredients = slide2;
      }
    });
  }
  if (!!selectedIngredients) {
    if (!!selectedIngredients.getAttribute("data-identifier")) {
      let ingredientIdentifier = selectedIngredients.getAttribute("data-identifier");
      if (!!document.querySelectorAll(".ingredients--heading")) {
        let ingredientsHeadings = document.querySelectorAll(".ingredients--heading");
        ingredientsHeadings.forEach((heading) => {
          if (heading.getAttribute("data-identifier") == ingredientIdentifier) {
            heading.classList.remove("hidden");
          } else {
            heading.classList.add("hidden");
          }
        });
      }
      if (!!document.querySelectorAll(".product-ingridients__wrapper")) {
        let ingredientsColaps = document.querySelectorAll(".product-ingridients__wrapper");
        ingredientsColaps.forEach((ingredient) => {
          if (ingredient.getAttribute("data-identifier") == ingredientIdentifier) {
            ingredient.classList.remove("hidden");
          } else {
            ingredient.classList.add("hidden");
          }
        });
      }
    }
  }
}
window.addEventListener("flickity:slide-changed", (e) => {
  setTimeout(() => {
    changeIngredients();
  }, 1500);
});
function changeProgressBar(currentSlide, index) {
  if (!!currentSlide) {
    if (!!currentSlide.querySelector(`.multi-column__item-${currentSlide.getAttribute("section-id")}.is-selected`)) {
      let slideSelected = currentSlide.querySelector(`.multi-column__item-${currentSlide.getAttribute("section-id")}.is-selected`);
      if (!!slideSelected.getAttribute("data-blocks-size")) {
        let blocksSize = slideSelected.getAttribute("data-blocks-size");
        let progress = 100 / Number(blocksSize);
        let currentindex = index + 1;
        if (currentindex === Number(blocksSize)) {
          progress = 100;
        } else {
          progress = progress * currentindex;
        }
        if (!!document.querySelector(`.progress-bar-${currentSlide.getAttribute("section-id")}`)) {
          let progressBar = document.querySelector(`.progress-bar-${currentSlide.getAttribute("section-id")}`);
          progressBar.style.width = progress + "%";
        }
      }
    }
  }
}
window.addEventListener("flickity:slide-changed", function(e) {
  if (!!e.target) {
    changeProgressBar(e.target, e.detail);
  }
});
const productsInCartText = document.getElementById("productsInCart") ? document.getElementById("productsInCart").textContent : null;
let productsInCart, productFromPromo;
let isProductPromoRemoved = false;
if (!!productsInCartText) {
  try {
    productsInCart = JSON.parse(productsInCartText);
    productFromPromo = findPromoProduct(productsInCart.items, "original");
    subscribeToEvent();
  } catch (error) {
    console.error("❌ Error parsing JSON", error);
  }
}
async function subscribeToEvent() {
  document.addEventListener("cart:updated", async (event) => {
    var _a;
    if ((_a = event.detail) == null ? void 0 : _a.updateFromPromo) return;
    productsInCart.items = event.detail.cart.items;
    if (!productFromPromo) {
      productFromPromo = findPromoProduct(productsInCart.items, "event");
    }
    if (!productFromPromo) return;
    if (event.detail.cart.items_removed && event.detail.cart.items_removed.length > 0) {
      isProductPromoRemoved = checkForRemovedProducts(event.detail.cart.items_removed);
    }
    if (isProductPromoRemoved) {
      deleteAllCookiesWithName("cart");
      isProductPromoRemoved = false;
      await addProductsAndAttributes(event.detail.cart);
    }
  });
}
function findPromoProduct(products, typeOfArray) {
  if (typeOfArray === "original") {
    return products.find((product) => {
      return product.properties.some((property) => property[0] === "_addedByCode");
    });
  } else if (typeOfArray === "event") {
    return products.find((product) => {
      return product.properties && product.properties._addedByCode;
    });
  }
  return null;
}
function checkForRemovedProducts(removedItems) {
  return removedItems.some((item) => item.variant_id === productFromPromo.variant_id);
}
function deleteAllCookiesWithName(name) {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const cookieParts = cookie.split("=");
    const cookieName = cookieParts[0].trim();
    if (cookieName === name) {
      document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
  }
}
async function addProductsAndAttributes(cart) {
  const formData = {
    items: cart.items,
    attributes: cart.attributes
  };
  try {
    const result = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    });
    if (result.ok) {
      delete cart.sections;
      document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart,
          updateFromPromo: true
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart
        }
      }));
    }
  } catch (error) {
    console.error("❌ Error updating cart", error);
  }
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var js = { exports: {} };
var core$1 = { exports: {} };
var evEmitter$1 = { exports: {} };
var evEmitter = evEmitter$1.exports;
var hasRequiredEvEmitter;
function requireEvEmitter() {
  if (hasRequiredEvEmitter) return evEmitter$1.exports;
  hasRequiredEvEmitter = 1;
  (function(module) {
    (function(global2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        global2.EvEmitter = factory();
      }
    })(typeof window != "undefined" ? window : evEmitter, function() {
      function EvEmitter() {
      }
      let proto = EvEmitter.prototype;
      proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        let events = this._events = this._events || {};
        let listeners = events[eventName] = events[eventName] || [];
        if (!listeners.includes(listener)) {
          listeners.push(listener);
        }
        return this;
      };
      proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        this.on(eventName, listener);
        let onceEvents = this._onceEvents = this._onceEvents || {};
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        onceListeners[listener] = true;
        return this;
      };
      proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) {
          listeners.splice(index, 1);
        }
        return this;
      };
      proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        listeners = listeners.slice(0);
        args = args || [];
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners) {
          let isOnce = onceListeners && onceListeners[listener];
          if (isOnce) {
            this.off(eventName, listener);
            delete onceListeners[listener];
          }
          listener.apply(this, args);
        }
        return this;
      };
      proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
      };
      return EvEmitter;
    });
  })(evEmitter$1);
  return evEmitter$1.exports;
}
var getSize = { exports: {} };
/*!
 * Infinite Scroll v2.0.4
 * measure size of elements
 * MIT license
 */
var hasRequiredGetSize;
function requireGetSize() {
  if (hasRequiredGetSize) return getSize.exports;
  hasRequiredGetSize = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        window2.getSize = factory();
      }
    })(window, function factory() {
      function getStyleSize(value) {
        let num = parseFloat(value);
        let isValid = value.indexOf("%") == -1 && !isNaN(num);
        return isValid && num;
      }
      let measurements = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth"
      ];
      function getZeroSize() {
        let size = {
          width: 0,
          height: 0,
          innerWidth: 0,
          innerHeight: 0,
          outerWidth: 0,
          outerHeight: 0
        };
        measurements.forEach((measurement) => {
          size[measurement] = 0;
        });
        return size;
      }
      function getSize2(elem) {
        if (typeof elem == "string") elem = document.querySelector(elem);
        let isElement = elem && typeof elem == "object" && elem.nodeType;
        if (!isElement) return;
        let style = getComputedStyle(elem);
        if (style.display == "none") return getZeroSize();
        let size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        let isBorderBox = size.isBorderBox = style.boxSizing == "border-box";
        measurements.forEach((measurement) => {
          let value = style[measurement];
          let num = parseFloat(value);
          size[measurement] = !isNaN(num) ? num : 0;
        });
        let paddingWidth = size.paddingLeft + size.paddingRight;
        let paddingHeight = size.paddingTop + size.paddingBottom;
        let marginWidth = size.marginLeft + size.marginRight;
        let marginHeight = size.marginTop + size.marginBottom;
        let borderWidth = size.borderLeftWidth + size.borderRightWidth;
        let borderHeight = size.borderTopWidth + size.borderBottomWidth;
        let styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) {
          size.width = styleWidth + // add padding and border unless it's already including it
          (isBorderBox ? 0 : paddingWidth + borderWidth);
        }
        let styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) {
          size.height = styleHeight + // add padding and border unless it's already including it
          (isBorderBox ? 0 : paddingHeight + borderHeight);
        }
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
      }
      return getSize2;
    });
  })(getSize);
  return getSize.exports;
}
var utils$1 = { exports: {} };
var utils = utils$1.exports;
var hasRequiredUtils;
function requireUtils() {
  if (hasRequiredUtils) return utils$1.exports;
  hasRequiredUtils = 1;
  (function(module) {
    (function(global2, factory) {
      if (module.exports) {
        module.exports = factory(global2);
      } else {
        global2.fizzyUIUtils = factory(global2);
      }
    })(utils, function factory(global2) {
      let utils2 = {};
      utils2.extend = function(a, b) {
        return Object.assign(a, b);
      };
      utils2.modulo = function(num, div) {
        return (num % div + div) % div;
      };
      utils2.makeArray = function(obj) {
        if (Array.isArray(obj)) return obj;
        if (obj === null || obj === void 0) return [];
        let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike) return [...obj];
        return [obj];
      };
      utils2.removeFrom = function(ary, obj) {
        let index = ary.indexOf(obj);
        if (index != -1) {
          ary.splice(index, 1);
        }
      };
      utils2.getParent = function(elem, selector) {
        while (elem.parentNode && elem != document.body) {
          elem = elem.parentNode;
          if (elem.matches(selector)) return elem;
        }
      };
      utils2.getQueryElement = function(elem) {
        if (typeof elem == "string") {
          return document.querySelector(elem);
        }
        return elem;
      };
      utils2.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) {
          this[method](event);
        }
      };
      utils2.filterFindElements = function(elems, selector) {
        elems = utils2.makeArray(elems);
        return elems.filter((elem) => elem instanceof HTMLElement).reduce((ffElems, elem) => {
          if (!selector) {
            ffElems.push(elem);
            return ffElems;
          }
          if (elem.matches(selector)) {
            ffElems.push(elem);
          }
          let childElems = elem.querySelectorAll(selector);
          ffElems = ffElems.concat(...childElems);
          return ffElems;
        }, []);
      };
      utils2.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        let method = _class.prototype[methodName];
        let timeoutName = methodName + "Timeout";
        _class.prototype[methodName] = function() {
          clearTimeout(this[timeoutName]);
          let args = arguments;
          this[timeoutName] = setTimeout(() => {
            method.apply(this, args);
            delete this[timeoutName];
          }, threshold);
        };
      };
      utils2.docReady = function(onDocReady) {
        let readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") {
          setTimeout(onDocReady);
        } else {
          document.addEventListener("DOMContentLoaded", onDocReady);
        }
      };
      utils2.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
          return $1 + "-" + $2;
        }).toLowerCase();
      };
      let console2 = global2.console;
      utils2.htmlInit = function(WidgetClass, namespace) {
        utils2.docReady(function() {
          let dashedNamespace = utils2.toDashed(namespace);
          let dataAttr = "data-" + dashedNamespace;
          let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
          let jQuery = global2.jQuery;
          [...dataAttrElems].forEach((elem) => {
            let attr = elem.getAttribute(dataAttr);
            let options;
            try {
              options = attr && JSON.parse(attr);
            } catch (error) {
              if (console2) {
                console2.error(`Error parsing ${dataAttr} on ${elem.className}: ${error}`);
              }
              return;
            }
            let instance = new WidgetClass(elem, options);
            if (jQuery) {
              jQuery.data(elem, namespace, instance);
            }
          });
        });
      };
      return utils2;
    });
  })(utils$1);
  return utils$1.exports;
}
var cell$1 = { exports: {} };
var cell = cell$1.exports;
var hasRequiredCell;
function requireCell() {
  if (hasRequiredCell) return cell$1.exports;
  hasRequiredCell = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(requireGetSize());
      } else {
        window2.Flickity = window2.Flickity || {};
        window2.Flickity.Cell = factory(window2.getSize);
      }
    })(typeof window != "undefined" ? window : cell, function factory(getSize2) {
      const cellClassName = "flickity-cell";
      function Cell(elem) {
        this.element = elem;
        this.element.classList.add(cellClassName);
        this.x = 0;
        this.unselect();
      }
      let proto = Cell.prototype;
      proto.destroy = function() {
        this.unselect();
        this.element.classList.remove(cellClassName);
        this.element.style.transform = "";
        this.element.removeAttribute("aria-hidden");
      };
      proto.getSize = function() {
        this.size = getSize2(this.element);
      };
      proto.select = function() {
        this.element.classList.add("is-selected");
        this.element.removeAttribute("aria-hidden");
      };
      proto.unselect = function() {
        this.element.classList.remove("is-selected");
        this.element.setAttribute("aria-hidden", "true");
      };
      proto.remove = function() {
        this.element.remove();
      };
      return Cell;
    });
  })(cell$1);
  return cell$1.exports;
}
var slide$1 = { exports: {} };
var slide = slide$1.exports;
var hasRequiredSlide;
function requireSlide() {
  if (hasRequiredSlide) return slide$1.exports;
  hasRequiredSlide = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory();
      } else {
        window2.Flickity = window2.Flickity || {};
        window2.Flickity.Slide = factory();
      }
    })(typeof window != "undefined" ? window : slide, function factory() {
      function Slide2(beginMargin, endMargin, cellAlign) {
        this.beginMargin = beginMargin;
        this.endMargin = endMargin;
        this.cellAlign = cellAlign;
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
      }
      let proto = Slide2.prototype;
      proto.addCell = function(cell2) {
        this.cells.push(cell2);
        this.outerWidth += cell2.size.outerWidth;
        this.height = Math.max(cell2.size.outerHeight, this.height);
        if (this.cells.length === 1) {
          this.x = cell2.x;
          this.firstMargin = cell2.size[this.beginMargin];
        }
      };
      proto.updateTarget = function() {
        let lastCell = this.getLastCell();
        let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
        let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.cellAlign;
      };
      proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
      };
      proto.select = function() {
        this.cells.forEach((cell2) => cell2.select());
      };
      proto.unselect = function() {
        this.cells.forEach((cell2) => cell2.unselect());
      };
      proto.getCellElements = function() {
        return this.cells.map((cell2) => cell2.element);
      };
      return Slide2;
    });
  })(slide$1);
  return slide$1.exports;
}
var animate$1 = { exports: {} };
var animate = animate$1.exports;
var hasRequiredAnimate;
function requireAnimate() {
  if (hasRequiredAnimate) return animate$1.exports;
  hasRequiredAnimate = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(requireUtils());
      } else {
        window2.Flickity = window2.Flickity || {};
        window2.Flickity.animatePrototype = factory(window2.fizzyUIUtils);
      }
    })(typeof window != "undefined" ? window : animate, function factory(utils2) {
      let proto = {};
      proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
      };
      proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        let previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        if (this.isAnimating) requestAnimationFrame(() => this.animate());
      };
      proto.positionSlider = function() {
        let x = this.x;
        if (this.isWrapping) {
          x = utils2.modulo(x, this.slideableWidth) - this.slideableWidth;
          this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
      };
      proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        if (this.options.rightToLeft) x = -x;
        let translateX = this.getPositionValue(x);
        this.slider.style.transform = is3d ? `translate3d(${translateX},0,0)` : `translateX(${translateX})`;
      };
      proto.dispatchScrollEvent = function() {
        let firstSlide = this.slides[0];
        if (!firstSlide) return;
        let positionX = -this.x - firstSlide.target;
        let progress = positionX / this.slidesWidth;
        this.dispatchEvent("scroll", null, [progress, positionX]);
      };
      proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0;
        this.positionSlider();
      };
      proto.getPositionValue = function(position) {
        if (this.options.percentPosition) {
          return Math.round(position / this.size.innerWidth * 1e4) * 0.01 + "%";
        } else {
          return Math.round(position) + "px";
        }
      };
      proto.settle = function(previousX) {
        let isResting = !this.isPointerDown && Math.round(this.x * 100) === Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        if (this.restingFrames > 2) {
          this.isAnimating = false;
          delete this.isFreeScrolling;
          this.positionSlider();
          this.dispatchEvent("settle", null, [this.selectedIndex]);
        }
      };
      proto.shiftWrapCells = function(x) {
        let beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        let afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
      };
      proto._shiftCells = function(cells, gap, shift) {
        cells.forEach((cell2) => {
          let cellShift = gap > 0 ? shift : 0;
          this._wrapShiftCell(cell2, cellShift);
          gap -= cell2.size.outerWidth;
        });
      };
      proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        cells.forEach((cell2) => this._wrapShiftCell(cell2, 0));
      };
      proto._wrapShiftCell = function(cell2, shift) {
        this._renderCellPosition(cell2, cell2.x + this.slideableWidth * shift);
      };
      proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
      };
      proto.applyForce = function(force) {
        this.velocity += force;
      };
      proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
      };
      proto.getRestingPosition = function() {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
      };
      proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        let dragVelocity = this.dragX - this.x;
        let dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
      };
      proto.applySelectedAttraction = function() {
        let dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        let distance = this.selectedSlide.target * -1 - this.x;
        let force = distance * this.options.selectedAttraction;
        this.applyForce(force);
      };
      return proto;
    });
  })(animate$1);
  return animate$1.exports;
}
var core = core$1.exports;
var hasRequiredCore;
function requireCore() {
  if (hasRequiredCore) return core$1.exports;
  hasRequiredCore = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          window2,
          requireEvEmitter(),
          requireGetSize(),
          requireUtils(),
          requireCell(),
          requireSlide(),
          requireAnimate()
        );
      } else {
        let _Flickity = window2.Flickity;
        window2.Flickity = factory(
          window2,
          window2.EvEmitter,
          window2.getSize,
          window2.fizzyUIUtils,
          _Flickity.Cell,
          _Flickity.Slide,
          _Flickity.animatePrototype
        );
      }
    })(
      typeof window != "undefined" ? window : core,
      function factory(window2, EvEmitter, getSize2, utils2, Cell, Slide2, animatePrototype) {
        const { getComputedStyle: getComputedStyle2, console: console2 } = window2;
        let { jQuery } = window2;
        let GUID = 0;
        let instances = {};
        function Flickity2(element, options) {
          let queryElement = utils2.getQueryElement(element);
          if (!queryElement) {
            if (console2) console2.error(`Bad element for Flickity: ${queryElement || element}`);
            return;
          }
          this.element = queryElement;
          if (this.element.flickityGUID) {
            let instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
          }
          if (jQuery) {
            this.$element = jQuery(this.element);
          }
          this.options = { ...this.constructor.defaults };
          this.option(options);
          this._create();
        }
        Flickity2.defaults = {
          accessibility: true,
          // adaptiveHeight: false,
          cellAlign: "center",
          // cellSelector: undefined,
          // contain: false,
          freeScrollFriction: 0.075,
          // friction when free-scrolling
          friction: 0.28,
          // friction when selecting
          namespaceJQueryEvents: true,
          // initialIndex: 0,
          percentPosition: true,
          resize: true,
          selectedAttraction: 0.025,
          setGallerySize: true
          // watchCSS: false,
          // wrapAround: false
        };
        Flickity2.create = {};
        let proto = Flickity2.prototype;
        Object.assign(proto, EvEmitter.prototype);
        proto._create = function() {
          let { resize, watchCSS, rightToLeft } = this.options;
          let id = this.guid = ++GUID;
          this.element.flickityGUID = id;
          instances[id] = this;
          this.selectedIndex = 0;
          this.restingFrames = 0;
          this.x = 0;
          this.velocity = 0;
          this.beginMargin = rightToLeft ? "marginRight" : "marginLeft";
          this.endMargin = rightToLeft ? "marginLeft" : "marginRight";
          this.viewport = document.createElement("div");
          this.viewport.className = "flickity-viewport";
          this._createSlider();
          this.focusableElems = [this.element];
          if (resize || watchCSS) {
            window2.addEventListener("resize", this);
          }
          for (let eventName in this.options.on) {
            let listener = this.options.on[eventName];
            this.on(eventName, listener);
          }
          for (let method in Flickity2.create) {
            Flickity2.create[method].call(this);
          }
          if (watchCSS) {
            this.watchCSS();
          } else {
            this.activate();
          }
        };
        proto.option = function(opts) {
          Object.assign(this.options, opts);
        };
        proto.activate = function() {
          if (this.isActive) return;
          this.isActive = true;
          this.element.classList.add("flickity-enabled");
          if (this.options.rightToLeft) {
            this.element.classList.add("flickity-rtl");
          }
          this.getSize();
          let cellElems = this._filterFindCellElements(this.element.children);
          this.slider.append(...cellElems);
          this.viewport.append(this.slider);
          this.element.append(this.viewport);
          this.reloadCells();
          if (this.options.accessibility) {
            this.element.tabIndex = 0;
            this.element.addEventListener("keydown", this);
          }
          this.emitEvent("activate");
          this.selectInitialIndex();
          this.isInitActivated = true;
          this.dispatchEvent("ready");
        };
        proto._createSlider = function() {
          let slider = document.createElement("div");
          slider.className = "flickity-slider";
          this.slider = slider;
        };
        proto._filterFindCellElements = function(elems) {
          return utils2.filterFindElements(elems, this.options.cellSelector);
        };
        proto.reloadCells = function() {
          this.cells = this._makeCells(this.slider.children);
          this.positionCells();
          this._updateWrapShiftCells();
          this.setGallerySize();
        };
        proto._makeCells = function(elems) {
          let cellElems = this._filterFindCellElements(elems);
          return cellElems.map((cellElem) => new Cell(cellElem));
        };
        proto.getLastCell = function() {
          return this.cells[this.cells.length - 1];
        };
        proto.getLastSlide = function() {
          return this.slides[this.slides.length - 1];
        };
        proto.positionCells = function() {
          this._sizeCells(this.cells);
          this._positionCells(0);
        };
        proto._positionCells = function(index) {
          index = index || 0;
          this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
          let cellX = 0;
          if (index > 0) {
            let startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
          }
          this.cells.slice(index).forEach((cell2) => {
            cell2.x = cellX;
            this._renderCellPosition(cell2, cellX);
            cellX += cell2.size.outerWidth;
            this.maxCellHeight = Math.max(cell2.size.outerHeight, this.maxCellHeight);
          });
          this.slideableWidth = cellX;
          this.updateSlides();
          this._containSlides();
          this.slidesWidth = this.cells.length ? this.getLastSlide().target - this.slides[0].target : 0;
        };
        proto._renderCellPosition = function(cell2, x) {
          let sideOffset = this.options.rightToLeft ? -1 : 1;
          let renderX = x * sideOffset;
          if (this.options.percentPosition) renderX *= this.size.innerWidth / cell2.size.width;
          let positionValue = this.getPositionValue(renderX);
          cell2.element.style.transform = `translateX( ${positionValue} )`;
        };
        proto._sizeCells = function(cells) {
          cells.forEach((cell2) => cell2.getSize());
        };
        proto.updateSlides = function() {
          this.slides = [];
          if (!this.cells.length) return;
          let { beginMargin, endMargin } = this;
          let slide2 = new Slide2(beginMargin, endMargin, this.cellAlign);
          this.slides.push(slide2);
          let canCellFit = this._getCanCellFit();
          this.cells.forEach((cell2, i) => {
            if (!slide2.cells.length) {
              slide2.addCell(cell2);
              return;
            }
            let slideWidth = slide2.outerWidth - slide2.firstMargin + (cell2.size.outerWidth - cell2.size[endMargin]);
            if (canCellFit(i, slideWidth)) {
              slide2.addCell(cell2);
            } else {
              slide2.updateTarget();
              slide2 = new Slide2(beginMargin, endMargin, this.cellAlign);
              this.slides.push(slide2);
              slide2.addCell(cell2);
            }
          });
          slide2.updateTarget();
          this.updateSelectedSlide();
        };
        proto._getCanCellFit = function() {
          let { groupCells } = this.options;
          if (!groupCells) return () => false;
          if (typeof groupCells == "number") {
            let number = parseInt(groupCells, 10);
            return (i) => i % number !== 0;
          }
          let percent = 1;
          let percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
          if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
          let groupWidth = (this.size.innerWidth + 1) * percent;
          return (i, slideWidth) => slideWidth <= groupWidth;
        };
        proto._init = proto.reposition = function() {
          this.positionCells();
          this.positionSliderAtSelected();
        };
        proto.getSize = function() {
          this.size = getSize2(this.element);
          this.setCellAlign();
          this.cursorPosition = this.size.innerWidth * this.cellAlign;
        };
        let cellAlignShorthands = {
          left: 0,
          center: 0.5,
          right: 1
        };
        proto.setCellAlign = function() {
          let { cellAlign, rightToLeft } = this.options;
          let shorthand = cellAlignShorthands[cellAlign];
          this.cellAlign = shorthand !== void 0 ? shorthand : cellAlign;
          if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
        };
        proto.setGallerySize = function() {
          if (!this.options.setGallerySize) return;
          let height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
          this.viewport.style.height = `${height}px`;
        };
        proto._updateWrapShiftCells = function() {
          this.isWrapping = this.getIsWrapping();
          if (!this.isWrapping) return;
          this._unshiftCells(this.beforeShiftCells);
          this._unshiftCells(this.afterShiftCells);
          let beforeGapX = this.cursorPosition;
          let lastIndex = this.cells.length - 1;
          this.beforeShiftCells = this._getGapCells(beforeGapX, lastIndex, -1);
          let afterGapX = this.size.innerWidth - this.cursorPosition;
          this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
        };
        proto.getIsWrapping = function() {
          let { wrapAround } = this.options;
          if (!wrapAround || this.slides.length < 2) return false;
          if (wrapAround !== "fill") return true;
          let gapWidth = this.slideableWidth - this.size.innerWidth;
          if (gapWidth > this.size.innerWidth) return true;
          for (let cell2 of this.cells) {
            if (cell2.size.outerWidth > gapWidth) return false;
          }
          return true;
        };
        proto._getGapCells = function(gapX, cellIndex, increment) {
          let cells = [];
          while (gapX > 0) {
            let cell2 = this.cells[cellIndex];
            if (!cell2) break;
            cells.push(cell2);
            cellIndex += increment;
            gapX -= cell2.size.outerWidth;
          }
          return cells;
        };
        proto._containSlides = function() {
          let isContaining = this.options.contain && !this.isWrapping && this.cells.length;
          if (!isContaining) return;
          let contentWidth = this.slideableWidth - this.getLastCell().size[this.endMargin];
          let isContentSmaller = contentWidth < this.size.innerWidth;
          if (isContentSmaller) {
            this.slides.forEach((slide2) => {
              slide2.target = contentWidth * this.cellAlign;
            });
          } else {
            let beginBound = this.cursorPosition + this.cells[0].size[this.beginMargin];
            let endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach((slide2) => {
              slide2.target = Math.max(slide2.target, beginBound);
              slide2.target = Math.min(slide2.target, endBound);
            });
          }
        };
        proto.dispatchEvent = function(type, event, args) {
          let emitArgs = event ? [event].concat(args) : args;
          this.emitEvent(type, emitArgs);
          if (jQuery && this.$element) {
            type += this.options.namespaceJQueryEvents ? ".flickity" : "";
            let $event = type;
            if (event) {
              let jQEvent = new jQuery.Event(event);
              jQEvent.type = type;
              $event = jQEvent;
            }
            this.$element.trigger($event, args);
          }
        };
        const unidraggerEvents = [
          "dragStart",
          "dragMove",
          "dragEnd",
          "pointerDown",
          "pointerMove",
          "pointerEnd",
          "staticClick"
        ];
        let _emitEvent = proto.emitEvent;
        proto.emitEvent = function(eventName, args) {
          if (eventName === "staticClick") {
            let clickedCell = this.getParentCell(args[0].target);
            let cellElem = clickedCell && clickedCell.element;
            let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
            args = args.concat(cellElem, cellIndex);
          }
          _emitEvent.call(this, eventName, args);
          let isUnidraggerEvent = unidraggerEvents.includes(eventName);
          if (!isUnidraggerEvent || !jQuery || !this.$element) return;
          eventName += this.options.namespaceJQueryEvents ? ".flickity" : "";
          let event = args.shift(0);
          let jQEvent = new jQuery.Event(event);
          jQEvent.type = eventName;
          this.$element.trigger(jQEvent, args);
        };
        proto.select = function(index, isWrap, isInstant) {
          if (!this.isActive) return;
          index = parseInt(index, 10);
          this._wrapSelect(index);
          if (this.isWrapping || isWrap) {
            index = utils2.modulo(index, this.slides.length);
          }
          if (!this.slides[index]) return;
          let prevIndex = this.selectedIndex;
          this.selectedIndex = index;
          this.updateSelectedSlide();
          if (isInstant) {
            this.positionSliderAtSelected();
          } else {
            this.startAnimation();
          }
          if (this.options.adaptiveHeight) {
            this.setGallerySize();
          }
          this.dispatchEvent("select", null, [index]);
          if (index !== prevIndex) {
            this.dispatchEvent("change", null, [index]);
          }
        };
        proto._wrapSelect = function(index) {
          if (!this.isWrapping) return;
          const { selectedIndex, slideableWidth, slides: { length } } = this;
          if (!this.isDragSelect) {
            let wrapIndex = utils2.modulo(index, length);
            let delta = Math.abs(wrapIndex - selectedIndex);
            let backWrapDelta = Math.abs(wrapIndex + length - selectedIndex);
            let forewardWrapDelta = Math.abs(wrapIndex - length - selectedIndex);
            if (backWrapDelta < delta) {
              index += length;
            } else if (forewardWrapDelta < delta) {
              index -= length;
            }
          }
          if (index < 0) {
            this.x -= slideableWidth;
          } else if (index >= length) {
            this.x += slideableWidth;
          }
        };
        proto.previous = function(isWrap, isInstant) {
          this.select(this.selectedIndex - 1, isWrap, isInstant);
        };
        proto.next = function(isWrap, isInstant) {
          this.select(this.selectedIndex + 1, isWrap, isInstant);
        };
        proto.updateSelectedSlide = function() {
          let slide2 = this.slides[this.selectedIndex];
          if (!slide2) return;
          this.unselectSelectedSlide();
          this.selectedSlide = slide2;
          slide2.select();
          this.selectedCells = slide2.cells;
          this.selectedElements = slide2.getCellElements();
          this.selectedCell = slide2.cells[0];
          this.selectedElement = this.selectedElements[0];
        };
        proto.unselectSelectedSlide = function() {
          if (this.selectedSlide) this.selectedSlide.unselect();
        };
        proto.selectInitialIndex = function() {
          let initialIndex = this.options.initialIndex;
          if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
          }
          if (initialIndex && typeof initialIndex == "string") {
            let cell2 = this.queryCell(initialIndex);
            if (cell2) {
              this.selectCell(initialIndex, false, true);
              return;
            }
          }
          let index = 0;
          if (initialIndex && this.slides[initialIndex]) {
            index = initialIndex;
          }
          this.select(index, false, true);
        };
        proto.selectCell = function(value, isWrap, isInstant) {
          let cell2 = this.queryCell(value);
          if (!cell2) return;
          let index = this.getCellSlideIndex(cell2);
          this.select(index, isWrap, isInstant);
        };
        proto.getCellSlideIndex = function(cell2) {
          let cellSlide = this.slides.find((slide2) => slide2.cells.includes(cell2));
          return this.slides.indexOf(cellSlide);
        };
        proto.getCell = function(elem) {
          for (let cell2 of this.cells) {
            if (cell2.element === elem) return cell2;
          }
        };
        proto.getCells = function(elems) {
          elems = utils2.makeArray(elems);
          return elems.map((elem) => this.getCell(elem)).filter(Boolean);
        };
        proto.getCellElements = function() {
          return this.cells.map((cell2) => cell2.element);
        };
        proto.getParentCell = function(elem) {
          let cell2 = this.getCell(elem);
          if (cell2) return cell2;
          let closest = elem.closest(".flickity-slider > *");
          return this.getCell(closest);
        };
        proto.getAdjacentCellElements = function(adjCount, index) {
          if (!adjCount) return this.selectedSlide.getCellElements();
          index = index === void 0 ? this.selectedIndex : index;
          let len = this.slides.length;
          if (1 + adjCount * 2 >= len) {
            return this.getCellElements();
          }
          let cellElems = [];
          for (let i = index - adjCount; i <= index + adjCount; i++) {
            let slideIndex = this.isWrapping ? utils2.modulo(i, len) : i;
            let slide2 = this.slides[slideIndex];
            if (slide2) {
              cellElems = cellElems.concat(slide2.getCellElements());
            }
          }
          return cellElems;
        };
        proto.queryCell = function(selector) {
          if (typeof selector == "number") {
            return this.cells[selector];
          }
          let isSelectorString = typeof selector == "string" && !selector.match(/^[#.]?[\d/]/);
          if (isSelectorString) {
            selector = this.element.querySelector(selector);
          }
          return this.getCell(selector);
        };
        proto.uiChange = function() {
          this.emitEvent("uiChange");
        };
        proto.onresize = function() {
          this.watchCSS();
          this.resize();
        };
        utils2.debounceMethod(Flickity2, "onresize", 150);
        proto.resize = function() {
          if (!this.isActive || this.isAnimating || this.isDragging) return;
          this.getSize();
          if (this.isWrapping) {
            this.x = utils2.modulo(this.x, this.slideableWidth);
          }
          this.positionCells();
          this._updateWrapShiftCells();
          this.setGallerySize();
          this.emitEvent("resize");
          let selectedElement = this.selectedElements && this.selectedElements[0];
          this.selectCell(selectedElement, false, true);
        };
        proto.watchCSS = function() {
          if (!this.options.watchCSS) return;
          let afterContent = getComputedStyle2(this.element, ":after").content;
          if (afterContent.includes("flickity")) {
            this.activate();
          } else {
            this.deactivate();
          }
        };
        proto.onkeydown = function(event) {
          let { activeElement } = document;
          let handler = Flickity2.keyboardHandlers[event.key];
          if (!this.options.accessibility || !activeElement || !handler) return;
          let isFocused = this.focusableElems.some((elem) => activeElement === elem);
          if (isFocused) handler.call(this);
        };
        Flickity2.keyboardHandlers = {
          ArrowLeft: function() {
            this.uiChange();
            let leftMethod = this.options.rightToLeft ? "next" : "previous";
            this[leftMethod]();
          },
          ArrowRight: function() {
            this.uiChange();
            let rightMethod = this.options.rightToLeft ? "previous" : "next";
            this[rightMethod]();
          }
        };
        proto.focus = function() {
          this.element.focus({ preventScroll: true });
        };
        proto.deactivate = function() {
          if (!this.isActive) return;
          this.element.classList.remove("flickity-enabled");
          this.element.classList.remove("flickity-rtl");
          this.unselectSelectedSlide();
          this.cells.forEach((cell2) => cell2.destroy());
          this.viewport.remove();
          this.element.append(...this.slider.children);
          if (this.options.accessibility) {
            this.element.removeAttribute("tabIndex");
            this.element.removeEventListener("keydown", this);
          }
          this.isActive = false;
          this.emitEvent("deactivate");
        };
        proto.destroy = function() {
          this.deactivate();
          window2.removeEventListener("resize", this);
          this.allOff();
          this.emitEvent("destroy");
          if (jQuery && this.$element) {
            jQuery.removeData(this.element, "flickity");
          }
          delete this.element.flickityGUID;
          delete instances[this.guid];
        };
        Object.assign(proto, animatePrototype);
        Flickity2.data = function(elem) {
          elem = utils2.getQueryElement(elem);
          if (elem) return instances[elem.flickityGUID];
        };
        utils2.htmlInit(Flickity2, "flickity");
        let { jQueryBridget } = window2;
        if (jQuery && jQueryBridget) {
          jQueryBridget("flickity", Flickity2, jQuery);
        }
        Flickity2.setJQuery = function(jq) {
          jQuery = jq;
        };
        Flickity2.Cell = Cell;
        Flickity2.Slide = Slide2;
        return Flickity2;
      }
    );
  })(core$1);
  return core$1.exports;
}
var drag$1 = { exports: {} };
var unidragger$1 = { exports: {} };
/*!
 * Unidragger v3.0.1
 * Draggable base class
 * MIT license
 */
var unidragger = unidragger$1.exports;
var hasRequiredUnidragger;
function requireUnidragger() {
  if (hasRequiredUnidragger) return unidragger$1.exports;
  hasRequiredUnidragger = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          window2,
          requireEvEmitter()
        );
      } else {
        window2.Unidragger = factory(
          window2,
          window2.EvEmitter
        );
      }
    })(typeof window != "undefined" ? window : unidragger, function factory(window2, EvEmitter) {
      function Unidragger() {
      }
      let proto = Unidragger.prototype = Object.create(EvEmitter.prototype);
      proto.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) {
          this[method](event);
        }
      };
      let startEvent, activeEvents;
      if ("ontouchstart" in window2) {
        startEvent = "touchstart";
        activeEvents = ["touchmove", "touchend", "touchcancel"];
      } else if (window2.PointerEvent) {
        startEvent = "pointerdown";
        activeEvents = ["pointermove", "pointerup", "pointercancel"];
      } else {
        startEvent = "mousedown";
        activeEvents = ["mousemove", "mouseup"];
      }
      proto.touchActionValue = "none";
      proto.bindHandles = function() {
        this._bindHandles("addEventListener", this.touchActionValue);
      };
      proto.unbindHandles = function() {
        this._bindHandles("removeEventListener", "");
      };
      proto._bindHandles = function(bindMethod, touchAction) {
        this.handles.forEach((handle) => {
          handle[bindMethod](startEvent, this);
          handle[bindMethod]("click", this);
          if (window2.PointerEvent) handle.style.touchAction = touchAction;
        });
      };
      proto.bindActivePointerEvents = function() {
        activeEvents.forEach((eventName) => {
          window2.addEventListener(eventName, this);
        });
      };
      proto.unbindActivePointerEvents = function() {
        activeEvents.forEach((eventName) => {
          window2.removeEventListener(eventName, this);
        });
      };
      proto.withPointer = function(methodName, event) {
        if (event.pointerId === this.pointerIdentifier) {
          this[methodName](event, event);
        }
      };
      proto.withTouch = function(methodName, event) {
        let touch;
        for (let changedTouch of event.changedTouches) {
          if (changedTouch.identifier === this.pointerIdentifier) {
            touch = changedTouch;
          }
        }
        if (touch) this[methodName](event, touch);
      };
      proto.onmousedown = function(event) {
        this.pointerDown(event, event);
      };
      proto.ontouchstart = function(event) {
        this.pointerDown(event, event.changedTouches[0]);
      };
      proto.onpointerdown = function(event) {
        this.pointerDown(event, event);
      };
      const cursorNodes = ["TEXTAREA", "INPUT", "SELECT", "OPTION"];
      const clickTypes = ["radio", "checkbox", "button", "submit", "image", "file"];
      proto.pointerDown = function(event, pointer) {
        let isCursorNode = cursorNodes.includes(event.target.nodeName);
        let isClickType = clickTypes.includes(event.target.type);
        let isOkayElement = !isCursorNode || isClickType;
        let isOkay = !this.isPointerDown && !event.button && isOkayElement;
        if (!isOkay) return;
        this.isPointerDown = true;
        this.pointerIdentifier = pointer.pointerId !== void 0 ? (
          // pointerId for pointer events, touch.indentifier for touch events
          pointer.pointerId
        ) : pointer.identifier;
        this.pointerDownPointer = {
          pageX: pointer.pageX,
          pageY: pointer.pageY
        };
        this.bindActivePointerEvents();
        this.emitEvent("pointerDown", [event, pointer]);
      };
      proto.onmousemove = function(event) {
        this.pointerMove(event, event);
      };
      proto.onpointermove = function(event) {
        this.withPointer("pointerMove", event);
      };
      proto.ontouchmove = function(event) {
        this.withTouch("pointerMove", event);
      };
      proto.pointerMove = function(event, pointer) {
        let moveVector = {
          x: pointer.pageX - this.pointerDownPointer.pageX,
          y: pointer.pageY - this.pointerDownPointer.pageY
        };
        this.emitEvent("pointerMove", [event, pointer, moveVector]);
        let isDragStarting = !this.isDragging && this.hasDragStarted(moveVector);
        if (isDragStarting) this.dragStart(event, pointer);
        if (this.isDragging) this.dragMove(event, pointer, moveVector);
      };
      proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
      };
      proto.dragStart = function(event, pointer) {
        this.isDragging = true;
        this.isPreventingClicks = true;
        this.emitEvent("dragStart", [event, pointer]);
      };
      proto.dragMove = function(event, pointer, moveVector) {
        this.emitEvent("dragMove", [event, pointer, moveVector]);
      };
      proto.onmouseup = function(event) {
        this.pointerUp(event, event);
      };
      proto.onpointerup = function(event) {
        this.withPointer("pointerUp", event);
      };
      proto.ontouchend = function(event) {
        this.withTouch("pointerUp", event);
      };
      proto.pointerUp = function(event, pointer) {
        this.pointerDone();
        this.emitEvent("pointerUp", [event, pointer]);
        if (this.isDragging) {
          this.dragEnd(event, pointer);
        } else {
          this.staticClick(event, pointer);
        }
      };
      proto.dragEnd = function(event, pointer) {
        this.isDragging = false;
        setTimeout(() => delete this.isPreventingClicks);
        this.emitEvent("dragEnd", [event, pointer]);
      };
      proto.pointerDone = function() {
        this.isPointerDown = false;
        delete this.pointerIdentifier;
        this.unbindActivePointerEvents();
        this.emitEvent("pointerDone");
      };
      proto.onpointercancel = function(event) {
        this.withPointer("pointerCancel", event);
      };
      proto.ontouchcancel = function(event) {
        this.withTouch("pointerCancel", event);
      };
      proto.pointerCancel = function(event, pointer) {
        this.pointerDone();
        this.emitEvent("pointerCancel", [event, pointer]);
      };
      proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
      };
      proto.staticClick = function(event, pointer) {
        let isMouseup = event.type === "mouseup";
        if (isMouseup && this.isIgnoringMouseUp) return;
        this.emitEvent("staticClick", [event, pointer]);
        if (isMouseup) {
          this.isIgnoringMouseUp = true;
          setTimeout(() => {
            delete this.isIgnoringMouseUp;
          }, 400);
        }
      };
      return Unidragger;
    });
  })(unidragger$1);
  return unidragger$1.exports;
}
var drag = drag$1.exports;
var hasRequiredDrag;
function requireDrag() {
  if (hasRequiredDrag) return drag$1.exports;
  hasRequiredDrag = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          window2,
          requireCore(),
          requireUnidragger(),
          requireUtils()
        );
      } else {
        window2.Flickity = factory(
          window2,
          window2.Flickity,
          window2.Unidragger,
          window2.fizzyUIUtils
        );
      }
    })(
      typeof window != "undefined" ? window : drag,
      function factory(window2, Flickity2, Unidragger, utils2) {
        Object.assign(Flickity2.defaults, {
          draggable: ">1",
          dragThreshold: 3
        });
        let proto = Flickity2.prototype;
        Object.assign(proto, Unidragger.prototype);
        proto.touchActionValue = "";
        Flickity2.create.drag = function() {
          this.on("activate", this.onActivateDrag);
          this.on("uiChange", this._uiChangeDrag);
          this.on("deactivate", this.onDeactivateDrag);
          this.on("cellChange", this.updateDraggable);
          this.on("pointerDown", this.handlePointerDown);
          this.on("pointerUp", this.handlePointerUp);
          this.on("pointerDown", this.handlePointerDone);
          this.on("dragStart", this.handleDragStart);
          this.on("dragMove", this.handleDragMove);
          this.on("dragEnd", this.handleDragEnd);
          this.on("staticClick", this.handleStaticClick);
        };
        proto.onActivateDrag = function() {
          this.handles = [this.viewport];
          this.bindHandles();
          this.updateDraggable();
        };
        proto.onDeactivateDrag = function() {
          this.unbindHandles();
          this.element.classList.remove("is-draggable");
        };
        proto.updateDraggable = function() {
          if (this.options.draggable === ">1") {
            this.isDraggable = this.slides.length > 1;
          } else {
            this.isDraggable = this.options.draggable;
          }
          this.element.classList.toggle("is-draggable", this.isDraggable);
        };
        proto._uiChangeDrag = function() {
          delete this.isFreeScrolling;
        };
        proto.handlePointerDown = function(event) {
          if (!this.isDraggable) {
            this.bindActivePointerEvents(event);
            return;
          }
          let isTouchStart = event.type === "touchstart";
          let isTouchPointer = event.pointerType === "touch";
          let isFocusNode = event.target.matches("input, textarea, select");
          if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
          if (!isFocusNode) this.focus();
          if (document.activeElement !== this.element) document.activeElement.blur();
          this.dragX = this.x;
          this.viewport.classList.add("is-pointer-down");
          this.pointerDownScroll = getScrollPosition();
          window2.addEventListener("scroll", this);
          this.bindActivePointerEvents(event);
        };
        proto.hasDragStarted = function(moveVector) {
          return Math.abs(moveVector.x) > this.options.dragThreshold;
        };
        proto.handlePointerUp = function() {
          delete this.isTouchScrolling;
          this.viewport.classList.remove("is-pointer-down");
        };
        proto.handlePointerDone = function() {
          window2.removeEventListener("scroll", this);
          delete this.pointerDownScroll;
        };
        proto.handleDragStart = function() {
          if (!this.isDraggable) return;
          this.dragStartPosition = this.x;
          this.startAnimation();
          window2.removeEventListener("scroll", this);
        };
        proto.handleDragMove = function(event, pointer, moveVector) {
          if (!this.isDraggable) return;
          event.preventDefault();
          this.previousDragX = this.dragX;
          let direction = this.options.rightToLeft ? -1 : 1;
          if (this.isWrapping) moveVector.x %= this.slideableWidth;
          let dragX = this.dragStartPosition + moveVector.x * direction;
          if (!this.isWrapping) {
            let originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            let endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
          }
          this.dragX = dragX;
          this.dragMoveTime = /* @__PURE__ */ new Date();
        };
        proto.handleDragEnd = function() {
          if (!this.isDraggable) return;
          let { freeScroll } = this.options;
          if (freeScroll) this.isFreeScrolling = true;
          let index = this.dragEndRestingSelect();
          if (freeScroll && !this.isWrapping) {
            let restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
          } else if (!freeScroll && index === this.selectedIndex) {
            index += this.dragEndBoostSelect();
          }
          delete this.previousDragX;
          this.isDragSelect = this.isWrapping;
          this.select(index);
          delete this.isDragSelect;
        };
        proto.dragEndRestingSelect = function() {
          let restingX = this.getRestingPosition();
          let distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
          let positiveResting = this._getClosestResting(restingX, distance, 1);
          let negativeResting = this._getClosestResting(restingX, distance, -1);
          return positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
        };
        proto._getClosestResting = function(restingX, distance, increment) {
          let index = this.selectedIndex;
          let minDistance = Infinity;
          let condition = this.options.contain && !this.isWrapping ? (
            // if containing, keep going if distance is equal to minDistance
            (dist, minDist) => dist <= minDist
          ) : (dist, minDist) => dist < minDist;
          while (condition(distance, minDistance)) {
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
          }
          return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
          };
        };
        proto.getSlideDistance = function(x, index) {
          let len = this.slides.length;
          let isWrapAround = this.options.wrapAround && len > 1;
          let slideIndex = isWrapAround ? utils2.modulo(index, len) : index;
          let slide2 = this.slides[slideIndex];
          if (!slide2) return null;
          let wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
          return x - (slide2.target + wrap);
        };
        proto.dragEndBoostSelect = function() {
          if (this.previousDragX === void 0 || !this.dragMoveTime || // or if drag was held for 100 ms
          /* @__PURE__ */ new Date() - this.dragMoveTime > 100) {
            return 0;
          }
          let distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
          let delta = this.previousDragX - this.dragX;
          if (distance > 0 && delta > 0) {
            return 1;
          } else if (distance < 0 && delta < 0) {
            return -1;
          }
          return 0;
        };
        proto.onscroll = function() {
          let scroll = getScrollPosition();
          let scrollMoveX = this.pointerDownScroll.x - scroll.x;
          let scrollMoveY = this.pointerDownScroll.y - scroll.y;
          if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
            this.pointerDone();
          }
        };
        function getScrollPosition() {
          return {
            x: window2.pageXOffset,
            y: window2.pageYOffset
          };
        }
        return Flickity2;
      }
    );
  })(drag$1);
  return drag$1.exports;
}
var prevNextButton$1 = { exports: {} };
var prevNextButton = prevNextButton$1.exports;
var hasRequiredPrevNextButton;
function requirePrevNextButton() {
  if (hasRequiredPrevNextButton) return prevNextButton$1.exports;
  hasRequiredPrevNextButton = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(requireCore());
      } else {
        factory(window2.Flickity);
      }
    })(typeof window != "undefined" ? window : prevNextButton, function factory(Flickity2) {
      const svgURI = "http://www.w3.org/2000/svg";
      function PrevNextButton(increment, direction, arrowShape) {
        this.increment = increment;
        this.direction = direction;
        this.isPrevious = increment === "previous";
        this.isLeft = direction === "left";
        this._create(arrowShape);
      }
      PrevNextButton.prototype._create = function(arrowShape) {
        let element = this.element = document.createElement("button");
        element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
        let label = this.isPrevious ? "Previous" : "Next";
        element.setAttribute("type", "button");
        element.setAttribute("aria-label", label);
        this.disable();
        let svg = this.createSVG(label, arrowShape);
        element.append(svg);
      };
      PrevNextButton.prototype.createSVG = function(label, arrowShape) {
        let svg = document.createElementNS(svgURI, "svg");
        svg.setAttribute("class", "flickity-button-icon");
        svg.setAttribute("viewBox", "0 0 100 100");
        let title = document.createElementNS(svgURI, "title");
        title.append(label);
        let path = document.createElementNS(svgURI, "path");
        let pathMovements = getArrowMovements(arrowShape);
        path.setAttribute("d", pathMovements);
        path.setAttribute("class", "arrow");
        if (!this.isLeft) {
          path.setAttribute("transform", "translate(100, 100) rotate(180)");
        }
        svg.append(title, path);
        return svg;
      };
      function getArrowMovements(shape) {
        if (typeof shape == "string") return shape;
        let { x0, x1, x2, x3, y1, y2 } = shape;
        return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
      }
      PrevNextButton.prototype.enable = function() {
        this.element.removeAttribute("disabled");
      };
      PrevNextButton.prototype.disable = function() {
        this.element.setAttribute("disabled", true);
      };
      Object.assign(Flickity2.defaults, {
        prevNextButtons: true,
        arrowShape: {
          x0: 10,
          x1: 60,
          y1: 50,
          x2: 70,
          y2: 40,
          x3: 30
        }
      });
      Flickity2.create.prevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        let { rightToLeft, arrowShape } = this.options;
        let prevDirection = rightToLeft ? "right" : "left";
        let nextDirection = rightToLeft ? "left" : "right";
        this.prevButton = new PrevNextButton("previous", prevDirection, arrowShape);
        this.nextButton = new PrevNextButton("next", nextDirection, arrowShape);
        this.focusableElems.push(this.prevButton.element);
        this.focusableElems.push(this.nextButton.element);
        this.handlePrevButtonClick = () => {
          this.uiChange();
          this.previous();
        };
        this.handleNextButtonClick = () => {
          this.uiChange();
          this.next();
        };
        this.on("activate", this.activatePrevNextButtons);
        this.on("select", this.updatePrevNextButtons);
      };
      let proto = Flickity2.prototype;
      proto.updatePrevNextButtons = function() {
        let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
        this.updatePrevNextButton(this.prevButton, 0);
        this.updatePrevNextButton(this.nextButton, lastIndex);
      };
      proto.updatePrevNextButton = function(button, disabledIndex) {
        if (this.isWrapping && this.slides.length > 1) {
          button.enable();
          return;
        }
        let isEnabled = this.selectedIndex !== disabledIndex;
        button[isEnabled ? "enable" : "disable"]();
        let isDisabledFocused = !isEnabled && document.activeElement === button.element;
        if (isDisabledFocused) this.focus();
      };
      proto.activatePrevNextButtons = function() {
        this.prevButton.element.addEventListener("click", this.handlePrevButtonClick);
        this.nextButton.element.addEventListener("click", this.handleNextButtonClick);
        this.element.append(this.prevButton.element, this.nextButton.element);
        this.on("deactivate", this.deactivatePrevNextButtons);
      };
      proto.deactivatePrevNextButtons = function() {
        this.prevButton.element.remove();
        this.nextButton.element.remove();
        this.prevButton.element.removeEventListener("click", this.handlePrevButtonClick);
        this.nextButton.element.removeEventListener("click", this.handleNextButtonClick);
        this.off("deactivate", this.deactivatePrevNextButtons);
      };
      Flickity2.PrevNextButton = PrevNextButton;
      return Flickity2;
    });
  })(prevNextButton$1);
  return prevNextButton$1.exports;
}
var pageDots$1 = { exports: {} };
var pageDots = pageDots$1.exports;
var hasRequiredPageDots;
function requirePageDots() {
  if (hasRequiredPageDots) return pageDots$1.exports;
  hasRequiredPageDots = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireCore(),
          requireUtils()
        );
      } else {
        factory(
          window2.Flickity,
          window2.fizzyUIUtils
        );
      }
    })(typeof window != "undefined" ? window : pageDots, function factory(Flickity2, utils2) {
      function PageDots() {
        this.holder = document.createElement("div");
        this.holder.className = "flickity-page-dots";
        this.dots = [];
      }
      PageDots.prototype.setDots = function(slidesLength) {
        let delta = slidesLength - this.dots.length;
        if (delta > 0) {
          this.addDots(delta);
        } else if (delta < 0) {
          this.removeDots(-delta);
        }
      };
      PageDots.prototype.addDots = function(count) {
        let newDots = new Array(count).fill().map((item, i) => {
          let dot = document.createElement("button");
          dot.setAttribute("type", "button");
          let num = i + 1 + this.dots.length;
          dot.className = "flickity-page-dot";
          dot.textContent = `View slide ${num}`;
          return dot;
        });
        this.holder.append(...newDots);
        this.dots = this.dots.concat(newDots);
      };
      PageDots.prototype.removeDots = function(count) {
        let removeDots = this.dots.splice(this.dots.length - count, count);
        removeDots.forEach((dot) => dot.remove());
      };
      PageDots.prototype.updateSelected = function(index) {
        if (this.selectedDot) {
          this.selectedDot.classList.remove("is-selected");
          this.selectedDot.removeAttribute("aria-current");
        }
        if (!this.dots.length) return;
        this.selectedDot = this.dots[index];
        this.selectedDot.classList.add("is-selected");
        this.selectedDot.setAttribute("aria-current", "step");
      };
      Flickity2.PageDots = PageDots;
      Object.assign(Flickity2.defaults, {
        pageDots: true
      });
      Flickity2.create.pageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots();
        this.handlePageDotsClick = this.onPageDotsClick.bind(this);
        this.on("activate", this.activatePageDots);
        this.on("select", this.updateSelectedPageDots);
        this.on("cellChange", this.updatePageDots);
        this.on("resize", this.updatePageDots);
        this.on("deactivate", this.deactivatePageDots);
      };
      let proto = Flickity2.prototype;
      proto.activatePageDots = function() {
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
        this.pageDots.holder.addEventListener("click", this.handlePageDotsClick);
        this.element.append(this.pageDots.holder);
      };
      proto.onPageDotsClick = function(event) {
        let index = this.pageDots.dots.indexOf(event.target);
        if (index === -1) return;
        this.uiChange();
        this.select(index);
      };
      proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected(this.selectedIndex);
      };
      proto.updatePageDots = function() {
        this.pageDots.dots.forEach((dot) => {
          utils2.removeFrom(this.focusableElems, dot);
        });
        this.pageDots.setDots(this.slides.length);
        this.focusableElems.push(...this.pageDots.dots);
      };
      proto.deactivatePageDots = function() {
        this.pageDots.holder.remove();
        this.pageDots.holder.removeEventListener("click", this.handlePageDotsClick);
      };
      Flickity2.PageDots = PageDots;
      return Flickity2;
    });
  })(pageDots$1);
  return pageDots$1.exports;
}
var player$1 = { exports: {} };
var player = player$1.exports;
var hasRequiredPlayer;
function requirePlayer() {
  if (hasRequiredPlayer) return player$1.exports;
  hasRequiredPlayer = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(requireCore());
      } else {
        factory(window2.Flickity);
      }
    })(typeof window != "undefined" ? window : player, function factory(Flickity2) {
      function Player(autoPlay, onTick) {
        this.autoPlay = autoPlay;
        this.onTick = onTick;
        this.state = "stopped";
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
      }
      Player.prototype.play = function() {
        if (this.state === "playing") return;
        let isPageHidden = document.hidden;
        if (isPageHidden) {
          document.addEventListener("visibilitychange", this.onVisibilityPlay);
          return;
        }
        this.state = "playing";
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        this.tick();
      };
      Player.prototype.tick = function() {
        if (this.state !== "playing") return;
        let time = typeof this.autoPlay == "number" ? this.autoPlay : 3e3;
        this.clear();
        this.timeout = setTimeout(() => {
          this.onTick();
          this.tick();
        }, time);
      };
      Player.prototype.stop = function() {
        this.state = "stopped";
        this.clear();
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
      };
      Player.prototype.clear = function() {
        clearTimeout(this.timeout);
      };
      Player.prototype.pause = function() {
        if (this.state === "playing") {
          this.state = "paused";
          this.clear();
        }
      };
      Player.prototype.unpause = function() {
        if (this.state === "paused") this.play();
      };
      Player.prototype.visibilityChange = function() {
        let isPageHidden = document.hidden;
        this[isPageHidden ? "pause" : "unpause"]();
      };
      Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener("visibilitychange", this.onVisibilityPlay);
      };
      Object.assign(Flickity2.defaults, {
        pauseAutoPlayOnHover: true
      });
      Flickity2.create.player = function() {
        this.player = new Player(this.options.autoPlay, () => {
          this.next(true);
        });
        this.on("activate", this.activatePlayer);
        this.on("uiChange", this.stopPlayer);
        this.on("pointerDown", this.stopPlayer);
        this.on("deactivate", this.deactivatePlayer);
      };
      let proto = Flickity2.prototype;
      proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener("mouseenter", this);
      };
      proto.playPlayer = function() {
        this.player.play();
      };
      proto.stopPlayer = function() {
        this.player.stop();
      };
      proto.pausePlayer = function() {
        this.player.pause();
      };
      proto.unpausePlayer = function() {
        this.player.unpause();
      };
      proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener("mouseenter", this);
      };
      proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener("mouseleave", this);
      };
      proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener("mouseleave", this);
      };
      Flickity2.Player = Player;
      return Flickity2;
    });
  })(player$1);
  return player$1.exports;
}
var addRemoveCell$1 = { exports: {} };
var addRemoveCell = addRemoveCell$1.exports;
var hasRequiredAddRemoveCell;
function requireAddRemoveCell() {
  if (hasRequiredAddRemoveCell) return addRemoveCell$1.exports;
  hasRequiredAddRemoveCell = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireCore(),
          requireUtils()
        );
      } else {
        factory(
          window2.Flickity,
          window2.fizzyUIUtils
        );
      }
    })(typeof window != "undefined" ? window : addRemoveCell, function factory(Flickity2, utils2) {
      function getCellsFragment(cells) {
        let fragment = document.createDocumentFragment();
        cells.forEach((cell2) => fragment.appendChild(cell2.element));
        return fragment;
      }
      let proto = Flickity2.prototype;
      proto.insert = function(elems, index) {
        let cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        let len = this.cells.length;
        index = index === void 0 ? len : index;
        let fragment = getCellsFragment(cells);
        let isAppend = index === len;
        if (isAppend) {
          this.slider.appendChild(fragment);
        } else {
          let insertCellElement = this.cells[index].element;
          this.slider.insertBefore(fragment, insertCellElement);
        }
        if (index === 0) {
          this.cells = cells.concat(this.cells);
        } else if (isAppend) {
          this.cells = this.cells.concat(cells);
        } else {
          let endCells = this.cells.splice(index, len - index);
          this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index);
        this.positionSliderAtSelected();
      };
      proto.append = function(elems) {
        this.insert(elems, this.cells.length);
      };
      proto.prepend = function(elems) {
        this.insert(elems, 0);
      };
      proto.remove = function(elems) {
        let cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        let minCellIndex = this.cells.length - 1;
        cells.forEach((cell2) => {
          cell2.remove();
          let index = this.cells.indexOf(cell2);
          minCellIndex = Math.min(index, minCellIndex);
          utils2.removeFrom(this.cells, cell2);
        });
        this.cellChange(minCellIndex);
        this.positionSliderAtSelected();
      };
      proto.cellSizeChange = function(elem) {
        let cell2 = this.getCell(elem);
        if (!cell2) return;
        cell2.getSize();
        let index = this.cells.indexOf(cell2);
        this.cellChange(index);
      };
      proto.cellChange = function(changedCellIndex) {
        let prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._updateWrapShiftCells();
        this.setGallerySize();
        let cell2 = this.getCell(prevSelectedElem);
        if (cell2) this.selectedIndex = this.getCellSlideIndex(cell2);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent("cellChange", [changedCellIndex]);
        this.select(this.selectedIndex);
      };
      return Flickity2;
    });
  })(addRemoveCell$1);
  return addRemoveCell$1.exports;
}
var lazyload$1 = { exports: {} };
var lazyload = lazyload$1.exports;
var hasRequiredLazyload;
function requireLazyload() {
  if (hasRequiredLazyload) return lazyload$1.exports;
  hasRequiredLazyload = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireCore(),
          requireUtils()
        );
      } else {
        factory(
          window2.Flickity,
          window2.fizzyUIUtils
        );
      }
    })(typeof window != "undefined" ? window : lazyload, function factory(Flickity2, utils2) {
      const lazyAttr = "data-flickity-lazyload";
      const lazySrcAttr = `${lazyAttr}-src`;
      const lazySrcsetAttr = `${lazyAttr}-srcset`;
      const imgSelector = `img[${lazyAttr}], img[${lazySrcAttr}], img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;
      Flickity2.create.lazyLoad = function() {
        this.on("select", this.lazyLoad);
        this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
      };
      let proto = Flickity2.prototype;
      proto.lazyLoad = function() {
        let { lazyLoad } = this.options;
        if (!lazyLoad) return;
        let adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
        this.getAdjacentCellElements(adjCount).map(getCellLazyImages).flat().forEach((img) => new LazyLoader(img, this.handleLazyLoadComplete));
      };
      function getCellLazyImages(cellElem) {
        if (cellElem.matches("img")) {
          let cellAttr = cellElem.getAttribute(lazyAttr);
          let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
          let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
          if (cellAttr || cellSrcAttr || cellSrcsetAttr) {
            return cellElem;
          }
        }
        return [...cellElem.querySelectorAll(imgSelector)];
      }
      proto.onLazyLoadComplete = function(img, event) {
        let cell2 = this.getParentCell(img);
        let cellElem = cell2 && cell2.element;
        this.cellSizeChange(cellElem);
        this.dispatchEvent("lazyLoad", event, cellElem);
      };
      function LazyLoader(img, onComplete) {
        this.img = img;
        this.onComplete = onComplete;
        this.load();
      }
      LazyLoader.prototype.handleEvent = utils2.handleEvent;
      LazyLoader.prototype.load = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        let src = this.img.getAttribute(lazyAttr) || this.img.getAttribute(lazySrcAttr);
        let srcset = this.img.getAttribute(lazySrcsetAttr);
        this.img.src = src;
        if (srcset) this.img.setAttribute("srcset", srcset);
        this.img.removeAttribute(lazyAttr);
        this.img.removeAttribute(lazySrcAttr);
        this.img.removeAttribute(lazySrcsetAttr);
      };
      LazyLoader.prototype.onload = function(event) {
        this.complete(event, "flickity-lazyloaded");
      };
      LazyLoader.prototype.onerror = function(event) {
        this.complete(event, "flickity-lazyerror");
      };
      LazyLoader.prototype.complete = function(event, className) {
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
        let mediaElem = this.img.parentNode.matches("picture") ? this.img.parentNode : this.img;
        mediaElem.classList.add(className);
        this.onComplete(this.img, event);
      };
      Flickity2.LazyLoader = LazyLoader;
      return Flickity2;
    });
  })(lazyload$1);
  return lazyload$1.exports;
}
var imagesloaded$3 = { exports: {} };
var imagesloaded$2 = { exports: {} };
/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
var imagesloaded$1 = imagesloaded$2.exports;
var hasRequiredImagesloaded$1;
function requireImagesloaded$1() {
  if (hasRequiredImagesloaded$1) return imagesloaded$2.exports;
  hasRequiredImagesloaded$1 = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(window2, requireEvEmitter());
      } else {
        window2.imagesLoaded = factory(window2, window2.EvEmitter);
      }
    })(
      typeof window !== "undefined" ? window : imagesloaded$1,
      function factory(window2, EvEmitter) {
        let $ = window2.jQuery;
        let console2 = window2.console;
        function makeArray(obj) {
          if (Array.isArray(obj)) return obj;
          let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
          if (isArrayLike) return [...obj];
          return [obj];
        }
        function ImagesLoaded(elem, options, onAlways) {
          if (!(this instanceof ImagesLoaded)) {
            return new ImagesLoaded(elem, options, onAlways);
          }
          let queryElem = elem;
          if (typeof elem == "string") {
            queryElem = document.querySelectorAll(elem);
          }
          if (!queryElem) {
            console2.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
          }
          this.elements = makeArray(queryElem);
          this.options = {};
          if (typeof options == "function") {
            onAlways = options;
          } else {
            Object.assign(this.options, options);
          }
          if (onAlways) this.on("always", onAlways);
          this.getImages();
          if ($) this.jqDeferred = new $.Deferred();
          setTimeout(this.check.bind(this));
        }
        ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
        ImagesLoaded.prototype.getImages = function() {
          this.images = [];
          this.elements.forEach(this.addElementImages, this);
        };
        const elementNodeTypes = [1, 9, 11];
        ImagesLoaded.prototype.addElementImages = function(elem) {
          if (elem.nodeName === "IMG") {
            this.addImage(elem);
          }
          if (this.options.background === true) {
            this.addElementBackgroundImages(elem);
          }
          let { nodeType } = elem;
          if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
          let childImgs = elem.querySelectorAll("img");
          for (let img of childImgs) {
            this.addImage(img);
          }
          if (typeof this.options.background == "string") {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children) {
              this.addElementBackgroundImages(child);
            }
          }
        };
        const reURL = /url\((['"])?(.*?)\1\)/gi;
        ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
          let style = getComputedStyle(elem);
          if (!style) return;
          let matches = reURL.exec(style.backgroundImage);
          while (matches !== null) {
            let url = matches && matches[2];
            if (url) {
              this.addBackground(url, elem);
            }
            matches = reURL.exec(style.backgroundImage);
          }
        };
        ImagesLoaded.prototype.addImage = function(img) {
          let loadingImage = new LoadingImage(img);
          this.images.push(loadingImage);
        };
        ImagesLoaded.prototype.addBackground = function(url, elem) {
          let background = new Background(url, elem);
          this.images.push(background);
        };
        ImagesLoaded.prototype.check = function() {
          this.progressedCount = 0;
          this.hasAnyBroken = false;
          if (!this.images.length) {
            this.complete();
            return;
          }
          let onProgress = (image, elem, message) => {
            setTimeout(() => {
              this.progress(image, elem, message);
            });
          };
          this.images.forEach(function(loadingImage) {
            loadingImage.once("progress", onProgress);
            loadingImage.check();
          });
        };
        ImagesLoaded.prototype.progress = function(image, elem, message) {
          this.progressedCount++;
          this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
          this.emitEvent("progress", [this, image, elem]);
          if (this.jqDeferred && this.jqDeferred.notify) {
            this.jqDeferred.notify(this, image);
          }
          if (this.progressedCount === this.images.length) {
            this.complete();
          }
          if (this.options.debug && console2) {
            console2.log(`progress: ${message}`, image, elem);
          }
        };
        ImagesLoaded.prototype.complete = function() {
          let eventName = this.hasAnyBroken ? "fail" : "done";
          this.isComplete = true;
          this.emitEvent(eventName, [this]);
          this.emitEvent("always", [this]);
          if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[jqMethod](this);
          }
        };
        function LoadingImage(img) {
          this.img = img;
        }
        LoadingImage.prototype = Object.create(EvEmitter.prototype);
        LoadingImage.prototype.check = function() {
          let isComplete = this.getIsImageComplete();
          if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            return;
          }
          this.proxyImage = new Image();
          if (this.img.crossOrigin) {
            this.proxyImage.crossOrigin = this.img.crossOrigin;
          }
          this.proxyImage.addEventListener("load", this);
          this.proxyImage.addEventListener("error", this);
          this.img.addEventListener("load", this);
          this.img.addEventListener("error", this);
          this.proxyImage.src = this.img.currentSrc || this.img.src;
        };
        LoadingImage.prototype.getIsImageComplete = function() {
          return this.img.complete && this.img.naturalWidth;
        };
        LoadingImage.prototype.confirm = function(isLoaded, message) {
          this.isLoaded = isLoaded;
          let { parentNode } = this.img;
          let elem = parentNode.nodeName === "PICTURE" ? parentNode : this.img;
          this.emitEvent("progress", [this, elem, message]);
        };
        LoadingImage.prototype.handleEvent = function(event) {
          let method = "on" + event.type;
          if (this[method]) {
            this[method](event);
          }
        };
        LoadingImage.prototype.onload = function() {
          this.confirm(true, "onload");
          this.unbindEvents();
        };
        LoadingImage.prototype.onerror = function() {
          this.confirm(false, "onerror");
          this.unbindEvents();
        };
        LoadingImage.prototype.unbindEvents = function() {
          this.proxyImage.removeEventListener("load", this);
          this.proxyImage.removeEventListener("error", this);
          this.img.removeEventListener("load", this);
          this.img.removeEventListener("error", this);
        };
        function Background(url, element) {
          this.url = url;
          this.element = element;
          this.img = new Image();
        }
        Background.prototype = Object.create(LoadingImage.prototype);
        Background.prototype.check = function() {
          this.img.addEventListener("load", this);
          this.img.addEventListener("error", this);
          this.img.src = this.url;
          let isComplete = this.getIsImageComplete();
          if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            this.unbindEvents();
          }
        };
        Background.prototype.unbindEvents = function() {
          this.img.removeEventListener("load", this);
          this.img.removeEventListener("error", this);
        };
        Background.prototype.confirm = function(isLoaded, message) {
          this.isLoaded = isLoaded;
          this.emitEvent("progress", [this, this.element, message]);
        };
        ImagesLoaded.makeJQueryPlugin = function(jQuery) {
          jQuery = jQuery || window2.jQuery;
          if (!jQuery) return;
          $ = jQuery;
          $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
          };
        };
        ImagesLoaded.makeJQueryPlugin();
        return ImagesLoaded;
      }
    );
  })(imagesloaded$2);
  return imagesloaded$2.exports;
}
var imagesloaded = imagesloaded$3.exports;
var hasRequiredImagesloaded;
function requireImagesloaded() {
  if (hasRequiredImagesloaded) return imagesloaded$3.exports;
  hasRequiredImagesloaded = 1;
  (function(module) {
    (function(window2, factory) {
      if (module.exports) {
        module.exports = factory(
          requireCore(),
          requireImagesloaded$1()
        );
      } else {
        factory(
          window2.Flickity,
          window2.imagesLoaded
        );
      }
    })(
      typeof window != "undefined" ? window : imagesloaded,
      function factory(Flickity2, imagesLoaded) {
        Flickity2.create.imagesLoaded = function() {
          this.on("activate", this.imagesLoaded);
        };
        Flickity2.prototype.imagesLoaded = function() {
          if (!this.options.imagesLoaded) return;
          let onImagesLoadedProgress = (instance, image) => {
            let cell2 = this.getParentCell(image.img);
            this.cellSizeChange(cell2 && cell2.element);
            if (!this.options.freeScroll) this.positionSliderAtSelected();
          };
          imagesLoaded(this.slider).on("progress", onImagesLoadedProgress);
        };
        return Flickity2;
      }
    );
  })(imagesloaded$3);
  return imagesloaded$3.exports;
}
/*!
 * Flickity v3.0.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2022 Metafizzy
 */
var hasRequiredJs;
function requireJs() {
  if (hasRequiredJs) return js.exports;
  hasRequiredJs = 1;
  (function(module) {
    if (module.exports) {
      const Flickity2 = requireCore();
      requireDrag();
      requirePrevNextButton();
      requirePageDots();
      requirePlayer();
      requireAddRemoveCell();
      requireLazyload();
      requireImagesloaded();
      module.exports = Flickity2;
    }
  })(js);
  return js.exports;
}
var jsExports = requireJs();
const Flickity = /* @__PURE__ */ getDefaultExportFromCjs(jsExports);
const selectors$5 = {
  tabsSection: ".tabs-section",
  tabsCarousel: ".tabs-section__block",
  blockSlider: ".tabs-section__block-slider",
  prevButton: ".tabs-section-prev-btn",
  nextButton: ".tabs-section-next-btn",
  firstTabBtn: "#tabBtnFirst",
  secondTabBtn: "#tabBtnSecond",
  tabFirst: ".tabs-section__block-first",
  tabSecond: ".tabs-section__block-second"
};
document.addEventListener("DOMContentLoaded", function() {
  const tabsSection = document.querySelector(selectors$5.tabsSection);
  if (tabsSection) {
    let toggleTab2 = function(activeBtn, inactiveBtn, activeTab, inactiveTab) {
      if (activeBtn.classList.contains("active")) {
        activeBtn.classList.remove("active");
        activeTab.classList.add("tab-hidden");
      } else {
        inactiveBtn.classList.remove("active");
        inactiveTab.classList.add("tab-hidden");
        activeBtn.classList.add("active");
        activeTab.classList.remove("tab-hidden");
      }
    }, initializeSliders2 = function() {
      if (window.innerWidth < 1e3 && flktyInstances.length === 0) {
        const tabsCarousel = tabsSection == null ? void 0 : tabsSection.querySelectorAll(selectors$5.tabsCarousel);
        tabsCarousel.forEach((tab, index) => {
          const sliderBlock = tab.querySelector(selectors$5.blockSlider);
          const prevButton2 = tab.querySelector(selectors$5.prevButton);
          const nextButton2 = tab.querySelector(selectors$5.nextButton);
          if (sliderBlock) {
            let updateButtonState2 = function() {
              prevButton2.disabled = flkty.selectedIndex === 0;
              nextButton2.disabled = flkty.selectedIndex === flkty.slides.length - 1;
            };
            var updateButtonState = updateButtonState2;
            const flkty = new Flickity(sliderBlock, {
              cellAlign: "left",
              contain: true,
              prevNextButtons: false,
              pageDots: false
            });
            updateButtonState2();
            prevButton2.addEventListener("click", function() {
              flkty.previous();
            });
            nextButton2.addEventListener("click", function() {
              flkty.next();
            });
            flkty.on("change", updateButtonState2);
            flktyInstances[index] = flkty;
          }
        });
      }
    }, destroySliders2 = function() {
      if (window.innerWidth >= 1e3 && flktyInstances.length > 0) {
        flktyInstances.forEach((flkty) => {
          if (flkty) {
            flkty.destroy();
          }
        });
        flktyInstances = [];
      }
    };
    var toggleTab = toggleTab2, initializeSliders = initializeSliders2, destroySliders = destroySliders2;
    const firstTabBtn = document.querySelector(selectors$5.firstTabBtn);
    const tabFirst = document.querySelector(selectors$5.tabFirst);
    const secondTabBtn = document.querySelector(selectors$5.secondTabBtn);
    const tabSecond = document.querySelector(selectors$5.tabSecond);
    firstTabBtn == null ? void 0 : firstTabBtn.addEventListener("click", () => {
      toggleTab2(firstTabBtn, secondTabBtn, tabFirst, tabSecond);
    });
    secondTabBtn == null ? void 0 : secondTabBtn.addEventListener("click", () => {
      toggleTab2(secondTabBtn, firstTabBtn, tabSecond, tabFirst);
    });
    let flktyInstances = [];
    initializeSliders2();
    window.addEventListener("resize", function() {
      if (window.innerWidth < 1e3) {
        initializeSliders2();
      } else {
        destroySliders2();
      }
    });
  }
});
const selectors$4 = {
  carouselContainer: ".product-carousel__body",
  carouselProducts: ".product-carousel__product",
  featuredProducts: ".product.product-carousel__product-wrapper",
  prevButton: '.product-carousel__button[data-action="prev"]',
  nextButton: '.product-carousel__button[data-action="next"]'
};
const carouselProducts = document.querySelectorAll(selectors$4.carouselProducts);
const featuredProducts = document.querySelectorAll(selectors$4.featuredProducts);
const prevButton = document.querySelector(selectors$4.prevButton);
const nextButton = document.querySelector(selectors$4.nextButton);
let carouselContainer = document.querySelector(selectors$4.carouselContainer);
let isScrollCarouselEnabled = null;
function goToNextProduct() {
  let currentIndex = Array.from(carouselProducts).findIndex((prod) => prod.getAttribute("data-selected") === "true");
  let nextIndex = (currentIndex + 1) % carouselProducts.length;
  updateSelection(nextIndex);
}
function goToPrevProduct() {
  let currentIndex = Array.from(carouselProducts).findIndex((prod) => prod.getAttribute("data-selected") === "true");
  let prevIndex = (currentIndex - 1 + carouselProducts.length) % carouselProducts.length;
  updateSelection(prevIndex);
}
function updateSelection(newIndex) {
  carouselProducts.forEach((prod, index) => {
    prod.setAttribute("data-selected", "false");
    featuredProducts[index].setAttribute("data-selected", "false");
  });
  carouselProducts[newIndex].setAttribute("data-selected", "true");
  featuredProducts[newIndex].setAttribute("data-selected", "true");
  const container = carouselProducts[newIndex].parentElement;
  const containerWidth = container.offsetWidth;
  const itemLeft = carouselProducts[newIndex].offsetLeft;
  const itemRight = itemLeft + carouselProducts[newIndex].offsetWidth;
  if (itemLeft < container.scrollLeft) {
    container.scrollLeft = itemLeft - 40;
  } else if (itemRight > container.scrollLeft + containerWidth) {
    container.scrollLeft = itemRight - containerWidth + 40;
  }
  window.dispatchEvent(new Event("resize", { bubbles: true }));
}
function isScrollEnabled(container) {
  if (container) {
    return container.scrollWidth > container.clientWidth;
  }
}
if (carouselContainer) {
  isScrollCarouselEnabled = isScrollEnabled(carouselContainer);
  carouselContainer == null ? void 0 : carouselContainer.setAttribute("data-scroll", isScrollCarouselEnabled);
}
window.addEventListener("resize", () => {
  carouselContainer = document.querySelector(selectors$4.carouselContainer);
  if (carouselContainer) {
    isScrollCarouselEnabled = isScrollEnabled(carouselContainer);
    carouselContainer.setAttribute("data-scroll", isScrollCarouselEnabled);
  }
});
if (carouselProducts && featuredProducts) {
  carouselProducts.forEach((product, index) => {
    product.addEventListener("click", () => updateSelection(index));
  });
}
if (prevButton && nextButton) {
  prevButton.addEventListener("click", goToPrevProduct);
  nextButton.addEventListener("click", goToNextProduct);
}
function updateFlickityConfig(carousel) {
  if (!carousel) return;
  carousel.flickityInstance.then((instance) => {
    if (!instance) return;
    const isMobile = window.innerWidth < 1e3;
    instance.options.contain = !isMobile;
    instance.options.cellAlign = isMobile ? "left" : "center";
    instance.reposition();
    updateButtonStates(carousel, instance);
  }).catch(() => {
  });
}
function updateButtonStates(carousel, instance) {
  if (!instance || !carousel) return;
  const carouselId = carousel.id;
  const controls = document.querySelector(`flickity-controls[controls="${carouselId}"]`);
  if (!controls) return;
  const prevButton2 = controls.querySelector('[data-action="prev"]');
  const nextButton2 = controls.querySelector('[data-action="next"]');
  if (!prevButton2 || !nextButton2) return;
  const currentIndex = instance.selectedIndex;
  const totalSlides = instance.slides ? instance.slides.length : instance.cells.length;
  prevButton2.disabled = currentIndex === 0;
  nextButton2.disabled = currentIndex >= totalSlides - 1;
}
function initProductMediaFlickity() {
  const carousels = document.querySelectorAll(".product__media-list");
  carousels.forEach((carousel) => {
    if (carousel.hasAttribute("data-flickity-initialized")) return;
    carousel.setAttribute("data-flickity-initialized", "true");
    setTimeout(() => updateFlickityConfig(carousel), 100);
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => updateFlickityConfig(carousel), 150);
    });
    carousel.addEventListener("flickity:ready", () => updateFlickityConfig(carousel));
    carousel.addEventListener("flickity:slide-changed", () => {
      carousel.flickityInstance.then((instance) => {
        updateButtonStates(carousel, instance);
      }).catch(() => {
      });
    });
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductMediaFlickity);
} else {
  initProductMediaFlickity();
}
const boxBuilder = document.querySelector(".box-builder-banner");
const getStartedBtn = document.querySelectorAll(".getStartedBtn");
if (getStartedBtn.length > 0 && boxBuilder) {
  const boxBuilderHeight = boxBuilder.offsetHeight;
  getStartedBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
      window.scrollTo({
        top: boxBuilderHeight + 1,
        behavior: "smooth"
      });
    });
  });
}
(() => {
  function waitFor(t, i, o = false, a = 1e4, e = 25) {
    a < 0 || (t() ? i() : setTimeout(() => {
      o && waitFor(t, i, o, a, e);
      o || waitFor(t, i, o, a - e, e);
    }, e));
  }
  function q(s, o) {
    return document.querySelector(s);
  }
  function insert(target, position, element, exists) {
    if (!exists) {
      typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
    }
  }
  var VAR = "1";
  var EXPID = "HLY-7";
  function testInfo() {
    window.runningExperiments = window.runningExperiments || {};
    window.runningExperiments[EXPID] = {
      name: "Add paypal badge to USP section on PDP",
      variation: `${VAR}`,
      logs: []
    };
    waitFor(
      () => q("body"),
      () => {
        q("body").classList.add(`${EXPID}`);
      }
    );
  }
  function insertPaypalSection() {
    const paypalSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
    <path d="M15.1658 9.84595C14.9826 9.8461 14.8055 9.91158 14.6662 10.0306C14.5269 10.1497 14.4347 10.3145 14.406 10.4955L13.1436 18.5026C13.2024 18.1287 13.5246 17.8531 13.9034 17.8531H17.6028C21.3261 17.8531 24.4854 15.137 25.0627 11.4562C25.1057 11.1814 25.13 10.9041 25.1356 10.626C24.1894 10.1298 23.0779 9.84595 21.86 9.84595H15.1658Z" fill="#001C64"/>
    <path d="M25.1358 10.6265C25.1302 10.9045 25.1059 11.1819 25.0629 11.4567C24.4856 15.1375 21.326 17.8536 17.603 17.8536H13.9035C13.5251 17.8536 13.2026 18.1289 13.1437 18.5031L11.9829 25.861L11.2558 30.477C11.2416 30.5662 11.2469 30.6574 11.2714 30.7443C11.2959 30.8312 11.3389 30.9118 11.3976 30.9805C11.4562 31.0491 11.5291 31.1043 11.6111 31.1421C11.6931 31.1798 11.7823 31.1994 11.8726 31.1994H15.8881C16.0713 31.1992 16.2485 31.1337 16.3877 31.0147C16.527 30.8956 16.6193 30.7308 16.6479 30.5498L17.7056 23.8414C17.7342 23.6604 17.8266 23.4955 17.966 23.3764C18.1054 23.2573 18.2827 23.1919 18.466 23.1919H20.8301C24.5534 23.1919 27.7127 20.4758 28.29 16.795C28.7 14.1827 27.3843 11.8054 25.1358 10.6265Z" fill="#0070E0"/>
    <path d="M10.6041 4.50854C10.2257 4.50854 9.90319 4.78381 9.84433 5.15748L6.6933 25.1385C6.63355 25.5178 6.92666 25.8609 7.31073 25.8609H11.9835L13.1437 18.5029L14.4062 10.4958C14.4348 10.3148 14.5271 10.15 14.6663 10.0309C14.8056 9.91189 14.9828 9.8464 15.166 9.84625H21.8601C23.0783 9.84625 24.1895 10.1304 25.1357 10.6263C25.2005 7.2752 22.4353 4.50854 18.6336 4.50854H10.6041Z" fill="#003087"/>
  </svg>
    `;
    const paypalSection = `<div class="${EXPID}__paypal-container text_content text_content--usp text_content--full">
    <div class="${EXPID}__paypal-visible-section" style="display: flex;">
      <div class="${EXPID}__svg">${paypalSVG}</div>
      <div class="${EXPID}__paypal-text">Bezahle nach <br> 30 Tagen</div>
    </div>
    <div id="${EXPID}__paypal-section" >
      <div style="text-align:center" 
          data-pp-message
          data-pp-buyerCountry="DE"
          data-pp-amount="10.99"
          data-pp-placement="cart"
          data-pp-style-layout="text"
          data-pp-style-logo-type="alternative"
          data-pp-style-text-color="black"
          data-pp-style-text-size="9"
          data-pp-style-text-align="right">
      </div>
    </div>
  </div>`;
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://www.paypal.com/sdk/js?client-id=AQMcCMPtGI5E_PtXfx-geaeFabK2E9Bd87VHtWjV4ryNgh8ZGvQ2B5_4DD0PZYsJAlQgrE-RBmE_tp2v&locale=de_DE&components=messages&enable-funding=paylater"
    );
    script.setAttribute("data-namespace", "paypal_sdk");
    waitFor(
      () => q("head") && q(".product-form .delivery_text"),
      () => {
        insert(q("head"), "beforeend", script, q('script[src*="paypal.com/sdk/js"]'));
        insert(q(".product-form .delivery_text"), "afterbegin", paypalSection, q(`.${EXPID}__paypal-container`));
      }
    );
  }
  const showPayPal = document.querySelector("[data-pay-pal-badge]");
  if (showPayPal && showPayPal.getAttribute("data-pay-pal-badge") === "true") {
    testInfo();
    insertPaypalSection();
  }
})();
window.openVideoModal = (videoUrl, productId) => {
  const modal = document.getElementById("dsVideoModal--" + productId);
  const video = document.getElementById("dsModalVideo--" + productId);
  const source = video.querySelector("source");
  source.src = videoUrl;
  video.load();
  modal.style.display = "flex";
  const openFullscreen = (el) => {
    if (el.requestFullscreen) return el.requestFullscreen();
    if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
    if (el.msRequestFullscreen) return el.msRequestFullscreen();
    return Promise.reject("Fullscreen API is not supported");
  };
  const isFullscreen = () => document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
  const onFullscreenChange = () => {
    if (!isFullscreen()) {
      window.closeVideoModal(productId);
    }
  };
  if (window.innerWidth <= 768) {
    setTimeout(() => {
      openFullscreen(video).catch((err) => {
        console.warn("Fullscreen denied:", err);
      });
    }, 100);
  }
  modal.onclick = function(event) {
    if (event.target === modal && !isFullscreen()) {
      window.closeVideoModal(productId);
    }
  };
  document.addEventListener("fullscreenchange", onFullscreenChange);
  document.addEventListener("webkitfullscreenchange", onFullscreenChange);
  video.addEventListener("webkitendfullscreen", onFullscreenChange);
  video._onFullscreenChange = onFullscreenChange;
};
window.closeVideoModal = (productId) => {
  const modal = document.getElementById("dsVideoModal--" + productId);
  const video = document.getElementById("dsModalVideo--" + productId);
  video.pause();
  modal.style.display = "none";
  const exitFullscreen = () => {
    if (document.exitFullscreen) return document.exitFullscreen();
    if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
    if (document.msExitFullscreen) return document.msExitFullscreen();
    return Promise.resolve();
  };
  if (document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
    exitFullscreen().catch((err) => {
      console.warn("Failed to exit fullscreen:", err);
    });
  }
  document.removeEventListener("fullscreenchange", video._onFullscreenChange);
  document.removeEventListener("webkitfullscreenchange", video._onFullscreenChange);
  video.removeEventListener("webkitendfullscreen", video._onFullscreenChange);
};
document.addEventListener("DOMContentLoaded", function() {
  const wrappers = document.querySelectorAll(".video-thumbnail-wrapper");
  wrappers.forEach((wrapper) => {
    const video = wrapper.querySelector("video");
    const pauseBtn = wrapper.querySelector(".button-pause");
    const muteBtn = wrapper.querySelector(".button-mute");
    pauseBtn.addEventListener("click", function() {
      if (video.paused) {
        video.play();
        pauseBtn.classList.remove("active");
      } else {
        video.pause();
        pauseBtn.classList.add("active");
      }
    });
    muteBtn.addEventListener("click", function() {
      if (video.muted) {
        video.muted = false;
        video.removeAttribute("muted");
        muteBtn.classList.remove("active");
      } else {
        video.muted = true;
        video.setAttribute("muted", "");
        muteBtn.classList.add("active");
      }
    });
  });
});
window.openFlavourPopup = (productId) => {
  const popup = document.getElementById("dsFlavourPopup--" + productId);
  if (!popup) {
    console.warn("Flavour popup not found for product:", productId);
    return;
  }
  const content = popup.querySelector(".ds-flavour-popup__content");
  if (content && !content.hasAttribute("data-swipe-initialized")) {
    content.setAttribute("data-swipe-initialized", "true");
    let startY = 0;
    let startX = 0;
    let isDragging = false;
    const SWIPE_THRESHOLD = 80;
    const onTouchStart = (event) => {
      if (event.touches.length !== 1) return;
      const touch = event.touches[0];
      startY = touch.clientY;
      startX = touch.clientX;
      isDragging = true;
    };
    const onTouchEnd = (event) => {
      if (!isDragging) return;
      isDragging = false;
      if (!event.changedTouches || event.changedTouches.length === 0) return;
      const touch = event.changedTouches[0];
      const deltaY = touch.clientY - startY;
      const deltaX = Math.abs(touch.clientX - startX);
      if (deltaY > SWIPE_THRESHOLD && deltaY > deltaX && window.closeFlavourPopup) {
        window.closeFlavourPopup(productId);
      }
    };
    const onTouchCancel = () => {
      isDragging = false;
    };
    content.addEventListener("touchstart", onTouchStart, { passive: true });
    content.addEventListener("touchend", onTouchEnd);
    content.addEventListener("touchcancel", onTouchCancel);
  }
  popup.classList.remove("is-closing");
  document.documentElement.classList.add("ds-flavour-popup-open");
  requestAnimationFrame(() => {
    popup.classList.add("is-open");
  });
  const handleEscape = (event) => {
    if (event.key === "Escape") {
      window.closeFlavourPopup(productId);
      document.removeEventListener("keydown", handleEscape);
    }
  };
  document.addEventListener("keydown", handleEscape);
  popup._handleEscape = handleEscape;
};
window.closeFlavourPopup = (productId) => {
  const popup = document.getElementById("dsFlavourPopup--" + productId);
  if (!popup) {
    return;
  }
  const isMobile = window.matchMedia("(max-width: 740px)").matches;
  popup.classList.remove("is-open");
  popup.classList.add("is-closing");
  const animationDuration = isMobile ? 500 : 200;
  setTimeout(() => {
    popup.classList.remove("is-closing");
    document.documentElement.classList.remove("ds-flavour-popup-open");
  }, animationDuration);
  if (popup._handleEscape) {
    document.removeEventListener("keydown", popup._handleEscape);
    delete popup._handleEscape;
  }
};
function initFlavourSelectionBlocks() {
  const flavourSelectionBlocks = document.querySelectorAll(".ds-flavour-selection-block");
  flavourSelectionBlocks.forEach((block) => {
    var _a;
    if (block.hasAttribute("data-initialized")) return;
    block.setAttribute("data-initialized", "true");
    let productId = block.dataset.productId;
    if (!productId) {
      const popup = (_a = block.closest(".product__info-redesign")) == null ? void 0 : _a.querySelector(".ds-flavour-popup");
      if (popup) {
        productId = popup.dataset.productId;
      } else {
        const allPopups = document.querySelectorAll(".ds-flavour-popup[data-product-id]");
        if (allPopups.length > 0) {
          productId = allPopups[0].dataset.productId;
        }
      }
    }
    if (productId) {
      block.addEventListener("click", (event) => {
        event.preventDefault();
        window.openFlavourPopup(productId);
      });
      block.setAttribute("role", "button");
      block.setAttribute("tabindex", "0");
      block.setAttribute("aria-label", "Open flavour selection");
      block.style.cursor = "pointer";
      block.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          window.openFlavourPopup(productId);
        }
      });
    }
  });
}
document.addEventListener("DOMContentLoaded", initFlavourSelectionBlocks);
if (document.readyState !== "loading") {
  initFlavourSelectionBlocks();
}
document.addEventListener("click", (event) => {
  const productLink = event.target.closest(".ds-flavour-popup__link");
  if (!productLink) return;
});
document.addEventListener("click", (event) => {
  const dropdownTrigger = event.target.closest("[data-open-flavour-popup]");
  if (dropdownTrigger) {
    const productId = dropdownTrigger.getAttribute("data-open-flavour-popup");
    if (productId) {
      event.preventDefault();
      window.openFlavourPopup(productId);
    }
  }
});
const POPUP_CLOSE_MS = { desktop: 200, mobile: 500 };
const getPopups = () => document.querySelectorAll(".ds-flavour-popup--variant");
const getOpenPopupId = () => document.documentElement.getAttribute("data-ds-open-popup");
window.openVariantPopup = (optionId) => {
  const popup = document.getElementById("dsVariantPopup--" + optionId);
  if (!popup) return;
  popup.classList.remove("is-closing");
  document.documentElement.classList.add("ds-flavour-popup-open");
  document.documentElement.setAttribute("data-ds-open-popup", optionId);
  requestAnimationFrame(() => popup.classList.add("is-open"));
  const content = popup.querySelector(".ds-flavour-popup__content");
  if (content && !content.hasAttribute("data-swipe-initialized")) {
    content.setAttribute("data-swipe-initialized", "true");
    let startY = 0;
    let startX = 0;
    let isDragging = false;
    const SWIPE_THRESHOLD = 80;
    const onTouchStart = (event) => {
      if (event.touches.length !== 1) return;
      const touch = event.touches[0];
      startY = touch.clientY;
      startX = touch.clientX;
      isDragging = true;
    };
    const onTouchEnd = (event) => {
      if (!isDragging) return;
      isDragging = false;
      if (!event.changedTouches || event.changedTouches.length === 0) return;
      const touch = event.changedTouches[0];
      const deltaY = touch.clientY - startY;
      const deltaX = Math.abs(touch.clientX - startX);
      if (deltaY > SWIPE_THRESHOLD && deltaY > deltaX && window.closeVariantPopup) {
        window.closeVariantPopup(optionId);
      }
    };
    const onTouchCancel = () => {
      isDragging = false;
    };
    content.addEventListener("touchstart", onTouchStart, { passive: true });
    content.addEventListener("touchend", onTouchEnd);
    content.addEventListener("touchcancel", onTouchCancel);
  }
};
window.closeVariantPopup = (optionId) => {
  const popup = document.getElementById("dsVariantPopup--" + optionId);
  if (!popup) return;
  const ms = window.matchMedia("(max-width: 740px)").matches ? POPUP_CLOSE_MS.mobile : POPUP_CLOSE_MS.desktop;
  popup.classList.remove("is-open");
  popup.classList.add("is-closing");
  setTimeout(() => {
    popup.classList.remove("is-closing");
    document.documentElement.classList.remove("ds-flavour-popup-open");
    document.documentElement.removeAttribute("data-ds-open-popup");
  }, ms);
};
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape" && getOpenPopupId()) window.closeVariantPopup(getOpenPopupId());
});
function setVariantPopupActive(variantId) {
  const id = String(variantId);
  getPopups().forEach((popup) => {
    popup.querySelectorAll(".ds-flavour-popup__item").forEach((item) => {
      var _a;
      const isActive = item.getAttribute("data-variant-id") === id;
      item.classList.toggle("ds-flavour-popup__item--active", isActive);
      (_a = item.querySelector(".ds-variant-popup__select")) == null ? void 0 : _a.classList.toggle("current", isActive);
    });
  });
}
function getVariantIdFromForm(formId) {
  const form = document.getElementById(formId);
  const idEl = (form == null ? void 0 : form.querySelector('[name="id"]')) || document.querySelector('[name="id"][form="' + formId + '"]');
  return (idEl == null ? void 0 : idEl.value) || null;
}
function getFormIdForVariant(variantId) {
  var _a;
  const el = [...document.querySelectorAll('select[name="id"], input[name="id"]')].find((e) => e.value === String(variantId));
  return ((_a = el == null ? void 0 : el.form) == null ? void 0 : _a.id) || (el == null ? void 0 : el.getAttribute("form")) || null;
}
function updateDropdownCards(formId, variantId, optionValue) {
  const selector = formId ? '.product-variant-selector__dropdown-cards[data-form-id="' + formId + '"]' : ".product-variant-selector__dropdown-cards";
  const match = variantId != null ? (card) => card.getAttribute("data-variant-id") === String(variantId) : optionValue != null ? (card) => card.getAttribute("data-option-value") === optionValue : () => false;
  document.querySelectorAll(selector).forEach((container) => {
    container.querySelectorAll(".dropdown-variant-card").forEach((card) => card.classList.toggle("is-selected", match(card)));
  });
}
function syncBlockSwatchDisabled() {
  document.querySelectorAll(".product-variant-selector .block-swatch").forEach((el) => {
    const input = el.querySelector("input[data-variant-available]");
    if (input) el.classList.toggle("is-disabled", input.getAttribute("data-variant-available") === "false");
  });
  document.querySelectorAll(".dropdown-variant-card[data-variant-available]").forEach((card) => {
    card.classList.toggle("is-disabled", card.getAttribute("data-variant-available") === "false");
  });
}
document.addEventListener("click", (e) => {
  const open = e.target.closest("[data-open-variant-popup]");
  if (open) {
    e.preventDefault();
    window.openVariantPopup(open.getAttribute("data-open-variant-popup"));
    return;
  }
  const close = e.target.closest("[data-close-variant-popup]");
  if (close) {
    e.preventDefault();
    window.closeVariantPopup(close.getAttribute("data-close-variant-popup"));
    return;
  }
  const btn = e.target.closest(".ds-variant-popup__select");
  if (!btn) return;
  const popup = btn.closest(".ds-flavour-popup--variant");
  if (!(popup == null ? void 0 : popup.classList.contains("is-open"))) return;
  e.preventDefault();
  e.stopPropagation();
  const variantId = btn.getAttribute("data-variant-id");
  const formId = popup.getAttribute("data-form-id");
  const optionId = popup.getAttribute("data-option-id");
  if (!variantId) return;
  const pv = document.querySelector('product-variants[form-id="' + formId + '"]');
  if (pv == null ? void 0 : pv.selectVariant) pv.selectVariant(parseInt(variantId, 10));
  else {
    const form = document.getElementById(formId);
    const pos = popup.getAttribute("data-option-position");
    const select = document.getElementById(optionId + "-select") || (form == null ? void 0 : form.querySelector('select[name="option' + pos + '"]'));
    const idEl = (form == null ? void 0 : form.querySelector('[name="id"]')) || document.querySelector('[name="id"][form="' + formId + '"]');
    const val = btn.getAttribute("data-option-value");
    if (select) {
      select.value = val;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (idEl) idEl.value = variantId;
  }
  const span = document.getElementById(optionId + "-value");
  if (span) {
    span.textContent = btn.getAttribute("data-option-value");
    span.setAttribute("variant-title", span.textContent);
  }
  window.closeVariantPopup(optionId);
  updateDropdownCards(formId, variantId);
});
document.addEventListener("change", (e) => {
  var _a, _b, _c;
  const el = e.target;
  if (!((_b = (_a = el == null ? void 0 : el.getAttribute) == null ? void 0 : _a.call(el, "name")) == null ? void 0 : _b.startsWith("option"))) return;
  const formId = ((_c = el.form) == null ? void 0 : _c.id) || el.getAttribute("form");
  if (!formId) return;
  setTimeout(() => {
    const variantId = getVariantIdFromForm(formId);
    updateDropdownCards(formId, variantId || void 0, variantId ? void 0 : el.value);
  }, 50);
});
document.addEventListener("variant:changed", onVariantChanged);
document.addEventListener("variant:changed:cdp", onVariantChanged);
window.addEventListener("flickity:slide-changed-element-selected", (e) => {
  var _a, _b, _c, _d, _e, _f;
  const id = ((_c = (_b = (_a = e.detail) == null ? void 0 : _a.selectedElement) == null ? void 0 : _b.getAttribute) == null ? void 0 : _c.call(_b, "variant_id")) || ((_f = (_e = (_d = e.detail) == null ? void 0 : _d.selectedElement) == null ? void 0 : _e.getAttribute) == null ? void 0 : _f.call(_e, "variant_Id"));
  if (id) {
    setVariantPopupActive(id);
    updateDropdownCards(null, id);
    syncBlockSwatchDisabled();
  }
});
function onVariantChanged(e) {
  var _a, _b, _c, _d, _e, _f;
  const variant = (_a = e.detail) == null ? void 0 : _a.variant;
  if (!variant) return;
  setVariantPopupActive(variant.id);
  const formId = ((_b = e.target) == null ? void 0 : _b.id) || ((_f = (_e = (_d = (_c = e.target) == null ? void 0 : _c.closest) == null ? void 0 : _d.call(_c, "product-variants")) == null ? void 0 : _e.getAttribute) == null ? void 0 : _f.call(_e, "form-id")) || getFormIdForVariant(variant.id);
  updateDropdownCards(formId, variant.id);
  const options = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
  const popups = formId ? document.querySelectorAll('.ds-flavour-popup--variant[data-form-id="' + formId + '"]') : getPopups();
  popups.forEach((popup) => {
    const pos = parseInt(popup.getAttribute("data-option-position"), 10);
    const val = options[pos - 1];
    const optId = popup.getAttribute("data-option-id");
    const select = document.getElementById(optId + "-select");
    if (select && val != null) select.value = val;
    const span = document.getElementById(optId + "-value");
    if (span && val != null) {
      span.textContent = val;
      span.setAttribute("variant-title", val);
    }
  });
}
function initDropdownCards() {
  syncBlockSwatchDisabled();
  document.querySelectorAll(".product-variant-selector__dropdown-cards[data-form-id]").forEach((container) => {
    const formId = container.getAttribute("data-form-id");
    const variantId = getVariantIdFromForm(formId);
    if (variantId) updateDropdownCards(formId, variantId);
  });
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initDropdownCards);
else initDropdownCards();
function initMMBannerModals() {
  const openButtons = document.querySelectorAll(".js-ds-m-m-open-modal");
  openButtons.forEach((openBtn) => {
    const modalId = openBtn.getAttribute("aria-controls");
    if (!modalId) return;
    const modal = document.getElementById(modalId);
    if (!modal) return;
    const closeBtns = modal.querySelectorAll(".js-ds-m-m-close-modal");
    function closeModal() {
      modal.hidden = true;
      modal.classList.remove("ds-m-m-modal--open");
      openBtn.setAttribute("aria-expanded", "false");
      document.documentElement.style.overflow = "";
      document.removeEventListener("keydown", handleEscape);
    }
    function handleEscape(e) {
      if (e.key === "Escape") closeModal();
    }
    function openModal() {
      modal.hidden = false;
      modal.classList.add("ds-m-m-modal--open");
      openBtn.setAttribute("aria-expanded", "true");
      document.documentElement.style.overflow = "hidden";
      document.addEventListener("keydown", handleEscape);
    }
    openBtn.addEventListener("click", openModal);
    closeBtns.forEach((btn) => btn.addEventListener("click", closeModal));
  });
}
document.addEventListener("DOMContentLoaded", initMMBannerModals);
const mobileDrawer = document.getElementById("mobile-menu-drawer");
function observeSelector() {
  const detailsEl = mobileDrawer.querySelector("details");
  if (detailsEl) {
    detailsEl.addEventListener("toggle", () => {
      if (detailsEl.open) {
        mobileDrawer.classList.add("overlay");
      } else {
        mobileDrawer.classList.remove("overlay");
      }
    });
  }
}
function calculateContentWrapperHeight() {
  if (!mobileDrawer) return;
  const contentWrapper = mobileDrawer.querySelector(".drawer__content");
  if (!contentWrapper) return;
  const updateHeight = () => {
    const height = contentWrapper.offsetHeight;
    mobileDrawer.style.setProperty("--drawer-content-height", `${height}px`);
  };
  updateHeight();
  const observer = new MutationObserver(() => {
    if (mobileDrawer.hasAttribute("open")) {
      setTimeout(updateHeight, 100);
    }
  });
  observer.observe(mobileDrawer, {
    attributes: true,
    attributeFilter: ["open"]
  });
  window.addEventListener("resize", updateHeight);
  const contentObserver = new ResizeObserver(updateHeight);
  contentObserver.observe(contentWrapper);
}
if (mobileDrawer) {
  observeSelector();
  calculateContentWrapperHeight();
}
document.addEventListener("DOMContentLoaded", () => {
  let header = document.querySelector(".ds-header");
  let dsNavigation = document.querySelector(".dsStickyNavigation");
  if (header && dsNavigation) {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio === 0) {
          dsNavigation.classList.add("is-sticky");
        } else {
          dsNavigation.classList.remove("is-sticky");
        }
      });
    }, { threshold: [0] });
    observer.observe(header);
  }
});
function initMegaMenuCampaignSlider() {
  if (window.innerWidth <= 1199) return;
  const campaignSliders = document.querySelectorAll(".mega-menu__campaign");
  if (!campaignSliders.length) return;
  campaignSliders.forEach((campaignContainer) => {
    const wrapper = campaignContainer.querySelector(".mega-menu__campaign-wrapper");
    const prevButton2 = campaignContainer.querySelector(".mega-menu__campaign-nav--prev");
    const nextButton2 = campaignContainer.querySelector(".mega-menu__campaign-nav--next");
    const cards = campaignContainer.querySelectorAll(".mega-menu__campaign-card");
    if (!wrapper || !prevButton2 || !nextButton2 || !cards.length) return;
    const cardWidth = cards[0].offsetWidth;
    const gap = 12;
    const scrollAmount = cardWidth + gap;
    function updateButtonState() {
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      const currentScroll = wrapper.scrollLeft;
      const eps = 2;
      prevButton2.disabled = currentScroll <= eps;
      nextButton2.disabled = currentScroll >= maxScroll - eps;
    }
    function scrollToNext() {
      const currentScroll = wrapper.scrollLeft;
      const targetScroll = currentScroll + scrollAmount;
      wrapper.scrollTo({
        left: targetScroll,
        behavior: "smooth"
      });
    }
    function scrollToPrev() {
      const currentScroll = wrapper.scrollLeft;
      const targetScroll = currentScroll - scrollAmount;
      wrapper.scrollTo({
        left: targetScroll,
        behavior: "smooth"
      });
    }
    prevButton2.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      scrollToPrev();
    });
    nextButton2.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      scrollToNext();
    });
    function updateCardOpacity() {
      if (window.innerWidth <= 1199) return;
      cards.forEach((card) => {
        const cardRect = card.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();
        const visibleLeft = Math.max(cardRect.left, wrapperRect.left);
        const visibleRight = Math.min(cardRect.right, wrapperRect.right);
        const visibleWidth = Math.max(0, visibleRight - visibleLeft);
        const cardWidth2 = cardRect.width;
        const visibilityPercentage = cardWidth2 > 0 ? visibleWidth / cardWidth2 * 100 : 0;
        if (visibilityPercentage < 50) {
          card.style.opacity = "0.2";
        } else {
          card.style.opacity = "1";
        }
      });
    }
    wrapper.addEventListener("scroll", () => {
      updateButtonState();
      updateCardOpacity();
    }, { passive: true });
    const resizeObserver = new ResizeObserver(() => {
      updateButtonState();
      updateCardOpacity();
    });
    resizeObserver.observe(wrapper);
    updateButtonState();
    updateCardOpacity();
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMegaMenuCampaignSlider);
} else {
  initMegaMenuCampaignSlider();
}
document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "hidden") {
        const megaMenu = mutation.target;
        if (megaMenu.classList.contains("mega-menu") && !megaMenu.hasAttribute("hidden")) {
          setTimeout(initMegaMenuCampaignSlider, 100);
        }
      }
    });
  });
  document.querySelectorAll(".mega-menu").forEach((megaMenu) => {
    observer.observe(megaMenu, { attributes: true });
  });
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initMegaMenuCampaignSlider();
    }, 100);
  });
});
(function() {
  const selectors2 = {
    menuItem: ".header__linklist-item.has-dropdown",
    menuLink: "[aria-controls]",
    megaMenuClass: "mega-menu",
    megaMenu: ".mega-menu",
    megaMenuInner: ".mega-menu__inner",
    desktopNavigation: "desktop-navigation",
    trianglePositionVar: "--triangle-position",
    panelShiftVar: "--panel-shift"
  };
  function centerTriangle(menuItem, megaMenuInner) {
    if (!menuItem || !megaMenuInner) return;
    const menuLink = menuItem.querySelector(selectors2.menuLink);
    if (!menuLink) return;
    const menuItemRect = menuLink.getBoundingClientRect();
    const megaMenuInnerRect = megaMenuInner.getBoundingClientRect();
    const menuItemCenter = menuItemRect.left + menuItemRect.width / 2;
    const isPanelCentered = megaMenuInner.getAttribute("data-panel-centered") === "true";
    if (isPanelCentered) {
      megaMenuInner.style.setProperty(selectors2.trianglePositionVar, "50%");
      const container = megaMenuInner.parentElement;
      if (container) {
        const containerRect = container.getBoundingClientRect();
        const containerStyle = window.getComputedStyle(container);
        const paddingLeft = parseFloat(containerStyle.paddingLeft) || 0;
        const contentLeft = containerRect.left + paddingLeft;
        const panelCenterOffset = menuItemCenter - contentLeft - megaMenuInnerRect.width / 2;
        megaMenuInner.style.setProperty(selectors2.panelShiftVar, `${panelCenterOffset}px`);
      }
    } else {
      const megaMenuInnerLeft = megaMenuInnerRect.left;
      const trianglePosition = (menuItemCenter - megaMenuInnerLeft) / megaMenuInnerRect.width * 100;
      const clampedPosition = Math.max(5, Math.min(95, trianglePosition));
      megaMenuInner.style.setProperty(selectors2.trianglePositionVar, `${clampedPosition}%`);
      megaMenuInner.style.setProperty(selectors2.panelShiftVar, "0px");
    }
  }
  function initTriangleCentering() {
    const menuItems = document.querySelectorAll(selectors2.menuItem);
    menuItems.forEach((menuItem) => {
      const menuLink = menuItem.querySelector(selectors2.menuLink);
      if (!menuLink) return;
      const megaMenuId = menuLink.getAttribute("aria-controls");
      if (!megaMenuId) return;
      const megaMenu = document.getElementById(megaMenuId);
      if (!megaMenu) return;
      if (!megaMenu.classList.contains(selectors2.megaMenuClass)) return;
      const megaMenuInner = megaMenu.querySelector(selectors2.megaMenuInner);
      if (!megaMenuInner) return;
      centerTriangle(menuItem, megaMenuInner);
    });
    document.addEventListener("desktop-nav:dropdown:open", (event) => {
      var _a, _b;
      const desktopNav = ((_b = (_a = event.target).closest) == null ? void 0 : _b.call(_a, selectors2.desktopNavigation)) || document.querySelector(selectors2.desktopNavigation);
      if (!desktopNav) return;
      const openMegaMenus = desktopNav.querySelectorAll(`${selectors2.megaMenu}:not([hidden])`);
      openMegaMenus.forEach((megaMenu) => {
        var _a2;
        const menuId = megaMenu.id;
        const menuItem = (_a2 = desktopNav.querySelector(`[aria-controls="${menuId}"]`)) == null ? void 0 : _a2.closest(selectors2.menuItem);
        if (!menuItem) return;
        const megaMenuInner = megaMenu.querySelector(selectors2.megaMenuInner);
        if (!megaMenuInner) return;
        setTimeout(() => {
          centerTriangle(menuItem, megaMenuInner);
        }, 100);
      });
    });
  }
  function updateAllTriangles() {
    const menuItems = document.querySelectorAll(selectors2.menuItem);
    menuItems.forEach((menuItem) => {
      const menuLink = menuItem.querySelector(selectors2.menuLink);
      if (!menuLink) return;
      const megaMenuId = menuLink.getAttribute("aria-controls");
      if (!megaMenuId) return;
      const megaMenu = document.getElementById(megaMenuId);
      if (!megaMenu || !megaMenu.classList.contains(selectors2.megaMenuClass)) return;
      const megaMenuInner = megaMenu.querySelector(selectors2.megaMenuInner);
      if (!megaMenuInner) return;
      if (!megaMenu.hasAttribute("hidden")) {
        centerTriangle(menuItem, megaMenuInner);
      }
    });
  }
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTriangleCentering);
  } else {
    initTriangleCentering();
  }
  const debouncedResize = debounce(updateAllTriangles, 150);
  window.addEventListener("resize", debouncedResize);
  window.addEventListener("orientationchange", () => {
    setTimeout(updateAllTriangles, 300);
  });
})();
const selectors$3 = {
  ratingStars: ".R-RatingStars-js",
  reviewStatistics: ".reviewStatistics-js"
};
const API_URL = "https://api.reviews.io/merchant/reviews?store=holyenergy.myshopify.com";
document.addEventListener("DOMContentLoaded", () => {
  fetch(API_URL).then((response) => response.json()).then((data) => {
    const { total_reviews, average_rating } = data.stats;
    const ratingStarsElements = document.querySelectorAll(selectors$3.ratingStars);
    if (ratingStarsElements && ratingStarsElements.length > 0) {
      ratingStarsElements.forEach((ratingStarsElement) => {
        const reviewStatisticsElement = ratingStarsElement.querySelector(selectors$3.reviewStatistics);
        if (reviewStatisticsElement) {
          const originalText = reviewStatisticsElement.textContent || reviewStatisticsElement.innerText;
          const updatedText = originalText.replace("{average_rating}", average_rating).replace("{total_reviews}", total_reviews.toLocaleString());
          reviewStatisticsElement.textContent = updatedText;
        }
        ratingStarsElement.style.display = "flex";
      });
    }
  }).catch((error) => {
    console.error("Error fetching reviews data:", error);
  });
});
/**
* @vue/shared v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function makeMap(str) {
  const map = /* @__PURE__ */ Object.create(null);
  for (const key of str.split(",")) map[key] = 1;
  return (val) => val in map;
}
const EMPTY_OBJ = {};
const EMPTY_ARR = [];
const NOOP = () => {
};
const NO = () => false;
const isOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
(key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const isModelListener = (key) => key.startsWith("onUpdate:");
const extend = Object.assign;
const remove = (arr, el) => {
  const i = arr.indexOf(el);
  if (i > -1) {
    arr.splice(i, 1);
  }
};
const hasOwnProperty$1 = Object.prototype.hasOwnProperty;
const hasOwn = (val, key) => hasOwnProperty$1.call(val, key);
const isArray = Array.isArray;
const isMap = (val) => toTypeString(val) === "[object Map]";
const isSet = (val) => toTypeString(val) === "[object Set]";
const isFunction = (val) => typeof val === "function";
const isString = (val) => typeof val === "string";
const isSymbol = (val) => typeof val === "symbol";
const isObject$1 = (val) => val !== null && typeof val === "object";
const isPromise$1 = (val) => {
  return (isObject$1(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value) => objectToString.call(value);
const toRawType = (value) => {
  return toTypeString(value).slice(8, -1);
};
const isPlainObject = (val) => toTypeString(val) === "[object Object]";
const isIntegerKey = (key) => isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const isReservedProp = /* @__PURE__ */ makeMap(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
);
const cacheStringFunction = (fn) => {
  const cache = /* @__PURE__ */ Object.create(null);
  return (str) => {
    const hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
};
const camelizeRE = /-(\w)/g;
const camelize = cacheStringFunction(
  (str) => {
    return str.replace(camelizeRE, (_, c) => c ? c.toUpperCase() : "");
  }
);
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction(
  (str) => str.replace(hyphenateRE, "-$1").toLowerCase()
);
const capitalize = cacheStringFunction((str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
});
const toHandlerKey = cacheStringFunction(
  (str) => {
    const s = str ? `on${capitalize(str)}` : ``;
    return s;
  }
);
const hasChanged = (value, oldValue) => !Object.is(value, oldValue);
const invokeArrayFns = (fns, ...arg) => {
  for (let i = 0; i < fns.length; i++) {
    fns[i](...arg);
  }
};
const def = (obj, key, value, writable = false) => {
  Object.defineProperty(obj, key, {
    configurable: true,
    enumerable: false,
    writable,
    value
  });
};
const looseToNumber = (val) => {
  const n = parseFloat(val);
  return isNaN(n) ? val : n;
};
let _globalThis;
const getGlobalThis = () => {
  return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
function normalizeStyle(value) {
  if (isArray(value)) {
    const res = {};
    for (let i = 0; i < value.length; i++) {
      const item = value[i];
      const normalized = isString(item) ? parseStringStyle(item) : normalizeStyle(item);
      if (normalized) {
        for (const key in normalized) {
          res[key] = normalized[key];
        }
      }
    }
    return res;
  } else if (isString(value) || isObject$1(value)) {
    return value;
  }
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:([^]+)/;
const styleCommentRE = /\/\*[^]*?\*\//g;
function parseStringStyle(cssText) {
  const ret = {};
  cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item) => {
    if (item) {
      const tmp = item.split(propertyDelimiterRE);
      tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return ret;
}
function normalizeClass(value) {
  let res = "";
  if (isString(value)) {
    res = value;
  } else if (isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      const normalized = normalizeClass(value[i]);
      if (normalized) {
        res += normalized + " ";
      }
    }
  } else if (isObject$1(value)) {
    for (const name in value) {
      if (value[name]) {
        res += name + " ";
      }
    }
  }
  return res.trim();
}
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
function includeBooleanAttr(value) {
  return !!value || value === "";
}
const isRef$1 = (val) => {
  return !!(val && val["__v_isRef"] === true);
};
const toDisplayString = (val) => {
  return isString(val) ? val : val == null ? "" : isArray(val) || isObject$1(val) && (val.toString === objectToString || !isFunction(val.toString)) ? isRef$1(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val) => {
  if (isRef$1(val)) {
    return replacer(_key, val.value);
  } else if (isMap(val)) {
    return {
      [`Map(${val.size})`]: [...val.entries()].reduce(
        (entries, [key, val2], i) => {
          entries[stringifySymbol(key, i) + " =>"] = val2;
          return entries;
        },
        {}
      )
    };
  } else if (isSet(val)) {
    return {
      [`Set(${val.size})`]: [...val.values()].map((v) => stringifySymbol(v))
    };
  } else if (isSymbol(val)) {
    return stringifySymbol(val);
  } else if (isObject$1(val) && !isArray(val) && !isPlainObject(val)) {
    return String(val);
  }
  return val;
};
const stringifySymbol = (v, i = "") => {
  var _a;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v
  );
};
/**
* @vue/reactivity v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let activeEffectScope;
class EffectScope {
  constructor(detached = false) {
    this.detached = detached;
    this._active = true;
    this.effects = [];
    this.cleanups = [];
    this._isPaused = false;
    this.parent = activeEffectScope;
    if (!detached && activeEffectScope) {
      this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(
        this
      ) - 1;
    }
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = true;
      let i, l;
      if (this.scopes) {
        for (i = 0, l = this.scopes.length; i < l; i++) {
          this.scopes[i].pause();
        }
      }
      for (i = 0, l = this.effects.length; i < l; i++) {
        this.effects[i].pause();
      }
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active) {
      if (this._isPaused) {
        this._isPaused = false;
        let i, l;
        if (this.scopes) {
          for (i = 0, l = this.scopes.length; i < l; i++) {
            this.scopes[i].resume();
          }
        }
        for (i = 0, l = this.effects.length; i < l; i++) {
          this.effects[i].resume();
        }
      }
    }
  }
  run(fn) {
    if (this._active) {
      const currentEffectScope = activeEffectScope;
      try {
        activeEffectScope = this;
        return fn();
      } finally {
        activeEffectScope = currentEffectScope;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    activeEffectScope = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    activeEffectScope = this.parent;
  }
  stop(fromParent) {
    if (this._active) {
      this._active = false;
      let i, l;
      for (i = 0, l = this.effects.length; i < l; i++) {
        this.effects[i].stop();
      }
      this.effects.length = 0;
      for (i = 0, l = this.cleanups.length; i < l; i++) {
        this.cleanups[i]();
      }
      this.cleanups.length = 0;
      if (this.scopes) {
        for (i = 0, l = this.scopes.length; i < l; i++) {
          this.scopes[i].stop(true);
        }
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !fromParent) {
        const last = this.parent.scopes.pop();
        if (last && last !== this) {
          this.parent.scopes[this.index] = last;
          last.index = this.index;
        }
      }
      this.parent = void 0;
    }
  }
}
function effectScope(detached) {
  return new EffectScope(detached);
}
function getCurrentScope() {
  return activeEffectScope;
}
let activeSub;
const pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class ReactiveEffect {
  constructor(fn) {
    this.fn = fn;
    this.deps = void 0;
    this.depsTail = void 0;
    this.flags = 1 | 4;
    this.next = void 0;
    this.cleanup = void 0;
    this.scheduler = void 0;
    if (activeEffectScope && activeEffectScope.active) {
      activeEffectScope.effects.push(this);
    }
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    if (this.flags & 64) {
      this.flags &= -65;
      if (pausedQueueEffects.has(this)) {
        pausedQueueEffects.delete(this);
        this.trigger();
      }
    }
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags & 2 && !(this.flags & 32)) {
      return;
    }
    if (!(this.flags & 8)) {
      batch(this);
    }
  }
  run() {
    if (!(this.flags & 1)) {
      return this.fn();
    }
    this.flags |= 2;
    cleanupEffect(this);
    prepareDeps(this);
    const prevEffect = activeSub;
    const prevShouldTrack = shouldTrack;
    activeSub = this;
    shouldTrack = true;
    try {
      return this.fn();
    } finally {
      cleanupDeps(this);
      activeSub = prevEffect;
      shouldTrack = prevShouldTrack;
      this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let link = this.deps; link; link = link.nextDep) {
        removeSub(link);
      }
      this.deps = this.depsTail = void 0;
      cleanupEffect(this);
      this.onStop && this.onStop();
      this.flags &= -2;
    }
  }
  trigger() {
    if (this.flags & 64) {
      pausedQueueEffects.add(this);
    } else if (this.scheduler) {
      this.scheduler();
    } else {
      this.runIfDirty();
    }
  }
  /**
   * @internal
   */
  runIfDirty() {
    if (isDirty(this)) {
      this.run();
    }
  }
  get dirty() {
    return isDirty(this);
  }
}
let batchDepth = 0;
let batchedSub;
let batchedComputed;
function batch(sub, isComputed = false) {
  sub.flags |= 8;
  if (isComputed) {
    sub.next = batchedComputed;
    batchedComputed = sub;
    return;
  }
  sub.next = batchedSub;
  batchedSub = sub;
}
function startBatch() {
  batchDepth++;
}
function endBatch() {
  if (--batchDepth > 0) {
    return;
  }
  if (batchedComputed) {
    let e = batchedComputed;
    batchedComputed = void 0;
    while (e) {
      const next = e.next;
      e.next = void 0;
      e.flags &= -9;
      e = next;
    }
  }
  let error;
  while (batchedSub) {
    let e = batchedSub;
    batchedSub = void 0;
    while (e) {
      const next = e.next;
      e.next = void 0;
      e.flags &= -9;
      if (e.flags & 1) {
        try {
          ;
          e.trigger();
        } catch (err) {
          if (!error) error = err;
        }
      }
      e = next;
    }
  }
  if (error) throw error;
}
function prepareDeps(sub) {
  for (let link = sub.deps; link; link = link.nextDep) {
    link.version = -1;
    link.prevActiveLink = link.dep.activeLink;
    link.dep.activeLink = link;
  }
}
function cleanupDeps(sub) {
  let head;
  let tail = sub.depsTail;
  let link = tail;
  while (link) {
    const prev = link.prevDep;
    if (link.version === -1) {
      if (link === tail) tail = prev;
      removeSub(link);
      removeDep(link);
    } else {
      head = link;
    }
    link.dep.activeLink = link.prevActiveLink;
    link.prevActiveLink = void 0;
    link = prev;
  }
  sub.deps = head;
  sub.depsTail = tail;
}
function isDirty(sub) {
  for (let link = sub.deps; link; link = link.nextDep) {
    if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) {
      return true;
    }
  }
  if (sub._dirty) {
    return true;
  }
  return false;
}
function refreshComputed(computed2) {
  if (computed2.flags & 4 && !(computed2.flags & 16)) {
    return;
  }
  computed2.flags &= -17;
  if (computed2.globalVersion === globalVersion) {
    return;
  }
  computed2.globalVersion = globalVersion;
  const dep = computed2.dep;
  computed2.flags |= 2;
  if (dep.version > 0 && !computed2.isSSR && computed2.deps && !isDirty(computed2)) {
    computed2.flags &= -3;
    return;
  }
  const prevSub = activeSub;
  const prevShouldTrack = shouldTrack;
  activeSub = computed2;
  shouldTrack = true;
  try {
    prepareDeps(computed2);
    const value = computed2.fn(computed2._value);
    if (dep.version === 0 || hasChanged(value, computed2._value)) {
      computed2._value = value;
      dep.version++;
    }
  } catch (err) {
    dep.version++;
    throw err;
  } finally {
    activeSub = prevSub;
    shouldTrack = prevShouldTrack;
    cleanupDeps(computed2);
    computed2.flags &= -3;
  }
}
function removeSub(link, soft = false) {
  const { dep, prevSub, nextSub } = link;
  if (prevSub) {
    prevSub.nextSub = nextSub;
    link.prevSub = void 0;
  }
  if (nextSub) {
    nextSub.prevSub = prevSub;
    link.nextSub = void 0;
  }
  if (dep.subs === link) {
    dep.subs = prevSub;
    if (!prevSub && dep.computed) {
      dep.computed.flags &= -5;
      for (let l = dep.computed.deps; l; l = l.nextDep) {
        removeSub(l, true);
      }
    }
  }
  if (!soft && !--dep.sc && dep.map) {
    dep.map.delete(dep.key);
  }
}
function removeDep(link) {
  const { prevDep, nextDep } = link;
  if (prevDep) {
    prevDep.nextDep = nextDep;
    link.prevDep = void 0;
  }
  if (nextDep) {
    nextDep.prevDep = prevDep;
    link.nextDep = void 0;
  }
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
  trackStack.push(shouldTrack);
  shouldTrack = false;
}
function resetTracking() {
  const last = trackStack.pop();
  shouldTrack = last === void 0 ? true : last;
}
function cleanupEffect(e) {
  const { cleanup } = e;
  e.cleanup = void 0;
  if (cleanup) {
    const prevSub = activeSub;
    activeSub = void 0;
    try {
      cleanup();
    } finally {
      activeSub = prevSub;
    }
  }
}
let globalVersion = 0;
class Link {
  constructor(sub, dep) {
    this.sub = sub;
    this.dep = dep;
    this.version = dep.version;
    this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class Dep {
  constructor(computed2) {
    this.computed = computed2;
    this.version = 0;
    this.activeLink = void 0;
    this.subs = void 0;
    this.map = void 0;
    this.key = void 0;
    this.sc = 0;
  }
  track(debugInfo) {
    if (!activeSub || !shouldTrack || activeSub === this.computed) {
      return;
    }
    let link = this.activeLink;
    if (link === void 0 || link.sub !== activeSub) {
      link = this.activeLink = new Link(activeSub, this);
      if (!activeSub.deps) {
        activeSub.deps = activeSub.depsTail = link;
      } else {
        link.prevDep = activeSub.depsTail;
        activeSub.depsTail.nextDep = link;
        activeSub.depsTail = link;
      }
      addSub(link);
    } else if (link.version === -1) {
      link.version = this.version;
      if (link.nextDep) {
        const next = link.nextDep;
        next.prevDep = link.prevDep;
        if (link.prevDep) {
          link.prevDep.nextDep = next;
        }
        link.prevDep = activeSub.depsTail;
        link.nextDep = void 0;
        activeSub.depsTail.nextDep = link;
        activeSub.depsTail = link;
        if (activeSub.deps === link) {
          activeSub.deps = next;
        }
      }
    }
    return link;
  }
  trigger(debugInfo) {
    this.version++;
    globalVersion++;
    this.notify(debugInfo);
  }
  notify(debugInfo) {
    startBatch();
    try {
      if (false) ;
      for (let link = this.subs; link; link = link.prevSub) {
        if (link.sub.notify()) {
          ;
          link.sub.dep.notify();
        }
      }
    } finally {
      endBatch();
    }
  }
}
function addSub(link) {
  link.dep.sc++;
  if (link.sub.flags & 4) {
    const computed2 = link.dep.computed;
    if (computed2 && !link.dep.subs) {
      computed2.flags |= 4 | 16;
      for (let l = computed2.deps; l; l = l.nextDep) {
        addSub(l);
      }
    }
    const currentTail = link.dep.subs;
    if (currentTail !== link) {
      link.prevSub = currentTail;
      if (currentTail) currentTail.nextSub = link;
    }
    link.dep.subs = link;
  }
}
const targetMap = /* @__PURE__ */ new WeakMap();
const ITERATE_KEY = Symbol(
  ""
);
const MAP_KEY_ITERATE_KEY = Symbol(
  ""
);
const ARRAY_ITERATE_KEY = Symbol(
  ""
);
function track(target, type, key) {
  if (shouldTrack && activeSub) {
    let depsMap = targetMap.get(target);
    if (!depsMap) {
      targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    }
    let dep = depsMap.get(key);
    if (!dep) {
      depsMap.set(key, dep = new Dep());
      dep.map = depsMap;
      dep.key = key;
    }
    {
      dep.track();
    }
  }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
  const depsMap = targetMap.get(target);
  if (!depsMap) {
    globalVersion++;
    return;
  }
  const run = (dep) => {
    if (dep) {
      {
        dep.trigger();
      }
    }
  };
  startBatch();
  if (type === "clear") {
    depsMap.forEach(run);
  } else {
    const targetIsArray = isArray(target);
    const isArrayIndex = targetIsArray && isIntegerKey(key);
    if (targetIsArray && key === "length") {
      const newLength = Number(newValue);
      depsMap.forEach((dep, key2) => {
        if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !isSymbol(key2) && key2 >= newLength) {
          run(dep);
        }
      });
    } else {
      if (key !== void 0 || depsMap.has(void 0)) {
        run(depsMap.get(key));
      }
      if (isArrayIndex) {
        run(depsMap.get(ARRAY_ITERATE_KEY));
      }
      switch (type) {
        case "add":
          if (!targetIsArray) {
            run(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              run(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          } else if (isArrayIndex) {
            run(depsMap.get("length"));
          }
          break;
        case "delete":
          if (!targetIsArray) {
            run(depsMap.get(ITERATE_KEY));
            if (isMap(target)) {
              run(depsMap.get(MAP_KEY_ITERATE_KEY));
            }
          }
          break;
        case "set":
          if (isMap(target)) {
            run(depsMap.get(ITERATE_KEY));
          }
          break;
      }
    }
  }
  endBatch();
}
function getDepFromReactive(object, key) {
  const depMap = targetMap.get(object);
  return depMap && depMap.get(key);
}
function reactiveReadArray(array) {
  const raw = toRaw(array);
  if (raw === array) return raw;
  track(raw, "iterate", ARRAY_ITERATE_KEY);
  return isShallow(array) ? raw : raw.map(toReactive);
}
function shallowReadArray(arr) {
  track(arr = toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
  return arr;
}
const arrayInstrumentations = {
  __proto__: null,
  [Symbol.iterator]() {
    return iterator(this, Symbol.iterator, toReactive);
  },
  concat(...args) {
    return reactiveReadArray(this).concat(
      ...args.map((x) => isArray(x) ? reactiveReadArray(x) : x)
    );
  },
  entries() {
    return iterator(this, "entries", (value) => {
      value[1] = toReactive(value[1]);
      return value;
    });
  },
  every(fn, thisArg) {
    return apply(this, "every", fn, thisArg, void 0, arguments);
  },
  filter(fn, thisArg) {
    return apply(this, "filter", fn, thisArg, (v) => v.map(toReactive), arguments);
  },
  find(fn, thisArg) {
    return apply(this, "find", fn, thisArg, toReactive, arguments);
  },
  findIndex(fn, thisArg) {
    return apply(this, "findIndex", fn, thisArg, void 0, arguments);
  },
  findLast(fn, thisArg) {
    return apply(this, "findLast", fn, thisArg, toReactive, arguments);
  },
  findLastIndex(fn, thisArg) {
    return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(fn, thisArg) {
    return apply(this, "forEach", fn, thisArg, void 0, arguments);
  },
  includes(...args) {
    return searchProxy(this, "includes", args);
  },
  indexOf(...args) {
    return searchProxy(this, "indexOf", args);
  },
  join(separator) {
    return reactiveReadArray(this).join(separator);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...args) {
    return searchProxy(this, "lastIndexOf", args);
  },
  map(fn, thisArg) {
    return apply(this, "map", fn, thisArg, void 0, arguments);
  },
  pop() {
    return noTracking(this, "pop");
  },
  push(...args) {
    return noTracking(this, "push", args);
  },
  reduce(fn, ...args) {
    return reduce(this, "reduce", fn, args);
  },
  reduceRight(fn, ...args) {
    return reduce(this, "reduceRight", fn, args);
  },
  shift() {
    return noTracking(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(fn, thisArg) {
    return apply(this, "some", fn, thisArg, void 0, arguments);
  },
  splice(...args) {
    return noTracking(this, "splice", args);
  },
  toReversed() {
    return reactiveReadArray(this).toReversed();
  },
  toSorted(comparer) {
    return reactiveReadArray(this).toSorted(comparer);
  },
  toSpliced(...args) {
    return reactiveReadArray(this).toSpliced(...args);
  },
  unshift(...args) {
    return noTracking(this, "unshift", args);
  },
  values() {
    return iterator(this, "values", toReactive);
  }
};
function iterator(self2, method, wrapValue) {
  const arr = shallowReadArray(self2);
  const iter = arr[method]();
  if (arr !== self2 && !isShallow(self2)) {
    iter._next = iter.next;
    iter.next = () => {
      const result = iter._next();
      if (result.value) {
        result.value = wrapValue(result.value);
      }
      return result;
    };
  }
  return iter;
}
const arrayProto = Array.prototype;
function apply(self2, method, fn, thisArg, wrappedRetFn, args) {
  const arr = shallowReadArray(self2);
  const needsWrap = arr !== self2 && !isShallow(self2);
  const methodFn = arr[method];
  if (methodFn !== arrayProto[method]) {
    const result2 = methodFn.apply(self2, args);
    return needsWrap ? toReactive(result2) : result2;
  }
  let wrappedFn = fn;
  if (arr !== self2) {
    if (needsWrap) {
      wrappedFn = function(item, index) {
        return fn.call(this, toReactive(item), index, self2);
      };
    } else if (fn.length > 2) {
      wrappedFn = function(item, index) {
        return fn.call(this, item, index, self2);
      };
    }
  }
  const result = methodFn.call(arr, wrappedFn, thisArg);
  return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function reduce(self2, method, fn, args) {
  const arr = shallowReadArray(self2);
  let wrappedFn = fn;
  if (arr !== self2) {
    if (!isShallow(self2)) {
      wrappedFn = function(acc, item, index) {
        return fn.call(this, acc, toReactive(item), index, self2);
      };
    } else if (fn.length > 3) {
      wrappedFn = function(acc, item, index) {
        return fn.call(this, acc, item, index, self2);
      };
    }
  }
  return arr[method](wrappedFn, ...args);
}
function searchProxy(self2, method, args) {
  const arr = toRaw(self2);
  track(arr, "iterate", ARRAY_ITERATE_KEY);
  const res = arr[method](...args);
  if ((res === -1 || res === false) && isProxy(args[0])) {
    args[0] = toRaw(args[0]);
    return arr[method](...args);
  }
  return res;
}
function noTracking(self2, method, args = []) {
  pauseTracking();
  startBatch();
  const res = toRaw(self2)[method].apply(self2, args);
  endBatch();
  resetTracking();
  return res;
}
const isNonTrackableKeys = /* @__PURE__ */ makeMap(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key) => key !== "arguments" && key !== "caller").map((key) => Symbol[key]).filter(isSymbol)
);
function hasOwnProperty(key) {
  if (!isSymbol(key)) key = String(key);
  const obj = toRaw(this);
  track(obj, "has", key);
  return obj.hasOwnProperty(key);
}
class BaseReactiveHandler {
  constructor(_isReadonly = false, _isShallow = false) {
    this._isReadonly = _isReadonly;
    this._isShallow = _isShallow;
  }
  get(target, key, receiver) {
    if (key === "__v_skip") return target["__v_skip"];
    const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_isShallow") {
      return isShallow2;
    } else if (key === "__v_raw") {
      if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) {
        return target;
      }
      return;
    }
    const targetIsArray = isArray(target);
    if (!isReadonly2) {
      let fn;
      if (targetIsArray && (fn = arrayInstrumentations[key])) {
        return fn;
      }
      if (key === "hasOwnProperty") {
        return hasOwnProperty;
      }
    }
    const res = Reflect.get(
      target,
      key,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      isRef(target) ? target : receiver
    );
    if (isSymbol(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) {
      return res;
    }
    if (!isReadonly2) {
      track(target, "get", key);
    }
    if (isShallow2) {
      return res;
    }
    if (isRef(res)) {
      return targetIsArray && isIntegerKey(key) ? res : res.value;
    }
    if (isObject$1(res)) {
      return isReadonly2 ? readonly(res) : reactive(res);
    }
    return res;
  }
}
class MutableReactiveHandler extends BaseReactiveHandler {
  constructor(isShallow2 = false) {
    super(false, isShallow2);
  }
  set(target, key, value, receiver) {
    let oldValue = target[key];
    if (!this._isShallow) {
      const isOldValueReadonly = isReadonly(oldValue);
      if (!isShallow(value) && !isReadonly(value)) {
        oldValue = toRaw(oldValue);
        value = toRaw(value);
      }
      if (!isArray(target) && isRef(oldValue) && !isRef(value)) {
        if (isOldValueReadonly) {
          return false;
        } else {
          oldValue.value = value;
          return true;
        }
      }
    }
    const hadKey = isArray(target) && isIntegerKey(key) ? Number(key) < target.length : hasOwn(target, key);
    const result = Reflect.set(
      target,
      key,
      value,
      isRef(target) ? target : receiver
    );
    if (target === toRaw(receiver)) {
      if (!hadKey) {
        trigger(target, "add", key, value);
      } else if (hasChanged(value, oldValue)) {
        trigger(target, "set", key, value);
      }
    }
    return result;
  }
  deleteProperty(target, key) {
    const hadKey = hasOwn(target, key);
    target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) {
      trigger(target, "delete", key, void 0);
    }
    return result;
  }
  has(target, key) {
    const result = Reflect.has(target, key);
    if (!isSymbol(key) || !builtInSymbols.has(key)) {
      track(target, "has", key);
    }
    return result;
  }
  ownKeys(target) {
    track(
      target,
      "iterate",
      isArray(target) ? "length" : ITERATE_KEY
    );
    return Reflect.ownKeys(target);
  }
}
class ReadonlyReactiveHandler extends BaseReactiveHandler {
  constructor(isShallow2 = false) {
    super(true, isShallow2);
  }
  set(target, key) {
    return true;
  }
  deleteProperty(target, key) {
    return true;
  }
}
const mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
const readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
const shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
const shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
const toShallow = (value) => value;
const getProto = (v) => Reflect.getPrototypeOf(v);
function createIterableMethod(method, isReadonly2, isShallow2) {
  return function(...args) {
    const target = this["__v_raw"];
    const rawTarget = toRaw(target);
    const targetIsMap = isMap(rawTarget);
    const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
    const isKeyOnly = method === "keys" && targetIsMap;
    const innerIterator = target[method](...args);
    const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
    !isReadonly2 && track(
      rawTarget,
      "iterate",
      isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY
    );
    return {
      // iterator protocol
      next() {
        const { value, done } = innerIterator.next();
        return done ? { value, done } : {
          value: isPair ? [wrap(value[0]), wrap(value[1])] : wrap(value),
          done
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function createReadonlyMethod(type) {
  return function(...args) {
    return type === "delete" ? false : type === "clear" ? void 0 : this;
  };
}
function createInstrumentations(readonly2, shallow) {
  const instrumentations = {
    get(key) {
      const target = this["__v_raw"];
      const rawTarget = toRaw(target);
      const rawKey = toRaw(key);
      if (!readonly2) {
        if (hasChanged(key, rawKey)) {
          track(rawTarget, "get", key);
        }
        track(rawTarget, "get", rawKey);
      }
      const { has } = getProto(rawTarget);
      const wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
      if (has.call(rawTarget, key)) {
        return wrap(target.get(key));
      } else if (has.call(rawTarget, rawKey)) {
        return wrap(target.get(rawKey));
      } else if (target !== rawTarget) {
        target.get(key);
      }
    },
    get size() {
      const target = this["__v_raw"];
      !readonly2 && track(toRaw(target), "iterate", ITERATE_KEY);
      return Reflect.get(target, "size", target);
    },
    has(key) {
      const target = this["__v_raw"];
      const rawTarget = toRaw(target);
      const rawKey = toRaw(key);
      if (!readonly2) {
        if (hasChanged(key, rawKey)) {
          track(rawTarget, "has", key);
        }
        track(rawTarget, "has", rawKey);
      }
      return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
    },
    forEach(callback, thisArg) {
      const observed = this;
      const target = observed["__v_raw"];
      const rawTarget = toRaw(target);
      const wrap = shallow ? toShallow : readonly2 ? toReadonly : toReactive;
      !readonly2 && track(rawTarget, "iterate", ITERATE_KEY);
      return target.forEach((value, key) => {
        return callback.call(thisArg, wrap(value), wrap(key), observed);
      });
    }
  };
  extend(
    instrumentations,
    readonly2 ? {
      add: createReadonlyMethod("add"),
      set: createReadonlyMethod("set"),
      delete: createReadonlyMethod("delete"),
      clear: createReadonlyMethod("clear")
    } : {
      add(value) {
        if (!shallow && !isShallow(value) && !isReadonly(value)) {
          value = toRaw(value);
        }
        const target = toRaw(this);
        const proto = getProto(target);
        const hadKey = proto.has.call(target, value);
        if (!hadKey) {
          target.add(value);
          trigger(target, "add", value, value);
        }
        return this;
      },
      set(key, value) {
        if (!shallow && !isShallow(value) && !isReadonly(value)) {
          value = toRaw(value);
        }
        const target = toRaw(this);
        const { has, get: get2 } = getProto(target);
        let hadKey = has.call(target, key);
        if (!hadKey) {
          key = toRaw(key);
          hadKey = has.call(target, key);
        }
        const oldValue = get2.call(target, key);
        target.set(key, value);
        if (!hadKey) {
          trigger(target, "add", key, value);
        } else if (hasChanged(value, oldValue)) {
          trigger(target, "set", key, value);
        }
        return this;
      },
      delete(key) {
        const target = toRaw(this);
        const { has, get: get2 } = getProto(target);
        let hadKey = has.call(target, key);
        if (!hadKey) {
          key = toRaw(key);
          hadKey = has.call(target, key);
        }
        get2 ? get2.call(target, key) : void 0;
        const result = target.delete(key);
        if (hadKey) {
          trigger(target, "delete", key, void 0);
        }
        return result;
      },
      clear() {
        const target = toRaw(this);
        const hadItems = target.size !== 0;
        const result = target.clear();
        if (hadItems) {
          trigger(
            target,
            "clear",
            void 0,
            void 0
          );
        }
        return result;
      }
    }
  );
  const iteratorMethods = [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ];
  iteratorMethods.forEach((method) => {
    instrumentations[method] = createIterableMethod(method, readonly2, shallow);
  });
  return instrumentations;
}
function createInstrumentationGetter(isReadonly2, shallow) {
  const instrumentations = createInstrumentations(isReadonly2, shallow);
  return (target, key, receiver) => {
    if (key === "__v_isReactive") {
      return !isReadonly2;
    } else if (key === "__v_isReadonly") {
      return isReadonly2;
    } else if (key === "__v_raw") {
      return target;
    }
    return Reflect.get(
      hasOwn(instrumentations, key) && key in target ? instrumentations : target,
      key,
      receiver
    );
  };
}
const mutableCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const shallowReadonlyCollectionHandlers = {
  get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
  switch (rawType) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function getTargetType(value) {
  return value["__v_skip"] || !Object.isExtensible(value) ? 0 : targetTypeMap(toRawType(value));
}
function reactive(target) {
  if (isReadonly(target)) {
    return target;
  }
  return createReactiveObject(
    target,
    false,
    mutableHandlers,
    mutableCollectionHandlers,
    reactiveMap
  );
}
function shallowReactive(target) {
  return createReactiveObject(
    target,
    false,
    shallowReactiveHandlers,
    shallowCollectionHandlers,
    shallowReactiveMap
  );
}
function readonly(target) {
  return createReactiveObject(
    target,
    true,
    readonlyHandlers,
    readonlyCollectionHandlers,
    readonlyMap
  );
}
function shallowReadonly(target) {
  return createReactiveObject(
    target,
    true,
    shallowReadonlyHandlers,
    shallowReadonlyCollectionHandlers,
    shallowReadonlyMap
  );
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
  if (!isObject$1(target)) {
    return target;
  }
  if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) {
    return target;
  }
  const existingProxy = proxyMap.get(target);
  if (existingProxy) {
    return existingProxy;
  }
  const targetType = getTargetType(target);
  if (targetType === 0) {
    return target;
  }
  const proxy = new Proxy(
    target,
    targetType === 2 ? collectionHandlers : baseHandlers
  );
  proxyMap.set(target, proxy);
  return proxy;
}
function isReactive(value) {
  if (isReadonly(value)) {
    return isReactive(value["__v_raw"]);
  }
  return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
  return !!(value && value["__v_isReadonly"]);
}
function isShallow(value) {
  return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
  return value ? !!value["__v_raw"] : false;
}
function toRaw(observed) {
  const raw = observed && observed["__v_raw"];
  return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
  if (!hasOwn(value, "__v_skip") && Object.isExtensible(value)) {
    def(value, "__v_skip", true);
  }
  return value;
}
const toReactive = (value) => isObject$1(value) ? reactive(value) : value;
const toReadonly = (value) => isObject$1(value) ? readonly(value) : value;
function isRef(r) {
  return r ? r["__v_isRef"] === true : false;
}
function ref(value) {
  return createRef(value, false);
}
function createRef(rawValue, shallow) {
  if (isRef(rawValue)) {
    return rawValue;
  }
  return new RefImpl(rawValue, shallow);
}
class RefImpl {
  constructor(value, isShallow2) {
    this.dep = new Dep();
    this["__v_isRef"] = true;
    this["__v_isShallow"] = false;
    this._rawValue = isShallow2 ? value : toRaw(value);
    this._value = isShallow2 ? value : toReactive(value);
    this["__v_isShallow"] = isShallow2;
  }
  get value() {
    {
      this.dep.track();
    }
    return this._value;
  }
  set value(newValue) {
    const oldValue = this._rawValue;
    const useDirectValue = this["__v_isShallow"] || isShallow(newValue) || isReadonly(newValue);
    newValue = useDirectValue ? newValue : toRaw(newValue);
    if (hasChanged(newValue, oldValue)) {
      this._rawValue = newValue;
      this._value = useDirectValue ? newValue : toReactive(newValue);
      {
        this.dep.trigger();
      }
    }
  }
}
function unref(ref2) {
  return isRef(ref2) ? ref2.value : ref2;
}
const shallowUnwrapHandlers = {
  get: (target, key, receiver) => key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver)),
  set: (target, key, value, receiver) => {
    const oldValue = target[key];
    if (isRef(oldValue) && !isRef(value)) {
      oldValue.value = value;
      return true;
    } else {
      return Reflect.set(target, key, value, receiver);
    }
  }
};
function proxyRefs(objectWithRefs) {
  return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
function toRefs(object) {
  const ret = isArray(object) ? new Array(object.length) : {};
  for (const key in object) {
    ret[key] = propertyToRef(object, key);
  }
  return ret;
}
class ObjectRefImpl {
  constructor(_object, _key, _defaultValue) {
    this._object = _object;
    this._key = _key;
    this._defaultValue = _defaultValue;
    this["__v_isRef"] = true;
    this._value = void 0;
  }
  get value() {
    const val = this._object[this._key];
    return this._value = val === void 0 ? this._defaultValue : val;
  }
  set value(newVal) {
    this._object[this._key] = newVal;
  }
  get dep() {
    return getDepFromReactive(toRaw(this._object), this._key);
  }
}
function propertyToRef(source, key, defaultValue) {
  const val = source[key];
  return isRef(val) ? val : new ObjectRefImpl(source, key, defaultValue);
}
class ComputedRefImpl {
  constructor(fn, setter, isSSR) {
    this.fn = fn;
    this.setter = setter;
    this._value = void 0;
    this.dep = new Dep(this);
    this.__v_isRef = true;
    this.deps = void 0;
    this.depsTail = void 0;
    this.flags = 16;
    this.globalVersion = globalVersion - 1;
    this.next = void 0;
    this.effect = this;
    this["__v_isReadonly"] = !setter;
    this.isSSR = isSSR;
  }
  /**
   * @internal
   */
  notify() {
    this.flags |= 16;
    if (!(this.flags & 8) && // avoid infinite self recursion
    activeSub !== this) {
      batch(this, true);
      return true;
    }
  }
  get value() {
    const link = this.dep.track();
    refreshComputed(this);
    if (link) {
      link.version = this.dep.version;
    }
    return this._value;
  }
  set value(newValue) {
    if (this.setter) {
      this.setter(newValue);
    }
  }
}
function computed$1(getterOrOptions, debugOptions, isSSR = false) {
  let getter;
  let setter;
  if (isFunction(getterOrOptions)) {
    getter = getterOrOptions;
  } else {
    getter = getterOrOptions.get;
    setter = getterOrOptions.set;
  }
  const cRef = new ComputedRefImpl(getter, setter, isSSR);
  return cRef;
}
const INITIAL_WATCHER_VALUE = {};
const cleanupMap = /* @__PURE__ */ new WeakMap();
let activeWatcher = void 0;
function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
  if (owner) {
    let cleanups = cleanupMap.get(owner);
    if (!cleanups) cleanupMap.set(owner, cleanups = []);
    cleanups.push(cleanupFn);
  }
}
function watch$1(source, cb, options = EMPTY_OBJ) {
  const { immediate, deep, once, scheduler, augmentJob, call } = options;
  const reactiveGetter = (source2) => {
    if (deep) return source2;
    if (isShallow(source2) || deep === false || deep === 0)
      return traverse(source2, 1);
    return traverse(source2);
  };
  let effect2;
  let getter;
  let cleanup;
  let boundCleanup;
  let forceTrigger = false;
  let isMultiSource = false;
  if (isRef(source)) {
    getter = () => source.value;
    forceTrigger = isShallow(source);
  } else if (isReactive(source)) {
    getter = () => reactiveGetter(source);
    forceTrigger = true;
  } else if (isArray(source)) {
    isMultiSource = true;
    forceTrigger = source.some((s) => isReactive(s) || isShallow(s));
    getter = () => source.map((s) => {
      if (isRef(s)) {
        return s.value;
      } else if (isReactive(s)) {
        return reactiveGetter(s);
      } else if (isFunction(s)) {
        return call ? call(s, 2) : s();
      } else ;
    });
  } else if (isFunction(source)) {
    if (cb) {
      getter = call ? () => call(source, 2) : source;
    } else {
      getter = () => {
        if (cleanup) {
          pauseTracking();
          try {
            cleanup();
          } finally {
            resetTracking();
          }
        }
        const currentEffect = activeWatcher;
        activeWatcher = effect2;
        try {
          return call ? call(source, 3, [boundCleanup]) : source(boundCleanup);
        } finally {
          activeWatcher = currentEffect;
        }
      };
    }
  } else {
    getter = NOOP;
  }
  if (cb && deep) {
    const baseGetter = getter;
    const depth = deep === true ? Infinity : deep;
    getter = () => traverse(baseGetter(), depth);
  }
  const scope = getCurrentScope();
  const watchHandle = () => {
    effect2.stop();
    if (scope && scope.active) {
      remove(scope.effects, effect2);
    }
  };
  if (once && cb) {
    const _cb = cb;
    cb = (...args) => {
      _cb(...args);
      watchHandle();
    };
  }
  let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
  const job = (immediateFirstRun) => {
    if (!(effect2.flags & 1) || !effect2.dirty && !immediateFirstRun) {
      return;
    }
    if (cb) {
      const newValue = effect2.run();
      if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i) => hasChanged(v, oldValue[i])) : hasChanged(newValue, oldValue))) {
        if (cleanup) {
          cleanup();
        }
        const currentWatcher = activeWatcher;
        activeWatcher = effect2;
        try {
          const args = [
            newValue,
            // pass undefined as the old value when it's changed for the first time
            oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
            boundCleanup
          ];
          call ? call(cb, 3, args) : (
            // @ts-expect-error
            cb(...args)
          );
          oldValue = newValue;
        } finally {
          activeWatcher = currentWatcher;
        }
      }
    } else {
      effect2.run();
    }
  };
  if (augmentJob) {
    augmentJob(job);
  }
  effect2 = new ReactiveEffect(getter);
  effect2.scheduler = scheduler ? () => scheduler(job, false) : job;
  boundCleanup = (fn) => onWatcherCleanup(fn, false, effect2);
  cleanup = effect2.onStop = () => {
    const cleanups = cleanupMap.get(effect2);
    if (cleanups) {
      if (call) {
        call(cleanups, 4);
      } else {
        for (const cleanup2 of cleanups) cleanup2();
      }
      cleanupMap.delete(effect2);
    }
  };
  if (cb) {
    if (immediate) {
      job(true);
    } else {
      oldValue = effect2.run();
    }
  } else if (scheduler) {
    scheduler(job.bind(null, true), true);
  } else {
    effect2.run();
  }
  watchHandle.pause = effect2.pause.bind(effect2);
  watchHandle.resume = effect2.resume.bind(effect2);
  watchHandle.stop = watchHandle;
  return watchHandle;
}
function traverse(value, depth = Infinity, seen) {
  if (depth <= 0 || !isObject$1(value) || value["__v_skip"]) {
    return value;
  }
  seen = seen || /* @__PURE__ */ new Set();
  if (seen.has(value)) {
    return value;
  }
  seen.add(value);
  depth--;
  if (isRef(value)) {
    traverse(value.value, depth, seen);
  } else if (isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      traverse(value[i], depth, seen);
    }
  } else if (isSet(value) || isMap(value)) {
    value.forEach((v) => {
      traverse(v, depth, seen);
    });
  } else if (isPlainObject(value)) {
    for (const key in value) {
      traverse(value[key], depth, seen);
    }
    for (const key of Object.getOwnPropertySymbols(value)) {
      if (Object.prototype.propertyIsEnumerable.call(value, key)) {
        traverse(value[key], depth, seen);
      }
    }
  }
  return value;
}
/**
* @vue/runtime-core v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const stack = [];
let isWarning = false;
function warn$1(msg, ...args) {
  if (isWarning) return;
  isWarning = true;
  pauseTracking();
  const instance = stack.length ? stack[stack.length - 1].component : null;
  const appWarnHandler = instance && instance.appContext.config.warnHandler;
  const trace = getComponentTrace();
  if (appWarnHandler) {
    callWithErrorHandling(
      appWarnHandler,
      instance,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a) => {
          var _a, _b;
          return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(
          ({ vnode }) => `at <${formatComponentName(instance, vnode.type)}>`
        ).join("\n"),
        trace
      ]
    );
  } else {
    const warnArgs = [`[Vue warn]: ${msg}`, ...args];
    if (trace.length && // avoid spamming console during tests
    true) {
      warnArgs.push(`
`, ...formatTrace(trace));
    }
    console.warn(...warnArgs);
  }
  resetTracking();
  isWarning = false;
}
function getComponentTrace() {
  let currentVNode = stack[stack.length - 1];
  if (!currentVNode) {
    return [];
  }
  const normalizedStack = [];
  while (currentVNode) {
    const last = normalizedStack[0];
    if (last && last.vnode === currentVNode) {
      last.recurseCount++;
    } else {
      normalizedStack.push({
        vnode: currentVNode,
        recurseCount: 0
      });
    }
    const parentInstance = currentVNode.component && currentVNode.component.parent;
    currentVNode = parentInstance && parentInstance.vnode;
  }
  return normalizedStack;
}
function formatTrace(trace) {
  const logs = [];
  trace.forEach((entry, i) => {
    logs.push(...i === 0 ? [] : [`
`], ...formatTraceEntry(entry));
  });
  return logs;
}
function formatTraceEntry({ vnode, recurseCount }) {
  const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
  const isRoot = vnode.component ? vnode.component.parent == null : false;
  const open = ` at <${formatComponentName(
    vnode.component,
    vnode.type,
    isRoot
  )}`;
  const close = `>` + postfix;
  return vnode.props ? [open, ...formatProps(vnode.props), close] : [open + close];
}
function formatProps(props) {
  const res = [];
  const keys = Object.keys(props);
  keys.slice(0, 3).forEach((key) => {
    res.push(...formatProp(key, props[key]));
  });
  if (keys.length > 3) {
    res.push(` ...`);
  }
  return res;
}
function formatProp(key, value, raw) {
  if (isString(value)) {
    value = JSON.stringify(value);
    return raw ? value : [`${key}=${value}`];
  } else if (typeof value === "number" || typeof value === "boolean" || value == null) {
    return raw ? value : [`${key}=${value}`];
  } else if (isRef(value)) {
    value = formatProp(key, toRaw(value.value), true);
    return raw ? value : [`${key}=Ref<`, value, `>`];
  } else if (isFunction(value)) {
    return [`${key}=fn${value.name ? `<${value.name}>` : ``}`];
  } else {
    value = toRaw(value);
    return raw ? value : [`${key}=`, value];
  }
}
function callWithErrorHandling(fn, instance, type, args) {
  try {
    return args ? fn(...args) : fn();
  } catch (err) {
    handleError(err, instance, type);
  }
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
  if (isFunction(fn)) {
    const res = callWithErrorHandling(fn, instance, type, args);
    if (res && isPromise$1(res)) {
      res.catch((err) => {
        handleError(err, instance, type);
      });
    }
    return res;
  }
  if (isArray(fn)) {
    const values = [];
    for (let i = 0; i < fn.length; i++) {
      values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
    }
    return values;
  }
}
function handleError(err, instance, type, throwInDev = true) {
  const contextVNode = instance ? instance.vnode : null;
  const { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || EMPTY_OBJ;
  if (instance) {
    let cur = instance.parent;
    const exposedInstance = instance.proxy;
    const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
    while (cur) {
      const errorCapturedHooks = cur.ec;
      if (errorCapturedHooks) {
        for (let i = 0; i < errorCapturedHooks.length; i++) {
          if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) {
            return;
          }
        }
      }
      cur = cur.parent;
    }
    if (errorHandler) {
      pauseTracking();
      callWithErrorHandling(errorHandler, null, 10, [
        err,
        exposedInstance,
        errorInfo
      ]);
      resetTracking();
      return;
    }
  }
  logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
  if (throwInProd) {
    throw err;
  } else {
    console.error(err);
  }
}
const queue = [];
let flushIndex = -1;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
function nextTick(fn) {
  const p2 = currentFlushPromise || resolvedPromise;
  return fn ? p2.then(this ? fn.bind(this) : fn) : p2;
}
function findInsertionIndex(id) {
  let start = flushIndex + 1;
  let end = queue.length;
  while (start < end) {
    const middle = start + end >>> 1;
    const middleJob = queue[middle];
    const middleJobId = getId(middleJob);
    if (middleJobId < id || middleJobId === id && middleJob.flags & 2) {
      start = middle + 1;
    } else {
      end = middle;
    }
  }
  return start;
}
function queueJob(job) {
  if (!(job.flags & 1)) {
    const jobId = getId(job);
    const lastJob = queue[queue.length - 1];
    if (!lastJob || // fast path when the job id is larger than the tail
    !(job.flags & 2) && jobId >= getId(lastJob)) {
      queue.push(job);
    } else {
      queue.splice(findInsertionIndex(jobId), 0, job);
    }
    job.flags |= 1;
    queueFlush();
  }
}
function queueFlush() {
  if (!currentFlushPromise) {
    currentFlushPromise = resolvedPromise.then(flushJobs);
  }
}
function queuePostFlushCb(cb) {
  if (!isArray(cb)) {
    if (activePostFlushCbs && cb.id === -1) {
      activePostFlushCbs.splice(postFlushIndex + 1, 0, cb);
    } else if (!(cb.flags & 1)) {
      pendingPostFlushCbs.push(cb);
      cb.flags |= 1;
    }
  } else {
    pendingPostFlushCbs.push(...cb);
  }
  queueFlush();
}
function flushPreFlushCbs(instance, seen, i = flushIndex + 1) {
  for (; i < queue.length; i++) {
    const cb = queue[i];
    if (cb && cb.flags & 2) {
      if (instance && cb.id !== instance.uid) {
        continue;
      }
      queue.splice(i, 1);
      i--;
      if (cb.flags & 4) {
        cb.flags &= -2;
      }
      cb();
      if (!(cb.flags & 4)) {
        cb.flags &= -2;
      }
    }
  }
}
function flushPostFlushCbs(seen) {
  if (pendingPostFlushCbs.length) {
    const deduped = [...new Set(pendingPostFlushCbs)].sort(
      (a, b) => getId(a) - getId(b)
    );
    pendingPostFlushCbs.length = 0;
    if (activePostFlushCbs) {
      activePostFlushCbs.push(...deduped);
      return;
    }
    activePostFlushCbs = deduped;
    for (postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++) {
      const cb = activePostFlushCbs[postFlushIndex];
      if (cb.flags & 4) {
        cb.flags &= -2;
      }
      if (!(cb.flags & 8)) cb();
      cb.flags &= -2;
    }
    activePostFlushCbs = null;
    postFlushIndex = 0;
  }
}
const getId = (job) => job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function flushJobs(seen) {
  try {
    for (flushIndex = 0; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      if (job && !(job.flags & 8)) {
        if (false) ;
        if (job.flags & 4) {
          job.flags &= ~1;
        }
        callWithErrorHandling(
          job,
          job.i,
          job.i ? 15 : 14
        );
        if (!(job.flags & 4)) {
          job.flags &= ~1;
        }
      }
    }
  } finally {
    for (; flushIndex < queue.length; flushIndex++) {
      const job = queue[flushIndex];
      if (job) {
        job.flags &= -2;
      }
    }
    flushIndex = -1;
    queue.length = 0;
    flushPostFlushCbs();
    currentFlushPromise = null;
    if (queue.length || pendingPostFlushCbs.length) {
      flushJobs();
    }
  }
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance) {
  const prev = currentRenderingInstance;
  currentRenderingInstance = instance;
  currentScopeId = instance && instance.type.__scopeId || null;
  return prev;
}
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
  if (!ctx) return fn;
  if (fn._n) {
    return fn;
  }
  const renderFnWithContext = (...args) => {
    if (renderFnWithContext._d) {
      setBlockTracking(-1);
    }
    const prevInstance = setCurrentRenderingInstance(ctx);
    let res;
    try {
      res = fn(...args);
    } finally {
      setCurrentRenderingInstance(prevInstance);
      if (renderFnWithContext._d) {
        setBlockTracking(1);
      }
    }
    return res;
  };
  renderFnWithContext._n = true;
  renderFnWithContext._c = true;
  renderFnWithContext._d = true;
  return renderFnWithContext;
}
function withDirectives(vnode, directives) {
  if (currentRenderingInstance === null) {
    return vnode;
  }
  const instance = getComponentPublicInstance(currentRenderingInstance);
  const bindings = vnode.dirs || (vnode.dirs = []);
  for (let i = 0; i < directives.length; i++) {
    let [dir, value, arg, modifiers = EMPTY_OBJ] = directives[i];
    if (dir) {
      if (isFunction(dir)) {
        dir = {
          mounted: dir,
          updated: dir
        };
      }
      if (dir.deep) {
        traverse(value);
      }
      bindings.push({
        dir,
        instance,
        value,
        oldValue: void 0,
        arg,
        modifiers
      });
    }
  }
  return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
  const bindings = vnode.dirs;
  const oldBindings = prevVNode && prevVNode.dirs;
  for (let i = 0; i < bindings.length; i++) {
    const binding = bindings[i];
    if (oldBindings) {
      binding.oldValue = oldBindings[i].value;
    }
    let hook = binding.dir[name];
    if (hook) {
      pauseTracking();
      callWithAsyncErrorHandling(hook, instance, 8, [
        vnode.el,
        binding,
        vnode,
        prevVNode
      ]);
      resetTracking();
    }
  }
}
const TeleportEndKey = Symbol("_vte");
const isTeleport = (type) => type.__isTeleport;
function setTransitionHooks(vnode, hooks) {
  if (vnode.shapeFlag & 6 && vnode.component) {
    vnode.transition = hooks;
    setTransitionHooks(vnode.component.subTree, hooks);
  } else if (vnode.shapeFlag & 128) {
    vnode.ssContent.transition = hooks.clone(vnode.ssContent);
    vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
  } else {
    vnode.transition = hooks;
  }
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function defineComponent(options, extraOptions) {
  return isFunction(options) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (() => extend({ name: options.name }, extraOptions, { setup: options }))()
  ) : options;
}
function useId() {
  const i = getCurrentInstance();
  if (i) {
    return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
  }
  return "";
}
function markAsyncBoundary(instance) {
  instance.ids = [instance.ids[0] + instance.ids[2]++ + "-", 0, 0];
}
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
  if (isArray(rawRef)) {
    rawRef.forEach(
      (r, i) => setRef(
        r,
        oldRawRef && (isArray(oldRawRef) ? oldRawRef[i] : oldRawRef),
        parentSuspense,
        vnode,
        isUnmount
      )
    );
    return;
  }
  if (isAsyncWrapper(vnode) && !isUnmount) {
    if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) {
      setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
    }
    return;
  }
  const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
  const value = isUnmount ? null : refValue;
  const { i: owner, r: ref3 } = rawRef;
  const oldRef = oldRawRef && oldRawRef.r;
  const refs = owner.refs === EMPTY_OBJ ? owner.refs = {} : owner.refs;
  const setupState = owner.setupState;
  const rawSetupState = toRaw(setupState);
  const canSetSetupRef = setupState === EMPTY_OBJ ? () => false : (key) => {
    return hasOwn(rawSetupState, key);
  };
  if (oldRef != null && oldRef !== ref3) {
    if (isString(oldRef)) {
      refs[oldRef] = null;
      if (canSetSetupRef(oldRef)) {
        setupState[oldRef] = null;
      }
    } else if (isRef(oldRef)) {
      oldRef.value = null;
    }
  }
  if (isFunction(ref3)) {
    callWithErrorHandling(ref3, owner, 12, [value, refs]);
  } else {
    const _isString = isString(ref3);
    const _isRef = isRef(ref3);
    if (_isString || _isRef) {
      const doSet = () => {
        if (rawRef.f) {
          const existing = _isString ? canSetSetupRef(ref3) ? setupState[ref3] : refs[ref3] : ref3.value;
          if (isUnmount) {
            isArray(existing) && remove(existing, refValue);
          } else {
            if (!isArray(existing)) {
              if (_isString) {
                refs[ref3] = [refValue];
                if (canSetSetupRef(ref3)) {
                  setupState[ref3] = refs[ref3];
                }
              } else {
                ref3.value = [refValue];
                if (rawRef.k) refs[rawRef.k] = ref3.value;
              }
            } else if (!existing.includes(refValue)) {
              existing.push(refValue);
            }
          }
        } else if (_isString) {
          refs[ref3] = value;
          if (canSetSetupRef(ref3)) {
            setupState[ref3] = value;
          }
        } else if (_isRef) {
          ref3.value = value;
          if (rawRef.k) refs[rawRef.k] = value;
        } else ;
      };
      if (value) {
        doSet.id = -1;
        queuePostRenderEffect(doSet, parentSuspense);
      } else {
        doSet();
      }
    }
  }
}
getGlobalThis().requestIdleCallback || ((cb) => setTimeout(cb, 1));
getGlobalThis().cancelIdleCallback || ((id) => clearTimeout(id));
const isAsyncWrapper = (i) => !!i.type.__asyncLoader;
const isKeepAlive = (vnode) => vnode.type.__isKeepAlive;
function onActivated(hook, target) {
  registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
  registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
  const wrappedHook = hook.__wdc || (hook.__wdc = () => {
    let current = target;
    while (current) {
      if (current.isDeactivated) {
        return;
      }
      current = current.parent;
    }
    return hook();
  });
  injectHook(type, wrappedHook, target);
  if (target) {
    let current = target.parent;
    while (current && current.parent) {
      if (isKeepAlive(current.parent.vnode)) {
        injectToKeepAliveRoot(wrappedHook, type, target, current);
      }
      current = current.parent;
    }
  }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
  const injected = injectHook(
    type,
    hook,
    keepAliveRoot,
    true
    /* prepend */
  );
  onUnmounted(() => {
    remove(keepAliveRoot[type], injected);
  }, target);
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
  if (target) {
    const hooks = target[type] || (target[type] = []);
    const wrappedHook = hook.__weh || (hook.__weh = (...args) => {
      pauseTracking();
      const reset = setCurrentInstance(target);
      const res = callWithAsyncErrorHandling(hook, target, type, args);
      reset();
      resetTracking();
      return res;
    });
    if (prepend) {
      hooks.unshift(wrappedHook);
    } else {
      hooks.push(wrappedHook);
    }
    return wrappedHook;
  }
}
const createHook = (lifecycle) => (hook, target = currentInstance) => {
  if (!isInSSRComponentSetup || lifecycle === "sp") {
    injectHook(lifecycle, (...args) => hook(...args), target);
  }
};
const onBeforeMount = createHook("bm");
const onMounted = createHook("m");
const onBeforeUpdate = createHook(
  "bu"
);
const onUpdated = createHook("u");
const onBeforeUnmount = createHook(
  "bum"
);
const onUnmounted = createHook("um");
const onServerPrefetch = createHook(
  "sp"
);
const onRenderTriggered = createHook("rtg");
const onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
  injectHook("ec", hook, target);
}
const COMPONENTS = "components";
function resolveComponent(name, maybeSelfReference) {
  return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
}
const NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
  const instance = currentRenderingInstance || currentInstance;
  if (instance) {
    const Component = instance.type;
    {
      const selfName = getComponentName(
        Component,
        false
      );
      if (selfName && (selfName === name || selfName === camelize(name) || selfName === capitalize(camelize(name)))) {
        return Component;
      }
    }
    const res = (
      // local registration
      // check instance[type] first which is resolved for options API
      resolve(instance[type] || Component[type], name) || // global registration
      resolve(instance.appContext[type], name)
    );
    if (!res && maybeSelfReference) {
      return Component;
    }
    return res;
  }
}
function resolve(registry, name) {
  return registry && (registry[name] || registry[camelize(name)] || registry[capitalize(camelize(name))]);
}
function renderList(source, renderItem, cache, index) {
  let ret;
  const cached = cache;
  const sourceIsArray = isArray(source);
  if (sourceIsArray || isString(source)) {
    const sourceIsReactiveArray = sourceIsArray && isReactive(source);
    let needsWrap = false;
    if (sourceIsReactiveArray) {
      needsWrap = !isShallow(source);
      source = shallowReadArray(source);
    }
    ret = new Array(source.length);
    for (let i = 0, l = source.length; i < l; i++) {
      ret[i] = renderItem(
        needsWrap ? toReactive(source[i]) : source[i],
        i,
        void 0,
        cached
      );
    }
  } else if (typeof source === "number") {
    ret = new Array(source);
    for (let i = 0; i < source; i++) {
      ret[i] = renderItem(i + 1, i, void 0, cached);
    }
  } else if (isObject$1(source)) {
    if (source[Symbol.iterator]) {
      ret = Array.from(
        source,
        (item, i) => renderItem(item, i, void 0, cached)
      );
    } else {
      const keys = Object.keys(source);
      ret = new Array(keys.length);
      for (let i = 0, l = keys.length; i < l; i++) {
        const key = keys[i];
        ret[i] = renderItem(source[key], key, i, cached);
      }
    }
  } else {
    ret = [];
  }
  return ret;
}
function renderSlot(slots, name, props = {}, fallback, noSlotted) {
  if (currentRenderingInstance.ce || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.ce) {
    return openBlock(), createBlock(
      Fragment,
      null,
      [createVNode("slot", props, fallback)],
      64
    );
  }
  let slot = slots[name];
  if (slot && slot._c) {
    slot._d = false;
  }
  openBlock();
  const validSlotContent = slot && ensureValidVNode(slot(props));
  const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  validSlotContent && validSlotContent.key;
  const rendered = createBlock(
    Fragment,
    {
      key: (slotKey && !isSymbol(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
      (!validSlotContent && fallback ? "_fb" : "")
    },
    validSlotContent || [],
    validSlotContent && slots._ === 1 ? 64 : -2
  );
  if (rendered.scopeId) {
    rendered.slotScopeIds = [rendered.scopeId + "-s"];
  }
  if (slot && slot._c) {
    slot._d = true;
  }
  return rendered;
}
function ensureValidVNode(vnodes) {
  return vnodes.some((child) => {
    if (!isVNode(child)) return true;
    if (child.type === Comment) return false;
    if (child.type === Fragment && !ensureValidVNode(child.children))
      return false;
    return true;
  }) ? vnodes : null;
}
const getPublicInstance = (i) => {
  if (!i) return null;
  if (isStatefulComponent(i)) return getComponentPublicInstance(i);
  return getPublicInstance(i.parent);
};
const publicPropertiesMap = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ extend(/* @__PURE__ */ Object.create(null), {
    $: (i) => i,
    $el: (i) => i.vnode.el,
    $data: (i) => i.data,
    $props: (i) => i.props,
    $attrs: (i) => i.attrs,
    $slots: (i) => i.slots,
    $refs: (i) => i.refs,
    $parent: (i) => getPublicInstance(i.parent),
    $root: (i) => getPublicInstance(i.root),
    $host: (i) => i.ce,
    $emit: (i) => i.emit,
    $options: (i) => resolveMergedOptions(i),
    $forceUpdate: (i) => i.f || (i.f = () => {
      queueJob(i.update);
    }),
    $nextTick: (i) => i.n || (i.n = nextTick.bind(i.proxy)),
    $watch: (i) => instanceWatch.bind(i)
  })
);
const hasSetupBinding = (state, key) => state !== EMPTY_OBJ && !state.__isScriptSetup && hasOwn(state, key);
const PublicInstanceProxyHandlers = {
  get({ _: instance }, key) {
    if (key === "__v_skip") {
      return true;
    }
    const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
    let normalizedProps;
    if (key[0] !== "$") {
      const n = accessCache[key];
      if (n !== void 0) {
        switch (n) {
          case 1:
            return setupState[key];
          case 2:
            return data[key];
          case 4:
            return ctx[key];
          case 3:
            return props[key];
        }
      } else if (hasSetupBinding(setupState, key)) {
        accessCache[key] = 1;
        return setupState[key];
      } else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
        accessCache[key] = 2;
        return data[key];
      } else if (
        // only cache other properties when instance has declared (thus stable)
        // props
        (normalizedProps = instance.propsOptions[0]) && hasOwn(normalizedProps, key)
      ) {
        accessCache[key] = 3;
        return props[key];
      } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
        accessCache[key] = 4;
        return ctx[key];
      } else if (shouldCacheAccess) {
        accessCache[key] = 0;
      }
    }
    const publicGetter = publicPropertiesMap[key];
    let cssModule, globalProperties;
    if (publicGetter) {
      if (key === "$attrs") {
        track(instance.attrs, "get", "");
      }
      return publicGetter(instance);
    } else if (
      // css module (injected by vue-loader)
      (cssModule = type.__cssModules) && (cssModule = cssModule[key])
    ) {
      return cssModule;
    } else if (ctx !== EMPTY_OBJ && hasOwn(ctx, key)) {
      accessCache[key] = 4;
      return ctx[key];
    } else if (
      // global properties
      globalProperties = appContext.config.globalProperties, hasOwn(globalProperties, key)
    ) {
      {
        return globalProperties[key];
      }
    } else ;
  },
  set({ _: instance }, key, value) {
    const { data, setupState, ctx } = instance;
    if (hasSetupBinding(setupState, key)) {
      setupState[key] = value;
      return true;
    } else if (data !== EMPTY_OBJ && hasOwn(data, key)) {
      data[key] = value;
      return true;
    } else if (hasOwn(instance.props, key)) {
      return false;
    }
    if (key[0] === "$" && key.slice(1) in instance) {
      return false;
    } else {
      {
        ctx[key] = value;
      }
    }
    return true;
  },
  has({
    _: { data, setupState, accessCache, ctx, appContext, propsOptions }
  }, key) {
    let normalizedProps;
    return !!accessCache[key] || data !== EMPTY_OBJ && hasOwn(data, key) || hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && hasOwn(normalizedProps, key) || hasOwn(ctx, key) || hasOwn(publicPropertiesMap, key) || hasOwn(appContext.config.globalProperties, key);
  },
  defineProperty(target, key, descriptor) {
    if (descriptor.get != null) {
      target._.accessCache[key] = 0;
    } else if (hasOwn(descriptor, "value")) {
      this.set(target, key, descriptor.value, null);
    }
    return Reflect.defineProperty(target, key, descriptor);
  }
};
function normalizePropsOrEmits(props) {
  return isArray(props) ? props.reduce(
    (normalized, p2) => (normalized[p2] = null, normalized),
    {}
  ) : props;
}
let shouldCacheAccess = true;
function applyOptions(instance) {
  const options = resolveMergedOptions(instance);
  const publicThis = instance.proxy;
  const ctx = instance.ctx;
  shouldCacheAccess = false;
  if (options.beforeCreate) {
    callHook(options.beforeCreate, instance, "bc");
  }
  const {
    // state
    data: dataOptions,
    computed: computedOptions,
    methods,
    watch: watchOptions,
    provide: provideOptions,
    inject: injectOptions,
    // lifecycle
    created,
    beforeMount,
    mounted,
    beforeUpdate,
    updated,
    activated,
    deactivated,
    beforeDestroy,
    beforeUnmount,
    destroyed,
    unmounted,
    render,
    renderTracked,
    renderTriggered,
    errorCaptured,
    serverPrefetch,
    // public API
    expose,
    inheritAttrs,
    // assets
    components,
    directives,
    filters
  } = options;
  const checkDuplicateProperties = null;
  if (injectOptions) {
    resolveInjections(injectOptions, ctx, checkDuplicateProperties);
  }
  if (methods) {
    for (const key in methods) {
      const methodHandler = methods[key];
      if (isFunction(methodHandler)) {
        {
          ctx[key] = methodHandler.bind(publicThis);
        }
      }
    }
  }
  if (dataOptions) {
    const data = dataOptions.call(publicThis, publicThis);
    if (!isObject$1(data)) ;
    else {
      instance.data = reactive(data);
    }
  }
  shouldCacheAccess = true;
  if (computedOptions) {
    for (const key in computedOptions) {
      const opt = computedOptions[key];
      const get2 = isFunction(opt) ? opt.bind(publicThis, publicThis) : isFunction(opt.get) ? opt.get.bind(publicThis, publicThis) : NOOP;
      const set = !isFunction(opt) && isFunction(opt.set) ? opt.set.bind(publicThis) : NOOP;
      const c = computed({
        get: get2,
        set
      });
      Object.defineProperty(ctx, key, {
        enumerable: true,
        configurable: true,
        get: () => c.value,
        set: (v) => c.value = v
      });
    }
  }
  if (watchOptions) {
    for (const key in watchOptions) {
      createWatcher(watchOptions[key], ctx, publicThis, key);
    }
  }
  if (provideOptions) {
    const provides = isFunction(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
    Reflect.ownKeys(provides).forEach((key) => {
      provide(key, provides[key]);
    });
  }
  if (created) {
    callHook(created, instance, "c");
  }
  function registerLifecycleHook(register2, hook) {
    if (isArray(hook)) {
      hook.forEach((_hook) => register2(_hook.bind(publicThis)));
    } else if (hook) {
      register2(hook.bind(publicThis));
    }
  }
  registerLifecycleHook(onBeforeMount, beforeMount);
  registerLifecycleHook(onMounted, mounted);
  registerLifecycleHook(onBeforeUpdate, beforeUpdate);
  registerLifecycleHook(onUpdated, updated);
  registerLifecycleHook(onActivated, activated);
  registerLifecycleHook(onDeactivated, deactivated);
  registerLifecycleHook(onErrorCaptured, errorCaptured);
  registerLifecycleHook(onRenderTracked, renderTracked);
  registerLifecycleHook(onRenderTriggered, renderTriggered);
  registerLifecycleHook(onBeforeUnmount, beforeUnmount);
  registerLifecycleHook(onUnmounted, unmounted);
  registerLifecycleHook(onServerPrefetch, serverPrefetch);
  if (isArray(expose)) {
    if (expose.length) {
      const exposed = instance.exposed || (instance.exposed = {});
      expose.forEach((key) => {
        Object.defineProperty(exposed, key, {
          get: () => publicThis[key],
          set: (val) => publicThis[key] = val
        });
      });
    } else if (!instance.exposed) {
      instance.exposed = {};
    }
  }
  if (render && instance.render === NOOP) {
    instance.render = render;
  }
  if (inheritAttrs != null) {
    instance.inheritAttrs = inheritAttrs;
  }
  if (components) instance.components = components;
  if (directives) instance.directives = directives;
  if (serverPrefetch) {
    markAsyncBoundary(instance);
  }
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = NOOP) {
  if (isArray(injectOptions)) {
    injectOptions = normalizeInject(injectOptions);
  }
  for (const key in injectOptions) {
    const opt = injectOptions[key];
    let injected;
    if (isObject$1(opt)) {
      if ("default" in opt) {
        injected = inject(
          opt.from || key,
          opt.default,
          true
        );
      } else {
        injected = inject(opt.from || key);
      }
    } else {
      injected = inject(opt);
    }
    if (isRef(injected)) {
      Object.defineProperty(ctx, key, {
        enumerable: true,
        configurable: true,
        get: () => injected.value,
        set: (v) => injected.value = v
      });
    } else {
      ctx[key] = injected;
    }
  }
}
function callHook(hook, instance, type) {
  callWithAsyncErrorHandling(
    isArray(hook) ? hook.map((h2) => h2.bind(instance.proxy)) : hook.bind(instance.proxy),
    instance,
    type
  );
}
function createWatcher(raw, ctx, publicThis, key) {
  let getter = key.includes(".") ? createPathGetter(publicThis, key) : () => publicThis[key];
  if (isString(raw)) {
    const handler = ctx[raw];
    if (isFunction(handler)) {
      {
        watch(getter, handler);
      }
    }
  } else if (isFunction(raw)) {
    {
      watch(getter, raw.bind(publicThis));
    }
  } else if (isObject$1(raw)) {
    if (isArray(raw)) {
      raw.forEach((r) => createWatcher(r, ctx, publicThis, key));
    } else {
      const handler = isFunction(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
      if (isFunction(handler)) {
        watch(getter, handler, raw);
      }
    }
  } else ;
}
function resolveMergedOptions(instance) {
  const base = instance.type;
  const { mixins, extends: extendsOptions } = base;
  const {
    mixins: globalMixins,
    optionsCache: cache,
    config: { optionMergeStrategies }
  } = instance.appContext;
  const cached = cache.get(base);
  let resolved;
  if (cached) {
    resolved = cached;
  } else if (!globalMixins.length && !mixins && !extendsOptions) {
    {
      resolved = base;
    }
  } else {
    resolved = {};
    if (globalMixins.length) {
      globalMixins.forEach(
        (m) => mergeOptions(resolved, m, optionMergeStrategies, true)
      );
    }
    mergeOptions(resolved, base, optionMergeStrategies);
  }
  if (isObject$1(base)) {
    cache.set(base, resolved);
  }
  return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
  const { mixins, extends: extendsOptions } = from;
  if (extendsOptions) {
    mergeOptions(to, extendsOptions, strats, true);
  }
  if (mixins) {
    mixins.forEach(
      (m) => mergeOptions(to, m, strats, true)
    );
  }
  for (const key in from) {
    if (asMixin && key === "expose") ;
    else {
      const strat = internalOptionMergeStrats[key] || strats && strats[key];
      to[key] = strat ? strat(to[key], from[key]) : from[key];
    }
  }
  return to;
}
const internalOptionMergeStrats = {
  data: mergeDataFn,
  props: mergeEmitsOrPropsOptions,
  emits: mergeEmitsOrPropsOptions,
  // objects
  methods: mergeObjectOptions,
  computed: mergeObjectOptions,
  // lifecycle
  beforeCreate: mergeAsArray,
  created: mergeAsArray,
  beforeMount: mergeAsArray,
  mounted: mergeAsArray,
  beforeUpdate: mergeAsArray,
  updated: mergeAsArray,
  beforeDestroy: mergeAsArray,
  beforeUnmount: mergeAsArray,
  destroyed: mergeAsArray,
  unmounted: mergeAsArray,
  activated: mergeAsArray,
  deactivated: mergeAsArray,
  errorCaptured: mergeAsArray,
  serverPrefetch: mergeAsArray,
  // assets
  components: mergeObjectOptions,
  directives: mergeObjectOptions,
  // watch
  watch: mergeWatchOptions,
  // provide / inject
  provide: mergeDataFn,
  inject: mergeInject
};
function mergeDataFn(to, from) {
  if (!from) {
    return to;
  }
  if (!to) {
    return from;
  }
  return function mergedDataFn() {
    return extend(
      isFunction(to) ? to.call(this, this) : to,
      isFunction(from) ? from.call(this, this) : from
    );
  };
}
function mergeInject(to, from) {
  return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
  if (isArray(raw)) {
    const res = {};
    for (let i = 0; i < raw.length; i++) {
      res[raw[i]] = raw[i];
    }
    return res;
  }
  return raw;
}
function mergeAsArray(to, from) {
  return to ? [...new Set([].concat(to, from))] : from;
}
function mergeObjectOptions(to, from) {
  return to ? extend(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function mergeEmitsOrPropsOptions(to, from) {
  if (to) {
    if (isArray(to) && isArray(from)) {
      return [.../* @__PURE__ */ new Set([...to, ...from])];
    }
    return extend(
      /* @__PURE__ */ Object.create(null),
      normalizePropsOrEmits(to),
      normalizePropsOrEmits(from != null ? from : {})
    );
  } else {
    return from;
  }
}
function mergeWatchOptions(to, from) {
  if (!to) return from;
  if (!from) return to;
  const merged = extend(/* @__PURE__ */ Object.create(null), to);
  for (const key in from) {
    merged[key] = mergeAsArray(to[key], from[key]);
  }
  return merged;
}
function createAppContext() {
  return {
    app: null,
    config: {
      isNativeTag: NO,
      performance: false,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let uid$1 = 0;
function createAppAPI(render, hydrate) {
  return function createApp2(rootComponent, rootProps = null) {
    if (!isFunction(rootComponent)) {
      rootComponent = extend({}, rootComponent);
    }
    if (rootProps != null && !isObject$1(rootProps)) {
      rootProps = null;
    }
    const context = createAppContext();
    const installedPlugins = /* @__PURE__ */ new WeakSet();
    const pluginCleanupFns = [];
    let isMounted = false;
    const app = context.app = {
      _uid: uid$1++,
      _component: rootComponent,
      _props: rootProps,
      _container: null,
      _context: context,
      _instance: null,
      version,
      get config() {
        return context.config;
      },
      set config(v) {
      },
      use(plugin, ...options) {
        if (installedPlugins.has(plugin)) ;
        else if (plugin && isFunction(plugin.install)) {
          installedPlugins.add(plugin);
          plugin.install(app, ...options);
        } else if (isFunction(plugin)) {
          installedPlugins.add(plugin);
          plugin(app, ...options);
        } else ;
        return app;
      },
      mixin(mixin) {
        {
          if (!context.mixins.includes(mixin)) {
            context.mixins.push(mixin);
          }
        }
        return app;
      },
      component(name, component) {
        if (!component) {
          return context.components[name];
        }
        context.components[name] = component;
        return app;
      },
      directive(name, directive) {
        if (!directive) {
          return context.directives[name];
        }
        context.directives[name] = directive;
        return app;
      },
      mount(rootContainer, isHydrate, namespace) {
        if (!isMounted) {
          const vnode = app._ceVNode || createVNode(rootComponent, rootProps);
          vnode.appContext = context;
          if (namespace === true) {
            namespace = "svg";
          } else if (namespace === false) {
            namespace = void 0;
          }
          {
            render(vnode, rootContainer, namespace);
          }
          isMounted = true;
          app._container = rootContainer;
          rootContainer.__vue_app__ = app;
          return getComponentPublicInstance(vnode.component);
        }
      },
      onUnmount(cleanupFn) {
        pluginCleanupFns.push(cleanupFn);
      },
      unmount() {
        if (isMounted) {
          callWithAsyncErrorHandling(
            pluginCleanupFns,
            app._instance,
            16
          );
          render(null, app._container);
          delete app._container.__vue_app__;
        }
      },
      provide(key, value) {
        context.provides[key] = value;
        return app;
      },
      runWithContext(fn) {
        const lastApp = currentApp;
        currentApp = app;
        try {
          return fn();
        } finally {
          currentApp = lastApp;
        }
      }
    };
    return app;
  };
}
let currentApp = null;
function provide(key, value) {
  if (!currentInstance) ;
  else {
    let provides = currentInstance.provides;
    const parentProvides = currentInstance.parent && currentInstance.parent.provides;
    if (parentProvides === provides) {
      provides = currentInstance.provides = Object.create(parentProvides);
    }
    provides[key] = value;
  }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
  const instance = currentInstance || currentRenderingInstance;
  if (instance || currentApp) {
    const provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
    if (provides && key in provides) {
      return provides[key];
    } else if (arguments.length > 1) {
      return treatDefaultAsFactory && isFunction(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    } else ;
  }
}
const internalObjectProto = {};
const createInternalObject = () => Object.create(internalObjectProto);
const isInternalObject = (obj) => Object.getPrototypeOf(obj) === internalObjectProto;
function initProps(instance, rawProps, isStateful, isSSR = false) {
  const props = {};
  const attrs = createInternalObject();
  instance.propsDefaults = /* @__PURE__ */ Object.create(null);
  setFullProps(instance, rawProps, props, attrs);
  for (const key in instance.propsOptions[0]) {
    if (!(key in props)) {
      props[key] = void 0;
    }
  }
  if (isStateful) {
    instance.props = isSSR ? props : shallowReactive(props);
  } else {
    if (!instance.type.props) {
      instance.props = attrs;
    } else {
      instance.props = props;
    }
  }
  instance.attrs = attrs;
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
  const {
    props,
    attrs,
    vnode: { patchFlag }
  } = instance;
  const rawCurrentProps = toRaw(props);
  const [options] = instance.propsOptions;
  let hasAttrsChanged = false;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)
  ) {
    if (patchFlag & 8) {
      const propsToUpdate = instance.vnode.dynamicProps;
      for (let i = 0; i < propsToUpdate.length; i++) {
        let key = propsToUpdate[i];
        if (isEmitListener(instance.emitsOptions, key)) {
          continue;
        }
        const value = rawProps[key];
        if (options) {
          if (hasOwn(attrs, key)) {
            if (value !== attrs[key]) {
              attrs[key] = value;
              hasAttrsChanged = true;
            }
          } else {
            const camelizedKey = camelize(key);
            props[camelizedKey] = resolvePropValue(
              options,
              rawCurrentProps,
              camelizedKey,
              value,
              instance,
              false
            );
          }
        } else {
          if (value !== attrs[key]) {
            attrs[key] = value;
            hasAttrsChanged = true;
          }
        }
      }
    }
  } else {
    if (setFullProps(instance, rawProps, props, attrs)) {
      hasAttrsChanged = true;
    }
    let kebabKey;
    for (const key in rawCurrentProps) {
      if (!rawProps || // for camelCase
      !hasOwn(rawProps, key) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((kebabKey = hyphenate(key)) === key || !hasOwn(rawProps, kebabKey))) {
        if (options) {
          if (rawPrevProps && // for camelCase
          (rawPrevProps[key] !== void 0 || // for kebab-case
          rawPrevProps[kebabKey] !== void 0)) {
            props[key] = resolvePropValue(
              options,
              rawCurrentProps,
              key,
              void 0,
              instance,
              true
            );
          }
        } else {
          delete props[key];
        }
      }
    }
    if (attrs !== rawCurrentProps) {
      for (const key in attrs) {
        if (!rawProps || !hasOwn(rawProps, key) && true) {
          delete attrs[key];
          hasAttrsChanged = true;
        }
      }
    }
  }
  if (hasAttrsChanged) {
    trigger(instance.attrs, "set", "");
  }
}
function setFullProps(instance, rawProps, props, attrs) {
  const [options, needCastKeys] = instance.propsOptions;
  let hasAttrsChanged = false;
  let rawCastValues;
  if (rawProps) {
    for (let key in rawProps) {
      if (isReservedProp(key)) {
        continue;
      }
      const value = rawProps[key];
      let camelKey;
      if (options && hasOwn(options, camelKey = camelize(key))) {
        if (!needCastKeys || !needCastKeys.includes(camelKey)) {
          props[camelKey] = value;
        } else {
          (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        }
      } else if (!isEmitListener(instance.emitsOptions, key)) {
        if (!(key in attrs) || value !== attrs[key]) {
          attrs[key] = value;
          hasAttrsChanged = true;
        }
      }
    }
  }
  if (needCastKeys) {
    const rawCurrentProps = toRaw(props);
    const castValues = rawCastValues || EMPTY_OBJ;
    for (let i = 0; i < needCastKeys.length; i++) {
      const key = needCastKeys[i];
      props[key] = resolvePropValue(
        options,
        rawCurrentProps,
        key,
        castValues[key],
        instance,
        !hasOwn(castValues, key)
      );
    }
  }
  return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
  const opt = options[key];
  if (opt != null) {
    const hasDefault = hasOwn(opt, "default");
    if (hasDefault && value === void 0) {
      const defaultValue = opt.default;
      if (opt.type !== Function && !opt.skipFactory && isFunction(defaultValue)) {
        const { propsDefaults } = instance;
        if (key in propsDefaults) {
          value = propsDefaults[key];
        } else {
          const reset = setCurrentInstance(instance);
          value = propsDefaults[key] = defaultValue.call(
            null,
            props
          );
          reset();
        }
      } else {
        value = defaultValue;
      }
      if (instance.ce) {
        instance.ce._setProp(key, value);
      }
    }
    if (opt[
      0
      /* shouldCast */
    ]) {
      if (isAbsent && !hasDefault) {
        value = false;
      } else if (opt[
        1
        /* shouldCastTrue */
      ] && (value === "" || value === hyphenate(key))) {
        value = true;
      }
    }
  }
  return value;
}
const mixinPropsCache = /* @__PURE__ */ new WeakMap();
function normalizePropsOptions(comp, appContext, asMixin = false) {
  const cache = asMixin ? mixinPropsCache : appContext.propsCache;
  const cached = cache.get(comp);
  if (cached) {
    return cached;
  }
  const raw = comp.props;
  const normalized = {};
  const needCastKeys = [];
  let hasExtends = false;
  if (!isFunction(comp)) {
    const extendProps = (raw2) => {
      hasExtends = true;
      const [props, keys] = normalizePropsOptions(raw2, appContext, true);
      extend(normalized, props);
      if (keys) needCastKeys.push(...keys);
    };
    if (!asMixin && appContext.mixins.length) {
      appContext.mixins.forEach(extendProps);
    }
    if (comp.extends) {
      extendProps(comp.extends);
    }
    if (comp.mixins) {
      comp.mixins.forEach(extendProps);
    }
  }
  if (!raw && !hasExtends) {
    if (isObject$1(comp)) {
      cache.set(comp, EMPTY_ARR);
    }
    return EMPTY_ARR;
  }
  if (isArray(raw)) {
    for (let i = 0; i < raw.length; i++) {
      const normalizedKey = camelize(raw[i]);
      if (validatePropName(normalizedKey)) {
        normalized[normalizedKey] = EMPTY_OBJ;
      }
    }
  } else if (raw) {
    for (const key in raw) {
      const normalizedKey = camelize(key);
      if (validatePropName(normalizedKey)) {
        const opt = raw[key];
        const prop = normalized[normalizedKey] = isArray(opt) || isFunction(opt) ? { type: opt } : extend({}, opt);
        const propType = prop.type;
        let shouldCast = false;
        let shouldCastTrue = true;
        if (isArray(propType)) {
          for (let index = 0; index < propType.length; ++index) {
            const type = propType[index];
            const typeName = isFunction(type) && type.name;
            if (typeName === "Boolean") {
              shouldCast = true;
              break;
            } else if (typeName === "String") {
              shouldCastTrue = false;
            }
          }
        } else {
          shouldCast = isFunction(propType) && propType.name === "Boolean";
        }
        prop[
          0
          /* shouldCast */
        ] = shouldCast;
        prop[
          1
          /* shouldCastTrue */
        ] = shouldCastTrue;
        if (shouldCast || hasOwn(prop, "default")) {
          needCastKeys.push(normalizedKey);
        }
      }
    }
  }
  const res = [normalized, needCastKeys];
  if (isObject$1(comp)) {
    cache.set(comp, res);
  }
  return res;
}
function validatePropName(key) {
  if (key[0] !== "$" && !isReservedProp(key)) {
    return true;
  }
  return false;
}
const isInternalKey = (key) => key[0] === "_" || key === "$stable";
const normalizeSlotValue = (value) => isArray(value) ? value.map(normalizeVNode) : [normalizeVNode(value)];
const normalizeSlot = (key, rawSlot, ctx) => {
  if (rawSlot._n) {
    return rawSlot;
  }
  const normalized = withCtx((...args) => {
    if (false) ;
    return normalizeSlotValue(rawSlot(...args));
  }, ctx);
  normalized._c = false;
  return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance) => {
  const ctx = rawSlots._ctx;
  for (const key in rawSlots) {
    if (isInternalKey(key)) continue;
    const value = rawSlots[key];
    if (isFunction(value)) {
      slots[key] = normalizeSlot(key, value, ctx);
    } else if (value != null) {
      const normalized = normalizeSlotValue(value);
      slots[key] = () => normalized;
    }
  }
};
const normalizeVNodeSlots = (instance, children) => {
  const normalized = normalizeSlotValue(children);
  instance.slots.default = () => normalized;
};
const assignSlots = (slots, children, optimized) => {
  for (const key in children) {
    if (optimized || key !== "_") {
      slots[key] = children[key];
    }
  }
};
const initSlots = (instance, children, optimized) => {
  const slots = instance.slots = createInternalObject();
  if (instance.vnode.shapeFlag & 32) {
    const type = children._;
    if (type) {
      assignSlots(slots, children, optimized);
      if (optimized) {
        def(slots, "_", type, true);
      }
    } else {
      normalizeObjectSlots(children, slots);
    }
  } else if (children) {
    normalizeVNodeSlots(instance, children);
  }
};
const updateSlots = (instance, children, optimized) => {
  const { vnode, slots } = instance;
  let needDeletionCheck = true;
  let deletionComparisonTarget = EMPTY_OBJ;
  if (vnode.shapeFlag & 32) {
    const type = children._;
    if (type) {
      if (optimized && type === 1) {
        needDeletionCheck = false;
      } else {
        assignSlots(slots, children, optimized);
      }
    } else {
      needDeletionCheck = !children.$stable;
      normalizeObjectSlots(children, slots);
    }
    deletionComparisonTarget = children;
  } else if (children) {
    normalizeVNodeSlots(instance, children);
    deletionComparisonTarget = { default: 1 };
  }
  if (needDeletionCheck) {
    for (const key in slots) {
      if (!isInternalKey(key) && deletionComparisonTarget[key] == null) {
        delete slots[key];
      }
    }
  }
};
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
  return baseCreateRenderer(options);
}
function baseCreateRenderer(options, createHydrationFns) {
  const target = getGlobalThis();
  target.__VUE__ = true;
  const {
    insert: hostInsert,
    remove: hostRemove,
    patchProp: hostPatchProp,
    createElement: hostCreateElement,
    createText: hostCreateText,
    createComment: hostCreateComment,
    setText: hostSetText,
    setElementText: hostSetElementText,
    parentNode: hostParentNode,
    nextSibling: hostNextSibling,
    setScopeId: hostSetScopeId = NOOP,
    insertStaticContent: hostInsertStaticContent
  } = options;
  const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace = void 0, slotScopeIds = null, optimized = !!n2.dynamicChildren) => {
    if (n1 === n2) {
      return;
    }
    if (n1 && !isSameVNodeType(n1, n2)) {
      anchor = getNextHostNode(n1);
      unmount(n1, parentComponent, parentSuspense, true);
      n1 = null;
    }
    if (n2.patchFlag === -2) {
      optimized = false;
      n2.dynamicChildren = null;
    }
    const { type, ref: ref3, shapeFlag } = n2;
    switch (type) {
      case Text:
        processText(n1, n2, container, anchor);
        break;
      case Comment:
        processCommentNode(n1, n2, container, anchor);
        break;
      case Static:
        if (n1 == null) {
          mountStaticNode(n2, container, anchor, namespace);
        }
        break;
      case Fragment:
        processFragment(
          n1,
          n2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
        break;
      default:
        if (shapeFlag & 1) {
          processElement(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else if (shapeFlag & 6) {
          processComponent(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else if (shapeFlag & 64) {
          type.process(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized,
            internals
          );
        } else if (shapeFlag & 128) {
          type.process(
            n1,
            n2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized,
            internals
          );
        } else ;
    }
    if (ref3 != null && parentComponent) {
      setRef(ref3, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    }
  };
  const processText = (n1, n2, container, anchor) => {
    if (n1 == null) {
      hostInsert(
        n2.el = hostCreateText(n2.children),
        container,
        anchor
      );
    } else {
      const el = n2.el = n1.el;
      if (n2.children !== n1.children) {
        hostSetText(el, n2.children);
      }
    }
  };
  const processCommentNode = (n1, n2, container, anchor) => {
    if (n1 == null) {
      hostInsert(
        n2.el = hostCreateComment(n2.children || ""),
        container,
        anchor
      );
    } else {
      n2.el = n1.el;
    }
  };
  const mountStaticNode = (n2, container, anchor, namespace) => {
    [n2.el, n2.anchor] = hostInsertStaticContent(
      n2.children,
      container,
      anchor,
      namespace,
      n2.el,
      n2.anchor
    );
  };
  const moveStaticNode = ({ el, anchor }, container, nextSibling) => {
    let next;
    while (el && el !== anchor) {
      next = hostNextSibling(el);
      hostInsert(el, container, nextSibling);
      el = next;
    }
    hostInsert(anchor, container, nextSibling);
  };
  const removeStaticNode = ({ el, anchor }) => {
    let next;
    while (el && el !== anchor) {
      next = hostNextSibling(el);
      hostRemove(el);
      el = next;
    }
    hostRemove(anchor);
  };
  const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    if (n2.type === "svg") {
      namespace = "svg";
    } else if (n2.type === "math") {
      namespace = "mathml";
    }
    if (n1 == null) {
      mountElement(
        n2,
        container,
        anchor,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized
      );
    } else {
      patchElement(
        n1,
        n2,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized
      );
    }
  };
  const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    let el;
    let vnodeHook;
    const { props, shapeFlag, transition, dirs } = vnode;
    el = vnode.el = hostCreateElement(
      vnode.type,
      namespace,
      props && props.is,
      props
    );
    if (shapeFlag & 8) {
      hostSetElementText(el, vnode.children);
    } else if (shapeFlag & 16) {
      mountChildren(
        vnode.children,
        el,
        null,
        parentComponent,
        parentSuspense,
        resolveChildrenNamespace(vnode, namespace),
        slotScopeIds,
        optimized
      );
    }
    if (dirs) {
      invokeDirectiveHook(vnode, null, parentComponent, "created");
    }
    setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
    if (props) {
      for (const key in props) {
        if (key !== "value" && !isReservedProp(key)) {
          hostPatchProp(el, key, null, props[key], namespace, parentComponent);
        }
      }
      if ("value" in props) {
        hostPatchProp(el, "value", null, props.value, namespace);
      }
      if (vnodeHook = props.onVnodeBeforeMount) {
        invokeVNodeHook(vnodeHook, parentComponent, vnode);
      }
    }
    if (dirs) {
      invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
    }
    const needCallTransitionHooks = needTransition(parentSuspense, transition);
    if (needCallTransitionHooks) {
      transition.beforeEnter(el);
    }
    hostInsert(el, container, anchor);
    if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
        needCallTransitionHooks && transition.enter(el);
        dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
      }, parentSuspense);
    }
  };
  const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent) => {
    if (scopeId) {
      hostSetScopeId(el, scopeId);
    }
    if (slotScopeIds) {
      for (let i = 0; i < slotScopeIds.length; i++) {
        hostSetScopeId(el, slotScopeIds[i]);
      }
    }
    if (parentComponent) {
      let subTree = parentComponent.subTree;
      if (vnode === subTree || isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
        const parentVNode = parentComponent.vnode;
        setScopeId(
          el,
          parentVNode,
          parentVNode.scopeId,
          parentVNode.slotScopeIds,
          parentComponent.parent
        );
      }
    }
  };
  const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0) => {
    for (let i = start; i < children.length; i++) {
      const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
      patch(
        null,
        child,
        container,
        anchor,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized
      );
    }
  };
  const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    const el = n2.el = n1.el;
    let { patchFlag, dynamicChildren, dirs } = n2;
    patchFlag |= n1.patchFlag & 16;
    const oldProps = n1.props || EMPTY_OBJ;
    const newProps = n2.props || EMPTY_OBJ;
    let vnodeHook;
    parentComponent && toggleRecurse(parentComponent, false);
    if (vnodeHook = newProps.onVnodeBeforeUpdate) {
      invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
    }
    if (dirs) {
      invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
    }
    parentComponent && toggleRecurse(parentComponent, true);
    if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) {
      hostSetElementText(el, "");
    }
    if (dynamicChildren) {
      patchBlockChildren(
        n1.dynamicChildren,
        dynamicChildren,
        el,
        parentComponent,
        parentSuspense,
        resolveChildrenNamespace(n2, namespace),
        slotScopeIds
      );
    } else if (!optimized) {
      patchChildren(
        n1,
        n2,
        el,
        null,
        parentComponent,
        parentSuspense,
        resolveChildrenNamespace(n2, namespace),
        slotScopeIds,
        false
      );
    }
    if (patchFlag > 0) {
      if (patchFlag & 16) {
        patchProps(el, oldProps, newProps, parentComponent, namespace);
      } else {
        if (patchFlag & 2) {
          if (oldProps.class !== newProps.class) {
            hostPatchProp(el, "class", null, newProps.class, namespace);
          }
        }
        if (patchFlag & 4) {
          hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
        }
        if (patchFlag & 8) {
          const propsToUpdate = n2.dynamicProps;
          for (let i = 0; i < propsToUpdate.length; i++) {
            const key = propsToUpdate[i];
            const prev = oldProps[key];
            const next = newProps[key];
            if (next !== prev || key === "value") {
              hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
          }
        }
      }
      if (patchFlag & 1) {
        if (n1.children !== n2.children) {
          hostSetElementText(el, n2.children);
        }
      }
    } else if (!optimized && dynamicChildren == null) {
      patchProps(el, oldProps, newProps, parentComponent, namespace);
    }
    if ((vnodeHook = newProps.onVnodeUpdated) || dirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
      }, parentSuspense);
    }
  };
  const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) => {
    for (let i = 0; i < newChildren.length; i++) {
      const oldVNode = oldChildren[i];
      const newVNode = newChildren[i];
      const container = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
        oldVNode.shapeFlag & (6 | 64)) ? hostParentNode(oldVNode.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          fallbackContainer
        )
      );
      patch(
        oldVNode,
        newVNode,
        container,
        null,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        true
      );
    }
  };
  const patchProps = (el, oldProps, newProps, parentComponent, namespace) => {
    if (oldProps !== newProps) {
      if (oldProps !== EMPTY_OBJ) {
        for (const key in oldProps) {
          if (!isReservedProp(key) && !(key in newProps)) {
            hostPatchProp(
              el,
              key,
              oldProps[key],
              null,
              namespace,
              parentComponent
            );
          }
        }
      }
      for (const key in newProps) {
        if (isReservedProp(key)) continue;
        const next = newProps[key];
        const prev = oldProps[key];
        if (next !== prev && key !== "value") {
          hostPatchProp(el, key, prev, next, namespace, parentComponent);
        }
      }
      if ("value" in newProps) {
        hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
      }
    }
  };
  const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
    const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
    let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
    if (fragmentSlotScopeIds) {
      slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
    }
    if (n1 == null) {
      hostInsert(fragmentStartAnchor, container, anchor);
      hostInsert(fragmentEndAnchor, container, anchor);
      mountChildren(
        // #10007
        // such fragment like `<></>` will be compiled into
        // a fragment which doesn't have a children.
        // In this case fallback to an empty array
        n2.children || [],
        container,
        fragmentEndAnchor,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized
      );
    } else {
      if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
      // of renderSlot() with no valid children
      n1.dynamicChildren) {
        patchBlockChildren(
          n1.dynamicChildren,
          dynamicChildren,
          container,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds
        );
        if (
          // #2080 if the stable fragment has a key, it's a <template v-for> that may
          //  get moved around. Make sure all root level vnodes inherit el.
          // #2134 or if it's a component root, it may also get moved around
          // as the component is being moved.
          n2.key != null || parentComponent && n2 === parentComponent.subTree
        ) {
          traverseStaticChildren(
            n1,
            n2,
            true
            /* shallow */
          );
        }
      } else {
        patchChildren(
          n1,
          n2,
          container,
          fragmentEndAnchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      }
    }
  };
  const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    n2.slotScopeIds = slotScopeIds;
    if (n1 == null) {
      if (n2.shapeFlag & 512) {
        parentComponent.ctx.activate(
          n2,
          container,
          anchor,
          namespace,
          optimized
        );
      } else {
        mountComponent(
          n2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          optimized
        );
      }
    } else {
      updateComponent(n1, n2, optimized);
    }
  };
  const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) => {
    const instance = initialVNode.component = createComponentInstance(
      initialVNode,
      parentComponent,
      parentSuspense
    );
    if (isKeepAlive(initialVNode)) {
      instance.ctx.renderer = internals;
    }
    {
      setupComponent(instance, false, optimized);
    }
    if (instance.asyncDep) {
      parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
      if (!initialVNode.el) {
        const placeholder = instance.subTree = createVNode(Comment);
        processCommentNode(null, placeholder, container, anchor);
      }
    } else {
      setupRenderEffect(
        instance,
        initialVNode,
        container,
        anchor,
        parentSuspense,
        namespace,
        optimized
      );
    }
  };
  const updateComponent = (n1, n2, optimized) => {
    const instance = n2.component = n1.component;
    if (shouldUpdateComponent(n1, n2, optimized)) {
      if (instance.asyncDep && !instance.asyncResolved) {
        updateComponentPreRender(instance, n2, optimized);
        return;
      } else {
        instance.next = n2;
        instance.update();
      }
    } else {
      n2.el = n1.el;
      instance.vnode = n2;
    }
  };
  const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) => {
    const componentUpdateFn = () => {
      if (!instance.isMounted) {
        let vnodeHook;
        const { el, props } = initialVNode;
        const { bm, m, parent, root, type } = instance;
        const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
        toggleRecurse(instance, false);
        if (bm) {
          invokeArrayFns(bm);
        }
        if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) {
          invokeVNodeHook(vnodeHook, parent, initialVNode);
        }
        toggleRecurse(instance, true);
        {
          if (root.ce) {
            root.ce._injectChildStyle(type);
          }
          const subTree = instance.subTree = renderComponentRoot(instance);
          patch(
            null,
            subTree,
            container,
            anchor,
            instance,
            parentSuspense,
            namespace
          );
          initialVNode.el = subTree.el;
        }
        if (m) {
          queuePostRenderEffect(m, parentSuspense);
        }
        if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
          const scopedInitialVNode = initialVNode;
          queuePostRenderEffect(
            () => invokeVNodeHook(vnodeHook, parent, scopedInitialVNode),
            parentSuspense
          );
        }
        if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) {
          instance.a && queuePostRenderEffect(instance.a, parentSuspense);
        }
        instance.isMounted = true;
        initialVNode = container = anchor = null;
      } else {
        let { next, bu, u, parent, vnode } = instance;
        {
          const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
          if (nonHydratedAsyncRoot) {
            if (next) {
              next.el = vnode.el;
              updateComponentPreRender(instance, next, optimized);
            }
            nonHydratedAsyncRoot.asyncDep.then(() => {
              if (!instance.isUnmounted) {
                componentUpdateFn();
              }
            });
            return;
          }
        }
        let originNext = next;
        let vnodeHook;
        toggleRecurse(instance, false);
        if (next) {
          next.el = vnode.el;
          updateComponentPreRender(instance, next, optimized);
        } else {
          next = vnode;
        }
        if (bu) {
          invokeArrayFns(bu);
        }
        if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) {
          invokeVNodeHook(vnodeHook, parent, next, vnode);
        }
        toggleRecurse(instance, true);
        const nextTree = renderComponentRoot(instance);
        const prevTree = instance.subTree;
        instance.subTree = nextTree;
        patch(
          prevTree,
          nextTree,
          // parent may have changed if it's in a teleport
          hostParentNode(prevTree.el),
          // anchor may have changed if it's in a fragment
          getNextHostNode(prevTree),
          instance,
          parentSuspense,
          namespace
        );
        next.el = nextTree.el;
        if (originNext === null) {
          updateHOCHostEl(instance, nextTree.el);
        }
        if (u) {
          queuePostRenderEffect(u, parentSuspense);
        }
        if (vnodeHook = next.props && next.props.onVnodeUpdated) {
          queuePostRenderEffect(
            () => invokeVNodeHook(vnodeHook, parent, next, vnode),
            parentSuspense
          );
        }
      }
    };
    instance.scope.on();
    const effect2 = instance.effect = new ReactiveEffect(componentUpdateFn);
    instance.scope.off();
    const update3 = instance.update = effect2.run.bind(effect2);
    const job = instance.job = effect2.runIfDirty.bind(effect2);
    job.i = instance;
    job.id = instance.uid;
    effect2.scheduler = () => queueJob(job);
    toggleRecurse(instance, true);
    update3();
  };
  const updateComponentPreRender = (instance, nextVNode, optimized) => {
    nextVNode.component = instance;
    const prevProps = instance.vnode.props;
    instance.vnode = nextVNode;
    instance.next = null;
    updateProps(instance, nextVNode.props, prevProps, optimized);
    updateSlots(instance, nextVNode.children, optimized);
    pauseTracking();
    flushPreFlushCbs(instance);
    resetTracking();
  };
  const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false) => {
    const c1 = n1 && n1.children;
    const prevShapeFlag = n1 ? n1.shapeFlag : 0;
    const c2 = n2.children;
    const { patchFlag, shapeFlag } = n2;
    if (patchFlag > 0) {
      if (patchFlag & 128) {
        patchKeyedChildren(
          c1,
          c2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
        return;
      } else if (patchFlag & 256) {
        patchUnkeyedChildren(
          c1,
          c2,
          container,
          anchor,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
        return;
      }
    }
    if (shapeFlag & 8) {
      if (prevShapeFlag & 16) {
        unmountChildren(c1, parentComponent, parentSuspense);
      }
      if (c2 !== c1) {
        hostSetElementText(container, c2);
      }
    } else {
      if (prevShapeFlag & 16) {
        if (shapeFlag & 16) {
          patchKeyedChildren(
            c1,
            c2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else {
          unmountChildren(c1, parentComponent, parentSuspense, true);
        }
      } else {
        if (prevShapeFlag & 8) {
          hostSetElementText(container, "");
        }
        if (shapeFlag & 16) {
          mountChildren(
            c2,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        }
      }
    }
  };
  const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    c1 = c1 || EMPTY_ARR;
    c2 = c2 || EMPTY_ARR;
    const oldLength = c1.length;
    const newLength = c2.length;
    const commonLength = Math.min(oldLength, newLength);
    let i;
    for (i = 0; i < commonLength; i++) {
      const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
      patch(
        c1[i],
        nextChild,
        container,
        null,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized
      );
    }
    if (oldLength > newLength) {
      unmountChildren(
        c1,
        parentComponent,
        parentSuspense,
        true,
        false,
        commonLength
      );
    } else {
      mountChildren(
        c2,
        container,
        anchor,
        parentComponent,
        parentSuspense,
        namespace,
        slotScopeIds,
        optimized,
        commonLength
      );
    }
  };
  const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) => {
    let i = 0;
    const l2 = c2.length;
    let e1 = c1.length - 1;
    let e2 = l2 - 1;
    while (i <= e1 && i <= e2) {
      const n1 = c1[i];
      const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
      if (isSameVNodeType(n1, n2)) {
        patch(
          n1,
          n2,
          container,
          null,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      } else {
        break;
      }
      i++;
    }
    while (i <= e1 && i <= e2) {
      const n1 = c1[e1];
      const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
      if (isSameVNodeType(n1, n2)) {
        patch(
          n1,
          n2,
          container,
          null,
          parentComponent,
          parentSuspense,
          namespace,
          slotScopeIds,
          optimized
        );
      } else {
        break;
      }
      e1--;
      e2--;
    }
    if (i > e1) {
      if (i <= e2) {
        const nextPos = e2 + 1;
        const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
        while (i <= e2) {
          patch(
            null,
            c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]),
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          i++;
        }
      }
    } else if (i > e2) {
      while (i <= e1) {
        unmount(c1[i], parentComponent, parentSuspense, true);
        i++;
      }
    } else {
      const s1 = i;
      const s2 = i;
      const keyToNewIndexMap = /* @__PURE__ */ new Map();
      for (i = s2; i <= e2; i++) {
        const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
        if (nextChild.key != null) {
          keyToNewIndexMap.set(nextChild.key, i);
        }
      }
      let j;
      let patched = 0;
      const toBePatched = e2 - s2 + 1;
      let moved = false;
      let maxNewIndexSoFar = 0;
      const newIndexToOldIndexMap = new Array(toBePatched);
      for (i = 0; i < toBePatched; i++) newIndexToOldIndexMap[i] = 0;
      for (i = s1; i <= e1; i++) {
        const prevChild = c1[i];
        if (patched >= toBePatched) {
          unmount(prevChild, parentComponent, parentSuspense, true);
          continue;
        }
        let newIndex;
        if (prevChild.key != null) {
          newIndex = keyToNewIndexMap.get(prevChild.key);
        } else {
          for (j = s2; j <= e2; j++) {
            if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
              newIndex = j;
              break;
            }
          }
        }
        if (newIndex === void 0) {
          unmount(prevChild, parentComponent, parentSuspense, true);
        } else {
          newIndexToOldIndexMap[newIndex - s2] = i + 1;
          if (newIndex >= maxNewIndexSoFar) {
            maxNewIndexSoFar = newIndex;
          } else {
            moved = true;
          }
          patch(
            prevChild,
            c2[newIndex],
            container,
            null,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
          patched++;
        }
      }
      const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : EMPTY_ARR;
      j = increasingNewIndexSequence.length - 1;
      for (i = toBePatched - 1; i >= 0; i--) {
        const nextIndex = s2 + i;
        const nextChild = c2[nextIndex];
        const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
        if (newIndexToOldIndexMap[i] === 0) {
          patch(
            null,
            nextChild,
            container,
            anchor,
            parentComponent,
            parentSuspense,
            namespace,
            slotScopeIds,
            optimized
          );
        } else if (moved) {
          if (j < 0 || i !== increasingNewIndexSequence[j]) {
            move(nextChild, container, anchor, 2);
          } else {
            j--;
          }
        }
      }
    }
  };
  const move = (vnode, container, anchor, moveType, parentSuspense = null) => {
    const { el, type, transition, children, shapeFlag } = vnode;
    if (shapeFlag & 6) {
      move(vnode.component.subTree, container, anchor, moveType);
      return;
    }
    if (shapeFlag & 128) {
      vnode.suspense.move(container, anchor, moveType);
      return;
    }
    if (shapeFlag & 64) {
      type.move(vnode, container, anchor, internals);
      return;
    }
    if (type === Fragment) {
      hostInsert(el, container, anchor);
      for (let i = 0; i < children.length; i++) {
        move(children[i], container, anchor, moveType);
      }
      hostInsert(vnode.anchor, container, anchor);
      return;
    }
    if (type === Static) {
      moveStaticNode(vnode, container, anchor);
      return;
    }
    const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
    if (needTransition2) {
      if (moveType === 0) {
        transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        queuePostRenderEffect(() => transition.enter(el), parentSuspense);
      } else {
        const { leave, delayLeave, afterLeave } = transition;
        const remove22 = () => hostInsert(el, container, anchor);
        const performLeave = () => {
          leave(el, () => {
            remove22();
            afterLeave && afterLeave();
          });
        };
        if (delayLeave) {
          delayLeave(el, remove22, performLeave);
        } else {
          performLeave();
        }
      }
    } else {
      hostInsert(el, container, anchor);
    }
  };
  const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false) => {
    const {
      type,
      props,
      ref: ref3,
      children,
      dynamicChildren,
      shapeFlag,
      patchFlag,
      dirs,
      cacheIndex
    } = vnode;
    if (patchFlag === -2) {
      optimized = false;
    }
    if (ref3 != null) {
      setRef(ref3, null, parentSuspense, vnode, true);
    }
    if (cacheIndex != null) {
      parentComponent.renderCache[cacheIndex] = void 0;
    }
    if (shapeFlag & 256) {
      parentComponent.ctx.deactivate(vnode);
      return;
    }
    const shouldInvokeDirs = shapeFlag & 1 && dirs;
    const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
    let vnodeHook;
    if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) {
      invokeVNodeHook(vnodeHook, parentComponent, vnode);
    }
    if (shapeFlag & 6) {
      unmountComponent(vnode.component, parentSuspense, doRemove);
    } else {
      if (shapeFlag & 128) {
        vnode.suspense.unmount(parentSuspense, doRemove);
        return;
      }
      if (shouldInvokeDirs) {
        invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
      }
      if (shapeFlag & 64) {
        vnode.type.remove(
          vnode,
          parentComponent,
          parentSuspense,
          internals,
          doRemove
        );
      } else if (dynamicChildren && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (type !== Fragment || patchFlag > 0 && patchFlag & 64)) {
        unmountChildren(
          dynamicChildren,
          parentComponent,
          parentSuspense,
          false,
          true
        );
      } else if (type === Fragment && patchFlag & (128 | 256) || !optimized && shapeFlag & 16) {
        unmountChildren(children, parentComponent, parentSuspense);
      }
      if (doRemove) {
        remove2(vnode);
      }
    }
    if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) {
      queuePostRenderEffect(() => {
        vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
        shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
      }, parentSuspense);
    }
  };
  const remove2 = (vnode) => {
    const { type, el, anchor, transition } = vnode;
    if (type === Fragment) {
      {
        removeFragment(el, anchor);
      }
      return;
    }
    if (type === Static) {
      removeStaticNode(vnode);
      return;
    }
    const performRemove = () => {
      hostRemove(el);
      if (transition && !transition.persisted && transition.afterLeave) {
        transition.afterLeave();
      }
    };
    if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
      const { leave, delayLeave } = transition;
      const performLeave = () => leave(el, performRemove);
      if (delayLeave) {
        delayLeave(vnode.el, performRemove, performLeave);
      } else {
        performLeave();
      }
    } else {
      performRemove();
    }
  };
  const removeFragment = (cur, end) => {
    let next;
    while (cur !== end) {
      next = hostNextSibling(cur);
      hostRemove(cur);
      cur = next;
    }
    hostRemove(end);
  };
  const unmountComponent = (instance, parentSuspense, doRemove) => {
    const { bum, scope, job, subTree, um, m, a } = instance;
    invalidateMount(m);
    invalidateMount(a);
    if (bum) {
      invokeArrayFns(bum);
    }
    scope.stop();
    if (job) {
      job.flags |= 8;
      unmount(subTree, instance, parentSuspense, doRemove);
    }
    if (um) {
      queuePostRenderEffect(um, parentSuspense);
    }
    queuePostRenderEffect(() => {
      instance.isUnmounted = true;
    }, parentSuspense);
    if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
      parentSuspense.deps--;
      if (parentSuspense.deps === 0) {
        parentSuspense.resolve();
      }
    }
  };
  const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0) => {
    for (let i = start; i < children.length; i++) {
      unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    }
  };
  const getNextHostNode = (vnode) => {
    if (vnode.shapeFlag & 6) {
      return getNextHostNode(vnode.component.subTree);
    }
    if (vnode.shapeFlag & 128) {
      return vnode.suspense.next();
    }
    const el = hostNextSibling(vnode.anchor || vnode.el);
    const teleportEnd = el && el[TeleportEndKey];
    return teleportEnd ? hostNextSibling(teleportEnd) : el;
  };
  let isFlushing = false;
  const render = (vnode, container, namespace) => {
    if (vnode == null) {
      if (container._vnode) {
        unmount(container._vnode, null, null, true);
      }
    } else {
      patch(
        container._vnode || null,
        vnode,
        container,
        null,
        null,
        null,
        namespace
      );
    }
    container._vnode = vnode;
    if (!isFlushing) {
      isFlushing = true;
      flushPreFlushCbs();
      flushPostFlushCbs();
      isFlushing = false;
    }
  };
  const internals = {
    p: patch,
    um: unmount,
    m: move,
    r: remove2,
    mt: mountComponent,
    mc: mountChildren,
    pc: patchChildren,
    pbc: patchBlockChildren,
    n: getNextHostNode,
    o: options
  };
  let hydrate;
  return {
    render,
    hydrate,
    createApp: createAppAPI(render)
  };
}
function resolveChildrenNamespace({ type, props }, currentNamespace) {
  return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function toggleRecurse({ effect: effect2, job }, allowed) {
  if (allowed) {
    effect2.flags |= 32;
    job.flags |= 4;
  } else {
    effect2.flags &= -33;
    job.flags &= -5;
  }
}
function needTransition(parentSuspense, transition) {
  return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function traverseStaticChildren(n1, n2, shallow = false) {
  const ch1 = n1.children;
  const ch2 = n2.children;
  if (isArray(ch1) && isArray(ch2)) {
    for (let i = 0; i < ch1.length; i++) {
      const c1 = ch1[i];
      let c2 = ch2[i];
      if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
        if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
          c2 = ch2[i] = cloneIfMounted(ch2[i]);
          c2.el = c1.el;
        }
        if (!shallow && c2.patchFlag !== -2)
          traverseStaticChildren(c1, c2);
      }
      if (c2.type === Text) {
        c2.el = c1.el;
      }
    }
  }
}
function getSequence(arr) {
  const p2 = arr.slice();
  const result = [0];
  let i, j, u, v, c;
  const len = arr.length;
  for (i = 0; i < len; i++) {
    const arrI = arr[i];
    if (arrI !== 0) {
      j = result[result.length - 1];
      if (arr[j] < arrI) {
        p2[i] = j;
        result.push(i);
        continue;
      }
      u = 0;
      v = result.length - 1;
      while (u < v) {
        c = u + v >> 1;
        if (arr[result[c]] < arrI) {
          u = c + 1;
        } else {
          v = c;
        }
      }
      if (arrI < arr[result[u]]) {
        if (u > 0) {
          p2[i] = result[u - 1];
        }
        result[u] = i;
      }
    }
  }
  u = result.length;
  v = result[u - 1];
  while (u-- > 0) {
    result[u] = v;
    v = p2[v];
  }
  return result;
}
function locateNonHydratedAsyncRoot(instance) {
  const subComponent = instance.subTree.component;
  if (subComponent) {
    if (subComponent.asyncDep && !subComponent.asyncResolved) {
      return subComponent;
    } else {
      return locateNonHydratedAsyncRoot(subComponent);
    }
  }
}
function invalidateMount(hooks) {
  if (hooks) {
    for (let i = 0; i < hooks.length; i++)
      hooks[i].flags |= 8;
  }
}
const ssrContextKey = Symbol.for("v-scx");
const useSSRContext = () => {
  {
    const ctx = inject(ssrContextKey);
    return ctx;
  }
};
function watchEffect(effect2, options) {
  return doWatch(effect2, null, options);
}
function watch(source, cb, options) {
  return doWatch(source, cb, options);
}
function doWatch(source, cb, options = EMPTY_OBJ) {
  const { immediate, deep, flush, once } = options;
  const baseWatchOptions = extend({}, options);
  const runsImmediately = cb && immediate || !cb && flush !== "post";
  let ssrCleanup;
  if (isInSSRComponentSetup) {
    if (flush === "sync") {
      const ctx = useSSRContext();
      ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
    } else if (!runsImmediately) {
      const watchStopHandle = () => {
      };
      watchStopHandle.stop = NOOP;
      watchStopHandle.resume = NOOP;
      watchStopHandle.pause = NOOP;
      return watchStopHandle;
    }
  }
  const instance = currentInstance;
  baseWatchOptions.call = (fn, type, args) => callWithAsyncErrorHandling(fn, instance, type, args);
  let isPre = false;
  if (flush === "post") {
    baseWatchOptions.scheduler = (job) => {
      queuePostRenderEffect(job, instance && instance.suspense);
    };
  } else if (flush !== "sync") {
    isPre = true;
    baseWatchOptions.scheduler = (job, isFirstRun) => {
      if (isFirstRun) {
        job();
      } else {
        queueJob(job);
      }
    };
  }
  baseWatchOptions.augmentJob = (job) => {
    if (cb) {
      job.flags |= 4;
    }
    if (isPre) {
      job.flags |= 2;
      if (instance) {
        job.id = instance.uid;
        job.i = instance;
      }
    }
  };
  const watchHandle = watch$1(source, cb, baseWatchOptions);
  if (isInSSRComponentSetup) {
    if (ssrCleanup) {
      ssrCleanup.push(watchHandle);
    } else if (runsImmediately) {
      watchHandle();
    }
  }
  return watchHandle;
}
function instanceWatch(source, value, options) {
  const publicThis = this.proxy;
  const getter = isString(source) ? source.includes(".") ? createPathGetter(publicThis, source) : () => publicThis[source] : source.bind(publicThis, publicThis);
  let cb;
  if (isFunction(value)) {
    cb = value;
  } else {
    cb = value.handler;
    options = value;
  }
  const reset = setCurrentInstance(this);
  const res = doWatch(getter, cb.bind(publicThis), options);
  reset();
  return res;
}
function createPathGetter(ctx, path) {
  const segments = path.split(".");
  return () => {
    let cur = ctx;
    for (let i = 0; i < segments.length && cur; i++) {
      cur = cur[segments[i]];
    }
    return cur;
  };
}
const getModelModifiers = (props, modelName) => {
  return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${camelize(modelName)}Modifiers`] || props[`${hyphenate(modelName)}Modifiers`];
};
function emit(instance, event, ...rawArgs) {
  if (instance.isUnmounted) return;
  const props = instance.vnode.props || EMPTY_OBJ;
  let args = rawArgs;
  const isModelListener2 = event.startsWith("update:");
  const modifiers = isModelListener2 && getModelModifiers(props, event.slice(7));
  if (modifiers) {
    if (modifiers.trim) {
      args = rawArgs.map((a) => isString(a) ? a.trim() : a);
    }
    if (modifiers.number) {
      args = rawArgs.map(looseToNumber);
    }
  }
  let handlerName;
  let handler = props[handlerName = toHandlerKey(event)] || // also try camelCase event handler (#2249)
  props[handlerName = toHandlerKey(camelize(event))];
  if (!handler && isModelListener2) {
    handler = props[handlerName = toHandlerKey(hyphenate(event))];
  }
  if (handler) {
    callWithAsyncErrorHandling(
      handler,
      instance,
      6,
      args
    );
  }
  const onceHandler = props[handlerName + `Once`];
  if (onceHandler) {
    if (!instance.emitted) {
      instance.emitted = {};
    } else if (instance.emitted[handlerName]) {
      return;
    }
    instance.emitted[handlerName] = true;
    callWithAsyncErrorHandling(
      onceHandler,
      instance,
      6,
      args
    );
  }
}
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
  const cache = appContext.emitsCache;
  const cached = cache.get(comp);
  if (cached !== void 0) {
    return cached;
  }
  const raw = comp.emits;
  let normalized = {};
  let hasExtends = false;
  if (!isFunction(comp)) {
    const extendEmits = (raw2) => {
      const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
      if (normalizedFromExtend) {
        hasExtends = true;
        extend(normalized, normalizedFromExtend);
      }
    };
    if (!asMixin && appContext.mixins.length) {
      appContext.mixins.forEach(extendEmits);
    }
    if (comp.extends) {
      extendEmits(comp.extends);
    }
    if (comp.mixins) {
      comp.mixins.forEach(extendEmits);
    }
  }
  if (!raw && !hasExtends) {
    if (isObject$1(comp)) {
      cache.set(comp, null);
    }
    return null;
  }
  if (isArray(raw)) {
    raw.forEach((key) => normalized[key] = null);
  } else {
    extend(normalized, raw);
  }
  if (isObject$1(comp)) {
    cache.set(comp, normalized);
  }
  return normalized;
}
function isEmitListener(options, key) {
  if (!options || !isOn(key)) {
    return false;
  }
  key = key.slice(2).replace(/Once$/, "");
  return hasOwn(options, key[0].toLowerCase() + key.slice(1)) || hasOwn(options, hyphenate(key)) || hasOwn(options, key);
}
function markAttrsAccessed() {
}
function renderComponentRoot(instance) {
  const {
    type: Component,
    vnode,
    proxy,
    withProxy,
    propsOptions: [propsOptions],
    slots,
    attrs,
    emit: emit2,
    render,
    renderCache,
    props,
    data,
    setupState,
    ctx,
    inheritAttrs
  } = instance;
  const prev = setCurrentRenderingInstance(instance);
  let result;
  let fallthroughAttrs;
  try {
    if (vnode.shapeFlag & 4) {
      const proxyToUse = withProxy || proxy;
      const thisProxy = false ? new Proxy(proxyToUse, {
        get(target, key, receiver) {
          warn$1(
            `Property '${String(
              key
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          );
          return Reflect.get(target, key, receiver);
        }
      }) : proxyToUse;
      result = normalizeVNode(
        render.call(
          thisProxy,
          proxyToUse,
          renderCache,
          false ? shallowReadonly(props) : props,
          setupState,
          data,
          ctx
        )
      );
      fallthroughAttrs = attrs;
    } else {
      const render2 = Component;
      if (false) ;
      result = normalizeVNode(
        render2.length > 1 ? render2(
          false ? shallowReadonly(props) : props,
          false ? {
            get attrs() {
              markAttrsAccessed();
              return shallowReadonly(attrs);
            },
            slots,
            emit: emit2
          } : { attrs, slots, emit: emit2 }
        ) : render2(
          false ? shallowReadonly(props) : props,
          null
        )
      );
      fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
    }
  } catch (err) {
    blockStack.length = 0;
    handleError(err, instance, 1);
    result = createVNode(Comment);
  }
  let root = result;
  if (fallthroughAttrs && inheritAttrs !== false) {
    const keys = Object.keys(fallthroughAttrs);
    const { shapeFlag } = root;
    if (keys.length) {
      if (shapeFlag & (1 | 6)) {
        if (propsOptions && keys.some(isModelListener)) {
          fallthroughAttrs = filterModelListeners(
            fallthroughAttrs,
            propsOptions
          );
        }
        root = cloneVNode(root, fallthroughAttrs, false, true);
      }
    }
  }
  if (vnode.dirs) {
    root = cloneVNode(root, null, false, true);
    root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
  }
  if (vnode.transition) {
    setTransitionHooks(root, vnode.transition);
  }
  {
    result = root;
  }
  setCurrentRenderingInstance(prev);
  return result;
}
const getFunctionalFallthrough = (attrs) => {
  let res;
  for (const key in attrs) {
    if (key === "class" || key === "style" || isOn(key)) {
      (res || (res = {}))[key] = attrs[key];
    }
  }
  return res;
};
const filterModelListeners = (attrs, props) => {
  const res = {};
  for (const key in attrs) {
    if (!isModelListener(key) || !(key.slice(9) in props)) {
      res[key] = attrs[key];
    }
  }
  return res;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
  const { props: prevProps, children: prevChildren, component } = prevVNode;
  const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
  const emits = component.emitsOptions;
  if (nextVNode.dirs || nextVNode.transition) {
    return true;
  }
  if (optimized && patchFlag >= 0) {
    if (patchFlag & 1024) {
      return true;
    }
    if (patchFlag & 16) {
      if (!prevProps) {
        return !!nextProps;
      }
      return hasPropsChanged(prevProps, nextProps, emits);
    } else if (patchFlag & 8) {
      const dynamicProps = nextVNode.dynamicProps;
      for (let i = 0; i < dynamicProps.length; i++) {
        const key = dynamicProps[i];
        if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) {
          return true;
        }
      }
    }
  } else {
    if (prevChildren || nextChildren) {
      if (!nextChildren || !nextChildren.$stable) {
        return true;
      }
    }
    if (prevProps === nextProps) {
      return false;
    }
    if (!prevProps) {
      return !!nextProps;
    }
    if (!nextProps) {
      return true;
    }
    return hasPropsChanged(prevProps, nextProps, emits);
  }
  return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
  const nextKeys = Object.keys(nextProps);
  if (nextKeys.length !== Object.keys(prevProps).length) {
    return true;
  }
  for (let i = 0; i < nextKeys.length; i++) {
    const key = nextKeys[i];
    if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) {
      return true;
    }
  }
  return false;
}
function updateHOCHostEl({ vnode, parent }, el) {
  while (parent) {
    const root = parent.subTree;
    if (root.suspense && root.suspense.activeBranch === vnode) {
      root.el = vnode.el;
    }
    if (root === vnode) {
      (vnode = parent.vnode).el = el;
      parent = parent.parent;
    } else {
      break;
    }
  }
}
const isSuspense = (type) => type.__isSuspense;
function queueEffectWithSuspense(fn, suspense) {
  if (suspense && suspense.pendingBranch) {
    if (isArray(fn)) {
      suspense.effects.push(...fn);
    } else {
      suspense.effects.push(fn);
    }
  } else {
    queuePostFlushCb(fn);
  }
}
const Fragment = Symbol.for("v-fgt");
const Text = Symbol.for("v-txt");
const Comment = Symbol.for("v-cmt");
const Static = Symbol.for("v-stc");
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
  blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
  blockStack.pop();
  currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value, inVOnce = false) {
  isBlockTreeEnabled += value;
  if (value < 0 && currentBlock && inVOnce) {
    currentBlock.hasOnce = true;
  }
}
function setupBlock(vnode) {
  vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || EMPTY_ARR : null;
  closeBlock();
  if (isBlockTreeEnabled > 0 && currentBlock) {
    currentBlock.push(vnode);
  }
  return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
  return setupBlock(
    createBaseVNode(
      type,
      props,
      children,
      patchFlag,
      dynamicProps,
      shapeFlag,
      true
    )
  );
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
  return setupBlock(
    createVNode(
      type,
      props,
      children,
      patchFlag,
      dynamicProps,
      true
    )
  );
}
function isVNode(value) {
  return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
  return n1.type === n2.type && n1.key === n2.key;
}
const normalizeKey = ({ key }) => key != null ? key : null;
const normalizeRef = ({
  ref: ref3,
  ref_key,
  ref_for
}) => {
  if (typeof ref3 === "number") {
    ref3 = "" + ref3;
  }
  return ref3 != null ? isString(ref3) || isRef(ref3) || isFunction(ref3) ? { i: currentRenderingInstance, r: ref3, k: ref_key, f: !!ref_for } : ref3 : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
  const vnode = {
    __v_isVNode: true,
    __v_skip: true,
    type,
    props,
    key: props && normalizeKey(props),
    ref: props && normalizeRef(props),
    scopeId: currentScopeId,
    slotScopeIds: null,
    children,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag,
    patchFlag,
    dynamicProps,
    dynamicChildren: null,
    appContext: null,
    ctx: currentRenderingInstance
  };
  if (needFullChildrenNormalization) {
    normalizeChildren(vnode, children);
    if (shapeFlag & 128) {
      type.normalize(vnode);
    }
  } else if (children) {
    vnode.shapeFlag |= isString(children) ? 8 : 16;
  }
  if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
  !isBlockNode && // has current parent block
  currentBlock && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  vnode.patchFlag !== 32) {
    currentBlock.push(vnode);
  }
  return vnode;
}
const createVNode = _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
  if (!type || type === NULL_DYNAMIC_COMPONENT) {
    type = Comment;
  }
  if (isVNode(type)) {
    const cloned = cloneVNode(
      type,
      props,
      true
      /* mergeRef: true */
    );
    if (children) {
      normalizeChildren(cloned, children);
    }
    if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
      if (cloned.shapeFlag & 6) {
        currentBlock[currentBlock.indexOf(type)] = cloned;
      } else {
        currentBlock.push(cloned);
      }
    }
    cloned.patchFlag = -2;
    return cloned;
  }
  if (isClassComponent(type)) {
    type = type.__vccOpts;
  }
  if (props) {
    props = guardReactiveProps(props);
    let { class: klass, style } = props;
    if (klass && !isString(klass)) {
      props.class = normalizeClass(klass);
    }
    if (isObject$1(style)) {
      if (isProxy(style) && !isArray(style)) {
        style = extend({}, style);
      }
      props.style = normalizeStyle(style);
    }
  }
  const shapeFlag = isString(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : isObject$1(type) ? 4 : isFunction(type) ? 2 : 0;
  return createBaseVNode(
    type,
    props,
    children,
    patchFlag,
    dynamicProps,
    shapeFlag,
    isBlockNode,
    true
  );
}
function guardReactiveProps(props) {
  if (!props) return null;
  return isProxy(props) || isInternalObject(props) ? extend({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
  const { props, ref: ref3, patchFlag, children, transition } = vnode;
  const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
  const cloned = {
    __v_isVNode: true,
    __v_skip: true,
    type: vnode.type,
    props: mergedProps,
    key: mergedProps && normalizeKey(mergedProps),
    ref: extraProps && extraProps.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      mergeRef && ref3 ? isArray(ref3) ? ref3.concat(normalizeRef(extraProps)) : [ref3, normalizeRef(extraProps)] : normalizeRef(extraProps)
    ) : ref3,
    scopeId: vnode.scopeId,
    slotScopeIds: vnode.slotScopeIds,
    children,
    target: vnode.target,
    targetStart: vnode.targetStart,
    targetAnchor: vnode.targetAnchor,
    staticCount: vnode.staticCount,
    shapeFlag: vnode.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
    dynamicProps: vnode.dynamicProps,
    dynamicChildren: vnode.dynamicChildren,
    appContext: vnode.appContext,
    dirs: vnode.dirs,
    transition,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: vnode.component,
    suspense: vnode.suspense,
    ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
    ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
    el: vnode.el,
    anchor: vnode.anchor,
    ctx: vnode.ctx,
    ce: vnode.ce
  };
  if (transition && cloneTransition) {
    setTransitionHooks(
      cloned,
      transition.clone(cloned)
    );
  }
  return cloned;
}
function createTextVNode(text = " ", flag = 0) {
  return createVNode(Text, null, text, flag);
}
function createCommentVNode(text = "", asBlock = false) {
  return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
  if (child == null || typeof child === "boolean") {
    return createVNode(Comment);
  } else if (isArray(child)) {
    return createVNode(
      Fragment,
      null,
      // #3666, avoid reference pollution when reusing vnode
      child.slice()
    );
  } else if (isVNode(child)) {
    return cloneIfMounted(child);
  } else {
    return createVNode(Text, null, String(child));
  }
}
function cloneIfMounted(child) {
  return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
  let type = 0;
  const { shapeFlag } = vnode;
  if (children == null) {
    children = null;
  } else if (isArray(children)) {
    type = 16;
  } else if (typeof children === "object") {
    if (shapeFlag & (1 | 64)) {
      const slot = children.default;
      if (slot) {
        slot._c && (slot._d = false);
        normalizeChildren(vnode, slot());
        slot._c && (slot._d = true);
      }
      return;
    } else {
      type = 32;
      const slotFlag = children._;
      if (!slotFlag && !isInternalObject(children)) {
        children._ctx = currentRenderingInstance;
      } else if (slotFlag === 3 && currentRenderingInstance) {
        if (currentRenderingInstance.slots._ === 1) {
          children._ = 1;
        } else {
          children._ = 2;
          vnode.patchFlag |= 1024;
        }
      }
    }
  } else if (isFunction(children)) {
    children = { default: children, _ctx: currentRenderingInstance };
    type = 32;
  } else {
    children = String(children);
    if (shapeFlag & 64) {
      type = 16;
      children = [createTextVNode(children)];
    } else {
      type = 8;
    }
  }
  vnode.children = children;
  vnode.shapeFlag |= type;
}
function mergeProps(...args) {
  const ret = {};
  for (let i = 0; i < args.length; i++) {
    const toMerge = args[i];
    for (const key in toMerge) {
      if (key === "class") {
        if (ret.class !== toMerge.class) {
          ret.class = normalizeClass([ret.class, toMerge.class]);
        }
      } else if (key === "style") {
        ret.style = normalizeStyle([ret.style, toMerge.style]);
      } else if (isOn(key)) {
        const existing = ret[key];
        const incoming = toMerge[key];
        if (incoming && existing !== incoming && !(isArray(existing) && existing.includes(incoming))) {
          ret[key] = existing ? [].concat(existing, incoming) : incoming;
        }
      } else if (key !== "") {
        ret[key] = toMerge[key];
      }
    }
  }
  return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
  callWithAsyncErrorHandling(hook, instance, 7, [
    vnode,
    prevVNode
  ]);
}
const emptyAppContext = createAppContext();
let uid = 0;
function createComponentInstance(vnode, parent, suspense) {
  const type = vnode.type;
  const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
  const instance = {
    uid: uid++,
    vnode,
    type,
    parent,
    appContext,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new EffectScope(
      true
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: parent ? parent.provides : Object.create(appContext.provides),
    ids: parent ? parent.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: normalizePropsOptions(type, appContext),
    emitsOptions: normalizeEmitsOptions(type, appContext),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: EMPTY_OBJ,
    // inheritAttrs
    inheritAttrs: type.inheritAttrs,
    // state
    ctx: EMPTY_OBJ,
    data: EMPTY_OBJ,
    props: EMPTY_OBJ,
    attrs: EMPTY_OBJ,
    slots: EMPTY_OBJ,
    refs: EMPTY_OBJ,
    setupState: EMPTY_OBJ,
    setupContext: null,
    // suspense related
    suspense,
    suspenseId: suspense ? suspense.pendingId : 0,
    asyncDep: null,
    asyncResolved: false,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: false,
    isUnmounted: false,
    isDeactivated: false,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  {
    instance.ctx = { _: instance };
  }
  instance.root = parent ? parent.root : instance;
  instance.emit = emit.bind(null, instance);
  if (vnode.ce) {
    vnode.ce(instance);
  }
  return instance;
}
let currentInstance = null;
const getCurrentInstance = () => currentInstance || currentRenderingInstance;
let internalSetCurrentInstance;
let setInSSRSetupState;
{
  const g = getGlobalThis();
  const registerGlobalSetter = (key, setter) => {
    let setters;
    if (!(setters = g[key])) setters = g[key] = [];
    setters.push(setter);
    return (v) => {
      if (setters.length > 1) setters.forEach((set) => set(v));
      else setters[0](v);
    };
  };
  internalSetCurrentInstance = registerGlobalSetter(
    `__VUE_INSTANCE_SETTERS__`,
    (v) => currentInstance = v
  );
  setInSSRSetupState = registerGlobalSetter(
    `__VUE_SSR_SETTERS__`,
    (v) => isInSSRComponentSetup = v
  );
}
const setCurrentInstance = (instance) => {
  const prev = currentInstance;
  internalSetCurrentInstance(instance);
  instance.scope.on();
  return () => {
    instance.scope.off();
    internalSetCurrentInstance(prev);
  };
};
const unsetCurrentInstance = () => {
  currentInstance && currentInstance.scope.off();
  internalSetCurrentInstance(null);
};
function isStatefulComponent(instance) {
  return instance.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false, optimized = false) {
  isSSR && setInSSRSetupState(isSSR);
  const { props, children } = instance.vnode;
  const isStateful = isStatefulComponent(instance);
  initProps(instance, props, isStateful, isSSR);
  initSlots(instance, children, optimized);
  const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
  isSSR && setInSSRSetupState(false);
  return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
  const Component = instance.type;
  instance.accessCache = /* @__PURE__ */ Object.create(null);
  instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
  const { setup } = Component;
  if (setup) {
    pauseTracking();
    const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
    const reset = setCurrentInstance(instance);
    const setupResult = callWithErrorHandling(
      setup,
      instance,
      0,
      [
        instance.props,
        setupContext
      ]
    );
    const isAsyncSetup = isPromise$1(setupResult);
    resetTracking();
    reset();
    if ((isAsyncSetup || instance.sp) && !isAsyncWrapper(instance)) {
      markAsyncBoundary(instance);
    }
    if (isAsyncSetup) {
      setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
      if (isSSR) {
        return setupResult.then((resolvedResult) => {
          handleSetupResult(instance, resolvedResult);
        }).catch((e) => {
          handleError(e, instance, 0);
        });
      } else {
        instance.asyncDep = setupResult;
      }
    } else {
      handleSetupResult(instance, setupResult);
    }
  } else {
    finishComponentSetup(instance);
  }
}
function handleSetupResult(instance, setupResult, isSSR) {
  if (isFunction(setupResult)) {
    if (instance.type.__ssrInlineRender) {
      instance.ssrRender = setupResult;
    } else {
      instance.render = setupResult;
    }
  } else if (isObject$1(setupResult)) {
    instance.setupState = proxyRefs(setupResult);
  } else ;
  finishComponentSetup(instance);
}
function finishComponentSetup(instance, isSSR, skipOptions) {
  const Component = instance.type;
  if (!instance.render) {
    instance.render = Component.render || NOOP;
  }
  {
    const reset = setCurrentInstance(instance);
    pauseTracking();
    try {
      applyOptions(instance);
    } finally {
      resetTracking();
      reset();
    }
  }
}
const attrsProxyHandlers = {
  get(target, key) {
    track(target, "get", "");
    return target[key];
  }
};
function createSetupContext(instance) {
  const expose = (exposed) => {
    instance.exposed = exposed || {};
  };
  {
    return {
      attrs: new Proxy(instance.attrs, attrsProxyHandlers),
      slots: instance.slots,
      emit: instance.emit,
      expose
    };
  }
}
function getComponentPublicInstance(instance) {
  if (instance.exposed) {
    return instance.exposeProxy || (instance.exposeProxy = new Proxy(proxyRefs(markRaw(instance.exposed)), {
      get(target, key) {
        if (key in target) {
          return target[key];
        } else if (key in publicPropertiesMap) {
          return publicPropertiesMap[key](instance);
        }
      },
      has(target, key) {
        return key in target || key in publicPropertiesMap;
      }
    }));
  } else {
    return instance.proxy;
  }
}
const classifyRE = /(?:^|[-_])(\w)/g;
const classify = (str) => str.replace(classifyRE, (c) => c.toUpperCase()).replace(/[-_]/g, "");
function getComponentName(Component, includeInferred = true) {
  return isFunction(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function formatComponentName(instance, Component, isRoot = false) {
  let name = getComponentName(Component);
  if (!name && Component.__file) {
    const match = Component.__file.match(/([^/\\]+)\.\w+$/);
    if (match) {
      name = match[1];
    }
  }
  if (!name && instance && instance.parent) {
    const inferFromRegistry = (registry) => {
      for (const key in registry) {
        if (registry[key] === Component) {
          return key;
        }
      }
    };
    name = inferFromRegistry(
      instance.components || instance.parent.type.components
    ) || inferFromRegistry(instance.appContext.components);
  }
  return name ? classify(name) : isRoot ? `App` : `Anonymous`;
}
function isClassComponent(value) {
  return isFunction(value) && "__vccOpts" in value;
}
const computed = (getterOrOptions, debugOptions) => {
  const c = computed$1(getterOrOptions, debugOptions, isInSSRComponentSetup);
  return c;
};
function h(type, propsOrChildren, children) {
  const l = arguments.length;
  if (l === 2) {
    if (isObject$1(propsOrChildren) && !isArray(propsOrChildren)) {
      if (isVNode(propsOrChildren)) {
        return createVNode(type, null, [propsOrChildren]);
      }
      return createVNode(type, propsOrChildren);
    } else {
      return createVNode(type, null, propsOrChildren);
    }
  } else {
    if (l > 3) {
      children = Array.prototype.slice.call(arguments, 2);
    } else if (l === 3 && isVNode(children)) {
      children = [children];
    }
    return createVNode(type, propsOrChildren, children);
  }
}
const version = "3.5.13";
/**
* @vue/runtime-dom v3.5.13
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let policy = void 0;
const tt = typeof window !== "undefined" && window.trustedTypes;
if (tt) {
  try {
    policy = /* @__PURE__ */ tt.createPolicy("vue", {
      createHTML: (val) => val
    });
  } catch (e) {
  }
}
const unsafeToTrustedHTML = policy ? (val) => policy.createHTML(val) : (val) => val;
const svgNS = "http://www.w3.org/2000/svg";
const mathmlNS = "http://www.w3.org/1998/Math/MathML";
const doc = typeof document !== "undefined" ? document : null;
const templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
const nodeOps = {
  insert: (child, parent, anchor) => {
    parent.insertBefore(child, anchor || null);
  },
  remove: (child) => {
    const parent = child.parentNode;
    if (parent) {
      parent.removeChild(child);
    }
  },
  createElement: (tag, namespace, is, props) => {
    const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is ? doc.createElement(tag, { is }) : doc.createElement(tag);
    if (tag === "select" && props && props.multiple != null) {
      el.setAttribute("multiple", props.multiple);
    }
    return el;
  },
  createText: (text) => doc.createTextNode(text),
  createComment: (text) => doc.createComment(text),
  setText: (node, text) => {
    node.nodeValue = text;
  },
  setElementText: (el, text) => {
    el.textContent = text;
  },
  parentNode: (node) => node.parentNode,
  nextSibling: (node) => node.nextSibling,
  querySelector: (selector) => doc.querySelector(selector),
  setScopeId(el, id) {
    el.setAttribute(id, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(content, parent, anchor, namespace, start, end) {
    const before = anchor ? anchor.previousSibling : parent.lastChild;
    if (start && (start === end || start.nextSibling)) {
      while (true) {
        parent.insertBefore(start.cloneNode(true), anchor);
        if (start === end || !(start = start.nextSibling)) break;
      }
    } else {
      templateContainer.innerHTML = unsafeToTrustedHTML(
        namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content
      );
      const template2 = templateContainer.content;
      if (namespace === "svg" || namespace === "mathml") {
        const wrapper = template2.firstChild;
        while (wrapper.firstChild) {
          template2.appendChild(wrapper.firstChild);
        }
        template2.removeChild(wrapper);
      }
      parent.insertBefore(template2, anchor);
    }
    return [
      // first
      before ? before.nextSibling : parent.firstChild,
      // last
      anchor ? anchor.previousSibling : parent.lastChild
    ];
  }
};
const vtcKey = Symbol("_vtc");
function patchClass(el, value, isSVG) {
  const transitionClasses = el[vtcKey];
  if (transitionClasses) {
    value = (value ? [value, ...transitionClasses] : [...transitionClasses]).join(" ");
  }
  if (value == null) {
    el.removeAttribute("class");
  } else if (isSVG) {
    el.setAttribute("class", value);
  } else {
    el.className = value;
  }
}
const vShowOriginalDisplay = Symbol("_vod");
const vShowHidden = Symbol("_vsh");
const vShow = {
  beforeMount(el, { value }, { transition }) {
    el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
    if (transition && value) {
      transition.beforeEnter(el);
    } else {
      setDisplay(el, value);
    }
  },
  mounted(el, { value }, { transition }) {
    if (transition && value) {
      transition.enter(el);
    }
  },
  updated(el, { value, oldValue }, { transition }) {
    if (!value === !oldValue) return;
    if (transition) {
      if (value) {
        transition.beforeEnter(el);
        setDisplay(el, true);
        transition.enter(el);
      } else {
        transition.leave(el, () => {
          setDisplay(el, false);
        });
      }
    } else {
      setDisplay(el, value);
    }
  },
  beforeUnmount(el, { value }) {
    setDisplay(el, value);
  }
};
function setDisplay(el, value) {
  el.style.display = value ? el[vShowOriginalDisplay] : "none";
  el[vShowHidden] = !value;
}
const CSS_VAR_TEXT = Symbol("");
const displayRE = /(^|;)\s*display\s*:/;
function patchStyle(el, prev, next) {
  const style = el.style;
  const isCssString = isString(next);
  let hasControlledDisplay = false;
  if (next && !isCssString) {
    if (prev) {
      if (!isString(prev)) {
        for (const key in prev) {
          if (next[key] == null) {
            setStyle(style, key, "");
          }
        }
      } else {
        for (const prevStyle of prev.split(";")) {
          const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
          if (next[key] == null) {
            setStyle(style, key, "");
          }
        }
      }
    }
    for (const key in next) {
      if (key === "display") {
        hasControlledDisplay = true;
      }
      setStyle(style, key, next[key]);
    }
  } else {
    if (isCssString) {
      if (prev !== next) {
        const cssVarText = style[CSS_VAR_TEXT];
        if (cssVarText) {
          next += ";" + cssVarText;
        }
        style.cssText = next;
        hasControlledDisplay = displayRE.test(next);
      }
    } else if (prev) {
      el.removeAttribute("style");
    }
  }
  if (vShowOriginalDisplay in el) {
    el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
    if (el[vShowHidden]) {
      style.display = "none";
    }
  }
}
const importantRE = /\s*!important$/;
function setStyle(style, name, val) {
  if (isArray(val)) {
    val.forEach((v) => setStyle(style, name, v));
  } else {
    if (val == null) val = "";
    if (name.startsWith("--")) {
      style.setProperty(name, val);
    } else {
      const prefixed = autoPrefix(style, name);
      if (importantRE.test(val)) {
        style.setProperty(
          hyphenate(prefixed),
          val.replace(importantRE, ""),
          "important"
        );
      } else {
        style[prefixed] = val;
      }
    }
  }
}
const prefixes = ["Webkit", "Moz", "ms"];
const prefixCache = {};
function autoPrefix(style, rawName) {
  const cached = prefixCache[rawName];
  if (cached) {
    return cached;
  }
  let name = camelize(rawName);
  if (name !== "filter" && name in style) {
    return prefixCache[rawName] = name;
  }
  name = capitalize(name);
  for (let i = 0; i < prefixes.length; i++) {
    const prefixed = prefixes[i] + name;
    if (prefixed in style) {
      return prefixCache[rawName] = prefixed;
    }
  }
  return rawName;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance, isBoolean = isSpecialBooleanAttr(key)) {
  if (isSVG && key.startsWith("xlink:")) {
    if (value == null) {
      el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (value == null || isBoolean && !includeBooleanAttr(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(
        key,
        isBoolean ? "" : isSymbol(value) ? String(value) : value
      );
    }
  }
}
function patchDOMProp(el, key, value, parentComponent, attrName) {
  if (key === "innerHTML" || key === "textContent") {
    if (value != null) {
      el[key] = key === "innerHTML" ? unsafeToTrustedHTML(value) : value;
    }
    return;
  }
  const tag = el.tagName;
  if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
  !tag.includes("-")) {
    const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
    const newValue = value == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      el.type === "checkbox" ? "on" : ""
    ) : String(value);
    if (oldValue !== newValue || !("_value" in el)) {
      el.value = newValue;
    }
    if (value == null) {
      el.removeAttribute(key);
    }
    el._value = value;
    return;
  }
  let needRemove = false;
  if (value === "" || value == null) {
    const type = typeof el[key];
    if (type === "boolean") {
      value = includeBooleanAttr(value);
    } else if (value == null && type === "string") {
      value = "";
      needRemove = true;
    } else if (type === "number") {
      value = 0;
      needRemove = true;
    }
  }
  try {
    el[key] = value;
  } catch (e) {
  }
  needRemove && el.removeAttribute(attrName || key);
}
function addEventListener(el, event, handler, options) {
  el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
  el.removeEventListener(event, handler, options);
}
const veiKey = Symbol("_vei");
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
  const invokers = el[veiKey] || (el[veiKey] = {});
  const existingInvoker = invokers[rawName];
  if (nextValue && existingInvoker) {
    existingInvoker.value = nextValue;
  } else {
    const [name, options] = parseName(rawName);
    if (nextValue) {
      const invoker = invokers[rawName] = createInvoker(
        nextValue,
        instance
      );
      addEventListener(el, name, invoker, options);
    } else if (existingInvoker) {
      removeEventListener(el, name, existingInvoker, options);
      invokers[rawName] = void 0;
    }
  }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name) {
  let options;
  if (optionsModifierRE.test(name)) {
    options = {};
    let m;
    while (m = name.match(optionsModifierRE)) {
      name = name.slice(0, name.length - m[0].length);
      options[m[0].toLowerCase()] = true;
    }
  }
  const event = name[2] === ":" ? name.slice(3) : hyphenate(name.slice(2));
  return [event, options];
}
let cachedNow = 0;
const p = /* @__PURE__ */ Promise.resolve();
const getNow = () => cachedNow || (p.then(() => cachedNow = 0), cachedNow = Date.now());
function createInvoker(initialValue, instance) {
  const invoker = (e) => {
    if (!e._vts) {
      e._vts = Date.now();
    } else if (e._vts <= invoker.attached) {
      return;
    }
    callWithAsyncErrorHandling(
      patchStopImmediatePropagation(e, invoker.value),
      instance,
      5,
      [e]
    );
  };
  invoker.value = initialValue;
  invoker.attached = getNow();
  return invoker;
}
function patchStopImmediatePropagation(e, value) {
  if (isArray(value)) {
    const originalStop = e.stopImmediatePropagation;
    e.stopImmediatePropagation = () => {
      originalStop.call(e);
      e._stopped = true;
    };
    return value.map(
      (fn) => (e2) => !e2._stopped && fn && fn(e2)
    );
  } else {
    return value;
  }
}
const isNativeOn = (key) => key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const patchProp = (el, key, prevValue, nextValue, namespace, parentComponent) => {
  const isSVG = namespace === "svg";
  if (key === "class") {
    patchClass(el, nextValue, isSVG);
  } else if (key === "style") {
    patchStyle(el, prevValue, nextValue);
  } else if (isOn(key)) {
    if (!isModelListener(key)) {
      patchEvent(el, key, prevValue, nextValue, parentComponent);
    }
  } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
    patchDOMProp(el, key, nextValue);
    if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) {
      patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    }
  } else if (
    // #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !isString(nextValue))
  ) {
    patchDOMProp(el, camelize(key), nextValue, parentComponent, key);
  } else {
    if (key === "true-value") {
      el._trueValue = nextValue;
    } else if (key === "false-value") {
      el._falseValue = nextValue;
    }
    patchAttr(el, key, nextValue, isSVG);
  }
};
function shouldSetAsProp(el, key, value, isSVG) {
  if (isSVG) {
    if (key === "innerHTML" || key === "textContent") {
      return true;
    }
    if (key in el && isNativeOn(key) && isFunction(value)) {
      return true;
    }
    return false;
  }
  if (key === "spellcheck" || key === "draggable" || key === "translate") {
    return false;
  }
  if (key === "form") {
    return false;
  }
  if (key === "list" && el.tagName === "INPUT") {
    return false;
  }
  if (key === "type" && el.tagName === "TEXTAREA") {
    return false;
  }
  if (key === "width" || key === "height") {
    const tag = el.tagName;
    if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") {
      return false;
    }
  }
  if (isNativeOn(key) && isString(value)) {
    return false;
  }
  return key in el;
}
const getModelAssigner = (vnode) => {
  const fn = vnode.props["onUpdate:modelValue"] || false;
  return isArray(fn) ? (value) => invokeArrayFns(fn, value) : fn;
};
function onCompositionStart(e) {
  e.target.composing = true;
}
function onCompositionEnd(e) {
  const target = e.target;
  if (target.composing) {
    target.composing = false;
    target.dispatchEvent(new Event("input"));
  }
}
const assignKey = Symbol("_assign");
const vModelText = {
  created(el, { modifiers: { lazy, trim, number } }, vnode) {
    el[assignKey] = getModelAssigner(vnode);
    const castToNumber = number || vnode.props && vnode.props.type === "number";
    addEventListener(el, lazy ? "change" : "input", (e) => {
      if (e.target.composing) return;
      let domValue = el.value;
      if (trim) {
        domValue = domValue.trim();
      }
      if (castToNumber) {
        domValue = looseToNumber(domValue);
      }
      el[assignKey](domValue);
    });
    if (trim) {
      addEventListener(el, "change", () => {
        el.value = el.value.trim();
      });
    }
    if (!lazy) {
      addEventListener(el, "compositionstart", onCompositionStart);
      addEventListener(el, "compositionend", onCompositionEnd);
      addEventListener(el, "change", onCompositionEnd);
    }
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(el, { value }) {
    el.value = value == null ? "" : value;
  },
  beforeUpdate(el, { value, oldValue, modifiers: { lazy, trim, number } }, vnode) {
    el[assignKey] = getModelAssigner(vnode);
    if (el.composing) return;
    const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? looseToNumber(el.value) : el.value;
    const newValue = value == null ? "" : value;
    if (elValue === newValue) {
      return;
    }
    if (document.activeElement === el && el.type !== "range") {
      if (lazy && value === oldValue) {
        return;
      }
      if (trim && el.value.trim() === newValue) {
        return;
      }
    }
    el.value = newValue;
  }
};
const systemModifiers = ["ctrl", "shift", "alt", "meta"];
const modifierGuards = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, modifiers) => systemModifiers.some((m) => e[`${m}Key`] && !modifiers.includes(m))
};
const withModifiers = (fn, modifiers) => {
  const cache = fn._withMods || (fn._withMods = {});
  const cacheKey = modifiers.join(".");
  return cache[cacheKey] || (cache[cacheKey] = (event, ...args) => {
    for (let i = 0; i < modifiers.length; i++) {
      const guard = modifierGuards[modifiers[i]];
      if (guard && guard(event, modifiers)) return;
    }
    return fn(event, ...args);
  });
};
const keyNames = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
};
const withKeys = (fn, modifiers) => {
  const cache = fn._withKeys || (fn._withKeys = {});
  const cacheKey = modifiers.join(".");
  return cache[cacheKey] || (cache[cacheKey] = (event) => {
    if (!("key" in event)) {
      return;
    }
    const eventKey = hyphenate(event.key);
    if (modifiers.some(
      (k) => k === eventKey || keyNames[k] === eventKey
    )) {
      return fn(event);
    }
  });
};
const rendererOptions = /* @__PURE__ */ extend({ patchProp }, nodeOps);
let renderer;
function ensureRenderer() {
  return renderer || (renderer = createRenderer(rendererOptions));
}
const createApp = (...args) => {
  const app = ensureRenderer().createApp(...args);
  const { mount } = app;
  app.mount = (containerOrSelector) => {
    const container = normalizeContainer(containerOrSelector);
    if (!container) return;
    const component = app._component;
    if (!isFunction(component) && !component.render && !component.template) {
      component.template = container.innerHTML;
    }
    if (container.nodeType === 1) {
      container.textContent = "";
    }
    const proxy = mount(container, false, resolveRootNamespace(container));
    if (container instanceof Element) {
      container.removeAttribute("v-cloak");
      container.setAttribute("data-v-app", "");
    }
    return proxy;
  };
  return app;
};
function resolveRootNamespace(container) {
  if (container instanceof SVGElement) {
    return "svg";
  }
  if (typeof MathMLElement === "function" && container instanceof MathMLElement) {
    return "mathml";
  }
}
function normalizeContainer(container) {
  if (isString(container)) {
    const res = document.querySelector(container);
    return res;
  }
  return container;
}
function getDevtoolsGlobalHook() {
  return getTarget().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function getTarget() {
  return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : {};
}
const isProxyAvailable = typeof Proxy === "function";
const HOOK_SETUP = "devtools-plugin:setup";
const HOOK_PLUGIN_SETTINGS_SET = "plugin:settings:set";
let supported;
let perf;
function isPerformanceSupported() {
  var _a;
  if (supported !== void 0) {
    return supported;
  }
  if (typeof window !== "undefined" && window.performance) {
    supported = true;
    perf = window.performance;
  } else if (typeof globalThis !== "undefined" && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
    supported = true;
    perf = globalThis.perf_hooks.performance;
  } else {
    supported = false;
  }
  return supported;
}
function now() {
  return isPerformanceSupported() ? perf.now() : Date.now();
}
class ApiProxy {
  constructor(plugin, hook) {
    this.target = null;
    this.targetQueue = [];
    this.onQueue = [];
    this.plugin = plugin;
    this.hook = hook;
    const defaultSettings = {};
    if (plugin.settings) {
      for (const id in plugin.settings) {
        const item = plugin.settings[id];
        defaultSettings[id] = item.defaultValue;
      }
    }
    const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
    let currentSettings = Object.assign({}, defaultSettings);
    try {
      const raw = localStorage.getItem(localSettingsSaveId);
      const data = JSON.parse(raw);
      Object.assign(currentSettings, data);
    } catch (e) {
    }
    this.fallbacks = {
      getSettings() {
        return currentSettings;
      },
      setSettings(value) {
        try {
          localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
        } catch (e) {
        }
        currentSettings = value;
      },
      now() {
        return now();
      }
    };
    if (hook) {
      hook.on(HOOK_PLUGIN_SETTINGS_SET, (pluginId, value) => {
        if (pluginId === this.plugin.id) {
          this.fallbacks.setSettings(value);
        }
      });
    }
    this.proxiedOn = new Proxy({}, {
      get: (_target, prop) => {
        if (this.target) {
          return this.target.on[prop];
        } else {
          return (...args) => {
            this.onQueue.push({
              method: prop,
              args
            });
          };
        }
      }
    });
    this.proxiedTarget = new Proxy({}, {
      get: (_target, prop) => {
        if (this.target) {
          return this.target[prop];
        } else if (prop === "on") {
          return this.proxiedOn;
        } else if (Object.keys(this.fallbacks).includes(prop)) {
          return (...args) => {
            this.targetQueue.push({
              method: prop,
              args,
              resolve: () => {
              }
            });
            return this.fallbacks[prop](...args);
          };
        } else {
          return (...args) => {
            return new Promise((resolve2) => {
              this.targetQueue.push({
                method: prop,
                args,
                resolve: resolve2
              });
            });
          };
        }
      }
    });
  }
  async setRealTarget(target) {
    this.target = target;
    for (const item of this.onQueue) {
      this.target.on[item.method](...item.args);
    }
    for (const item of this.targetQueue) {
      item.resolve(await this.target[item.method](...item.args));
    }
  }
}
function setupDevtoolsPlugin(pluginDescriptor, setupFn) {
  const descriptor = pluginDescriptor;
  const target = getTarget();
  const hook = getDevtoolsGlobalHook();
  const enableProxy = isProxyAvailable && descriptor.enableEarlyProxy;
  if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) {
    hook.emit(HOOK_SETUP, pluginDescriptor, setupFn);
  } else {
    const proxy = enableProxy ? new ApiProxy(descriptor, hook) : null;
    const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
    list.push({
      pluginDescriptor: descriptor,
      setupFn,
      proxy
    });
    if (proxy) {
      setupFn(proxy.proxiedTarget);
    }
  }
}
/*!
 * vuex v4.1.0
 * (c) 2022 Evan You
 * @license MIT
 */
var storeKey = "store";
function forEachValue(obj, fn) {
  Object.keys(obj).forEach(function(key) {
    return fn(obj[key], key);
  });
}
function isObject(obj) {
  return obj !== null && typeof obj === "object";
}
function isPromise(val) {
  return val && typeof val.then === "function";
}
function partial(fn, arg) {
  return function() {
    return fn(arg);
  };
}
function genericSubscribe(fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend ? subs.unshift(fn) : subs.push(fn);
  }
  return function() {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  };
}
function resetStore(store2, hot) {
  store2._actions = /* @__PURE__ */ Object.create(null);
  store2._mutations = /* @__PURE__ */ Object.create(null);
  store2._wrappedGetters = /* @__PURE__ */ Object.create(null);
  store2._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var state = store2.state;
  installModule(store2, state, [], store2._modules.root, true);
  resetStoreState(store2, state, hot);
}
function resetStoreState(store2, state, hot) {
  var oldState = store2._state;
  var oldScope = store2._scope;
  store2.getters = {};
  store2._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var wrappedGetters = store2._wrappedGetters;
  var computedObj = {};
  var computedCache = {};
  var scope = effectScope(true);
  scope.run(function() {
    forEachValue(wrappedGetters, function(fn, key) {
      computedObj[key] = partial(fn, store2);
      computedCache[key] = computed(function() {
        return computedObj[key]();
      });
      Object.defineProperty(store2.getters, key, {
        get: function() {
          return computedCache[key].value;
        },
        enumerable: true
        // for local getters
      });
    });
  });
  store2._state = reactive({
    data: state
  });
  store2._scope = scope;
  if (store2.strict) {
    enableStrictMode(store2);
  }
  if (oldState) {
    if (hot) {
      store2._withCommit(function() {
        oldState.data = null;
      });
    }
  }
  if (oldScope) {
    oldScope.stop();
  }
}
function installModule(store2, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store2._modules.getNamespace(path);
  if (module.namespaced) {
    if (store2._modulesNamespaceMap[namespace] && false) ;
    store2._modulesNamespaceMap[namespace] = module;
  }
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store2._withCommit(function() {
      parentState[moduleName] = module.state;
    });
  }
  var local = module.context = makeLocalContext(store2, namespace, path);
  module.forEachMutation(function(mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store2, namespacedType, mutation, local);
  });
  module.forEachAction(function(action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store2, type, handler, local);
  });
  module.forEachGetter(function(getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store2, namespacedType, getter, local);
  });
  module.forEachChild(function(child, key) {
    installModule(store2, rootState, path.concat(key), child, hot);
  });
}
function makeLocalContext(store2, namespace, path) {
  var noNamespace = namespace === "";
  var local = {
    dispatch: noNamespace ? store2.dispatch : function(_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;
      if (!options || !options.root) {
        type = namespace + type;
      }
      return store2.dispatch(type, payload);
    },
    commit: noNamespace ? store2.commit : function(_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;
      if (!options || !options.root) {
        type = namespace + type;
      }
      store2.commit(type, payload, options);
    }
  };
  Object.defineProperties(local, {
    getters: {
      get: noNamespace ? function() {
        return store2.getters;
      } : function() {
        return makeLocalGetters(store2, namespace);
      }
    },
    state: {
      get: function() {
        return getNestedState(store2.state, path);
      }
    }
  });
  return local;
}
function makeLocalGetters(store2, namespace) {
  if (!store2._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store2.getters).forEach(function(type) {
      if (type.slice(0, splitPos) !== namespace) {
        return;
      }
      var localType = type.slice(splitPos);
      Object.defineProperty(gettersProxy, localType, {
        get: function() {
          return store2.getters[type];
        },
        enumerable: true
      });
    });
    store2._makeLocalGettersCache[namespace] = gettersProxy;
  }
  return store2._makeLocalGettersCache[namespace];
}
function registerMutation(store2, type, handler, local) {
  var entry = store2._mutations[type] || (store2._mutations[type] = []);
  entry.push(function wrappedMutationHandler(payload) {
    handler.call(store2, local.state, payload);
  });
}
function registerAction(store2, type, handler, local) {
  var entry = store2._actions[type] || (store2._actions[type] = []);
  entry.push(function wrappedActionHandler(payload) {
    var res = handler.call(store2, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store2.getters,
      rootState: store2.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store2._devtoolHook) {
      return res.catch(function(err) {
        store2._devtoolHook.emit("vuex:error", err);
        throw err;
      });
    } else {
      return res;
    }
  });
}
function registerGetter(store2, type, rawGetter, local) {
  if (store2._wrappedGetters[type]) {
    return;
  }
  store2._wrappedGetters[type] = function wrappedGetter(store22) {
    return rawGetter(
      local.state,
      // local state
      local.getters,
      // local getters
      store22.state,
      // root state
      store22.getters
      // root getters
    );
  };
}
function enableStrictMode(store2) {
  watch(function() {
    return store2._state.data;
  }, function() {
  }, { deep: true, flush: "sync" });
}
function getNestedState(state, path) {
  return path.reduce(function(state2, key) {
    return state2[key];
  }, state);
}
function unifyObjectStyle(type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }
  return { type, payload, options };
}
var LABEL_VUEX_BINDINGS = "vuex bindings";
var MUTATIONS_LAYER_ID = "vuex:mutations";
var ACTIONS_LAYER_ID = "vuex:actions";
var INSPECTOR_ID = "vuex";
var actionId = 0;
function addDevtools(app, store2) {
  setupDevtoolsPlugin(
    {
      id: "org.vuejs.vuex",
      app,
      label: "Vuex",
      homepage: "https://next.vuex.vuejs.org/",
      logo: "https://vuejs.org/images/icons/favicon-96x96.png",
      packageName: "vuex",
      componentStateTypes: [LABEL_VUEX_BINDINGS]
    },
    function(api) {
      api.addTimelineLayer({
        id: MUTATIONS_LAYER_ID,
        label: "Vuex Mutations",
        color: COLOR_LIME_500
      });
      api.addTimelineLayer({
        id: ACTIONS_LAYER_ID,
        label: "Vuex Actions",
        color: COLOR_LIME_500
      });
      api.addInspector({
        id: INSPECTOR_ID,
        label: "Vuex",
        icon: "storage",
        treeFilterPlaceholder: "Filter stores..."
      });
      api.on.getInspectorTree(function(payload) {
        if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
          if (payload.filter) {
            var nodes = [];
            flattenStoreForInspectorTree(nodes, store2._modules.root, payload.filter, "");
            payload.rootNodes = nodes;
          } else {
            payload.rootNodes = [
              formatStoreForInspectorTree(store2._modules.root, "")
            ];
          }
        }
      });
      api.on.getInspectorState(function(payload) {
        if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
          var modulePath = payload.nodeId;
          makeLocalGetters(store2, modulePath);
          payload.state = formatStoreForInspectorState(
            getStoreModule(store2._modules, modulePath),
            modulePath === "root" ? store2.getters : store2._makeLocalGettersCache,
            modulePath
          );
        }
      });
      api.on.editInspectorState(function(payload) {
        if (payload.app === app && payload.inspectorId === INSPECTOR_ID) {
          var modulePath = payload.nodeId;
          var path = payload.path;
          if (modulePath !== "root") {
            path = modulePath.split("/").filter(Boolean).concat(path);
          }
          store2._withCommit(function() {
            payload.set(store2._state.data, path, payload.state.value);
          });
        }
      });
      store2.subscribe(function(mutation, state) {
        var data = {};
        if (mutation.payload) {
          data.payload = mutation.payload;
        }
        data.state = state;
        api.notifyComponentUpdate();
        api.sendInspectorTree(INSPECTOR_ID);
        api.sendInspectorState(INSPECTOR_ID);
        api.addTimelineEvent({
          layerId: MUTATIONS_LAYER_ID,
          event: {
            time: Date.now(),
            title: mutation.type,
            data
          }
        });
      });
      store2.subscribeAction({
        before: function(action, state) {
          var data = {};
          if (action.payload) {
            data.payload = action.payload;
          }
          action._id = actionId++;
          action._time = Date.now();
          data.state = state;
          api.addTimelineEvent({
            layerId: ACTIONS_LAYER_ID,
            event: {
              time: action._time,
              title: action.type,
              groupId: action._id,
              subtitle: "start",
              data
            }
          });
        },
        after: function(action, state) {
          var data = {};
          var duration = Date.now() - action._time;
          data.duration = {
            _custom: {
              type: "duration",
              display: duration + "ms",
              tooltip: "Action duration",
              value: duration
            }
          };
          if (action.payload) {
            data.payload = action.payload;
          }
          data.state = state;
          api.addTimelineEvent({
            layerId: ACTIONS_LAYER_ID,
            event: {
              time: Date.now(),
              title: action.type,
              groupId: action._id,
              subtitle: "end",
              data
            }
          });
        }
      });
    }
  );
}
var COLOR_LIME_500 = 8702998;
var COLOR_DARK = 6710886;
var COLOR_WHITE = 16777215;
var TAG_NAMESPACED = {
  label: "namespaced",
  textColor: COLOR_WHITE,
  backgroundColor: COLOR_DARK
};
function extractNameFromPath(path) {
  return path && path !== "root" ? path.split("/").slice(-2, -1)[0] : "Root";
}
function formatStoreForInspectorTree(module, path) {
  return {
    id: path || "root",
    // all modules end with a `/`, we want the last segment only
    // cart/ -> cart
    // nested/cart/ -> cart
    label: extractNameFromPath(path),
    tags: module.namespaced ? [TAG_NAMESPACED] : [],
    children: Object.keys(module._children).map(
      function(moduleName) {
        return formatStoreForInspectorTree(
          module._children[moduleName],
          path + moduleName + "/"
        );
      }
    )
  };
}
function flattenStoreForInspectorTree(result, module, filter, path) {
  if (path.includes(filter)) {
    result.push({
      id: path || "root",
      label: path.endsWith("/") ? path.slice(0, path.length - 1) : path || "Root",
      tags: module.namespaced ? [TAG_NAMESPACED] : []
    });
  }
  Object.keys(module._children).forEach(function(moduleName) {
    flattenStoreForInspectorTree(result, module._children[moduleName], filter, path + moduleName + "/");
  });
}
function formatStoreForInspectorState(module, getters, path) {
  getters = path === "root" ? getters : getters[path];
  var gettersKeys = Object.keys(getters);
  var storeState = {
    state: Object.keys(module.state).map(function(key) {
      return {
        key,
        editable: true,
        value: module.state[key]
      };
    })
  };
  if (gettersKeys.length) {
    var tree = transformPathsToObjectTree(getters);
    storeState.getters = Object.keys(tree).map(function(key) {
      return {
        key: key.endsWith("/") ? extractNameFromPath(key) : key,
        editable: false,
        value: canThrow(function() {
          return tree[key];
        })
      };
    });
  }
  return storeState;
}
function transformPathsToObjectTree(getters) {
  var result = {};
  Object.keys(getters).forEach(function(key) {
    var path = key.split("/");
    if (path.length > 1) {
      var target = result;
      var leafKey = path.pop();
      path.forEach(function(p2) {
        if (!target[p2]) {
          target[p2] = {
            _custom: {
              value: {},
              display: p2,
              tooltip: "Module",
              abstract: true
            }
          };
        }
        target = target[p2]._custom.value;
      });
      target[leafKey] = canThrow(function() {
        return getters[key];
      });
    } else {
      result[key] = canThrow(function() {
        return getters[key];
      });
    }
  });
  return result;
}
function getStoreModule(moduleMap, path) {
  var names = path.split("/").filter(function(n) {
    return n;
  });
  return names.reduce(
    function(module, moduleName, i) {
      var child = module[moduleName];
      if (!child) {
        throw new Error('Missing module "' + moduleName + '" for path "' + path + '".');
      }
      return i === names.length - 1 ? child : child._children;
    },
    path === "root" ? moduleMap : moduleMap.root._children
  );
}
function canThrow(cb) {
  try {
    return cb();
  } catch (e) {
    return e;
  }
}
var Module = function Module2(rawModule, runtime) {
  this.runtime = runtime;
  this._children = /* @__PURE__ */ Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === "function" ? rawState() : rawState) || {};
};
var prototypeAccessors$1 = { namespaced: { configurable: true } };
prototypeAccessors$1.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
Module.prototype.addChild = function addChild(key, module) {
  this._children[key] = module;
};
Module.prototype.removeChild = function removeChild(key) {
  delete this._children[key];
};
Module.prototype.getChild = function getChild(key) {
  return this._children[key];
};
Module.prototype.hasChild = function hasChild(key) {
  return key in this._children;
};
Module.prototype.update = function update(rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};
Module.prototype.forEachChild = function forEachChild(fn) {
  forEachValue(this._children, fn);
};
Module.prototype.forEachGetter = function forEachGetter(fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};
Module.prototype.forEachAction = function forEachAction(fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};
Module.prototype.forEachMutation = function forEachMutation(fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};
Object.defineProperties(Module.prototype, prototypeAccessors$1);
var ModuleCollection = function ModuleCollection2(rawRootModule) {
  this.register([], rawRootModule, false);
};
ModuleCollection.prototype.get = function get(path) {
  return path.reduce(function(module, key) {
    return module.getChild(key);
  }, this.root);
};
ModuleCollection.prototype.getNamespace = function getNamespace(path) {
  var module = this.root;
  return path.reduce(function(namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + "/" : "");
  }, "");
};
ModuleCollection.prototype.update = function update$1(rawRootModule) {
  update2([], this.root, rawRootModule);
};
ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
  var this$1$1 = this;
  if (runtime === void 0) runtime = true;
  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function(rawChildModule, key) {
      this$1$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};
ModuleCollection.prototype.unregister = function unregister(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);
  if (!child) {
    return;
  }
  if (!child.runtime) {
    return;
  }
  parent.removeChild(key);
};
ModuleCollection.prototype.isRegistered = function isRegistered(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (parent) {
    return parent.hasChild(key);
  }
  return false;
};
function update2(path, targetModule, newModule) {
  targetModule.update(newModule);
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        return;
      }
      update2(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}
function createStore(options) {
  return new Store(options);
}
var Store = function Store2(options) {
  var this$1$1 = this;
  if (options === void 0) options = {};
  var plugins = options.plugins;
  if (plugins === void 0) plugins = [];
  var strict = options.strict;
  if (strict === void 0) strict = false;
  var devtools = options.devtools;
  this._committing = false;
  this._actions = /* @__PURE__ */ Object.create(null);
  this._actionSubscribers = [];
  this._mutations = /* @__PURE__ */ Object.create(null);
  this._wrappedGetters = /* @__PURE__ */ Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  this._subscribers = [];
  this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  this._scope = null;
  this._devtools = devtools;
  var store2 = this;
  var ref2 = this;
  var dispatch2 = ref2.dispatch;
  var commit2 = ref2.commit;
  this.dispatch = function boundDispatch(type, payload) {
    return dispatch2.call(store2, type, payload);
  };
  this.commit = function boundCommit(type, payload, options2) {
    return commit2.call(store2, type, payload, options2);
  };
  this.strict = strict;
  var state = this._modules.root.state;
  installModule(this, state, [], this._modules.root);
  resetStoreState(this, state);
  plugins.forEach(function(plugin) {
    return plugin(this$1$1);
  });
};
var prototypeAccessors = { state: { configurable: true } };
Store.prototype.install = function install(app, injectKey) {
  app.provide(injectKey || storeKey, this);
  app.config.globalProperties.$store = this;
  var useDevtools = this._devtools !== void 0 ? this._devtools : false;
  if (useDevtools) {
    addDevtools(app, this);
  }
};
prototypeAccessors.state.get = function() {
  return this._state.data;
};
prototypeAccessors.state.set = function(v) {
};
Store.prototype.commit = function commit(_type, _payload, _options) {
  var this$1$1 = this;
  var ref2 = unifyObjectStyle(_type, _payload, _options);
  var type = ref2.type;
  var payload = ref2.payload;
  var mutation = { type, payload };
  var entry = this._mutations[type];
  if (!entry) {
    return;
  }
  this._withCommit(function() {
    entry.forEach(function commitIterator(handler) {
      handler(payload);
    });
  });
  this._subscribers.slice().forEach(function(sub) {
    return sub(mutation, this$1$1.state);
  });
};
Store.prototype.dispatch = function dispatch(_type, _payload) {
  var this$1$1 = this;
  var ref2 = unifyObjectStyle(_type, _payload);
  var type = ref2.type;
  var payload = ref2.payload;
  var action = { type, payload };
  var entry = this._actions[type];
  if (!entry) {
    return;
  }
  try {
    this._actionSubscribers.slice().filter(function(sub) {
      return sub.before;
    }).forEach(function(sub) {
      return sub.before(action, this$1$1.state);
    });
  } catch (e) {
  }
  var result = entry.length > 1 ? Promise.all(entry.map(function(handler) {
    return handler(payload);
  })) : entry[0](payload);
  return new Promise(function(resolve2, reject) {
    result.then(function(res) {
      try {
        this$1$1._actionSubscribers.filter(function(sub) {
          return sub.after;
        }).forEach(function(sub) {
          return sub.after(action, this$1$1.state);
        });
      } catch (e) {
      }
      resolve2(res);
    }, function(error) {
      try {
        this$1$1._actionSubscribers.filter(function(sub) {
          return sub.error;
        }).forEach(function(sub) {
          return sub.error(action, this$1$1.state, error);
        });
      } catch (e) {
      }
      reject(error);
    });
  });
};
Store.prototype.subscribe = function subscribe(fn, options) {
  return genericSubscribe(fn, this._subscribers, options);
};
Store.prototype.subscribeAction = function subscribeAction(fn, options) {
  var subs = typeof fn === "function" ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options);
};
Store.prototype.watch = function watch$12(getter, cb, options) {
  var this$1$1 = this;
  return watch(function() {
    return getter(this$1$1.state, this$1$1.getters);
  }, cb, Object.assign({}, options));
};
Store.prototype.replaceState = function replaceState(state) {
  var this$1$1 = this;
  this._withCommit(function() {
    this$1$1._state.data = state;
  });
};
Store.prototype.registerModule = function registerModule(path, rawModule, options) {
  if (options === void 0) options = {};
  if (typeof path === "string") {
    path = [path];
  }
  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  resetStoreState(this, this.state);
};
Store.prototype.unregisterModule = function unregisterModule(path) {
  var this$1$1 = this;
  if (typeof path === "string") {
    path = [path];
  }
  this._modules.unregister(path);
  this._withCommit(function() {
    var parentState = getNestedState(this$1$1.state, path.slice(0, -1));
    delete parentState[path[path.length - 1]];
  });
  resetStore(this);
};
Store.prototype.hasModule = function hasModule(path) {
  if (typeof path === "string") {
    path = [path];
  }
  return this._modules.isRegistered(path);
};
Store.prototype.hotUpdate = function hotUpdate(newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};
Store.prototype._withCommit = function _withCommit(fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};
Object.defineProperties(Store.prototype, prototypeAccessors);
var mapMutations = normalizeNamespace(function(namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function(ref2) {
    var key = ref2.key;
    var val = ref2.val;
    res[key] = function mappedMutation() {
      var args = [], len = arguments.length;
      while (len--) args[len] = arguments[len];
      var commit2 = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, "mapMutations", namespace);
        if (!module) {
          return;
        }
        commit2 = module.context.commit;
      }
      return typeof val === "function" ? val.apply(this, [commit2].concat(args)) : commit2.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});
var mapGetters = normalizeNamespace(function(namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function(ref2) {
    var key = ref2.key;
    var val = ref2.val;
    val = namespace + val;
    res[key] = function mappedGetter() {
      if (namespace && !getModuleByNamespace(this.$store, "mapGetters", namespace)) {
        return;
      }
      return this.$store.getters[val];
    };
    res[key].vuex = true;
  });
  return res;
});
var mapActions = normalizeNamespace(function(namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function(ref2) {
    var key = ref2.key;
    var val = ref2.val;
    res[key] = function mappedAction() {
      var args = [], len = arguments.length;
      while (len--) args[len] = arguments[len];
      var dispatch2 = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, "mapActions", namespace);
        if (!module) {
          return;
        }
        dispatch2 = module.context.dispatch;
      }
      return typeof val === "function" ? val.apply(this, [dispatch2].concat(args)) : dispatch2.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});
function normalizeMap(map) {
  if (!isValidMap(map)) {
    return [];
  }
  return Array.isArray(map) ? map.map(function(key) {
    return { key, val: key };
  }) : Object.keys(map).map(function(key) {
    return { key, val: map[key] };
  });
}
function isValidMap(map) {
  return Array.isArray(map) || isObject(map);
}
function normalizeNamespace(fn) {
  return function(namespace, map) {
    if (typeof namespace !== "string") {
      map = namespace;
      namespace = "";
    } else if (namespace.charAt(namespace.length - 1) !== "/") {
      namespace += "/";
    }
    return fn(namespace, map);
  };
}
function getModuleByNamespace(store2, helper, namespace) {
  var module = store2._modulesNamespaceMap[namespace];
  return module;
}
function roundBackToNearest95(price) {
  price = price / 100;
  let adjustedPrice = price * 0.99;
  const result = Math.floor(adjustedPrice) + 0.95;
  return result * 100;
}
const store$1 = (config) => {
  return createStore({
    state() {
      var _a, _b;
      return {
        config,
        currency: config.currency,
        steps: config.steps,
        currentTab: "",
        currentGrid: 3,
        // default products qty per row on mobile
        addedProductsQuantity: 0,
        productsBox: [],
        productsBoxSeparatedVariants: [],
        discount: 0,
        /**
         * If the currency rate is not equal to 1, we need to round the specific discount amount to the nearest 0.95.
         */
        specificDiscountAmount: +window.Shopify.currency.rate < 1 || +window.Shopify.currency.rate > 1 ? roundBackToNearest95(+((_a = config.steps.find((step) => step.firstAddedProductDiscount)) == null ? void 0 : _a.firstAddedProductDiscount) * +window.Shopify.currency.rate) : +((_b = config.steps.find((step) => step.firstAddedProductDiscount)) == null ? void 0 : _b.firstAddedProductDiscount),
        stepWithSpecificDiscount: config.steps.find((step) => step.firstAddedProductDiscount),
        numberOfSpecificDiscountsUsed: 1,
        productTileWidth: null
      };
    },
    mutations: {
      setPassedStep(state, stepIdx) {
        state.steps.forEach((step, idx) => {
          step.isPassed = idx <= stepIdx ? true : false;
        });
      },
      setCurrentGrid(state, number) {
        state.currentGrid = number;
      },
      setCurrentTab(state, tabPosition) {
        state.steps.forEach((step) => {
          step.tabs.forEach((tab) => {
            tab.current = false;
          });
        });
        state.steps[tabPosition.stepIdx].tabs[tabPosition.tabIdx].current = true;
        state.currentTab = state.steps[tabPosition.stepIdx].tabs[tabPosition.tabIdx];
      },
      applySpecificDiscount(state) {
        state.numberOfSpecificDiscountsUsed--;
      },
      applySpecificDiscount(state) {
        state.numberOfSpecificDiscountsUsed--;
      },
      disapplySpecificDiscount(state) {
        state.numberOfSpecificDiscountsUsed++;
      },
      resetSpecificDiscountApplying(state) {
        state.numberOfSpecificDiscountsUsed = 1;
      },
      setProductsBoxSeparatedVariants(state, variants) {
        state.productsBoxSeparatedVariants = variants;
      },
      ADD_TO_BOX(state, variant) {
        const productIndex = state.productsBox.findIndex((p2) => p2.id === variant.id);
        if (productIndex !== -1) {
          state.productsBox[productIndex].addedQty += 1;
          state.addedProductsQuantity++;
        } else {
          state.productsBox.push({ ...variant, addedQty: 1 });
          state.addedProductsQuantity++;
        }
        state.productsBox = [...state.productsBox];
      },
      REMOVE_FROM_BOX(state, variant) {
        const productIndex = state.productsBox.findIndex((p2) => p2.id === variant.id);
        if (productIndex !== -1) {
          state.productsBox[productIndex].addedQty -= 1;
          if (state.productsBox[productIndex].addedQty === 0) {
            state.productsBox.splice(productIndex, 1);
          }
          state.addedProductsQuantity--;
        }
        state.productsBox = [...state.productsBox];
      },
      SET_QUANTITY(state, { variant, quantity }) {
        const productIndex = state.productsBox.findIndex((p2) => p2.id === variant.id);
        if (productIndex !== -1) {
          if (state.productsBox[productIndex].addedQty < quantity) {
            state.addedProductsQuantity -= quantity;
          }
          state.productsBox[productIndex].addedQty = quantity;
          if (state.productsBox[productIndex].addedQty === 0) {
            state.productsBox.splice(productIndex, 1);
            state.addedProductsQuantity -= quantity;
          }
        } else if (quantity > 0) {
          state.productsBox.push({ ...variant, addedQty: quantity });
          state.addedProductsQuantity += quantity;
        }
        state.productsBox = [...state.productsBox];
      },
      calculateDiscount(state) {
        if (!state.productsBox || !state.productsBox.length || state.productsBox.length < 1) {
          state.discount = 0;
          return;
        }
        let stepsWithAddedProductsQty = {};
        state.productsBox.forEach((variant) => {
          if (!variant.stepName && !variant.tabName) {
            return;
          }
          const alreadyAdded = stepsWithAddedProductsQty[variant.stepName];
          stepsWithAddedProductsQty[variant.stepName] = alreadyAdded > 0 ? alreadyAdded + variant.addedQty : variant.addedQty;
        });
        const stepWithDiscounts = state.steps.find((step) => step.discounts);
        const discounts = [...stepWithDiscounts.discounts].sort((a, b) => b.discount_percent - a.discount_percent);
        const addedQtyForFoundStep = stepsWithAddedProductsQty[stepWithDiscounts.title];
        let result = 0;
        for (const discount of discounts) {
          if (addedQtyForFoundStep >= discount.products_quantity) {
            result = discount.discount_percent;
            break;
          }
        }
        state.discount = result;
      },
      updateProductTileWidth(state, width) {
        state.productTileWidth = width;
      }
    },
    actions: {
      addToBox({ commit: commit2 }, variant) {
        commit2("ADD_TO_BOX", variant);
      },
      removeFromBox({ commit: commit2 }, variant) {
        commit2("REMOVE_FROM_BOX", variant);
      },
      setQuantity({ commit: commit2 }, payload) {
        commit2("SET_QUANTITY", payload);
      },
      updateProductTileWidth({ commit: commit2 }, width) {
        commit2("updateProductTileWidth", width);
      }
    },
    getters: {
      productTileWidth: (state) => state.productTileWidth,
      getAddedUniqueProductsQty: (state) => {
        var _a;
        return ((_a = state.productsBox) == null ? void 0 : _a.length) || 0;
      },
      getSteps: (state) => {
        return state.steps;
      },
      getCurrentGrid: (state) => {
        return state.currentGrid;
      },
      getCurrentStep: (state) => {
        const passedSteps = state.steps.filter((step) => step.isPassed);
        const currentStep = passedSteps[passedSteps.length - 1] || state.steps[0];
        return currentStep;
      },
      getCurrentTab(state) {
        return state.currentTab;
      },
      getProductsBox: (state) => {
        return state.productsBox;
      },
      getAddedProductsQuantity: (state) => {
        return state.addedProductsQuantity;
      },
      getDiscount: (state) => {
        return state.discount;
      },
      getNextDiscount: (state) => {
        var _a;
        const empty = {
          discount_percent: 0,
          products_quantity: 0,
          theLastOneReached: true
        };
        const stepWithDiscounts = (_a = state.steps) == null ? void 0 : _a.find((step) => {
          var _a2;
          return (_a2 = step.discounts) == null ? void 0 : _a2.length;
        });
        if (!stepWithDiscounts) {
          return empty;
        }
        const discounts = [...stepWithDiscounts.discounts].sort((a, b) => b.discount_percent - a.discount_percent).reverse();
        if (!discounts.length) {
          return empty;
        }
        if (!state.discount) {
          return { ...discounts[0], theLastOneReached: false };
        }
        const currentDiscountIdx = discounts.findIndex((discount) => discount.discount_percent === state.discount);
        if (currentDiscountIdx === -1) {
          return empty;
        }
        const theLastOneReached = currentDiscountIdx === discounts.length - 1;
        const result = theLastOneReached ? { ...discounts[discounts.length - 1] } : { ...discounts[currentDiscountIdx + 1] };
        result.theLastOneReached = theLastOneReached;
        return result;
      },
      /** Скидка (%), которая применится при указанном количестве продуктов в шаге со скидками */
      getDiscountForQuantity: (state) => (quantity) => {
        var _a;
        const stepWithDiscounts = state.steps.find((step) => step.discounts);
        if (!((_a = stepWithDiscounts == null ? void 0 : stepWithDiscounts.discounts) == null ? void 0 : _a.length)) return null;
        const sorted = [...stepWithDiscounts.discounts].sort((a, b) => b.discount_percent - a.discount_percent);
        const tier = sorted.find((d) => quantity >= d.products_quantity);
        return tier ? tier.discount_percent : null;
      },
      getSpecificDiscountAmount: (state) => {
        return state.specificDiscountAmount;
      },
      getNumberOfSpecificDiscountsUsed: (state) => {
        return state.numberOfSpecificDiscountsUsed;
      },
      getVariantsAddedQuantuty: (state) => (variantId) => {
        var _a;
        return state.addedProductsQuantity > 0 ? (_a = state.productsBox.find((v) => v.id === variantId)) == null ? void 0 : _a.addedQty : 0;
      },
      getAddedDiscountableProductsQty: (state) => {
        if (state.addedProductsQuantity < 1) {
          return 0;
        }
        let res = 0;
        const stepWithDiscounts = state.steps.find((step) => step.discounts);
        const discountableProducts = state.productsBox.filter((product) => product.stepName === stepWithDiscounts.title);
        if (discountableProducts.length < 1) {
          return 0;
        }
        discountableProducts.forEach((product) => {
          res += product.addedQty;
        });
        return res;
      },
      getProductsBoxSeparatedVariants: (state) => {
        return state.productsBoxSeparatedVariants;
      },
      // price total / portions qty - discount
      // portions qty = metafield * added qty
      getReductedPricePerPortion: (state) => {
        let priceTotal = 0;
        let portionsTotal = 0;
        state.productsBox.forEach((variant) => {
          const product = variant.product;
          const productPortions = product.portions;
          const variantPortions = variant.portions;
          const portions = +productPortions || +variantPortions;
          if (portions) {
            portionsTotal += portions * +variant.addedQty;
            priceTotal += +variant.price / 100 * +variant.addedQty;
          }
        });
        const pricePerPortion = priceTotal / portionsTotal;
        const pricePerPortionDiscounted = pricePerPortion * (1 - state.discount / 100);
        return pricePerPortionDiscounted;
      },
      getCappedSpecificDiscountForVariant: (state) => (variant) => {
        const specificDiscountAmountBase = Number(state.specificDiscountAmount) || 0;
        const priceVariant = Number(variant == null ? void 0 : variant.price) || 0;
        return Math.min(specificDiscountAmountBase, priceVariant);
      },
      /**
       * Checks if a variant is eligible for category discount
       * Eligibility is determined by the isCategoryDiscountable flag set in Liquid template
       * @param {Object} state - Vuex state
       * @returns {Function} Function that takes a variant and returns boolean
       */
      isVariantEligibleForCategoryDiscount: (state) => (variant) => {
        console.log("[Category Discount] Checking eligibility for variant:", {
          variantId: variant == null ? void 0 : variant.id,
          variantTitle: variant == null ? void 0 : variant.productTitle,
          stepName: variant == null ? void 0 : variant.stepName,
          tabName: variant == null ? void 0 : variant.tabName,
          isCategoryDiscountable: variant == null ? void 0 : variant.isCategoryDiscountable
        });
        if (!variant) {
          console.log("[Category Discount] Variant is missing");
          return false;
        }
        if (variant.isCategoryDiscountable === true) {
          const step = state.steps.find((s) => s.title === variant.stepName);
          if (step && step.categoryDiscount) {
            console.log("[Category Discount] Variant is eligible (isCategoryDiscountable flag is true)");
            return true;
          } else {
            console.warn("[Category Discount] Variant has isCategoryDiscountable=true but step has no categoryDiscount configured");
            return false;
          }
        }
        console.log("[Category Discount] Variant is not eligible (isCategoryDiscountable is not true)");
        return false;
      },
      /**
       * Gets the category discount percentage for a variant
       * Only returns discount if variant has isCategoryDiscountable flag set to true
       * @param {Object} state - Vuex state
       * @returns {Function} Function that takes a variant and returns discount percentage or 0
       */
      getCategoryDiscountForVariant: (state) => (variant) => {
        if (!variant) {
          console.log("[Category Discount] getCategoryDiscountForVariant: Variant is missing");
          return 0;
        }
        if (variant.isCategoryDiscountable !== true) {
          console.log("[Category Discount] getCategoryDiscountForVariant: Variant is not eligible (isCategoryDiscountable is not true)");
          return 0;
        }
        const step = state.steps.find((s) => s.title === variant.stepName);
        if (!step || !step.categoryDiscount) {
          console.warn("[Category Discount] getCategoryDiscountForVariant: Variant is eligible but step has no categoryDiscount configured");
          return 0;
        }
        const discount = Number(step.categoryDiscount);
        console.log("[Category Discount] getCategoryDiscountForVariant result:", {
          variantId: variant.id,
          variantTitle: variant.productTitle,
          isCategoryDiscountable: variant.isCategoryDiscountable,
          discount
        });
        return discount;
      },
      /**
       * Calculates the effective discount percentage for a variant
       * Combines bundle discount and category discount additively (percentages are summed)
       * @param {Object} state - Vuex state
       * @returns {Function} Function that takes a variant and returns effective discount percentage
       */
      getEffectiveDiscountForVariant: (state, getters) => (variant) => {
        const bundleDiscount = state.discount || 0;
        const categoryDiscount = getters.getCategoryDiscountForVariant(variant) || 0;
        if (bundleDiscount === 0) {
          return categoryDiscount;
        }
        if (categoryDiscount === 0) {
          return bundleDiscount;
        }
        return bundleDiscount + categoryDiscount;
      },
      /**
       * Gets the display discount percentage for a variant
       * Eligibility for category discount is checked via isCategoryDiscountable flag
       * Returns bundle discount if category discount is not applicable,
       * or category discount if bundle discount is not yet reached,
       * or combined discount (sum of percentages) if both are applicable
       * @param {Object} state - Vuex state
       * @returns {Function} Function that takes a variant and returns display discount percentage
       */
      getDisplayDiscountForVariant: (state, getters) => (variant) => {
        const bundleDiscount = state.discount || 0;
        const isEligibleForCategory = (variant == null ? void 0 : variant.isCategoryDiscountable) === true;
        const categoryDiscount = isEligibleForCategory ? getters.getCategoryDiscountForVariant(variant) || 0 : 0;
        console.log("[Category Discount] getDisplayDiscountForVariant:", {
          variantId: variant == null ? void 0 : variant.id,
          variantTitle: variant == null ? void 0 : variant.productTitle,
          isCategoryDiscountable: variant == null ? void 0 : variant.isCategoryDiscountable,
          bundleDiscount,
          categoryDiscount,
          isEligibleForCategory
        });
        if (!isEligibleForCategory) {
          console.log("[Category Discount] Not eligible (isCategoryDiscountable is not true), returning bundle discount:", bundleDiscount);
          return bundleDiscount;
        }
        if (bundleDiscount === 0) {
          console.log("[Category Discount] Bundle discount not reached, returning category discount:", categoryDiscount);
          return categoryDiscount;
        }
        const combinedDiscount = bundleDiscount + categoryDiscount;
        console.log("[Category Discount] Both discounts apply, returning combined discount (sum):", combinedDiscount);
        return combinedDiscount;
      }
    }
  });
};
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$s = {
  data() {
    return {
      icons: null,
      screenWidth: window.innerWidth
    };
  },
  methods: {
    setGrid(number) {
      if (this.screenWidth >= 375 && this.screenWidth < 640 && number === 3) {
        return;
      }
      if (this.screenWidth < 375) {
        return;
      }
      this.$store.commit("setCurrentGrid", number);
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
      if (this.currentGrid === 3 && this.screenWidth < 640) {
        this.setGrid(2);
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.updateScreenWidth);
    if (this.screenWidth >= 640) {
      this.setGrid(3);
    } else if (this.screenWidth >= 375 && this.screenWidth < 640) {
      this.setGrid(2);
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  created() {
    this.icons = this.$store.state.config.htmlSnippets.icons;
  },
  computed: {
    ...mapGetters({
      currentGrid: "getCurrentGrid"
    })
  }
};
const _hoisted_1$p = { class: "bb-header__grid-switcher" };
const _hoisted_2$k = ["innerHTML"];
const _hoisted_3$h = ["innerHTML"];
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$p, [
    withDirectives(createBaseVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event) => $options.setGrid(3)),
      class: normalizeClass(["bb-hedaer__grid-button", { "bb-hedaer__grid-button--active": _ctx.currentGrid === 3 }]),
      innerHTML: $data.icons["grid-3"]
    }, null, 10, _hoisted_2$k), [
      [vShow, $data.screenWidth >= 640]
    ]),
    withDirectives(createBaseVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event) => $options.setGrid(2)),
      class: normalizeClass(["bb-hedaer__grid-button", { "bb-hedaer__grid-button--active": _ctx.currentGrid === 2 }]),
      innerHTML: $data.icons["grid-2"]
    }, null, 10, _hoisted_3$h), [
      [vShow, $data.screenWidth >= 640]
    ])
  ]);
}
const GridSwitcher = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$s]]);
const _sfc_main$r = {
  props: [
    "tab",
    "tabIdx",
    "isCurrent",
    "tabsContainer",
    "hasProducts"
  ],
  data() {
    return {};
  },
  methods: {
    setCurrentTab(event) {
      if (!this.hasProducts) return;
      if (!!this.tabsContainer && !!this.tabsContainer.offsetLeft && (!!event.target && !!event.target.offsetLeft)) {
        const x = event.target.offsetLeft - this.tabsContainer.offsetLeft;
        this.tabsContainer.scroll({
          left: x,
          behavior: "smooth"
        });
      }
      this.$emit("setCurrentTab", this.tabIdx);
    },
    title(str) {
      return str.includes("®") ? str.replace("®", `<sup>®</sup>`) : str;
    }
  },
  mounted() {
  }
};
const _hoisted_1$o = ["disabled", "innerHTML"];
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.setCurrentTab && $options.setCurrentTab(...args)),
    class: normalizeClass(["bb-product-grid__tab label-s", { "bb-product-grid__tab--active": $props.isCurrent, "bb-product-grid__tab--disabled": !$props.hasProducts }]),
    disabled: !$props.hasProducts,
    innerHTML: $options.title($props.tab.title)
  }, null, 10, _hoisted_1$o);
}
const Tab$1 = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$r]]);
const _sfc_main$q = {
  props: {
    src: String,
    additionalClasses: String,
    loading: String,
    alt: String,
    width: Number,
    height: Number,
    useSrcset: Boolean,
    usePlaceholder: Boolean,
    sizes: {
      type: Array,
      default: () => [200, 300, 400, 500, 600, 700, 800, 900, 1e3, 1100, 1200]
    }
  },
  data() {
    return {
      showPlaceholder: true
    };
  },
  methods: {
    addPrefixBeforeExtension(str, prefix) {
      if (!str) {
        return "";
      }
      const extensions = [".png", ".webp", ".jpg"];
      for (const ext of extensions) {
        if (str.includes(ext)) {
          str = str.replace(ext, `${prefix}${ext}`);
        }
      }
      return str;
    }
  },
  computed: {
    srcset() {
      let result = "";
      this.sizes.forEach((size, idx) => {
        const newSrc = this.addPrefixBeforeExtension(this.src, `_${size}x`);
        const comma = idx === this.sizes.length - 1 ? "" : ",";
        result += `${newSrc} ${size}w${comma}`;
      });
      return result;
    },
    imageStyle() {
      return this.showPlaceholder ? { opacity: 0, height: "1px", width: "1px" } : {};
    }
  }
};
const _hoisted_1$n = ["src", "width", "height", "alt"];
const _hoisted_2$j = ["loading", "src", "srcset", "width", "height", "alt"];
const _hoisted_3$g = ["loading", "src", "width", "height", "alt"];
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.useSrcset ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["bb-image-wrapper", $props.additionalClasses])
  }, [
    withDirectives(createBaseVNode("img", {
      src: $options.addPrefixBeforeExtension($props.src, "_10x"),
      width: $props.width,
      height: $props.height,
      alt: $props.alt,
      class: "bb-image-wrapper__placeholder"
    }, null, 8, _hoisted_1$n), [
      [vShow, $data.showPlaceholder && $props.usePlaceholder]
    ]),
    createBaseVNode("img", {
      loading: $props.loading,
      src: $props.src,
      sizes: "(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 0px) / 4 - 18px)",
      srcset: $options.srcset,
      width: $props.width,
      height: $props.height,
      alt: $props.alt,
      style: normalizeStyle($options.imageStyle),
      onLoad: _cache[0] || (_cache[0] = () => $data.showPlaceholder = false)
    }, null, 44, _hoisted_2$j)
  ], 2)) : (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(["bb-image-wrapper", $props.additionalClasses])
  }, [
    createBaseVNode("img", {
      loading: $props.loading,
      src: $props.src,
      width: $props.width,
      height: $props.height,
      alt: $props.alt
    }, null, 8, _hoisted_3$g)
  ], 2));
}
const Image$1 = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$q]]);
const _sfc_main$p = {
  props: {
    variantIncoming: Object,
    product: Object
  },
  data() {
    var _a;
    return {
      disabled: false,
      addedQty: 0,
      maximum: ((_a = this.variantIncoming) == null ? void 0 : _a.inventory_quantity) || 99,
      variant: this.variantIncoming
    };
  },
  methods: {
    validateInput() {
      if (this.addedQty > this.maximum) {
        this.addedQty = this.maximum;
      }
    },
    addToBox() {
      if (this.disabled || !this.variant.available) {
        return;
      }
      this.validateInput();
      this.$store.dispatch("addToBox", this.variant);
      this.addedQty += 1;
    },
    increaseQty() {
      this.validateInput();
      this.$store.dispatch("addToBox", this.variant);
      this.addedQty += 1;
    },
    decreaseQty() {
      const specificVariantIdx = this.productsBoxSeparatedVariants.findIndex((v) => v.specificDiscount);
      const specificVariant = this.productsBoxSeparatedVariants[specificVariantIdx];
      if ((specificVariant == null ? void 0 : specificVariant.id) === this.variant.id) {
        this.$store.commit("disapplySpecificDiscount");
      }
      if (this.addedQty > 0) {
        this.$store.dispatch("removeFromBox", this.variant);
        this.addedQty -= 1;
      }
    },
    updateQty() {
      this.validateInput();
      this.$store.dispatch("setQuantity", {
        variant: this.variant,
        quantity: this.addedQty
      });
    },
    getVariantsAddedQuantuty() {
      return this.$store.getters.getVariantsAddedQuantuty(this.variantIncoming.id);
    }
  },
  mounted() {
    this.addedQty = this.getVariantsAddedQuantuty() || 0;
  },
  updated() {
    this.variant = this.variantIncoming;
  },
  computed: {
    minusButtonClass() {
      return {
        "bb-quantity-selector__button--disabled": this.addedQty < 1
      };
    },
    plusButtonClass() {
      return {
        "bb-quantity-selector__button--disabled": this.maximum === this.addedQty
      };
    },
    ...mapGetters({
      addedUniqueProductsQty: "getAddedUniqueProductsQty",
      productsBoxWithVariants: "getProductsBox",
      productsBoxSeparatedVariants: "getProductsBoxSeparatedVariants"
    }),
    disabledATB() {
      const condition = !this.variant.available || this.addedUniqueProductsQty === +this.$store.state.config.maximum_unique_products;
      this.disabled = condition;
      return {
        "disabled": condition
      };
    },
    innerTextATB() {
      return this.variant.available ? this.$store.state.config.translations.addToBox : this.$store.state.config.translations.soldOut;
    }
  },
  watch: {
    variant: {
      handler(newV, old) {
        this.maximum = (newV == null ? void 0 : newV.inventory_quantity) || 99;
        this.addedQty = this.getVariantsAddedQuantuty() || 0;
      },
      deep: true
    },
    productsBoxWithVariants: {
      handler(newV, old) {
        const array = newV;
        const foundVariant = array.find((v) => v.id === this.variant.id);
        if (foundVariant && foundVariant.addedQty !== this.addedQty) {
          this.addedQty = foundVariant.addedQty;
        } else if (this.addedQty > 0 && !foundVariant) {
          this.addedQty = 0;
        }
      },
      deep: true,
      immediate: true
      // Ensure watcher runs on component mount to sync with pre-initialized box state
    }
  }
};
const _hoisted_1$m = ["innerHTML"];
const _hoisted_2$i = { class: "bb-product__add-to-box_text label-m" };
const _hoisted_3$f = { class: "bb-quantity-selector" };
const _hoisted_4$b = ["innerHTML"];
const _hoisted_5$a = ["innerHTML"];
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(Fragment, null, [
    withDirectives(createBaseVNode("button", {
      class: normalizeClass(["bb-product__add-to-box btn btn--secondary btn--transparent btn--small btn--border", $options.disabledATB]),
      onClick: _cache[0] || (_cache[0] = (...args) => $options.addToBox && $options.addToBox(...args)),
      type: "button"
    }, [
      $data.variant.available ? (openBlock(), createElementBlock("span", {
        key: 0,
        class: "bb-product__add-to-box_icon",
        innerHTML: _ctx.$store.state.config.htmlSnippets.icons.plus
      }, null, 8, _hoisted_1$m)) : createCommentVNode("", true),
      createBaseVNode("span", _hoisted_2$i, toDisplayString($options.innerTextATB), 1)
    ], 2), [
      [vShow, $data.addedQty === 0]
    ]),
    withDirectives(createBaseVNode("div", _hoisted_3$f, [
      createBaseVNode("button", {
        class: normalizeClass(["bb-quantity-selector__button", $options.minusButtonClass]),
        onClick: _cache[1] || (_cache[1] = (...args) => $options.decreaseQty && $options.decreaseQty(...args)),
        innerHTML: _ctx.$store.state.config.htmlSnippets.icons.minus
      }, null, 10, _hoisted_4$b),
      withDirectives(createBaseVNode("input", {
        class: "bb-quantity-selector__input heading-s",
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $data.addedQty = $event),
        readonly: ""
      }, null, 512), [
        [
          vModelText,
          $data.addedQty,
          void 0,
          { number: true }
        ]
      ]),
      createBaseVNode("button", {
        class: normalizeClass(["bb-quantity-selector__button bb-quantity-selector__button--plus", $options.plusButtonClass]),
        onClick: _cache[3] || (_cache[3] = (...args) => $options.increaseQty && $options.increaseQty(...args)),
        innerHTML: _ctx.$store.state.config.htmlSnippets.icons.plusRound
      }, null, 10, _hoisted_5$a)
    ], 512), [
      [vShow, $data.addedQty > 0]
    ])
  ], 64);
}
const QuantitySelector$1 = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$p]]);
const _sfc_main$o = {
  props: {
    product: Object
  },
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    showContext() {
      if (window.innerWidth > 768) {
        this.isActive = true;
      }
    },
    hideContext() {
      if (window.innerWidth > 768) {
        this.isActive = false;
      }
    },
    toggleContext() {
      if (window.innerWidth <= 768) {
        this.isActive = !this.isActive;
      }
    },
    closeOnClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isActive = false;
      }
    }
  },
  computed: {
    ...mapGetters(["productTileWidth"]),
    mhdPadding() {
      return window.innerWidth < 740 ? 8 : 16;
    }
  },
  mounted() {
    document.addEventListener("click", this.closeOnClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeOnClickOutside);
  }
};
const _hoisted_1$l = ["aria-label"];
const _hoisted_2$h = { class: "bb-product__mhd-title label-xs" };
const _hoisted_3$e = { class: "bb-product__mhd-context_content body-s" };
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "bb-product__mhd-wrapper",
    onClick: [
      _cache[2] || (_cache[2] = (...args) => $options.toggleContext && $options.toggleContext(...args)),
      _cache[3] || (_cache[3] = withModifiers(() => {
      }, ["stop"]))
    ],
    tabindex: "0",
    "aria-label": `${$props.product.mhd.title}. ${$props.product.mhd.description}`
  }, [
    createBaseVNode("div", {
      class: "bb-product__mhd",
      onMouseenter: _cache[0] || (_cache[0] = (...args) => $options.showContext && $options.showContext(...args)),
      onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.hideContext && $options.hideContext(...args))
    }, [
      _cache[4] || (_cache[4] = createBaseVNode("div", { class: "bb-product__mhd-icon-wrapper" }, [
        createBaseVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "10",
          height: "10",
          viewBox: "0 0 10 10",
          fill: "none"
        }, [
          createBaseVNode("path", {
            d: "M5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0ZM4.99414 6.26758C4.63677 6.26758 4.37519 6.51482 4.375 6.86523C4.375 7.22273 4.63664 7.4707 4.99414 7.4707C5.35831 7.47053 5.61914 7.22261 5.61914 6.86523C5.61895 6.51494 5.35818 6.26776 4.99414 6.26758ZM4.45703 2.5V3.83398L4.72559 5.88281H5.26855L5.53711 3.83398V2.5H4.45703Z",
            fill: "black"
          })
        ])
      ], -1)),
      createBaseVNode("span", _hoisted_2$h, toDisplayString($props.product.mhd.title), 1)
    ], 32),
    $data.isActive ? (openBlock(), createElementBlock("p", {
      key: 0,
      class: "bb-product__mhd-context",
      style: normalizeStyle(`width: calc(${_ctx.productTileWidth}px - ${$options.mhdPadding}px);`)
    }, [
      _cache[5] || (_cache[5] = createBaseVNode("span", { class: "bb-product__mhd-triangle" }, null, -1)),
      createBaseVNode("span", _hoisted_3$e, toDisplayString($props.product.mhd.description), 1)
    ], 4)) : createCommentVNode("", true)
  ], 8, _hoisted_1$l);
}
const MHD = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$o]]);
const _sfc_main$n = {
  props: {
    label: {
      type: Object,
      required: true
    }
  },
  computed: {
    labelStyle() {
      const style = {};
      if (this.label.background_color) {
        style.backgroundColor = this.label.background_color;
      }
      if (this.label.text_color) {
        style.color = this.label.text_color;
      }
      if (this.label.border_color) {
        style.borderColor = this.label.border_color;
      }
      return style;
    }
  }
};
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("span", {
    class: "bb-product__label label-xs",
    style: normalizeStyle($options.labelStyle)
  }, toDisplayString($props.label.text), 5);
}
const LabelBadge = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$n]]);
const _sfc_main$m = {
  props: {
    variant: Object,
    product: Object,
    titleFromVariant: Boolean
  },
  data() {
    return {};
  },
  mounted() {
    const allowedIds = [44926529110281, 44926529143049, 44926529175817];
    if (allowedIds.includes(this.variant.id)) {
      console.log("\nLabel:", this.variant.label);
      console.log("Variant:", this.variant);
    }
  },
  methods: {
    formatPrice(price, type) {
      if (!price || price <= 0) {
        return "0.00";
      }
      const isUKStore = Shopify.currency.active === "GBP" || Shopify.locale === "en-GB";
      console.log("Is UK Store:", isUKStore);
      const formattedPrice = (price / 100).toFixed(2);
      if (type === "comparePrice") {
        if (isUKStore) {
          return `${formattedPrice}`;
        }
        return `${formattedPrice.split(".").join(",")}`;
      }
      if (isUKStore) {
        return `£ ${formattedPrice}`;
      }
      return `${formattedPrice.split(".").join(",")} ${this.$store.state.currency}`;
    }
  },
  computed: {
    subtext_m_m() {
      var _a, _b, _c;
      return ((_a = this.variant) == null ? void 0 : _a.subtext_m_m) || ((_c = (_b = this.variant) == null ? void 0 : _b.product) == null ? void 0 : _c.subtext_m_m) || null;
    },
    price() {
      let discountedPrice = this.variant.price;
      const originalPrice = discountedPrice;
      console.log("[Variant.vue] Price calculation start:", {
        variantId: this.variant.id,
        variantTitle: this.variant.productTitle,
        originalPrice,
        hasSpecificDiscount: this.numberOfSpecificDiscountsUsed > 0 && this.variant.specificDiscountable && this.atLeastOneProductFromTheFirstStep
      });
      if (this.numberOfSpecificDiscountsUsed > 0 && this.variant.specificDiscountable && this.atLeastOneProductFromTheFirstStep) {
        discountedPrice -= this.cappedSpecificDiscount;
        console.log("[Variant.vue] Applied specific discount:", {
          cappedSpecificDiscount: this.cappedSpecificDiscount,
          discountedPrice
        });
      } else {
        const bundleDiscount = this.discount || 0;
        const categoryDiscount = this.categoryDiscount || 0;
        console.log("[Variant.vue] Applying discounts:", {
          variantId: this.variant.id,
          isCategoryDiscountable: this.variant.isCategoryDiscountable,
          bundleDiscount,
          categoryDiscount,
          originalPrice
        });
        if (bundleDiscount > 0 && categoryDiscount > 0) {
          const combinedDiscount = bundleDiscount + categoryDiscount;
          discountedPrice = discountedPrice * (1 - combinedDiscount / 100);
          console.log("[Variant.vue] Applied both discounts additively (summed):", {
            calculation: `${originalPrice} * (1 - (${bundleDiscount} + ${categoryDiscount})/100) = ${originalPrice} * (1 - ${combinedDiscount}/100)`,
            result: discountedPrice
          });
        } else if (bundleDiscount > 0) {
          discountedPrice = discountedPrice * (1 - bundleDiscount / 100);
          console.log("[Variant.vue] Applied bundle discount only:", {
            calculation: `${originalPrice} * (1 - ${bundleDiscount}/100)`,
            result: discountedPrice
          });
        } else if (categoryDiscount > 0) {
          discountedPrice = discountedPrice * (1 - categoryDiscount / 100);
          console.log("[Variant.vue] Applied category discount only:", {
            calculation: `${originalPrice} * (1 - ${categoryDiscount}/100)`,
            result: discountedPrice
          });
        } else {
          console.log("[Variant.vue] No discounts applied");
        }
      }
      if (discountedPrice < 0) {
        discountedPrice = 0;
      }
      console.log("[Variant.vue] Final price:", {
        originalPrice,
        discountedPrice,
        discountAmount: originalPrice - discountedPrice
      });
      return {
        formatted: this.formatPrice(discountedPrice),
        unformatted: discountedPrice,
        specificDiscount: this.cappedSpecificDiscount
      };
    },
    priceCompare() {
      var _a, _b;
      return {
        formatted: this.formatPrice((_a = this.variant) == null ? void 0 : _a.price, "comparePrice"),
        unformatted: (_b = this.variant) == null ? void 0 : _b.price
      };
    },
    priceCompareFormatted() {
      var _a;
      if (this.price.unformatted === 0) {
        const price = (_a = this.variant) == null ? void 0 : _a.price;
        if (!price || price <= 0) {
          return "0.00";
        }
        const isUKStore = Shopify.currency.active === "GBP" || Shopify.locale === "en-GB";
        const formattedPrice = (price / 100).toFixed(2);
        if (isUKStore) {
          return `£ ${formattedPrice}`;
        }
        return `${formattedPrice.split(".").join(",")} ${this.$store.state.currency}`;
      } else {
        return this.priceCompare.formatted;
      }
    },
    atLeastOneProductFromTheFirstStep() {
      return this.productsBoxWithVariants.find((v) => v.stepName === this.steps[0].title);
    },
    cappedSpecificDiscount() {
      return this.$store.getters.getCappedSpecificDiscountForVariant(this.variant);
    },
    categoryDiscount() {
      const discount = this.$store.getters.getCategoryDiscountForVariant(this.variant);
      console.log("[Variant.vue] categoryDiscount computed:", {
        variantId: this.variant.id,
        discount
      });
      return discount;
    },
    displayDiscount() {
      const discount = this.$store.getters.getDisplayDiscountForVariant(this.variant);
      console.log("[Variant.vue] displayDiscount computed:", {
        variantId: this.variant.id,
        discount
      });
      return discount;
    },
    ...mapGetters({
      discount: "getDiscount",
      specificDiscountAmount: "getSpecificDiscountAmount",
      numberOfSpecificDiscountsUsed: "getNumberOfSpecificDiscountsUsed",
      productsBoxWithVariants: "getProductsBox",
      steps: "getSteps"
    })
  },
  components: {
    Image: Image$1,
    QuantitySelector: QuantitySelector$1,
    MHD,
    LabelBadge
  }
};
const _hoisted_1$k = {
  key: 0,
  class: "bb-product__variant"
};
const _hoisted_2$g = { class: "bb-product__variant_header" };
const _hoisted_3$d = { class: "bb-product__body" };
const _hoisted_4$a = { class: "bb-product__title heading-l-small-case heading-m-md" };
const _hoisted_5$9 = {
  key: 0,
  class: "bb-product__title-subtext body-s"
};
const _hoisted_6$7 = {
  key: 0,
  class: "bb-product__price-item bb-product__price--normal body-l-strong body-m-strong-md"
};
const _hoisted_7$4 = {
  key: 1,
  class: "bb-product__price-item bb-product__price--free body-s-strong"
};
const _hoisted_8$4 = { class: "bb-product__discount-wrapper" };
const _hoisted_9$3 = {
  key: 1,
  class: "bb-product__price-item bb-product__price--discount body-s-strong"
};
const _hoisted_10$3 = { class: "bb-product__controls" };
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  const _component_MHD = resolveComponent("MHD");
  const _component_LabelBadge = resolveComponent("LabelBadge");
  const _component_Image = resolveComponent("Image");
  const _component_QuantitySelector = resolveComponent("QuantitySelector");
  return $props.variant ? (openBlock(), createElementBlock("div", _hoisted_1$k, [
    createBaseVNode("div", _hoisted_2$g, [
      ((_c = (_b = (_a = $props.variant) == null ? void 0 : _a.product) == null ? void 0 : _b.mhd) == null ? void 0 : _c.description) && ((_f = (_e = (_d = $props.variant) == null ? void 0 : _d.product) == null ? void 0 : _e.mhd) == null ? void 0 : _f.title) ? (openBlock(), createBlock(_component_MHD, {
        key: 0,
        product: $props.variant.product
      }, null, 8, ["product"])) : ((_g = $props.variant.labels) == null ? void 0 : _g[0]) ? (openBlock(), createBlock(_component_LabelBadge, {
        key: 1,
        label: (_h = $props.variant.labels) == null ? void 0 : _h[0]
      }, null, 8, ["label"])) : createCommentVNode("", true),
      createVNode(_component_Image, {
        src: ((_j = (_i = $props.variant) == null ? void 0 : _i.featured_image) == null ? void 0 : _j.src) || ((_k = $props.product) == null ? void 0 : _k.featured_image),
        additionalClasses: "bb-product__image-wrapper",
        alt: ((_m = (_l = $props.variant) == null ? void 0 : _l.featured_image) == null ? void 0 : _m.alt) || ((_n = $props.variant) == null ? void 0 : _n.productTitle),
        width: 200,
        height: 200,
        useSrcset: true,
        usePlaceholder: true,
        loading: "lazy"
      }, null, 8, ["src", "alt"])
    ]),
    createBaseVNode("div", _hoisted_3$d, [
      createBaseVNode("span", _hoisted_4$a, toDisplayString($props.titleFromVariant ? $props.variant.title === "Default Title" ? $props.variant.productTitle : $props.variant.title : (_o = $props.variant) == null ? void 0 : _o.productTitle), 1),
      $options.subtext_m_m ? (openBlock(), createElementBlock("span", _hoisted_5$9, toDisplayString($options.subtext_m_m), 1)) : createCommentVNode("", true),
      createBaseVNode("div", {
        class: normalizeClass(["bb-product__price", { "free-product": $options.price.unformatted === 0 }]),
        style: normalizeStyle({
          flexDirection: $options.price.unformatted === 0 ? "row-reverse" : "row",
          justifyContent: $options.price.unformatted === 0 ? "flex-end" : "flex-start"
        })
      }, [
        $options.price.unformatted > 0 ? (openBlock(), createElementBlock("span", _hoisted_6$7, toDisplayString($options.price.formatted), 1)) : (openBlock(), createElementBlock("span", _hoisted_7$4, toDisplayString(_ctx.$store.state.config.translations.free), 1)),
        createBaseVNode("div", _hoisted_8$4, [
          $options.priceCompare.unformatted > $options.price.unformatted ? (openBlock(), createElementBlock("del", {
            key: 0,
            class: normalizeClass(["bb-product__price-item bb-product__price--compare", $options.price.unformatted === 0 ? "body-l-strong body-m-strong-md" : "body-s-strong"]),
            style: normalizeStyle({
              color: $options.price.unformatted === 0 ? "#000000" : "#737373"
            })
          }, toDisplayString($options.priceCompareFormatted), 7)) : createCommentVNode("", true),
          _ctx.numberOfSpecificDiscountsUsed > 0 && $props.variant.specificDiscountable && $options.price.unformatted > 0 && this.atLeastOneProductFromTheFirstStep ? (openBlock(), createElementBlock("div", _hoisted_9$3, " -" + toDisplayString($options.formatPrice($options.cappedSpecificDiscount)), 1)) : $options.displayDiscount > 0 ? withDirectives((openBlock(), createElementBlock("div", {
            key: 2,
            class: "bb-product__price-item bb-product__price--discount body-s-strong"
          }, " -" + toDisplayString(Math.round($options.displayDiscount)) + "% ", 513)), [
            [vShow, $props.variant.specificDiscountable ? _ctx.numberOfSpecificDiscountsUsed < 1 : true]
          ]) : createCommentVNode("", true)
        ])
      ], 6),
      createBaseVNode("div", _hoisted_10$3, [
        createVNode(_component_QuantitySelector, {
          variantIncoming: $props.variant,
          product: $props.product
        }, null, 8, ["variantIncoming", "product"])
      ])
    ])
  ])) : createCommentVNode("", true);
}
const Variant = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$m]]);
const _sfc_main$l = {
  props: {
    isLastRendered: Boolean,
    variant: Object,
    step: Object,
    product: Object,
    useFirstAvailabeVariant: Boolean,
    separateVariants: Boolean
  },
  data() {
    var _a;
    return {
      selectedVariant: this.getFirstAvailableVariant() || ((_a = this.product) == null ? void 0 : _a.variants[0])
    };
  },
  computed: {
    productTileStyle() {
      var _a, _b, _c, _d;
      const color = this.useFirstAvailabeVariant ? (_a = this.product) == null ? void 0 : _a.background_color_product_tile : ((_b = this.variant) == null ? void 0 : _b.split_bg_color) || ((_d = (_c = this.variant) == null ? void 0 : _c.product) == null ? void 0 : _d.background_color_product_tile);
      if (!color || !color.trim()) return {};
      return { backgroundColor: color };
    }
  },
  methods: {
    ...mapActions(["updateProductTileWidth"]),
    getFirstAvailableVariant() {
      var _a, _b, _c;
      if (!this.product) {
        return;
      }
      return ((_a = this.product) == null ? void 0 : _a.variants.length) === 1 ? (_b = this.product) == null ? void 0 : _b.variants[0] : (_c = this.product) == null ? void 0 : _c.variants.find((v) => {
        return v.available;
      });
    },
    updateTileWidth() {
      const newWidth = this.$el.offsetWidth;
      this.updateProductTileWidth(newWidth);
    }
  },
  mounted() {
    if (this.isLastRendered) {
      this.$emit("theLastOneMounted");
    }
    window.addEventListener("resize", () => {
      this.updateTileWidth();
    });
    this.updateTileWidth();
  },
  components: {
    Image: Image$1,
    Variant
  }
};
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  var _a;
  const _component_Variant = resolveComponent("Variant");
  return $options.getFirstAvailableVariant() && ((_a = $props.product) == null ? void 0 : _a.available) && $props.useFirstAvailabeVariant ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "bb-product",
    style: normalizeStyle($options.productTileStyle)
  }, [
    createVNode(_component_Variant, {
      product: $props.product,
      variant: $data.selectedVariant
    }, null, 8, ["product", "variant"])
  ], 4)) : $props.separateVariants && !$props.useFirstAvailabeVariant ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: "bb-product",
    style: normalizeStyle($options.productTileStyle)
  }, [
    createVNode(_component_Variant, {
      variant: $props.variant,
      titleFromVariant: $props.step.number !== 1
    }, null, 8, ["variant", "titleFromVariant"])
  ], 4)) : createCommentVNode("", true);
}
const Product = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$l]]);
const _sfc_main$k = {
  props: {
    isLastRendered: Boolean
  },
  mounted() {
    if (this.isLastRendered) {
      this.$emit("theLastOneMounted");
    }
  }
};
const _hoisted_1$j = { class: "bb-product--placeholder bb-product" };
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$j, _cache[0] || (_cache[0] = [
    createBaseVNode("div", { class: "bb-product__variant" }, [
      createBaseVNode("div", { class: "bb-product__image-placeholder" }),
      createBaseVNode("div", { class: "bb-product__controls" })
    ], -1)
  ]));
}
const ProductPlaceholder = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k]]);
const _sfc_main$j = {
  props: {
    tab: Object,
    step: Object
  },
  data() {
    return {
      variantsPerRow: 0,
      variantsToShow: []
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      let calculateVariantsPerRowTimer = setTimeout(() => {
        this.calculateVariantsPerRow();
        clearTimeout(calculateVariantsPerRowTimer);
      }, 20);
    });
    window.addEventListener("scroll", () => {
      let calculateVariantsToShowTimer = setTimeout(() => {
        this.calculateVariantsToShow();
        clearTimeout(calculateVariantsToShowTimer);
      }, 20);
    });
  },
  updated() {
    if (this.variantsPerRow < 1 && this.tab.variants) {
      this.calculateVariantsPerRow();
    }
    if (this.variantsToShow.length < 1 && this.variantsPerRow) {
      this.calculateVariantsToShow(this.variantsPerRow);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateVariantsPerRow);
  },
  methods: {
    calculateVariantsPerRow() {
      var _a, _b, _c, _d;
      if (!this.isShown) {
        this.variantsPerRow = 0;
        return;
      }
      if (window.innerWidth <= 768) {
        if (this.currentGrid > 0) {
          this.variantsPerRow = this.currentGrid;
        } else if (window.innerWidth < 375) {
          this.variantsPerRow = 1;
        }
        return;
      }
      const container = this.$el.offsetWidth ? this.$el : this.$el.parentNode;
      const containerWidth = container ? (_a = container.getBoundingClientRect()) == null ? void 0 : _a.width : 0;
      const firstVariantEl = this.$refs.variants && this.$refs.variants.length > 0 ? this.$refs.variants[0].$el : null;
      const itemWidth = firstVariantEl ? (_b = firstVariantEl.getBoundingClientRect()) == null ? void 0 : _b.width : (_d = (_c = this.$refs.productPlaceholder) == null ? void 0 : _c.$el) == null ? void 0 : _d.getBoundingClientRect().width;
      const gridGap = 30;
      const containerStyles = window.getComputedStyle(container);
      const paddingLeft = parseFloat(containerStyles.paddingLeft);
      const paddingRight = parseFloat(containerStyles.paddingRight);
      const res = Math.floor((containerWidth - (paddingLeft + paddingRight) + gridGap) / (itemWidth + gridGap));
      this.variantsPerRow = res < 0 ? this.variantsPerRow : res;
    },
    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return element ? rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth) : false;
    },
    calculateVariantsToShow(initialValue = 0) {
      var _a;
      if (!this.isShown || !this.tab.variants || !this.tab.variants.length || this.tab.variants.length < 1) {
        return;
      }
      if (initialValue > 0) {
        this.variantsToShow = this.tab.variants.slice(0, this.variantsPerRow * 2);
      }
      if (!this.$refs.variants) {
        return;
      }
      const variantsRefsLength = this.$refs.variants.length;
      const variantElementIdx = variantsRefsLength - this.variantsPerRow;
      const variantElement = variantElementIdx < variantsRefsLength ? (_a = this.$refs.variants[variantElementIdx]) == null ? void 0 : _a.$el : null;
      if (!variantElement) {
        return;
      }
      if (this.isInViewport(variantElement)) {
        const fromIdx = variantsRefsLength - 1;
        const toIdx = variantsRefsLength - 1 + this.variantsPerRow;
        const additionalVariants = this.tab.variants.slice(fromIdx, toIdx);
        additionalVariants.forEach((v) => {
          const alreadyAddedVariant = this.variantsToShow.find((variant) => (variant == null ? void 0 : variant.id) === (v == null ? void 0 : v.id));
          if (!alreadyAddedVariant) {
            this.variantsToShow.push(v);
          }
        });
      }
    },
    theLastOneMounted() {
      this.calculateVariantsToShow();
    }
  },
  computed: {
    ...mapGetters({
      currentGrid: "getCurrentGrid",
      currentTab: "getCurrentTab"
    }),
    isShown() {
      return this.currentTab.title === this.tab.title;
    },
    gridClass() {
      return {
        "bb-product-grid__container--2_per_row": this.currentGrid === 2,
        "bb-product-grid__container--3_per_row": this.currentGrid === 3
      };
    }
  },
  watch: {
    step(newStep, old) {
      if (this.step.title === newStep.title) {
        this.variantsToShow = [];
        this.calculateVariantsPerRow();
        this.calculateVariantsToShow(this.variantsPerRow);
      }
    }
  },
  components: {
    Product,
    ProductPlaceholder
  }
};
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProductPlaceholder = resolveComponent("ProductPlaceholder");
  const _component_Product = resolveComponent("Product");
  return withDirectives((openBlock(), createElementBlock("div", {
    class: normalizeClass(["bb-product-grid__container", $options.gridClass])
  }, [
    withDirectives(createVNode(_component_ProductPlaceholder, { ref: "productPlaceholder" }, null, 512), [
      [vShow, $data.variantsToShow.length < 1]
    ]),
    (openBlock(true), createElementBlock(Fragment, null, renderList($data.variantsToShow, (variant, idx) => {
      var _a;
      return withDirectives((openBlock(), createBlock(_component_Product, {
        ref_for: true,
        ref: "variants",
        key: idx,
        isLastRendered: $data.variantsToShow.length - 1 === idx,
        variant,
        separateVariants: true,
        step: $props.step,
        onTheLastOneMounted: $options.theLastOneMounted
      }, null, 8, ["isLastRendered", "variant", "step", "onTheLastOneMounted"])), [
        [vShow, !((_a = variant == null ? void 0 : variant.title) == null ? void 0 : _a.includes("Reward"))]
      ]);
    }), 128))
  ], 2)), [
    [vShow, $options.isShown]
  ]);
}
const ProductsContainer = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j]]);
const _sfc_main$i = {
  props: ["tabs", "currentStep"],
  data() {
    return {};
  },
  methods: {
    initCurrentTab() {
      this.$store.commit("setCurrentTab", {
        stepIdx: this.currentStep.number - 1,
        tabIdx: this.getInitalTabFromUrl()
      });
    },
    setCurrentTab(clickedTab) {
      this.$store.commit("setCurrentTab", {
        stepIdx: this.currentStep.number - 1,
        tabIdx: clickedTab
      });
    },
    getInitalTabFromUrl() {
      var _a;
      const url = window.location.search;
      const urlParams = new URLSearchParams(url);
      const tabFromUrlParams = Number(urlParams.get("tab")) || 0;
      const tabsLength = ((_a = this.tabs) == null ? void 0 : _a.length) ?? 0;
      const isTabFromUrlParamsValid = tabFromUrlParams > 0 && tabFromUrlParams <= tabsLength;
      return this.currentStep.number === 1 && isTabFromUrlParamsValid ? tabFromUrlParams - 1 : 0;
    }
  },
  mounted() {
    this.initCurrentTab();
  },
  computed: {
    ...mapGetters({
      currentTab: "getCurrentTab"
    }),
    currentTabIndex() {
      const index = this.tabs.findIndex((tab) => tab.current);
      return index === -1 ? 0 : index;
    }
  },
  watch: {
    currentStep(newV, old) {
      this.setCurrentTab(0);
    }
  },
  components: {
    Tab: Tab$1,
    ProductsContainer
  }
};
const _hoisted_1$i = { class: "bb-product-grid" };
const _hoisted_2$f = ["innerHTML"];
const _hoisted_3$c = {
  key: 0,
  class: "bb-product-grid__header"
};
const _hoisted_4$9 = { class: "bb-product-grid__body" };
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tab = resolveComponent("Tab");
  const _component_ProductsContainer = resolveComponent("ProductsContainer");
  return openBlock(), createElementBlock("div", _hoisted_1$i, [
    createBaseVNode("div", {
      class: "bb-product-grid__heading hidden-on-desktop",
      innerHTML: $props.currentStep.heading
    }, null, 8, _hoisted_2$f),
    $props.tabs.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_3$c, [
      createBaseVNode("div", {
        class: normalizeClass(["bb-product-grid__tabs", $props.tabs.length > 4 ? `bb-product-grid-big` : "bb-product-grid-small"]),
        ref: "tabsContainer"
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.tabs, (tab, idx) => {
          return openBlock(), createBlock(_component_Tab, {
            onSetCurrentTab: $options.setCurrentTab,
            key: idx,
            tab,
            tabIdx: idx,
            isCurrent: idx === $options.currentTabIndex,
            tabsContainer: _ctx.$refs.tabsContainer,
            hasProducts: !!(tab.variants && tab.variants.length)
          }, null, 8, ["onSetCurrentTab", "tab", "tabIdx", "isCurrent", "tabsContainer", "hasProducts"]);
        }), 128))
      ], 2)
    ])) : createCommentVNode("", true),
    createBaseVNode("div", _hoisted_4$9, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.tabs, (tab, idx) => {
        return openBlock(), createBlock(_component_ProductsContainer, {
          key: idx,
          tab,
          step: $props.currentStep
        }, null, 8, ["tab", "step"]);
      }), 128))
    ])
  ]);
}
const ProductGrid = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i]]);
const _sfc_main$h = {
  props: [
    "number",
    "title",
    /** CDN URL from Liquid (`box_builder_step.icon` file upload); empty falls back to step number */
    "stepIconUrl",
    "isPassed",
    "isPrevious",
    "isDisabled"
  ],
  data() {
    return {};
  },
  methods: {
    passTheStep() {
      if (this.isDisabled) {
        return;
      }
      this.$store.commit("setPassedStep", this.number - 1);
      this.updateUrlForStep(this.number);
    },
    updateUrlForStep(stepNumber) {
      const url = new URL(window.location.href);
      url.searchParams.set("tab", String(stepNumber));
      window.history.replaceState({}, "", url);
    }
  },
  mounted() {
  },
  computed: {
    resolvedIconUrl() {
      const u = this.stepIconUrl;
      return typeof u === "string" && u.trim() !== "" ? u : "";
    }
  },
  watch: {},
  components: {}
};
const _hoisted_1$h = { class: "bb-step__header" };
const _hoisted_2$e = {
  key: 0,
  class: "bb-step__header_number"
};
const _hoisted_3$b = ["src"];
const _hoisted_4$8 = {
  key: 1,
  class: "bb-step__header_number"
};
const _hoisted_5$8 = { class: "bb-step__headr_title label-xs" };
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.passTheStep && $options.passTheStep(...args)),
    class: normalizeClass(["bb-step", { "bb-step--active": !$props.isPrevious && $props.isPassed, "bb-step--previous": $props.isPrevious }])
  }, [
    createBaseVNode("div", _hoisted_1$h, [
      $options.resolvedIconUrl ? (openBlock(), createElementBlock("span", _hoisted_2$e, [
        createBaseVNode("img", {
          src: $options.resolvedIconUrl,
          alt: "",
          class: "bb-step__icon-img"
        }, null, 8, _hoisted_3$b)
      ])) : (openBlock(), createElementBlock("span", _hoisted_4$8, toDisplayString($props.number), 1)),
      createBaseVNode("span", _hoisted_5$8, toDisplayString($props.title), 1)
    ]),
    _cache[1] || (_cache[1] = createBaseVNode("div", { class: "bb-step__selector" }, null, -1))
  ], 2);
}
const Step = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h]]);
const _sfc_main$g = {
  props: [
    "isDisabled",
    "bbHeaderCoords"
  ],
  data() {
    return {
      expandedView: false,
      slotsInFirstRow: 5,
      productsPerRow: 5,
      specificDiscountedVariantIndex: "",
      initedFromSessionStorage: false,
      is_old_checkout: this.$store.state.config.is_old_checkout,
      proccessingAddToCart: false,
      discountMessageIcon: '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="25" viewBox="0 0 21 25" fill="none"><path d="M21 1.97932C21 2.32767 20.7724 2.64032 20.4341 2.75972C19.596 3.05391 19.5833 3.48474 19.5769 3.68045L18.9195 23.3629C18.8902 24.2811 18.1234 25 17.1747 25H3.82535C2.87664 25 2.10979 24.2811 2.08054 23.3641L1.42306 3.66937C1.41797 3.48474 1.40399 3.05391 0.565918 2.76096C0.22764 2.64279 0 2.3289 0 1.98055V0H21V1.97932ZM3.82662 23.7691H17.1747C17.4315 23.7691 17.6401 23.5746 17.6477 23.3247L18.1984 6.82792H2.80034L3.351 23.3259C3.35863 23.5746 3.56719 23.7703 3.82408 23.7703L3.82662 23.7691ZM19.7283 1.23092H1.273V1.70975C1.95591 2.01009 2.66172 2.57632 2.69479 3.64106L2.75965 5.597H18.2404L18.3065 3.63245C18.3396 2.57632 19.0466 2.01009 19.7283 1.71098V1.23092Z" fill="currentColor"/><path d="M8.7482 20.2905H12.3586C12.7096 20.2905 12.9945 20.5662 12.9945 20.906C12.9945 21.2457 12.7096 21.5214 12.3586 21.5214H8.7482C8.3972 21.5214 8.11234 21.2457 8.11234 20.906C8.11234 20.5662 8.3972 20.2905 8.7482 20.2905Z" fill="currentColor"/><path d="M12.8521 17.6539C12.8521 17.9936 12.5672 18.2693 12.2162 18.2693C11.8652 18.2693 11.5803 17.9936 11.5803 17.6539C11.5803 17.3523 11.6414 17.0606 11.7609 16.7861C12.117 15.97 12.9322 15.4394 13.8453 15.4247C13.8516 15.4247 13.858 15.4247 13.8656 15.4247H13.8834C13.8898 15.4247 13.8974 15.4247 13.9038 15.4247C14.794 15.4394 15.6003 15.9515 15.9665 16.7381C16.1102 17.0483 15.9678 17.4126 15.6473 17.5517C15.3268 17.6908 14.9504 17.5529 14.8067 17.2427C14.6414 16.8882 14.2764 16.6581 13.8745 16.6544C13.4625 16.6581 13.0937 16.8956 12.9334 17.2637C12.88 17.3868 12.8533 17.5172 12.8533 17.6526L12.8521 17.6539Z" fill="currentColor"/><path d="M5.23442 17.5529C4.91395 17.4138 4.77151 17.0495 4.91522 16.7393C5.28148 15.9527 6.08775 15.4394 6.97796 15.4259C6.98431 15.4259 6.99067 15.4259 6.9983 15.4259H7.01611C7.02247 15.4259 7.02883 15.4259 7.03646 15.4259C7.94955 15.4407 8.76473 15.9712 9.12081 16.7861C9.24036 17.0618 9.3014 17.3535 9.3014 17.6539C9.3014 17.9936 9.01653 18.2693 8.66554 18.2693C8.31454 18.2693 8.02967 17.9936 8.02967 17.6539C8.02967 17.5185 8.00297 17.388 7.94955 17.2649C7.78932 16.8968 7.42052 16.6593 7.00848 16.6556C6.60661 16.6593 6.24163 16.8895 6.0763 17.244C5.9326 17.5542 5.55617 17.692 5.23569 17.5529H5.23442Z" fill="currentColor"/><path d="M16.0301 19.1876C16.6761 19.1876 17.1632 19.4916 17.1632 19.8941C17.1632 20.2966 16.6761 20.6007 16.0301 20.6007C15.3841 20.6007 14.897 20.2966 14.897 19.8941C14.897 19.4916 15.3841 19.1876 16.0301 19.1876Z" fill="currentColor"/><path d="M4.94193 19.1876C5.58796 19.1876 6.07503 19.4916 6.07503 19.8941C6.07503 20.2966 5.58796 20.6007 4.94193 20.6007C4.29589 20.6007 3.80882 20.2966 3.80882 19.8941C3.80882 19.4916 4.29589 19.1876 4.94193 19.1876Z" fill="currentColor"/></svg>'
    };
  },
  created() {
    if (this.is_old_checkout) {
      this.initItemsFromSessionStorage();
    }
  },
  methods: {
    goToStep1() {
      this.$store.commit("setPassedStep", 0);
      const url = new URL(window.location.href);
      url.searchParams.set("tab", "1");
      window.history.replaceState({}, "", url);
    },
    async addToCart() {
      var _a;
      if (this.proccessingAddToCart || this.addedQty < 1 || this.disableATC) {
        return;
      }
      this.proccessingAddToCart = true;
      await this.removeBundleFromCart();
      setTimeout(() => {
        this.proccessingAddToCart = false;
      }, 3e3);
      var orderTimestamp = Date.now();
      let items = [];
      if (this.is_old_checkout) {
        this.productsVariants.forEach((variant) => {
          if (variant.available) {
            const foundIndex = items.findIndex((item) => item.id === variant.id);
            if (foundIndex === -1) {
              items.push({
                id: variant.id,
                quantity: 1,
                properties: {
                  _order_timestamp: orderTimestamp,
                  _has_specific_discount: variant.specificDiscount > 0,
                  _stepName: variant.stepName,
                  // needs to quick find this variant object in tabs on created hook
                  _tabName: variant.tabName
                  // needs to quick find this variant object in tabs on created hook
                }
              });
            } else {
              items[foundIndex].quantity++;
            }
          }
        });
      } else {
        const parentVariantId = this.$store.state.config.parentVariantId;
        if (!parentVariantId) return;
        const nestedProductVariantsIds = {};
        this.productsVariants.forEach((variant) => {
          if (nestedProductVariantsIds[variant.id]) {
            nestedProductVariantsIds[variant.id]++;
          } else {
            nestedProductVariantsIds[variant.id] = 1;
          }
        });
        items = [
          {
            id: parentVariantId,
            quantity: 1,
            properties: {
              _order_timestamp: orderTimestamp,
              _nestedVariantsIds: nestedProductVariantsIds,
              _bundle_type: "mix_powder",
              _root_id: (_a = this.$store.state.config) == null ? void 0 : _a.rootId
            }
          }
        ];
      }
      const formData = {
        "items": items
      };
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      }).then(async (response) => {
        const responseJson = await response.json();
        if (response.ok) {
          this.setCookie("box-builder-products", JSON.stringify(items), 1);
          document.documentElement.dispatchEvent(new CustomEvent("variant:added", {
            bubbles: true,
            detail: {
              variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
            }
          }));
          await fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
            const cartContent = await response2.json();
            document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: cartContent
              }
            }));
            cartContent["sections"] = responseJson["sections"];
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart: true
              }
            }));
          });
        }
        document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: response.ok ? "success" : "error",
            error: responseJson["description"] || ""
          }
        }));
      }).catch((error) => {
        console.error("Error:", error);
      });
    },
    setCookie(key, value, daysToExpire = 1) {
      const expirationDate = /* @__PURE__ */ new Date();
      expirationDate.setTime(expirationDate.getTime() + daysToExpire * 24 * 60 * 60 * 1e3);
      const expires = "expires=" + expirationDate.toUTCString();
      document.cookie = key + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
    },
    getCookie(key) {
      const name = key + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(";");
      for (let i = 0; i < cookieArray.length; i++) {
        const cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
      return "";
    },
    async initItemsFromSessionStorage() {
      let products = this.getCookie("box-builder-products");
      if (!products) {
        return;
      }
      try {
        products = JSON.parse(products);
      } catch (error) {
        console.log(error);
      }
      let cartItems;
      await fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }).then((response) => {
        console.log(response);
        return response.json();
      }).then((data) => {
        cartItems = data.items;
        return data;
      }).catch((error) => {
        console.error("Error:", error);
      });
      const cartQuantityById = new Map(cartItems.map((item) => [item.id, item.quantity]));
      const updatedProducts = products.filter((product) => cartQuantityById.has(product.id)).map((product) => ({
        ...product,
        // Keep all existing fields
        quantity: cartQuantityById.get(product.id)
        // Update quantity
      }));
      updatedProducts.forEach((p2) => {
        const step = this.steps.find((s) => s.title === p2.properties._stepName);
        const tab = step.tabs.find((t) => t.title === p2.properties._tabName);
        const foundVariant = tab.variants.find((v) => v.id === p2.id);
        for (let i = 0; i < p2.quantity; i++) {
          this.$store.dispatch("addToBox", foundVariant);
        }
      });
      this.initedFromSessionStorage = true;
    },
    remove(variant) {
      const foundVariantIdx = this.productsVariants.findIndex(
        (v) => v.id === variant.id
      );
      if (foundVariantIdx < 0) {
        return;
      }
      const foundVariant = this.productsVariants[foundVariantIdx];
      if (foundVariant.specificDiscount) {
        this.$store.commit("disapplySpecificDiscount");
      }
      this.$store.dispatch("removeFromBox", foundVariant);
    },
    updateProductsPerRow() {
      this.productsPerRow = 5;
    },
    showDiscountInPlaceholder(item) {
      if (!this.isOnDiscountStep) return false;
      if (item.discountPercent == null) return false;
      if (item.showDiscountLabel === false) return false;
      const currentDiscount = this.discount || 0;
      return item.discountPercent > currentDiscount;
    },
    getBoxProductStyle(item) {
      var _a, _b;
      const color = (_b = (_a = item.variant) == null ? void 0 : _a.product) == null ? void 0 : _b.background_color_product_tile;
      if (!color || !String(color).trim()) return {};
      return { backgroundColor: color };
    },
    getBlockIndex(rowIdx, slotIdx, row) {
      return rowIdx * row.length + slotIdx;
    },
    expand() {
      if (this.addedQty > this.slotsInFirstRow) {
        this.expandedView = true;
      } else {
        this.expandedView = false;
      }
    },
    formatPrice(price, dontDevideBy100 = false) {
      var _a, _b, _c, _d, _e;
      const isUKStore = Shopify.currency.active === "GBP" || Shopify.locale === "en-GB";
      if (isUKStore) {
        if (dontDevideBy100) {
          const priceDecimalsLength = (_b = (_a = price.toString().split(".")) == null ? void 0 : _a[1]) == null ? void 0 : _b.length;
          if (priceDecimalsLength > 2) {
            price = +price.toString().slice(0, -1 * (priceDecimalsLength - 2));
          }
          if (priceDecimalsLength < 2) {
            price = +price.toFixed(2);
          }
          const result = price && price > 0 ? `${price}` : "0.00";
          return `£ ${result}`;
        } else {
          const result = price && price > 0 ? (price / 100).toFixed(2) : "0.00";
          return `£ ${result}`;
        }
      } else {
        if (dontDevideBy100) {
          const priceDecimalsLength = (_d = (_c = price.toString().split(".")) == null ? void 0 : _c[1]) == null ? void 0 : _d.length;
          if (priceDecimalsLength > 2) {
            price = +price.toString().slice(0, -1 * (priceDecimalsLength - 2));
          }
          if (priceDecimalsLength < 2) {
            price = +price.toFixed(2);
          }
          const result = price && price > 0 ? (_e = `${price}`) == null ? void 0 : _e.split(".").join(",") : "0,00";
          return `${result} ${this.$store.state.currency}`;
        } else {
          const result = price && price > 0 ? (price / 100).toFixed(2).split(".").join(",") : "0,00";
          return `${result} ${this.$store.state.currency}`;
        }
      }
    },
    goToNextStep() {
      if (this.isDisabled) {
        return;
      }
      this.$store.commit("setPassedStep", this.currentStep.number);
      window.scrollTo({ top: this.bbHeaderCoords.top - this.bbHeaderCoords.height * 2, behavior: "smooth" });
    },
    async removeBundleFromCart() {
      let products = this.getCookie("box-builder-products");
      if (!products) {
        return;
      }
      try {
        products = JSON.parse(products);
      } catch (error) {
        console.log(error);
      }
      const updates = products.reduce((obj, product) => {
        obj[product.id] = 0;
        return obj;
      }, {});
      return fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          updates
        })
      }).then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      }).catch((error) => {
        console.error("Error:", error);
      });
    }
  },
  mounted() {
    window.addEventListener("resize", this.updateProductsPerRow);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateProductsPerRow);
  },
  computed: {
    ...mapGetters({
      productsBoxWithVariants: "getProductsBox",
      addedQty: "getAddedProductsQuantity",
      discount: "getDiscount",
      currentStep: "getCurrentStep",
      nextDiscount: "getNextDiscount",
      discountableProductsAddedQty: "getAddedDiscountableProductsQty",
      numberOfSpecificDiscountsUsed: "getNumberOfSpecificDiscountsUsed",
      specificDiscountAmount: "getSpecificDiscountAmount",
      steps: "getSteps",
      pricePerPortion: "getReductedPricePerPortion"
    }),
    checkoutButtonStyle() {
      var _a;
      const section = (_a = this.$store.state.config) == null ? void 0 : _a.section;
      if ((section == null ? void 0 : section.override_primary_button_background_checkout) && (section == null ? void 0 : section.primary_button_background_checkout) && !this.disableATC) {
        return { backgroundColor: section.primary_button_background_checkout };
      }
      return {};
    },
    shakerDiscountFormatted() {
      var _a;
      const specificDiscountedVariantValue = (_a = this.productsVariants) == null ? void 0 : _a[this.specificDiscountedVariantIndex];
      const capped = specificDiscountedVariantValue ? this.$store.getters.getCappedSpecificDiscountForVariant(specificDiscountedVariantValue) : this.$store.state.specificDiscountAmount;
      return this.formatPrice(capped);
    },
    pricePerPortionFormatted() {
      return this.formatPrice(this.pricePerPortion, true);
    },
    hasSavings() {
      const compare = Number(this.priceCompare.unformatted);
      const current = Number(this.price.unformatted);
      return compare > current;
    },
    stepWithProgressiveDiscount() {
      var _a;
      return ((_a = this.steps) == null ? void 0 : _a.find((step) => {
        var _a2;
        return (_a2 = step.discounts) == null ? void 0 : _a2.length;
      })) || null;
    },
    isOnDiscountStep() {
      var _a, _b;
      return !!this.stepWithProgressiveDiscount && ((_a = this.currentStep) == null ? void 0 : _a.number) === ((_b = this.stepWithProgressiveDiscount) == null ? void 0 : _b.number);
    },
    savingsPrice() {
      return this.formatPrice(this.priceCompare.unformatted - this.price.unformatted, true);
    },
    atLeastOneProductFromTheFirstStep() {
      return this.productsBoxWithVariants.find((v) => v.stepName === this.steps[0].title);
    },
    productsVariants() {
      if (!this.productsBoxWithVariants || !this.productsBoxWithVariants.length || this.productsBoxWithVariants.length < 1) {
        return;
      }
      const result = [];
      this.$store.commit("resetSpecificDiscountApplying");
      this.productsBoxWithVariants.forEach((variant) => {
        for (let i = 0; i < (variant.addedQty || 1); i++) {
          if (variant.specificDiscountable && this.numberOfSpecificDiscountsUsed > 0) {
            this.$store.commit("applySpecificDiscount");
            variant.specificDiscount = this.$store.getters.getCappedSpecificDiscountForVariant(variant);
          } else {
            variant.specificDiscount = 0;
          }
          result.push({ ...variant });
        }
      });
      this.$store.commit("setProductsBoxSeparatedVariants", result);
      return result;
    },
    rows() {
      var _a;
      const slotsInFirstRow = this.slotsInFirstRow;
      const expanded = this.expandedView;
      let products, rowsQty;
      if ((_a = this.productsVariants) == null ? void 0 : _a.length) {
        products = this.productsVariants.map((product, index) => ({
          ...product,
          index
        }));
        if (expanded) {
          rowsQty = Math.max(1, Math.ceil((this.addedQty + 1) / this.productsPerRow));
        } else if (this.addedQty > slotsInFirstRow) {
          rowsQty = 1 + Math.ceil((this.addedQty - (slotsInFirstRow - 1)) / this.productsPerRow);
        } else {
          rowsQty = 1;
        }
      }
      rowsQty = !products ? 1 : rowsQty;
      const rows = [];
      const discountTierAlreadyShown = /* @__PURE__ */ new Set();
      let discountPlaceholderCount = 0;
      for (let i = 0; i < rowsQty; i++) {
        const row = [];
        const isFirstRow = i === 0;
        const showExpandInFirstRow = !expanded && isFirstRow && this.addedQty > slotsInFirstRow;
        const slotsInThisRow = expanded ? this.productsPerRow : isFirstRow ? slotsInFirstRow : this.productsPerRow;
        const startIdx = expanded ? i * this.productsPerRow : isFirstRow ? 0 : this.addedQty > slotsInFirstRow ? slotsInFirstRow - 1 + (i - 1) * this.productsPerRow : i * this.productsPerRow;
        for (let j = 0; j < slotsInThisRow; j++) {
          const isExpandSlot = showExpandInFirstRow && j === slotsInFirstRow - 1;
          if (isExpandSlot) {
            row.push({
              placeholder: false,
              expandButton: true
            });
            continue;
          }
          const isLastVisibleCell = expanded && i === rowsQty - 1 && j === slotsInThisRow - 1;
          if (isLastVisibleCell) {
            row.push({
              placeholder: false,
              expandButton: false,
              collapseButton: true
            });
            continue;
          }
          const productIndex = startIdx + j;
          if ((products == null ? void 0 : products.length) && products[productIndex]) {
            const productVariant = products[productIndex];
            row.push({
              variant: productVariant,
              placeholder: false,
              expandButton: false
            });
            continue;
          }
          const slotQuantityForDiscount = this.discountableProductsAddedQty + discountPlaceholderCount + 1;
          const discountPercent = this.$store.getters.getDiscountForQuantity(slotQuantityForDiscount);
          const isFirstSlotForThisTier = discountPercent != null && !discountTierAlreadyShown.has(discountPercent);
          if (discountPercent != null) discountTierAlreadyShown.add(discountPercent);
          discountPlaceholderCount++;
          row.push({
            placeholder: true,
            expandButton: false,
            slotIndex: productIndex,
            discountPercent,
            showDiscountLabel: isFirstSlotForThisTier
          });
        }
        rows.push(row);
      }
      return rows;
    },
    price() {
      var _a;
      let result = 0;
      let specificDiscountedPrice = 0;
      if (!((_a = this.productsVariants) == null ? void 0 : _a.length)) {
        return {
          formatted: this.formatPrice(result),
          unformatted: result
        };
      }
      console.log("[Box.vue] Price calculation start:", {
        variantsCount: this.productsVariants.length,
        bundleDiscount: this.discount
      });
      this.productsVariants.forEach((variant, idx) => {
        var _a2, _b, _c;
        const variantPrice = +((_a2 = variant.price / 100) == null ? void 0 : _a2.toFixed(2));
        console.log("[Box.vue] Processing variant:", {
          index: idx,
          variantId: variant.id,
          variantTitle: variant.productTitle,
          variantPrice,
          isCategoryDiscountable: variant.isCategoryDiscountable,
          hasSpecificDiscount: !!(variant.specificDiscount && this.atLeastOneProductFromTheFirstStep)
        });
        if (variant.specificDiscount && this.atLeastOneProductFromTheFirstStep) {
          const specificDiscount = +((_b = variant.specificDiscount / 100) == null ? void 0 : _b.toFixed(2));
          this.specificDiscountedVariantIndex = idx;
          const discountedPrice = +((_c = variantPrice - specificDiscount) == null ? void 0 : _c.toFixed(2));
          console.log("[Box.vue] Applied specific discount:", {
            specificDiscount,
            discountedPrice
          });
          specificDiscountedPrice += discountedPrice;
        } else {
          const bundleDiscount = this.discount || 0;
          const categoryDiscount = this.$store.getters.getCategoryDiscountForVariant(variant) || 0;
          console.log("[Box.vue] Checking discounts for variant:", {
            variantId: variant.id,
            isCategoryDiscountable: variant.isCategoryDiscountable,
            bundleDiscount,
            categoryDiscount,
            variantPrice
          });
          let discountedPrice = variantPrice;
          if (bundleDiscount > 0 && categoryDiscount > 0) {
            const combinedDiscount = bundleDiscount + categoryDiscount;
            discountedPrice = +(variantPrice * (1 - combinedDiscount / 100)).toFixed(2);
            console.log("[Box.vue] Applied both discounts additively (summed):", {
              calculation: `${variantPrice} * (1 - (${bundleDiscount} + ${categoryDiscount})/100) = ${variantPrice} * (1 - ${combinedDiscount}/100)`,
              result: discountedPrice
            });
          } else if (bundleDiscount > 0) {
            discountedPrice = +(variantPrice * (1 - bundleDiscount / 100)).toFixed(2);
            console.log("[Box.vue] Applied bundle discount only:", {
              calculation: `${variantPrice} * (1 - ${bundleDiscount}/100)`,
              result: discountedPrice
            });
          } else if (categoryDiscount > 0) {
            discountedPrice = +(variantPrice * (1 - categoryDiscount / 100)).toFixed(2);
            console.log("[Box.vue] Applied category discount only:", {
              calculation: `${variantPrice} * (1 - ${categoryDiscount}/100)`,
              result: discountedPrice
            });
          } else {
            console.log("[Box.vue] No discounts applied");
          }
          result += discountedPrice;
        }
      });
      console.log("[Box.vue] Price calculation complete:", {
        result,
        specificDiscountedPrice,
        total: result + specificDiscountedPrice
      });
      result += specificDiscountedPrice;
      result = result.toFixed(2);
      return {
        formatted: this.formatPrice(result, true),
        unformatted: result
      };
    },
    priceCompare() {
      var _a;
      let result = 0;
      if (!((_a = this.productsVariants) == null ? void 0 : _a.length)) {
        return {
          formatted: this.formatPrice(result),
          unformatted: result
        };
      }
      this.productsVariants.forEach((variant) => {
        result += variant.price;
      });
      return {
        formatted: this.formatPrice(result),
        unformatted: result / 100
      };
    },
    nextDiscountMessage() {
      var _a;
      const discountTemplate = (_a = this.$store.state.config.htmlSnippets) == null ? void 0 : _a.discountTemplate;
      const canWordTranslated = this.nextDiscount.products_quantity - this.discountableProductsAddedQty > 1 ? this.$store.state.config.translations.cans : this.$store.state.config.translations.can;
      const leftCub = discountTemplate.includes("&lcub;") ? "&lcub;" : "{";
      const rightCub = discountTemplate.includes("&rcub;") ? "&rcub;" : "}";
      const qtyStr = `${leftCub}qty${rightCub}`;
      const discountStr = `${leftCub}discount${rightCub}`;
      const canStr = `${leftCub}can${rightCub}`;
      return this.nextDiscount && discountTemplate ? discountTemplate.replace(qtyStr, `${this.nextDiscount.products_quantity - this.discountableProductsAddedQty} ${canWordTranslated}`).replace(discountStr, this.nextDiscount.discount_percent).replace(canStr, canWordTranslated) : "";
    },
    disableATC() {
      return this.addedQty < 1;
    }
  },
  watch: {
    addedQty(newV, old) {
      if (old > this.slotsInFirstRow && newV <= this.slotsInFirstRow) {
        this.expandedView = false;
      }
    }
  },
  components: {
    Image: Image$1
  }
};
const _hoisted_1$g = { class: "bb-box-root" };
const _hoisted_2$d = { class: "bb-box__header-wrapper" };
const _hoisted_3$a = { class: "bb-box__header" };
const _hoisted_4$7 = {
  key: 0,
  class: "bb-box__discount-message radius-large"
};
const _hoisted_5$7 = ["innerHTML"];
const _hoisted_6$6 = ["innerHTML"];
const _hoisted_7$3 = { class: "bb-box" };
const _hoisted_8$3 = { class: "bb-box__inner" };
const _hoisted_9$2 = { class: "bb-box__body" };
const _hoisted_10$2 = { class: "bb-box__scroll-container" };
const _hoisted_11$2 = { class: "bb-box__container" };
const _hoisted_12$2 = ["aria-label", "onClick", "innerHTML"];
const _hoisted_13$2 = ["innerHTML"];
const _hoisted_14$2 = {
  key: 3,
  class: "bb-box__product_placeholder bb-box__product_placeholder--discount"
};
const _hoisted_15$2 = { class: "bb-box__placeholder-save label-xs" };
const _hoisted_16$2 = { class: "bb-box__placeholder-percent label-xs" };
const _hoisted_17$2 = ["innerHTML"];
const _hoisted_18$2 = {
  key: 5,
  class: "bb-product__variant_specific-discount"
};
const _hoisted_19$1 = { class: "bb-box__body_summary" };
const _hoisted_20$1 = {
  key: 0,
  class: "bb-box__summary_price-wrapper"
};
const _hoisted_21$1 = { class: "bb-box__summary_price-wrapper--desktop" };
const _hoisted_22$1 = { class: "bb-box__summary_price-left" };
const _hoisted_23$1 = { class: "bb-box__savings label-xs" };
const _hoisted_24$1 = {
  key: 0,
  class: "bb-box__percent-off body-m-strong"
};
const _hoisted_25$1 = { class: "bb-box__summary_price-right" };
const _hoisted_26$1 = {
  key: 0,
  class: "bb-box__summary_price-compare label-xs"
};
const _hoisted_27$1 = { class: "bb-box__summary_price-normal body-m-strong" };
const _hoisted_28 = { class: "bb-box__summary_price-mobile" };
const _hoisted_29 = {
  key: 0,
  class: "label-m bb-box__summary_price-mobile-item bb-box__summary-discount"
};
const _hoisted_30 = {
  key: 0,
  class: "label-m bb-box__summary_price-mobile-item bb-box__saving"
};
const _hoisted_31 = {
  key: 1,
  class: "label-m bb-box__summary_price-mobile-item bb-box__summary-compare-price"
};
const _hoisted_32 = { class: "label-m bb-box__summary_price-mobile-item bb-box__price-formatted" };
const _hoisted_33 = { class: "bb-box__summary_controls" };
const _hoisted_34 = ["disabled"];
const _hoisted_35 = { key: 0 };
const _hoisted_36 = { key: 1 };
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = resolveComponent("Image");
  return openBlock(), createElementBlock("div", _hoisted_1$g, [
    createBaseVNode("div", _hoisted_2$d, [
      createBaseVNode("div", _hoisted_3$a, [
        _ctx.nextDiscount && !_ctx.nextDiscount.theLastOneReached && !$options.isOnDiscountStep ? (openBlock(), createElementBlock("div", _hoisted_4$7, [
          createBaseVNode("span", {
            class: "bb-box__discount-message-icon",
            innerHTML: $data.discountMessageIcon,
            "aria-hidden": "true"
          }, null, 8, _hoisted_5$7),
          createBaseVNode("span", {
            class: "bb-box__discount-message-text label-s",
            innerHTML: $options.nextDiscountMessage
          }, null, 8, _hoisted_6$6)
        ])) : createCommentVNode("", true)
      ])
    ]),
    createBaseVNode("div", _hoisted_7$3, [
      createBaseVNode("div", _hoisted_8$3, [
        createBaseVNode("div", _hoisted_9$2, [
          createBaseVNode("div", _hoisted_10$2, [
            createBaseVNode("div", _hoisted_11$2, [
              (openBlock(true), createElementBlock(Fragment, null, renderList($options.rows, (row, topIdx) => {
                return withDirectives((openBlock(), createElementBlock("div", {
                  class: "bb-box__container_row",
                  key: topIdx
                }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(row, (item, idx) => {
                    var _a, _b, _c, _d;
                    return openBlock(), createElementBlock("div", {
                      class: normalizeClass(["bb-box__product radius-small", {
                        "product-selected": !!item.variant,
                        "bb-box__product_expand-btn--wrapper": item.expandButton ? !$data.expandedView : false,
                        "bb-box__product_collapse-btn--wrapper": item.collapseButton,
                        "bb-box__box_expand-btn--disabled": item.expandButton && _ctx.addedQty <= $data.slotsInFirstRow,
                        "bb-box__product--darken-17": !item.collapseButton && $options.isOnDiscountStep && $options.getBlockIndex(topIdx, idx, row) === 2,
                        "bb-box__product--darken-20": !item.collapseButton && $options.isOnDiscountStep && $options.getBlockIndex(topIdx, idx, row) >= 3
                      }]),
                      key: idx,
                      onClick: _cache[2] || (_cache[2] = withModifiers(() => {
                      }, ["stop"])),
                      style: normalizeStyle($options.getBoxProductStyle(item))
                    }, [
                      !!item.variant ? (openBlock(), createElementBlock("button", {
                        key: 0,
                        class: "bb-box__product-remove",
                        type: "button",
                        "aria-label": _ctx.$store.state.config.translations.removeButton,
                        onClick: ($event) => $options.remove(item.variant),
                        innerHTML: _ctx.$store.state.config.htmlSnippets.icons.close
                      }, null, 8, _hoisted_12$2)) : createCommentVNode("", true),
                      item.expandButton ? (openBlock(), createElementBlock("button", {
                        key: 1,
                        class: "bb-box__product_placeholder bb-box__box_expand-btn label-xs",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = withModifiers((...args) => $options.expand && $options.expand(...args), ["stop"]))
                      }, toDisplayString(_ctx.$store.state.config.translations.expand), 1)) : createCommentVNode("", true),
                      item.collapseButton ? (openBlock(), createElementBlock("button", {
                        key: 2,
                        class: "bb-box__product_placeholder bb-box__box_expand-btn label-xs",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event) => $data.expandedView = false),
                        innerHTML: _ctx.$store.state.config.translations.showLess || "Show less"
                      }, null, 8, _hoisted_13$2)) : createCommentVNode("", true),
                      item.placeholder && !item.expandButton && $options.showDiscountInPlaceholder(item) ? (openBlock(), createElementBlock("div", _hoisted_14$2, [
                        createBaseVNode("span", _hoisted_15$2, toDisplayString(_ctx.$store.state.config.translations.savings || "SAVE"), 1),
                        createBaseVNode("span", _hoisted_16$2, toDisplayString(item.discountPercent) + "%", 1)
                      ])) : item.placeholder && !item.expandButton ? (openBlock(), createElementBlock("div", {
                        key: 4,
                        class: "bb-box__product_placeholder",
                        innerHTML: _ctx.$store.state.config.htmlSnippets.icons.placeholder
                      }, null, 8, _hoisted_17$2)) : createCommentVNode("", true),
                      ((_a = item.variant) == null ? void 0 : _a.specificDiscountable) && ((_b = item.variant) == null ? void 0 : _b.index) === $data.specificDiscountedVariantIndex && $options.atLeastOneProductFromTheFirstStep ? (openBlock(), createElementBlock("span", _hoisted_18$2, " -" + toDisplayString($options.shakerDiscountFormatted), 1)) : createCommentVNode("", true),
                      (item.expandButton ? $data.expandedView : !item.placeholder) && item.variant ? (openBlock(), createBlock(_component_Image, {
                        key: 6,
                        src: ((_c = item.variant.featured_image) == null ? void 0 : _c.src) || item.variant.featured_image,
                        additionalClasses: "bb-box__product_image-wrapper",
                        alt: ((_d = item.variant.featured_image) == null ? void 0 : _d.alt) || item.variant.title,
                        width: 60,
                        height: 60,
                        useSrcset: true,
                        usePlaceholder: false,
                        loading: "eager"
                      }, null, 8, ["src", "alt"])) : createCommentVNode("", true)
                    ], 6);
                  }), 128))
                ])), [
                  [vShow, topIdx === 0 || $data.expandedView]
                ]);
              }), 128))
            ])
          ]),
          createBaseVNode("div", _hoisted_19$1, [
            Number($options.price.unformatted) > 0 ? (openBlock(), createElementBlock("div", _hoisted_20$1, [
              createBaseVNode("div", _hoisted_21$1, [
                withDirectives(createBaseVNode("div", _hoisted_22$1, [
                  $options.hasSavings ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createBaseVNode("span", _hoisted_23$1, toDisplayString(_ctx.$store.state.config.translations.savings) + " " + toDisplayString($options.savingsPrice), 1),
                    _ctx.discount > 0 ? (openBlock(), createElementBlock("span", _hoisted_24$1, toDisplayString(_ctx.discount) + "% " + toDisplayString(_ctx.$store.state.config.translations.percentOff), 1)) : createCommentVNode("", true)
                  ], 64)) : createCommentVNode("", true)
                ], 512), [
                  [vShow, $options.hasSavings]
                ]),
                createBaseVNode("div", _hoisted_25$1, [
                  $options.hasSavings ? (openBlock(), createElementBlock("del", _hoisted_26$1, toDisplayString($options.priceCompare.formatted), 1)) : createCommentVNode("", true),
                  createBaseVNode("span", _hoisted_27$1, toDisplayString($options.price.formatted), 1)
                ])
              ]),
              createBaseVNode("div", _hoisted_28, [
                $options.hasSavings && _ctx.discount > 0 ? (openBlock(), createElementBlock("span", _hoisted_29, toDisplayString(_ctx.discount) + "% " + toDisplayString(_ctx.$store.state.config.translations.percentOff), 1)) : createCommentVNode("", true),
                createBaseVNode("div", null, [
                  $options.hasSavings ? (openBlock(), createElementBlock("span", _hoisted_30, toDisplayString(_ctx.$store.state.config.translations.savings) + " " + toDisplayString($options.savingsPrice), 1)) : createCommentVNode("", true),
                  $options.hasSavings ? (openBlock(), createElementBlock("del", _hoisted_31, toDisplayString($options.priceCompare.formatted), 1)) : createCommentVNode("", true),
                  createBaseVNode("span", _hoisted_32, toDisplayString($options.price.formatted), 1)
                ])
              ])
            ])) : createCommentVNode("", true),
            createBaseVNode("div", _hoisted_33, [
              _ctx.currentStep.number !== _ctx.$store.state.steps.length ? (openBlock(), createElementBlock("button", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = (...args) => $options.goToNextStep && $options.goToNextStep(...args)),
                class: "bb-box__summary_next-step-button btn btn--secondary btn--small btn--transparent",
                type: "button",
                disabled: _ctx.addedQty < 1
              }, toDisplayString(_ctx.$store.state.config.translations.continue), 9, _hoisted_34)) : createCommentVNode("", true),
              createBaseVNode("button", {
                class: normalizeClass(["bb-box__summary_checkout-button btn btn--primary btn--medium", {
                  "bb-box__summary_checkout-button--wider": _ctx.currentStep.number === _ctx.$store.state.steps.length,
                  "disabled": $options.disableATC
                }]),
                onClick: _cache[4] || (_cache[4] = (...args) => $options.addToCart && $options.addToCart(...args)),
                type: "button",
                style: normalizeStyle($options.checkoutButtonStyle)
              }, [
                !$data.initedFromSessionStorage ? (openBlock(), createElementBlock("span", _hoisted_35, toDisplayString(_ctx.$store.state.config.translations.checkout), 1)) : (openBlock(), createElementBlock("span", _hoisted_36, toDisplayString(_ctx.$store.state.config.translations.updateCart), 1))
              ], 6)
            ])
          ])
        ])
      ])
    ])
  ]);
}
const Box = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g]]);
const _sfc_main$f = {
  data() {
    return {
      config: null,
      bbHeaderCoords: { top: 0, left: 0, width: 0, height: 0 }
    };
  },
  methods: {
    initStepFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const tabParam = params.get("tab");
      const tabNum = tabParam ? parseInt(tabParam, 10) : NaN;
      if (!Number.isNaN(tabNum) && tabNum >= 1 && tabNum <= this.steps.length) {
        this.$store.commit("setPassedStep", tabNum - 1);
      }
    },
    calculateDiscount() {
      this.$store.commit("calculateDiscount");
    },
    getBBHeaderCoords() {
      this.$nextTick(() => {
        const bbHeader = this.$refs.bbHeader;
        if (bbHeader) {
          let element = bbHeader;
          let top = 0;
          let left = 0;
          while (element) {
            top += element.offsetTop;
            left += element.offsetLeft;
            element = element.offsetParent;
          }
          this.bbHeaderCoords = {
            top,
            left,
            width: bbHeader.offsetWidth,
            height: bbHeader.offsetHeight
          };
        }
      });
    },
    async fireCustomProductViewed() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
      const analytics = window.Shopify.analytics;
      if (typeof analytics === "undefined" || !analytics.publish) {
        console.warn("analytics.publish is not available");
        return;
      }
      const variantId = (_a = this.$store.state.config) == null ? void 0 : _a.parentVariantId;
      if (!variantId) {
        return;
      }
      let productId = (_b = this.config) == null ? void 0 : _b.mixMatchProductID;
      if (!productId) {
        console.warn("Mix & Match product ID not found in config, using default");
        return;
      }
      let currencyCode = "PLN";
      if ((_d = (_c = window.themeVariables) == null ? void 0 : _c.settings) == null ? void 0 : _d.cartCurrency) {
        currencyCode = window.themeVariables.settings.cartCurrency;
      } else if ((_f = (_e = window.Shopify) == null ? void 0 : _e.currency) == null ? void 0 : _f.active) {
        currencyCode = window.Shopify.currency.active;
      } else if ((_h = (_g = window.Shopify) == null ? void 0 : _g.locale) == null ? void 0 : _h.currency) {
        currencyCode = window.Shopify.locale.currency;
      } else if (((_i = window.Shopify) == null ? void 0 : _i.shop) && window.Shopify.shop.includes("pl")) {
        currencyCode = "PLN";
      } else if (((_j = window.Shopify) == null ? void 0 : _j.shop) && (window.Shopify.shop.includes("fr") || window.Shopify.shop.includes("de"))) {
        currencyCode = "EUR";
      }
      const imageUrl = ((_l = (_k = this.$store.state.config) == null ? void 0 : _k.parentProduct) == null ? void 0 : _l.featured_image) || "https://cdn.shopify.com/s/files/1/0913/0600/0750/files/ProductImage_mixandmatch_eac910ec-f2d5-4a9a-8ac7-ba8418d16573.png?v=1745319690";
      const eventData = {
        productVariant: {
          price: {
            amount: 0,
            // Fallback price for Mix & Match or 0
            currencyCode
          },
          product: {
            title: "Mix & Match",
            vendor: "HOLY",
            id: String(productId),
            untranslatedTitle: "Mix & Match",
            url: "/pages/mix-n-match",
            type: "20 - Other Items"
          },
          id: String(variantId),
          image: {
            src: imageUrl
          },
          sku: "NOSYNC",
          // M&M products currently have no SKU
          title: "Mix & Match",
          untranslatedTitle: "Mix & Match"
        }
      };
      try {
        analytics.publish("custom_product_viewed", eventData);
        console.log("custom_product_viewed event fired:", eventData);
      } catch (error) {
        console.error("Error firing custom_product_viewed event:", error);
      }
    }
  },
  created() {
    this.config = this.$store.state.config;
  },
  computed: {
    ...mapGetters({
      steps: "getSteps",
      currentStep: "getCurrentStep",
      addedProductsQty: "getAddedProductsQuantity",
      addedDiscountableProductsQty: "getAddedDiscountableProductsQty"
    }),
    isStepDisabled() {
      return false;
    },
    currentStepIndex() {
      return this.currentStep.number - 1;
    },
    previousStepIndexes() {
      return this.steps.slice(0, this.currentStepIndex).map((step) => step.number - 1);
    }
  },
  mounted() {
    this.initStepFromUrl();
    this.getBBHeaderCoords();
    window.addEventListener("resize", this.getBBHeaderCoords);
    console.log("✌️currentStep --->", this.currentStep);
    this.$nextTick(() => {
      this.fireCustomProductViewed();
    });
  },
  watch: {
    addedProductsQty(newV, old) {
      this.calculateDiscount();
    }
  },
  components: {
    Step,
    GridSwitcher,
    ProductGrid,
    Box
  }
};
const _hoisted_1$f = {
  class: "bb-header bb-steps-big",
  ref: "bbHeader"
};
const _hoisted_2$c = { class: "bb-steps__wrapper" };
const _hoisted_3$9 = { class: "bb-steps" };
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Step = resolveComponent("Step");
  const _component_GridSwitcher = resolveComponent("GridSwitcher");
  const _component_ProductGrid = resolveComponent("ProductGrid");
  const _component_Box = resolveComponent("Box");
  return openBlock(), createElementBlock(Fragment, null, [
    createBaseVNode("div", _hoisted_1$f, [
      createBaseVNode("div", _hoisted_2$c, [
        createBaseVNode("div", _hoisted_3$9, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.steps, (step, idx) => {
            return openBlock(), createBlock(_component_Step, {
              key: idx,
              title: step.title,
              number: step.number,
              "step-icon-url": step.step_icon_url,
              isPassed: idx === 0 || step.isPassed,
              isDisabled: false,
              isPrevious: $options.previousStepIndexes.includes(idx)
            }, null, 8, ["title", "number", "step-icon-url", "isPassed", "isPrevious"]);
          }), 128))
        ])
      ]),
      createVNode(_component_GridSwitcher)
    ], 512),
    createVNode(_component_ProductGrid, {
      tabs: _ctx.currentStep.tabs,
      currentStep: _ctx.currentStep
    }, null, 8, ["tabs", "currentStep"]),
    createVNode(_component_Box, {
      isDisabled: $options.isStepDisabled,
      bbHeaderCoords: $data.bbHeaderCoords
    }, null, 8, ["isDisabled", "bbHeaderCoords"])
  ], 64);
}
const App$1 = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f]]);
function sortObjectsByAvailability(arr) {
  arr.sort((a, b) => {
    if (!a.available && b.available) {
      return 1;
    } else if (a.available && !b.available) {
      return -1;
    }
    return 0;
  });
}
function findVariantById(steps, variantId) {
  if (!steps || !variantId) return null;
  const searchId = String(variantId);
  for (const step of steps) {
    if (!step.tabs) continue;
    for (const tab of step.tabs) {
      if (!tab.variants) continue;
      const foundVariant = tab.variants.find((v) => String(v.id) === searchId);
      if (foundVariant) {
        return foundVariant;
      }
    }
  }
  return null;
}
function preInitializeBoxWithVariant(vuexStore, steps) {
  const urlParams = new URLSearchParams(window.location.search);
  const selectedVariantId = urlParams.get("selectedVariantId");
  if (!selectedVariantId) {
    return;
  }
  const variant = findVariantById(steps, selectedVariantId);
  if (!variant) {
    console.warn(`Variant with ID ${selectedVariantId} not found in box-builder data`);
    return;
  }
  if (!variant.available) {
    console.warn(`Variant with ID ${selectedVariantId} is not available (sold out)`);
    return;
  }
  vuexStore.commit("ADD_TO_BOX", variant);
  vuexStore.commit("calculateDiscount");
  console.log(`Pre-initialized box with variant ID: ${selectedVariantId}`);
}
const boxBuilderMain = (selectors2) => {
  var _a, _b, _c;
  const jsonData = (_a = document.querySelector(selectors2.json)) == null ? void 0 : _a.textContent;
  let data;
  try {
    data = jsonData ? JSON.parse(jsonData) : null;
  } catch (error) {
    console.error(error);
    return;
  }
  if (!data) return;
  console.log("[Box Builder] Initial data received:", {
    stepsCount: (_b = data.steps) == null ? void 0 : _b.length,
    steps: (_c = data.steps) == null ? void 0 : _c.map((step) => {
      var _a2, _b2;
      return {
        title: step.title,
        categoryDiscount: step.categoryDiscount,
        tabsCount: (_a2 = step.tabs) == null ? void 0 : _a2.length,
        tabs: (_b2 = step.tabs) == null ? void 0 : _b2.map((tab, idx) => {
          var _a3, _b3, _c2, _d, _e, _f;
          return {
            index: idx,
            title: tab.title,
            collectionTitle: (_a3 = tab.collection) == null ? void 0 : _a3.title,
            collectionId: (_b3 = tab.collection) == null ? void 0 : _b3.id,
            productsCount: (_c2 = tab.products) == null ? void 0 : _c2.length,
            sampleVariant: ((_f = (_e = (_d = tab.products) == null ? void 0 : _d[0]) == null ? void 0 : _e.variants) == null ? void 0 : _f[0]) ? {
              id: tab.products[0].variants[0].id,
              isCategoryDiscountable: tab.products[0].variants[0].isCategoryDiscountable
            } : null
          };
        })
      };
    })
  });
  for (let i = 0; i < data.steps.length; i++) {
    const step = data.steps[i];
    console.log("[Box Builder] Processing step:", {
      index: i,
      title: step.title,
      categoryDiscount: step.categoryDiscount
    });
    step.tabs.forEach((tab, j) => {
      let variants = [];
      if (step.showOnlyFirstVariant) {
        tab.products.forEach((product) => {
          if (product.tags.includes("hide_product")) return;
          let variant = product.variants[0];
          if (product.tags.includes(`_hidden-variant:${variant.id}`) || variant.isHidden == "true") return;
          variant = {
            ...variant,
            collectionName: tab.collection.title,
            stepName: step.title,
            tabName: tab.title,
            productTitle: product.title,
            product,
            featured_image: !variant.featured_image ? { src: product.featured_image } : variant.featured_image,
            // Preserve isCategoryDiscountable flag from Liquid
            isCategoryDiscountable: variant.isCategoryDiscountable
          };
          variants.push(variant);
        });
      } else {
        tab.products.forEach((product) => {
          if (product.tags.includes("hide_product")) return;
          const newVariantsList = [];
          product.variants.forEach((variant) => {
            if (product.tags.includes(`_hidden-variant:${variant.id}`) || variant.isHidden == "true") return;
            const newV = {
              ...variant,
              collectionName: tab.collection.title,
              stepName: step.title,
              tabName: tab.title,
              productTitle: product.title,
              product,
              specificDiscountable: step.firstAddedProductDiscount ? true : false,
              featured_image: !variant.featured_image ? { src: product.featured_image } : variant.featured_image,
              // Preserve isCategoryDiscountable flag from Liquid
              isCategoryDiscountable: variant.isCategoryDiscountable
            };
            newVariantsList.push(newV);
          });
          product.variants = newVariantsList;
          variants.push(...product.variants);
        });
      }
      sortObjectsByAvailability(variants);
      step.tabs[j].variants = variants;
    });
  }
  console.log("✌️data --->", data);
  const vuexStore = store$1(data);
  preInitializeBoxWithVariant(vuexStore, data.steps);
  console.log("✌️data.steps --->", data.steps.map((step) => ({
    title: step.title,
    categoryDiscount: step.categoryDiscount,
    categoryDiscountTarget: step.categoryDiscountTarget
  })));
  const app = createApp(App$1);
  app.use(vuexStore);
  app.config.devtools = true;
  app.mount(selectors2.app);
};
function formatMoney(cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format;
  function defaultOption(opt, def2) {
    return typeof opt == "undefined" ? def2 : opt;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = number.toFixed(precision);
    var parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_with_dot_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}
function normalizeVariantId(id) {
  return id == null ? "" : String(id).trim();
}
function resolveGiftVariantIdForPricing(state, getters, giftsConfig) {
  if (!Array.isArray(giftsConfig) || giftsConfig.length === 0 || getters.areGiftsLocked) {
    return null;
  }
  const selected = state.selectedGiftVariantId;
  if (selected != null && selected !== "") {
    return selected;
  }
  const first = giftsConfig.find((g) => g.available === true);
  return first ? first.id : null;
}
function variantCompareAtOrPriceCents(variant) {
  if (!variant || typeof variant.price !== "number") return 0;
  const cap = variant.compare_at_price;
  if (typeof cap === "number" && cap > 0) return cap;
  return variant.price;
}
function getDefaultSelectedGiftVariantId(config) {
  const gifts = config.gifts;
  if (!Array.isArray(gifts) || gifts.length === 0) return null;
  const firstAvailable = gifts.find((g) => g.available === true);
  return firstAvailable ? firstAvailable.id : null;
}
function getInitialGiftSelection(params) {
  const threshold = params.config.giftsUnlockThreshold || 0;
  if (threshold > 0) {
    const preselectedBoxes = (params.config.preselectedVariantsIds || []).filter((id) => {
      var _a, _b;
      const v = (_b = (_a = params.config.variantAndProductIndex) == null ? void 0 : _a.variantsById) == null ? void 0 : _b[id];
      return v == null ? void 0 : v.isSampleBox;
    });
    if (preselectedBoxes.length < threshold) return null;
  }
  return getDefaultSelectedGiftVariantId(params.config);
}
const store = (params) => {
  return createStore({
    state() {
      var _a, _b;
      return {
        initialData: params,
        /**
         * @example
         * {
         *  [variantId]: selectedQuantity
         * }
         */
        selectedBoxesVariantsIds: ((_a = params.config.preselectedVariantsIds) == null ? void 0 : _a.reduce((acc, variantId) => {
          const variant = params.config.variantAndProductIndex.variantsById[variantId];
          if (variant == null ? void 0 : variant.isSampleBox) {
            acc[variantId] = 1;
          }
          return acc;
        }, {})) || {},
        /**
         * @example
         * {
         *  [variantId]: selectedQuantity
         * }
         */
        selectedShakersVariantsIds: ((_b = params.config.preselectedVariantsIds) == null ? void 0 : _b.reduce((acc, variantId) => {
          const variant = params.config.variantAndProductIndex.variantsById[variantId];
          if (variant == null ? void 0 : variant.isShaker) {
            acc[variantId] = 1;
          }
          return acc;
        }, {})) || {},
        selectedGiftVariantId: getInitialGiftSelection(params),
        currentProductImageSlide: 0
      };
    },
    mutations: {
      SET_SAMPLE_BOX_QUANTITY(state, { variantId, quantity }) {
        const copiedSelectedBoxesVariantsIds = {
          ...state.selectedBoxesVariantsIds
        };
        copiedSelectedBoxesVariantsIds[variantId] = quantity;
        state.selectedBoxesVariantsIds = copiedSelectedBoxesVariantsIds;
      },
      SET_SHAKER_QUANTITY(state, { variantId, quantity }) {
        state.selectedShakersVariantsIds = {};
        state.selectedShakersVariantsIds[variantId] = quantity;
      },
      SET_SELECTED_GIFT_VARIANT_ID(state, variantId) {
        state.selectedGiftVariantId = variantId;
      },
      SET_CURRENT_PRODUCT_IMAGE_SLIDE(state, slideIndex) {
        state.currentProductImageSlide = slideIndex;
      }
    },
    actions: {},
    getters: {
      getInitialData(state) {
        return state.initialData;
      },
      /**
       * Finds the product which holds current selected variants in its metafields.
       *
       * The main required condition is that a product should have Sample Boxes. There can't be that the product has only shakers.
       * So we are looking for exact mach by the selected boxes variants IDs and their quantity which is always 1 for each sample box.
       *
       * We check shakers only if the product has specific shakers in its metafields. If it doesn't, we don't care about NOT specific shakers.
       *
       * If no match - we return the default wrapper product, which is always present in the config.
       *
       */
      getSelectionRelatedProduct(state) {
        const { product, bulletPointsHtml } = state.initialData.config.wrapperProduct;
        const defaultWrapperProduct = product;
        if (bulletPointsHtml) {
          defaultWrapperProduct.bulletPointsHtml = bulletPointsHtml;
        }
        let result = defaultWrapperProduct;
        if (state.initialData.disableDynamicChanges) return result;
        const preselectProducts = state.initialData.config.preselectProducts;
        for (const { product: product2, metafields } of preselectProducts) {
          product2.metafields = metafields || {};
          const productChildren = product2.metafields.children;
          if (!productChildren) continue;
          const boxesVariantsIds = productChildren.boxesVariantsIds;
          if (!(boxesVariantsIds == null ? void 0 : boxesVariantsIds.length)) continue;
          const expectedBoxIds = (Array.isArray(boxesVariantsIds) ? boxesVariantsIds : []).map(normalizeVariantId).filter(Boolean).sort();
          const selectedBoxIds = Object.entries(state.selectedBoxesVariantsIds).filter(([_, qty]) => qty === 1).map(([id]) => normalizeVariantId(id)).filter(Boolean).sort();
          const isThereBoxesMatch = expectedBoxIds.length > 0 && selectedBoxIds.length === expectedBoxIds.length && selectedBoxIds.every((id, i) => id === expectedBoxIds[i]) && Object.entries(state.selectedBoxesVariantsIds).filter(([_, qty]) => qty > 1).length === 0;
          if (!isThereBoxesMatch) continue;
          const rawSpecific = product2.metafields.specificShakers;
          const specificShakers = Array.isArray(rawSpecific) ? rawSpecific.map(normalizeVariantId).filter(Boolean) : [];
          const isThereSpecificShakersMatch = !specificShakers.length ? true : specificShakers.filter((shakerID) => {
            const sel = state.selectedShakersVariantsIds;
            return sel[shakerID] === 1 || sel[normalizeVariantId(shakerID)] === 1;
          }).length === specificShakers.length;
          if (isThereBoxesMatch && isThereSpecificShakersMatch) {
            result = product2;
            break;
          }
        }
        return result;
      },
      getSelectedBoxesVariantsIds(state) {
        return state.selectedBoxesVariantsIds;
      },
      getSelectedShakersVariantsIds(state) {
        return state.selectedShakersVariantsIds;
      },
      getSelectedGiftVariantId(state) {
        return state.selectedGiftVariantId;
      },
      areGiftsLocked(state, getters) {
        const threshold = state.initialData.config.giftsUnlockThreshold;
        if (!threshold) return false;
        return getters.getSelectedBoxesCount < threshold;
      },
      getSelectedBoxesCount(state) {
        let count = 0;
        for (const quantity of Object.values(state.selectedBoxesVariantsIds)) {
          count += quantity;
        }
        return count;
      },
      getProductById: (state) => (productId) => {
        return state.initialData.config.variantAndProductIndex.productsById[productId] || null;
      },
      getVariantById: (state) => (variantId) => {
        return state.initialData.config.variantAndProductIndex.variantsById[variantId] || null;
      },
      getDiscountForShakerProductById: (state, getters) => (params2) => {
        var _a, _b;
        const sampleBoxesQuantity = getters.getSelectedBoxesCount;
        const shakerProductId = params2.productId;
        const shakerVariantId = params2.variantId;
        let discountAmount = 0;
        const lvl2ShakerDiscounts = state.initialData.config.shakerDiscountsLvl2 || [];
        const relatedLvl2Discount = lvl2ShakerDiscounts.find((discount) => {
          const sampleBoxesThreshold = +discount.sample_boxes_quantity_threshold;
          const shakerMatch = discount.shakers_variants.some(
            (shVariantId) => shVariantId.includes(shakerVariantId)
          );
          return shakerMatch && sampleBoxesQuantity >= sampleBoxesThreshold;
        });
        if (relatedLvl2Discount) {
          discountAmount += +relatedLvl2Discount.discount_amount;
        }
        const shakersCollectionsFiltered = state.initialData.config.shakersCollections.filter(
          (collection) => collection.products.some((product) => product.id === shakerProductId)
        );
        const shakerCollection = shakersCollectionsFiltered.reduce((highest, current) => {
          var _a2, _b2, _c, _d;
          const currentDiscount = ((_b2 = (_a2 = state.initialData.config.shakersDiscounts) == null ? void 0 : _a2.find((discount) => discount.collectionId == current.id)) == null ? void 0 : _b2.discountAmount) || 0;
          const highestDiscount = ((_d = (_c = state.initialData.config.shakersDiscounts) == null ? void 0 : _c.find((discount) => discount.collectionId == highest.id)) == null ? void 0 : _d.discountAmount) || 0;
          return currentDiscount > highestDiscount ? current : highest;
        }, shakersCollectionsFiltered == null ? void 0 : shakersCollectionsFiltered[0]);
        if (!(shakerCollection == null ? void 0 : shakerCollection.id))
          return {
            discountAmount
          };
        discountAmount += ((_b = (_a = state.initialData.config.shakersDiscounts) == null ? void 0 : _a.find(
          (discount) => discount.collectionId == shakerCollection.id
        )) == null ? void 0 : _b.discountAmount) || 0;
        return {
          discountAmount
        };
      },
      getLvl2DiscountBadgeByShakerVariantId: (state, getters) => (shakerVariantId) => {
        const sampleBoxesQuantity = getters.getSelectedBoxesCount;
        const lvl2ShakerDiscounts = state.initialData.config.shakerDiscountsLvl2 || [];
        const relatedLvl2Discount = lvl2ShakerDiscounts.find((discount) => {
          const sampleBoxesThreshold = +discount.sample_boxes_quantity_threshold;
          const shakerMatch = discount.shakers_variants.some(
            (shVariantId) => shVariantId.includes(shakerVariantId)
          );
          return shakerMatch && sampleBoxesQuantity >= sampleBoxesThreshold;
        });
        if (relatedLvl2Discount) {
          return relatedLvl2Discount.promo_tag || null;
        }
        return null;
      },
      getPrices: (state, getters) => {
        var _a, _b, _c, _d;
        getters.getSelectionRelatedProduct;
        let shakersDiscount = 0;
        let boxesDiscount = 0;
        let boxesPriceTotal = 0;
        let sampleBoxesPortionsQuantity = 0;
        let shakersPriceTotal = 0;
        let temporaryBoxesCount = 0;
        const sampleBoxesThresholds = state.initialData.config.sampleBoxesThresholds || [];
        Object.keys(state.selectedBoxesVariantsIds).forEach((variantId) => {
          const qty = state.selectedBoxesVariantsIds[variantId];
          if (!qty) return;
          const variant = getters.getVariantById(variantId);
          const product = getters.getProductById(variant == null ? void 0 : variant.productId);
          temporaryBoxesCount += qty;
          sampleBoxesPortionsQuantity += (product == null ? void 0 : product.portions) * qty || 0;
          boxesPriceTotal += (variant == null ? void 0 : variant.price) / 100 * qty || 0;
        });
        if (temporaryBoxesCount > 0) {
          sampleBoxesThresholds.forEach((threshold) => {
            if (temporaryBoxesCount >= threshold.quantity) {
              boxesDiscount += threshold.discountAmount;
            }
          });
          const maxThreshold = sampleBoxesThresholds[sampleBoxesThresholds.length - 1];
          if (temporaryBoxesCount > maxThreshold.quantity) {
            const extraBoxes = temporaryBoxesCount - maxThreshold.quantity;
            boxesDiscount += extraBoxes * maxThreshold.discountAmount;
          }
        }
        Object.keys(state.selectedShakersVariantsIds).forEach((variantId) => {
          var _a2;
          const qty = state.selectedShakersVariantsIds[variantId];
          if (qty <= 0) return;
          const variant = getters.getVariantById(variantId);
          getters.getProductById(variant == null ? void 0 : variant.productId);
          shakersPriceTotal += (variant == null ? void 0 : variant.price) / 100 * qty || 0;
          let shakersDiscountIntermediate = ((_a2 = getters.getDiscountForShakerProductById({
            productId: variant == null ? void 0 : variant.productId,
            variantId: variant.id
          })) == null ? void 0 : _a2.discountAmount) || 0;
          const variantPriceInEuro = (variant == null ? void 0 : variant.price) / 100 || 0;
          shakersDiscountIntermediate = shakersDiscountIntermediate > variantPriceInEuro ? variantPriceInEuro : shakersDiscountIntermediate;
          shakersDiscount += shakersDiscountIntermediate || 0;
        });
        const additionalDiscountSbThresholdQty = (_b = (_a = state.initialData.config) == null ? void 0 : _a.additionalBundleDiscount) == null ? void 0 : _b.sampleBoxesThresholdQty;
        const bundleDiscountAmount = getters.getSelectedBoxesCount >= additionalDiscountSbThresholdQty ? ((_d = (_c = state.initialData.config) == null ? void 0 : _c.additionalBundleDiscount) == null ? void 0 : _d.amount) || 0 : 0;
        const totalDiscountAmount = boxesPriceTotal > 0 ? boxesDiscount + shakersDiscount + bundleDiscountAmount : shakersDiscount;
        const priceTotal = shakersPriceTotal + boxesPriceTotal;
        const priceTotalDiscounted = priceTotal - totalDiscountAmount;
        let compareAtSum = 0;
        Object.keys(state.selectedBoxesVariantsIds).forEach((variantId) => {
          const qty = state.selectedBoxesVariantsIds[variantId];
          if (!qty) return;
          const v = getters.getVariantById(variantId);
          compareAtSum += variantCompareAtOrPriceCents(v) / 100 * qty;
        });
        Object.keys(state.selectedShakersVariantsIds).forEach((variantId) => {
          const qty = state.selectedShakersVariantsIds[variantId];
          if (qty <= 0) return;
          const v = getters.getVariantById(variantId);
          compareAtSum += variantCompareAtOrPriceCents(v) / 100 * qty;
        });
        const giftsConfig = state.initialData.config.gifts || [];
        const giftVariantIdForPricing = resolveGiftVariantIdForPricing(state, getters, giftsConfig);
        let giftPortions = 0;
        if (giftVariantIdForPricing) {
          const giftVariant = getters.getVariantById(giftVariantIdForPricing);
          const giftFromConfig = giftsConfig.find(
            (g) => normalizeVariantId(g.id) === normalizeVariantId(giftVariantIdForPricing)
          );
          if (giftVariant) {
            compareAtSum += variantCompareAtOrPriceCents(giftVariant) / 100;
          }
          const giftProduct = giftVariant ? getters.getProductById(giftVariant.productId) : null;
          giftPortions = +((giftVariant == null ? void 0 : giftVariant.portions) ?? (giftProduct == null ? void 0 : giftProduct.portions) ?? (giftFromConfig == null ? void 0 : giftFromConfig.portions) ?? 0);
        }
        const compareAtSubtotal = compareAtSum;
        const savingsVersusCompareAt = Math.max(0, compareAtSubtotal - priceTotalDiscounted);
        const boxesPriceTotalDiscounted = boxesPriceTotal - boxesDiscount;
        const giftsConfigForPortions = state.initialData.config.gifts || [];
        if (giftsConfigForPortions.length > 0 && state.selectedGiftVariantId) {
          const giftVariant = getters.getVariantById(state.selectedGiftVariantId);
          const giftProduct = getters.getProductById(giftVariant == null ? void 0 : giftVariant.productId);
          +((giftVariant == null ? void 0 : giftVariant.portions) ?? (giftProduct == null ? void 0 : giftProduct.portions) ?? 0);
          ((giftVariant == null ? void 0 : giftVariant.price) || 0) / 100;
        }
        const portionsTotal = sampleBoxesPortionsQuantity + giftPortions;
        const ppSum = boxesPriceTotal;
        const ppSumAfterDisc = boxesPriceTotalDiscounted;
        const pricePerPortion = portionsTotal > 0 ? ppSum / portionsTotal : 0;
        const pricePerPortionDiscounted = portionsTotal > 0 ? ppSumAfterDisc / portionsTotal : 0;
        return {
          formatted: {
            total: formatMoney(compareAtSubtotal, state.initialData.moneyFormat),
            discountTotal: formatMoney(priceTotalDiscounted, state.initialData.moneyFormat),
            discountAmount: formatMoney(savingsVersusCompareAt, state.initialData.moneyFormat),
            perPortion: formatMoney(pricePerPortion, state.initialData.moneyFormat),
            perPortionDiscounted: formatMoney(pricePerPortionDiscounted, state.initialData.moneyFormat)
          },
          unformatted: {
            total: compareAtSubtotal,
            discountTotal: priceTotalDiscounted,
            discountAmount: savingsVersusCompareAt,
            bundleDiscountAmount: totalDiscountAmount,
            perPortion: pricePerPortion,
            perPortionDiscounted: pricePerPortionDiscounted
          }
        };
      },
      getAddToCartPayload: (state, getters) => {
        const mainProduct = getters.getSelectionRelatedProduct;
        const nestedProductVariantsIds = [];
        const nestedItemsTotalPrice = getters.getPrices.unformatted.total;
        Object.keys(state.selectedBoxesVariantsIds).forEach((variantId) => {
          if (state.selectedBoxesVariantsIds[variantId] > 0) {
            nestedProductVariantsIds.push({
              id: variantId,
              quantity: state.selectedBoxesVariantsIds[variantId]
            });
          }
        });
        Object.keys(state.selectedShakersVariantsIds).forEach((variantId) => {
          if (state.selectedShakersVariantsIds[variantId] > 0) {
            nestedProductVariantsIds.push({
              id: variantId,
              quantity: state.selectedShakersVariantsIds[variantId]
            });
          }
        });
        if (state.selectedGiftVariantId) {
          nestedProductVariantsIds.push({
            id: state.selectedGiftVariantId,
            quantity: 1
          });
        }
        return [
          {
            id: mainProduct.variants[0].id,
            quantity: 1,
            properties: {
              _nestedVariantsIds: JSON.stringify(nestedProductVariantsIds),
              _root_id: state.initialData.config.rootId,
              _nested_items_total_price: nestedItemsTotalPrice * 100,
              // in cents
              _bundle_type: "starter_powder"
            }
          }
        ];
      },
      getNestedProductsImagesSrc: (state, getters) => {
        const nestedProductsImages = [];
        Object.keys(state.selectedShakersVariantsIds).forEach((variantId) => {
          var _a;
          if (state.selectedShakersVariantsIds[variantId] > 0) {
            const variant = getters.getVariantById(variantId);
            const productVariant = variant;
            const product = getters.getProductById(productVariant == null ? void 0 : productVariant.productId);
            if ((_a = product.additionalShakerImages) == null ? void 0 : _a.length) return;
            const images = [product == null ? void 0 : product.images[0]];
            images == null ? void 0 : images.forEach((image) => nestedProductsImages.push(image));
          }
        });
        Object.keys(state.selectedBoxesVariantsIds).forEach((variantId) => {
          var _a, _b, _c;
          if (state.selectedBoxesVariantsIds[variantId] > 0) {
            const variant = getters.getVariantById(variantId);
            const productVariant = variant;
            const product = getters.getProductById(productVariant == null ? void 0 : productVariant.productId);
            const image = ((_a = productVariant == null ? void 0 : productVariant.featured_image) == null ? void 0 : _a.src) ? (_b = productVariant.featured_image) == null ? void 0 : _b.src : (_c = product == null ? void 0 : product.images) == null ? void 0 : _c[0];
            if (image) {
              nestedProductsImages.push(image);
            }
          }
        });
        return nestedProductsImages;
      },
      getAdditionalShakerImagesSrc: (state, getters) => {
        const result = [];
        Object.keys(state.selectedShakersVariantsIds).forEach((variantId) => {
          var _a;
          if (state.selectedShakersVariantsIds[variantId] > 0) {
            const variant = getters.getVariantById(variantId);
            const productVariant = variant;
            const product = getters.getProductById(productVariant == null ? void 0 : productVariant.productId);
            if ((_a = product.additionalShakerImages) == null ? void 0 : _a.length) {
              result.push(...product.additionalShakerImages);
              result.push(product == null ? void 0 : product.images[0]);
            }
          }
        });
        return result;
      },
      getCurrentProductImageSlide(state) {
        return state.currentProductImageSlide;
      },
      getNextSbPrice(state) {
        var _a, _b, _c, _d;
        const sampleBoxesThresholds = state.initialData.config.sampleBoxesThresholds || [];
        const selectedBoxesCount = Object.values(state.selectedBoxesVariantsIds).reduce((acc, qty) => acc + qty, 0) + 1;
        const lastThreshold = sampleBoxesThresholds[sampleBoxesThresholds.length - 1];
        const isMaximumThresholdReached = sampleBoxesThresholds.length && selectedBoxesCount >= (lastThreshold == null ? void 0 : lastThreshold.quantity);
        const threshold = isMaximumThresholdReached ? lastThreshold : sampleBoxesThresholds.find((threshold2) => threshold2.quantity === selectedBoxesCount);
        const baseVariantPriceCents = (_d = (_c = (_b = (_a = state.initialData.config.sampleBoxesProducts) == null ? void 0 : _a[0]) == null ? void 0 : _b.variants) == null ? void 0 : _c[0]) == null ? void 0 : _d.price;
        const sbPrice = baseVariantPriceCents / 100 - ((threshold == null ? void 0 : threshold.discountAmount) || 0);
        if (isNaN(sbPrice) || sbPrice <= 0) return;
        return {
          formatted: formatMoney(sbPrice, state.initialData.moneyFormat),
          unformatted: sbPrice
        };
      }
    }
  });
};
/**
 * Vue 3 Carousel 0.16.0
 * (c) 2025
 * @license MIT
 */
const BREAKPOINT_MODE_OPTIONS = ["viewport", "carousel"];
const DIR_MAP = {
  "bottom-to-top": "btt",
  "left-to-right": "ltr",
  "right-to-left": "rtl",
  "top-to-bottom": "ttb"
};
const DIR_OPTIONS = [
  "ltr",
  "left-to-right",
  "rtl",
  "right-to-left",
  "ttb",
  "top-to-bottom",
  "btt",
  "bottom-to-top"
];
const I18N_DEFAULT_CONFIG = {
  ariaGallery: "Gallery",
  ariaNavigateToPage: "Navigate to page {slideNumber}",
  ariaNavigateToSlide: "Navigate to slide {slideNumber}",
  ariaNextSlide: "Navigate to next slide",
  ariaPreviousSlide: "Navigate to previous slide",
  iconArrowDown: "Arrow pointing downwards",
  iconArrowLeft: "Arrow pointing to the left",
  iconArrowRight: "Arrow pointing to the right",
  iconArrowUp: "Arrow pointing upwards",
  itemXofY: "Item {currentSlide} of {slidesCount}"
};
const SLIDE_EFFECTS = ["slide", "fade"];
const SNAP_ALIGN_OPTIONS = [
  "center",
  "start",
  "end",
  "center-even",
  "center-odd"
];
const DEFAULT_MOUSE_WHEEL_THRESHOLD = 10;
const DEFAULT_DRAG_THRESHOLD = 0.08;
const DEFAULT_CONFIG = {
  autoplay: 0,
  breakpointMode: BREAKPOINT_MODE_OPTIONS[0],
  breakpoints: void 0,
  dir: DIR_OPTIONS[0],
  enabled: true,
  gap: 0,
  height: "auto",
  i18n: I18N_DEFAULT_CONFIG,
  ignoreAnimations: false,
  itemsToScroll: 1,
  itemsToShow: 1,
  modelValue: 0,
  mouseDrag: true,
  mouseWheel: false,
  pauseAutoplayOnHover: false,
  preventExcessiveDragging: false,
  slideEffect: SLIDE_EFFECTS[0],
  snapAlign: SNAP_ALIGN_OPTIONS[0],
  touchDrag: true,
  transition: 300,
  wrapAround: false
};
const injectCarousel = Symbol("carousel");
const createSlideRegistry = (emit2) => {
  const slides = shallowReactive([]);
  const updateSlideIndexes = (startIndex) => {
    if (startIndex !== void 0) {
      slides.slice(startIndex).forEach((slide2, offset) => {
        var _a;
        (_a = slide2.exposed) === null || _a === void 0 ? void 0 : _a.setIndex(startIndex + offset);
      });
    } else {
      slides.forEach((slide2, index) => {
        var _a;
        (_a = slide2.exposed) === null || _a === void 0 ? void 0 : _a.setIndex(index);
      });
    }
  };
  return {
    cleanup: () => {
      slides.splice(0, slides.length);
    },
    getSlides: () => slides,
    registerSlide: (slide2, index) => {
      if (!slide2)
        return;
      if (slide2.props.isClone) {
        return;
      }
      const slideIndex = index !== null && index !== void 0 ? index : slides.length;
      slides.splice(slideIndex, 0, slide2);
      updateSlideIndexes(slideIndex);
      emit2("slide-registered", { slide: slide2, index: slideIndex });
    },
    unregisterSlide: (slide2) => {
      const slideIndex = slides.indexOf(slide2);
      if (slideIndex === -1)
        return;
      emit2("slide-unregistered", { slide: slide2, index: slideIndex });
      slides.splice(slideIndex, 1);
      updateSlideIndexes(slideIndex);
    }
  };
};
function calculateAverage(numbers) {
  if (numbers.length === 0)
    return 0;
  const sum = numbers.reduce((acc, num) => acc + num, 0);
  return sum / numbers.length;
}
function createCloneSlides({ slides, position, toShow }) {
  const clones = [];
  const isBefore = position === "before";
  const start = isBefore ? -toShow : 0;
  const end = isBefore ? 0 : toShow;
  if (slides.length <= 0) {
    return clones;
  }
  for (let i = start; i < end; i++) {
    const index = isBefore ? i : i + slides.length;
    const props = {
      index,
      isClone: true,
      id: void 0,
      // Make sure we don't duplicate the id which would be invalid html
      key: `clone-${position}-${i}`
    };
    const vnode = slides[(i % slides.length + slides.length) % slides.length].vnode;
    const clone = cloneVNode(vnode, props);
    clone.el = null;
    clones.push(clone);
  }
  return clones;
}
const FOCUSABLE_ELEMENTS_SELECTOR = 'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
function disableChildrenTabbing(node) {
  if (!node.el || !(node.el instanceof Element)) {
    return;
  }
  const elements = node.el.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR);
  for (const el of elements) {
    if (el instanceof HTMLElement && !el.hasAttribute("disabled") && el.getAttribute("aria-hidden") !== "true") {
      el.setAttribute("tabindex", "-1");
    }
  }
}
function except(obj, keys) {
  return Object.keys(obj).filter((k) => !keys.includes(k)).reduce((acc, key) => (acc[key] = obj[key], acc), {});
}
function getDraggedSlidesCount(params) {
  const { isVertical, isReversed, dragged, effectiveSlideSize, threshold } = params;
  const dragValue = isVertical ? dragged.y : dragged.x;
  if (dragValue === 0)
    return 0;
  const dragRatio = dragValue / effectiveSlideSize;
  const absRatio = Math.abs(dragRatio);
  if (absRatio < threshold)
    return 0;
  const slidesDragged = absRatio < 1 ? Math.sign(dragRatio) : Math.round(dragRatio);
  return isReversed ? slidesDragged : -slidesDragged;
}
function getNumberInRange({ val, max, min }) {
  if (max < min) {
    return val;
  }
  return Math.min(Math.max(val, isNaN(min) ? val : min), isNaN(max) ? val : max);
}
function getTransformValues(el) {
  const { transform } = window.getComputedStyle(el);
  return transform.split(/[(,)]/).slice(1, -1).map((v) => parseFloat(v));
}
function getScaleMultipliers(transformElements) {
  let widthMultiplier = 1;
  let heightMultiplier = 1;
  transformElements.forEach((el) => {
    const transformArr = getTransformValues(el);
    if (transformArr.length === 6) {
      widthMultiplier /= transformArr[0];
      heightMultiplier /= transformArr[3];
    }
  });
  return { widthMultiplier, heightMultiplier };
}
function getSnapAlignOffsetByItemsToShow(align, itemsToShow) {
  switch (align) {
    case "start":
      return 0;
    case "center":
    case "center-odd":
      return (itemsToShow - 1) / 2;
    case "center-even":
      return (itemsToShow - 2) / 2;
    case "end":
      return itemsToShow - 1;
    default:
      return 0;
  }
}
function getSnapAlignOffsetBySlideAndViewport(align, slideSize, viewportSize) {
  switch (align) {
    case "start":
      return 0;
    case "center":
    case "center-odd":
      return (viewportSize - slideSize) / 2;
    case "center-even":
      return viewportSize / 2 - slideSize;
    case "end":
      return viewportSize - slideSize;
    default:
      return 0;
  }
}
function getSnapAlignOffset({ slideSize, viewportSize, align, itemsToShow }) {
  if (itemsToShow !== void 0) {
    return getSnapAlignOffsetByItemsToShow(align, itemsToShow);
  }
  if (slideSize !== void 0 && viewportSize !== void 0) {
    return getSnapAlignOffsetBySlideAndViewport(align, slideSize, viewportSize);
  }
  return 0;
}
function i18nFormatter(string = "", values = {}) {
  return Object.entries(values).reduce((acc, [key, value]) => acc.replace(`{${key}}`, String(value)), string);
}
function mapNumberToRange({ val, max, min = 0 }) {
  const mod = max - min + 1;
  return ((val - min) % mod + mod) % mod + min;
}
function throttle(fn, ms = 0) {
  let isThrottled = false;
  let start = 0;
  let frameId = null;
  function throttled(...args) {
    if (isThrottled)
      return;
    isThrottled = true;
    const step = () => {
      frameId = requestAnimationFrame((time) => {
        const elapsed = time - start;
        if (elapsed > ms) {
          start = time;
          fn(...args);
          isThrottled = false;
        } else {
          step();
        }
      });
    };
    step();
  }
  throttled.cancel = () => {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
      isThrottled = false;
    }
  };
  return throttled;
}
function toCssValue(value, unit = "px") {
  if (value === null || value === void 0 || value === "") {
    return void 0;
  }
  if (typeof value === "number" || parseFloat(value).toString() === value) {
    return `${value}${unit}`;
  }
  return value;
}
const ARIA = /* @__PURE__ */ defineComponent({
  name: "CarouselAria",
  setup() {
    const carousel = inject(injectCarousel);
    if (!carousel) {
      return () => "";
    }
    return () => h("div", {
      class: ["carousel__liveregion", "carousel__sr-only"],
      "aria-live": "polite",
      "aria-atomic": "true"
    }, i18nFormatter(carousel.config.i18n["itemXofY"], {
      currentSlide: carousel.currentSlide + 1,
      slidesCount: carousel.slidesCount
    }));
  }
});
function useDrag(options) {
  let isTouch = false;
  const startPosition = { x: 0, y: 0 };
  const dragged = reactive({ x: 0, y: 0 });
  const isDragging = ref(false);
  const { isSliding } = options;
  const sliding = computed(() => {
    return typeof isSliding === "boolean" ? isSliding : isSliding.value;
  });
  const handleDragStart = (event) => {
    var _a;
    const targetTagName = event.target.tagName;
    if (["INPUT", "TEXTAREA", "SELECT"].includes(targetTagName) || sliding.value) {
      return;
    }
    isTouch = event.type === "touchstart";
    if (isTouch && event.touches.length > 1) {
      return;
    } else if (!isTouch) {
      event.preventDefault();
      if (event.button !== 0) {
        return;
      }
    }
    startPosition.x = isTouch ? event.touches[0].clientX : event.clientX;
    startPosition.y = isTouch ? event.touches[0].clientY : event.clientY;
    const moveEvent = isTouch ? "touchmove" : "mousemove";
    const endEvent = isTouch ? "touchend" : "mouseup";
    document.addEventListener(moveEvent, handleDrag, { passive: false });
    document.addEventListener(endEvent, handleDragEnd, { passive: true });
    (_a = options.onDragStart) === null || _a === void 0 ? void 0 : _a.call(options);
  };
  const handleDrag = throttle((event) => {
    var _a;
    if (isTouch && event.touches.length > 1) {
      return;
    }
    isDragging.value = true;
    const currentX = isTouch ? event.touches[0].clientX : event.clientX;
    const currentY = isTouch ? event.touches[0].clientY : event.clientY;
    dragged.x = currentX - startPosition.x;
    dragged.y = currentY - startPosition.y;
    (_a = options.onDrag) === null || _a === void 0 ? void 0 : _a.call(options, { deltaX: dragged.x, deltaY: dragged.y, isTouch });
  });
  const handleDragEnd = () => {
    var _a;
    handleDrag.cancel();
    const draggedDistance = Math.abs(dragged.x) + Math.abs(dragged.y);
    if (!isTouch && draggedDistance > 10) {
      window.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
      }, { once: true, capture: true });
    }
    (_a = options.onDragEnd) === null || _a === void 0 ? void 0 : _a.call(options);
    dragged.x = 0;
    dragged.y = 0;
    isDragging.value = false;
    const moveEvent = isTouch ? "touchmove" : "mousemove";
    const endEvent = isTouch ? "touchend" : "mouseup";
    document.removeEventListener(moveEvent, handleDrag);
    document.removeEventListener(endEvent, handleDragEnd);
  };
  return {
    dragged,
    isDragging,
    handleDragStart
  };
}
function useHover() {
  const isHover = ref(false);
  const handleMouseEnter = () => {
    isHover.value = true;
  };
  const handleMouseLeave = () => {
    isHover.value = false;
  };
  return {
    isHover,
    handleMouseEnter,
    handleMouseLeave
  };
}
function useWheel(options) {
  const { isVertical, isSliding, config } = options;
  const vertical = computed(() => {
    return typeof isVertical === "boolean" ? isVertical : isVertical.value;
  });
  const sliding = computed(() => {
    return typeof isSliding === "boolean" ? isSliding : isSliding.value;
  });
  const handleScroll = (event) => {
    var _a, _b;
    event.preventDefault();
    if (!config.mouseWheel || sliding.value) {
      return;
    }
    const threshold = typeof config.mouseWheel === "object" ? (_a = config.mouseWheel.threshold) !== null && _a !== void 0 ? _a : DEFAULT_MOUSE_WHEEL_THRESHOLD : DEFAULT_MOUSE_WHEEL_THRESHOLD;
    const deltaY = Math.abs(event.deltaY) > threshold ? event.deltaY : 0;
    const deltaX = Math.abs(event.deltaX) > threshold ? event.deltaX : 0;
    if (deltaY === 0 && deltaX === 0) {
      return;
    }
    const primaryDelta = vertical.value ? deltaY : deltaX;
    const effectiveDelta = primaryDelta !== 0 ? primaryDelta : vertical.value ? deltaX : deltaY;
    const isScrollingForward = effectiveDelta > 0;
    (_b = options.onWheel) === null || _b === void 0 ? void 0 : _b.call(options, { deltaX, deltaY, isScrollingForward });
  };
  return {
    handleScroll
  };
}
const carouselProps = {
  // time to auto advance slides in ms
  autoplay: {
    default: DEFAULT_CONFIG.autoplay,
    type: Number
  },
  // an object to store breakpoints
  breakpoints: {
    default: DEFAULT_CONFIG.breakpoints,
    type: Object
  },
  // controls the breakpoint mode relative to the carousel container or the viewport
  breakpointMode: {
    default: DEFAULT_CONFIG.breakpointMode,
    validator(value) {
      return BREAKPOINT_MODE_OPTIONS.includes(value);
    }
  },
  clamp: {
    type: Boolean
  },
  // control the direction of the carousel
  dir: {
    type: String,
    default: DEFAULT_CONFIG.dir,
    validator(value, props) {
      if (!DIR_OPTIONS.includes(value)) {
        return false;
      }
      const normalizedDir = value in DIR_MAP ? DIR_MAP[value] : value;
      if (["ttb", "btt"].includes(normalizedDir) && (!props.height || props.height === "auto")) {
        console.warn(`[vue3-carousel]: The dir "${value}" is not supported with height "auto".`);
      }
      return true;
    }
  },
  // enable/disable the carousel component
  enabled: {
    default: DEFAULT_CONFIG.enabled,
    type: Boolean
  },
  // control the gap between slides
  gap: {
    default: DEFAULT_CONFIG.gap,
    type: Number
  },
  // set carousel height
  height: {
    default: DEFAULT_CONFIG.height,
    type: [Number, String]
  },
  // aria-labels and additional text labels
  i18n: {
    default: DEFAULT_CONFIG.i18n,
    type: Object
  },
  ignoreAnimations: {
    default: false,
    type: [Array, Boolean, String]
  },
  // count of items to be scrolled
  itemsToScroll: {
    default: DEFAULT_CONFIG.itemsToScroll,
    type: Number
  },
  // count of items to showed per view
  itemsToShow: {
    default: DEFAULT_CONFIG.itemsToShow,
    type: [Number, String]
  },
  // slide number number of initial slide
  modelValue: {
    default: void 0,
    type: Number
  },
  // toggle mouse dragging
  mouseDrag: {
    default: DEFAULT_CONFIG.mouseDrag,
    type: [Boolean, Object]
  },
  // toggle mouse wheel scrolling
  mouseWheel: {
    default: DEFAULT_CONFIG.mouseWheel,
    type: [Boolean, Object]
  },
  // control mouse scroll threshold
  mouseScrollThreshold: {
    default: DEFAULT_CONFIG.mouseScrollThreshold,
    type: Number
  },
  pauseAutoplayOnHover: {
    default: DEFAULT_CONFIG.pauseAutoplayOnHover,
    type: Boolean
  },
  preventExcessiveDragging: {
    default: false,
    type: Boolean,
    validator(value, props) {
      if (value && props.wrapAround) {
        console.warn(`[vue3-carousel]: "preventExcessiveDragging" cannot be used with wrapAround. The setting will be ignored.`);
      }
      return true;
    }
  },
  slideEffect: {
    type: String,
    default: DEFAULT_CONFIG.slideEffect,
    validator(value) {
      return SLIDE_EFFECTS.includes(value);
    }
  },
  // control snap position alignment
  snapAlign: {
    default: DEFAULT_CONFIG.snapAlign,
    validator(value) {
      return SNAP_ALIGN_OPTIONS.includes(value);
    }
  },
  // toggle touch dragging
  touchDrag: {
    default: DEFAULT_CONFIG.touchDrag,
    type: [Boolean, Object]
  },
  // sliding transition time in ms
  transition: {
    default: DEFAULT_CONFIG.transition,
    type: Number
  },
  // control infinite scrolling mode
  wrapAround: {
    default: DEFAULT_CONFIG.wrapAround,
    type: Boolean
  }
};
const Carousel = /* @__PURE__ */ defineComponent({
  name: "VueCarousel",
  props: carouselProps,
  emits: [
    "before-init",
    "drag",
    "init",
    "loop",
    "slide-end",
    "slide-registered",
    "slide-start",
    "slide-unregistered",
    "update:modelValue",
    "wheel"
  ],
  setup(props, { slots, emit: emit2, expose }) {
    var _a;
    const slideRegistry = createSlideRegistry(emit2);
    const slides = slideRegistry.getSlides();
    const slidesCount = computed(() => slides.length);
    const root = ref(null);
    const viewport = ref(null);
    const slideSize = ref(0);
    const fallbackConfig = computed(() => Object.assign(Object.assign(Object.assign({}, DEFAULT_CONFIG), except(props, ["breakpoints", "modelValue"])), { i18n: Object.assign(Object.assign({}, DEFAULT_CONFIG.i18n), props.i18n) }));
    const config = shallowReactive(Object.assign({}, fallbackConfig.value));
    const currentSlideIndex = ref((_a = props.modelValue) !== null && _a !== void 0 ? _a : 0);
    const activeSlideIndex = ref(currentSlideIndex.value);
    watch(currentSlideIndex, (val) => activeSlideIndex.value = val);
    const prevSlideIndex = ref(0);
    const middleSlideIndex = computed(() => Math.ceil((slidesCount.value - 1) / 2));
    const maxSlideIndex = computed(() => slidesCount.value - 1);
    const minSlideIndex = computed(() => 0);
    let autoplayTimer = null;
    let transitionTimer = null;
    let resizeObserver = null;
    const effectiveSlideSize = computed(() => slideSize.value + config.gap);
    const normalizedDir = computed(() => {
      const dir = config.dir || "ltr";
      return dir in DIR_MAP ? DIR_MAP[dir] : dir;
    });
    const isReversed = computed(() => ["rtl", "btt"].includes(normalizedDir.value));
    const isVertical = computed(() => ["ttb", "btt"].includes(normalizedDir.value));
    const isAuto = computed(() => config.itemsToShow === "auto");
    const dimension = computed(() => isVertical.value ? "height" : "width");
    function updateBreakpointsConfig() {
      var _a2;
      if (!mounted.value) {
        return;
      }
      const widthSource = (fallbackConfig.value.breakpointMode === "carousel" ? (_a2 = root.value) === null || _a2 === void 0 ? void 0 : _a2.getBoundingClientRect().width : typeof window !== "undefined" ? window.innerWidth : 0) || 0;
      const breakpointsArray = Object.keys(props.breakpoints || {}).map((key) => Number(key)).sort((a, b) => +b - +a);
      const newConfig = {};
      breakpointsArray.some((breakpoint) => {
        if (widthSource >= breakpoint) {
          Object.assign(newConfig, props.breakpoints[breakpoint]);
          if (newConfig.i18n) {
            Object.assign(newConfig.i18n, fallbackConfig.value.i18n, props.breakpoints[breakpoint].i18n);
          }
          return true;
        }
        return false;
      });
      Object.assign(config, fallbackConfig.value, newConfig);
      if (!isAuto.value) {
        config.itemsToShow = getNumberInRange({
          val: Number(config.itemsToShow),
          max: props.clamp ? slidesCount.value : Infinity,
          min: 1
        });
      }
    }
    const handleResize = throttle(() => {
      updateBreakpointsConfig();
      updateSlidesData();
      updateSlideSize();
    });
    const transformElements = shallowReactive(/* @__PURE__ */ new Set());
    const slidesRect = ref([]);
    function updateSlidesRectSize({ widthMultiplier, heightMultiplier }) {
      slidesRect.value = slides.map((slide2) => {
        var _a2;
        const rect = (_a2 = slide2.exposed) === null || _a2 === void 0 ? void 0 : _a2.getBoundingRect();
        return {
          width: rect.width * widthMultiplier,
          height: rect.height * heightMultiplier
        };
      });
    }
    const viewportRect = ref({
      width: 0,
      height: 0
    });
    function updateViewportRectSize({ widthMultiplier, heightMultiplier }) {
      var _a2;
      const rect = ((_a2 = viewport.value) === null || _a2 === void 0 ? void 0 : _a2.getBoundingClientRect()) || { width: 0, height: 0 };
      viewportRect.value = {
        width: rect.width * widthMultiplier,
        height: rect.height * heightMultiplier
      };
    }
    function updateSlideSize() {
      if (!viewport.value)
        return;
      const scaleMultipliers = getScaleMultipliers(transformElements);
      updateViewportRectSize(scaleMultipliers);
      updateSlidesRectSize(scaleMultipliers);
      if (isAuto.value) {
        slideSize.value = calculateAverage(slidesRect.value.map((slide2) => slide2[dimension.value]));
      } else {
        const itemsToShow = Number(config.itemsToShow);
        const totalGap = (itemsToShow - 1) * config.gap;
        slideSize.value = (viewportRect.value[dimension.value] - totalGap) / itemsToShow;
      }
    }
    function updateSlidesData() {
      if (!config.wrapAround && slidesCount.value > 0) {
        currentSlideIndex.value = getNumberInRange({
          val: currentSlideIndex.value,
          max: maxSlideIndex.value,
          min: minSlideIndex.value
        });
      }
    }
    const ignoreAnimations = computed(() => {
      if (typeof props.ignoreAnimations === "string") {
        return props.ignoreAnimations.split(",");
      } else if (Array.isArray(props.ignoreAnimations)) {
        return props.ignoreAnimations;
      } else if (!props.ignoreAnimations) {
        return [];
      }
      return false;
    });
    watchEffect(() => updateSlidesData());
    watchEffect(() => {
      updateSlideSize();
    });
    let animationInterval;
    const setAnimationInterval = (event) => {
      const target = event.target;
      if (!(target === null || target === void 0 ? void 0 : target.contains(root.value)) || Array.isArray(ignoreAnimations.value) && ignoreAnimations.value.includes(event.animationName)) {
        return;
      }
      transformElements.add(target);
      if (!animationInterval) {
        const stepAnimation = () => {
          animationInterval = requestAnimationFrame(() => {
            updateSlideSize();
            stepAnimation();
          });
        };
        stepAnimation();
      }
    };
    const finishAnimation = (event) => {
      const target = event.target;
      if (target) {
        transformElements.delete(target);
      }
      if (animationInterval && transformElements.size === 0) {
        cancelAnimationFrame(animationInterval);
        updateSlideSize();
      }
    };
    const mounted = ref(false);
    if (typeof document !== "undefined") {
      watchEffect(() => {
        if (mounted.value && ignoreAnimations.value !== false) {
          document.addEventListener("animationstart", setAnimationInterval);
          document.addEventListener("animationend", finishAnimation);
        } else {
          document.removeEventListener("animationstart", setAnimationInterval);
          document.removeEventListener("animationend", finishAnimation);
        }
      });
    }
    onMounted(() => {
      mounted.value = true;
      updateBreakpointsConfig();
      initAutoplay();
      if (root.value) {
        resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(root.value);
      }
      emit2("init");
    });
    onBeforeUnmount(() => {
      mounted.value = false;
      slideRegistry.cleanup();
      if (transitionTimer) {
        clearTimeout(transitionTimer);
      }
      if (animationInterval) {
        cancelAnimationFrame(animationInterval);
      }
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
      }
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
      if (typeof document !== "undefined") {
        handleBlur();
      }
      if (root.value) {
        root.value.removeEventListener("transitionend", updateSlideSize);
        root.value.removeEventListener("animationiteration", updateSlideSize);
      }
    });
    const { isHover, handleMouseEnter, handleMouseLeave } = useHover();
    const handleArrowKeys = throttle((event) => {
      if (event.ctrlKey)
        return;
      switch (event.key) {
        case "ArrowLeft":
        case "ArrowUp":
          if (isVertical.value === event.key.endsWith("Up")) {
            if (isReversed.value) {
              next(true);
            } else {
              prev(true);
            }
          }
          break;
        case "ArrowRight":
        case "ArrowDown":
          if (isVertical.value === event.key.endsWith("Down")) {
            if (isReversed.value) {
              prev(true);
            } else {
              next(true);
            }
          }
          break;
      }
    }, 200);
    const handleBlur = () => {
      document.removeEventListener("keydown", handleArrowKeys);
    };
    const handleFocus = () => {
      document.addEventListener("keydown", handleArrowKeys);
    };
    function initAutoplay() {
      if (!config.autoplay || config.autoplay <= 0) {
        return;
      }
      autoplayTimer = setInterval(() => {
        if (config.pauseAutoplayOnHover && isHover.value) {
          return;
        }
        next();
      }, config.autoplay);
    }
    function resetAutoplay() {
      stopAutoplay();
      initAutoplay();
    }
    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }
    const isSliding = ref(false);
    const onDrag = ({ deltaX, deltaY, isTouch }) => {
      var _a2, _b, _c, _d;
      emit2("drag", { deltaX, deltaY });
      const threshold = isTouch ? typeof config.touchDrag === "object" ? (_b = (_a2 = config.touchDrag) === null || _a2 === void 0 ? void 0 : _a2.threshold) !== null && _b !== void 0 ? _b : DEFAULT_DRAG_THRESHOLD : DEFAULT_DRAG_THRESHOLD : typeof config.mouseDrag === "object" ? (_d = (_c = config.mouseDrag) === null || _c === void 0 ? void 0 : _c.threshold) !== null && _d !== void 0 ? _d : DEFAULT_DRAG_THRESHOLD : DEFAULT_DRAG_THRESHOLD;
      const draggedSlides = getDraggedSlidesCount({
        isVertical: isVertical.value,
        isReversed: isReversed.value,
        dragged: { x: deltaX, y: deltaY },
        effectiveSlideSize: effectiveSlideSize.value,
        threshold
      });
      if (draggedSlides === 0) {
        return;
      }
      activeSlideIndex.value = config.wrapAround ? currentSlideIndex.value + draggedSlides : getNumberInRange({
        val: currentSlideIndex.value + draggedSlides,
        max: maxSlideIndex.value,
        min: minSlideIndex.value
      });
    };
    const onDragEnd = () => slideTo(activeSlideIndex.value);
    const { dragged, isDragging, handleDragStart } = useDrag({
      isSliding,
      onDrag,
      onDragEnd
    });
    const onWheel = ({ deltaX, deltaY, isScrollingForward }) => {
      emit2("wheel", { deltaX, deltaY });
      if (isScrollingForward) {
        if (isReversed.value) {
          prev();
        } else {
          next();
        }
      } else {
        if (isReversed.value) {
          next();
        } else {
          prev();
        }
      }
    };
    const { handleScroll } = useWheel({
      isVertical,
      isSliding,
      config,
      onWheel
    });
    function next(skipTransition = false) {
      slideTo(currentSlideIndex.value + config.itemsToScroll, skipTransition);
    }
    function prev(skipTransition = false) {
      slideTo(currentSlideIndex.value - config.itemsToScroll, skipTransition);
    }
    function slideTo(slideIndex, skipTransition = false) {
      if (!skipTransition && isSliding.value) {
        return;
      }
      const targetIndex = (config.wrapAround ? mapNumberToRange : getNumberInRange)({
        val: slideIndex,
        max: maxSlideIndex.value,
        min: minSlideIndex.value
      });
      if (currentSlideIndex.value === targetIndex) {
        return;
      }
      prevSlideIndex.value = currentSlideIndex.value;
      emit2("slide-start", {
        slidingToIndex: slideIndex,
        currentSlideIndex: currentSlideIndex.value,
        prevSlideIndex: prevSlideIndex.value,
        slidesCount: slidesCount.value
      });
      stopAutoplay();
      isSliding.value = true;
      currentSlideIndex.value = slideIndex;
      if (targetIndex !== slideIndex) {
        modelWatcher.pause();
      }
      emit2("update:modelValue", targetIndex);
      const transitionCallback = () => {
        if (config.wrapAround && targetIndex !== slideIndex) {
          modelWatcher.resume();
          currentSlideIndex.value = targetIndex;
          emit2("loop", {
            currentSlideIndex: currentSlideIndex.value,
            slidingToIndex: slideIndex
          });
        }
        emit2("slide-end", {
          currentSlideIndex: currentSlideIndex.value,
          prevSlideIndex: prevSlideIndex.value,
          slidesCount: slidesCount.value
        });
        isSliding.value = false;
        resetAutoplay();
      };
      transitionTimer = setTimeout(transitionCallback, config.transition);
    }
    function restartCarousel() {
      updateBreakpointsConfig();
      updateSlidesData();
      updateSlideSize();
      resetAutoplay();
    }
    watch(() => [fallbackConfig.value, props.breakpoints], () => updateBreakpointsConfig(), { deep: true });
    watch(() => props.autoplay, () => resetAutoplay());
    const modelWatcher = watch(() => props.modelValue, (val) => {
      if (val === currentSlideIndex.value) {
        return;
      }
      slideTo(Number(val), true);
    });
    emit2("before-init");
    const clonedSlidesCount = computed(() => {
      if (!config.wrapAround) {
        return { before: 0, after: 0 };
      }
      if (isAuto.value) {
        return { before: slides.length, after: slides.length };
      }
      const itemsToShow = Number(config.itemsToShow);
      const slidesToClone = Math.ceil(itemsToShow + (config.itemsToScroll - 1));
      const before = slidesToClone - activeSlideIndex.value;
      const after = slidesToClone - (slidesCount.value - (activeSlideIndex.value + 1));
      return {
        before: Math.max(0, before),
        after: Math.max(0, after)
      };
    });
    const clonedSlidesOffset = computed(() => {
      if (!clonedSlidesCount.value.before) {
        return 0;
      }
      if (isAuto.value) {
        return slidesRect.value.slice(-1 * clonedSlidesCount.value.before).reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0) * -1;
      }
      return clonedSlidesCount.value.before * effectiveSlideSize.value * -1;
    });
    const snapAlignOffset = computed(() => {
      var _a2;
      if (isAuto.value) {
        const slideIndex = (currentSlideIndex.value % slides.length + slides.length) % slides.length;
        return getSnapAlignOffset({
          slideSize: (_a2 = slidesRect.value[slideIndex]) === null || _a2 === void 0 ? void 0 : _a2[dimension.value],
          viewportSize: viewportRect.value[dimension.value],
          align: config.snapAlign
        });
      }
      return getSnapAlignOffset({
        align: config.snapAlign,
        itemsToShow: +config.itemsToShow
      });
    });
    const scrolledOffset = computed(() => {
      let output = 0;
      if (isAuto.value) {
        if (currentSlideIndex.value < 0) {
          output = slidesRect.value.slice(currentSlideIndex.value).reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0) * -1;
        } else {
          output = slidesRect.value.slice(0, currentSlideIndex.value).reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0);
        }
        output -= snapAlignOffset.value;
        if (!config.wrapAround) {
          const maxSlidingValue = slidesRect.value.reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0) - viewportRect.value[dimension.value] - config.gap;
          output = getNumberInRange({
            val: output,
            max: maxSlidingValue,
            min: 0
          });
        }
      } else {
        let scrolledSlides = currentSlideIndex.value - snapAlignOffset.value;
        if (!config.wrapAround) {
          scrolledSlides = getNumberInRange({
            val: scrolledSlides,
            max: slidesCount.value - +config.itemsToShow,
            min: 0
          });
        }
        output = scrolledSlides * effectiveSlideSize.value;
      }
      return output * (isReversed.value ? 1 : -1);
    });
    const visibleRange = computed(() => {
      var _a2, _b;
      if (!isAuto.value) {
        const base = currentSlideIndex.value - snapAlignOffset.value;
        if (config.wrapAround) {
          return {
            min: Math.floor(base),
            max: Math.ceil(base + Number(config.itemsToShow) - 1)
          };
        }
        return {
          min: Math.floor(getNumberInRange({
            val: base,
            max: slidesCount.value - Number(config.itemsToShow),
            min: 0
          })),
          max: Math.ceil(getNumberInRange({
            val: base + Number(config.itemsToShow) - 1,
            max: slidesCount.value - 1,
            min: 0
          }))
        };
      }
      let minIndex = 0;
      {
        let accumulatedSize = 0;
        let index = 0 - clonedSlidesCount.value.before;
        const offset = Math.abs(scrolledOffset.value + clonedSlidesOffset.value);
        while (accumulatedSize <= offset) {
          const normalizedIndex = (index % slides.length + slides.length) % slides.length;
          accumulatedSize += ((_a2 = slidesRect.value[normalizedIndex]) === null || _a2 === void 0 ? void 0 : _a2[dimension.value]) + config.gap;
          index++;
        }
        minIndex = index - 1;
      }
      let maxIndex = 0;
      {
        let index = minIndex;
        let accumulatedSize = 0;
        if (index < 0) {
          accumulatedSize = slidesRect.value.slice(0, index).reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0) - Math.abs(scrolledOffset.value + clonedSlidesOffset.value);
        } else {
          accumulatedSize = slidesRect.value.slice(0, index).reduce((acc, slide2) => acc + slide2[dimension.value] + config.gap, 0) - Math.abs(scrolledOffset.value);
        }
        while (accumulatedSize < viewportRect.value[dimension.value]) {
          const normalizedIndex = (index % slides.length + slides.length) % slides.length;
          accumulatedSize += ((_b = slidesRect.value[normalizedIndex]) === null || _b === void 0 ? void 0 : _b[dimension.value]) + config.gap;
          index++;
        }
        maxIndex = index - 1;
      }
      return {
        min: Math.floor(minIndex),
        max: Math.ceil(maxIndex)
      };
    });
    const trackTransform = computed(() => {
      if (config.slideEffect === "fade") {
        return void 0;
      }
      const translateAxis = isVertical.value ? "Y" : "X";
      const dragOffset = isVertical.value ? dragged.y : dragged.x;
      let totalOffset = scrolledOffset.value + dragOffset;
      if (!config.wrapAround && config.preventExcessiveDragging) {
        let maxSlidingValue = 0;
        if (isAuto.value) {
          maxSlidingValue = slidesRect.value.reduce((acc, slide2) => acc + slide2[dimension.value], 0);
        } else {
          maxSlidingValue = (slidesCount.value - Number(config.itemsToShow)) * effectiveSlideSize.value;
        }
        const min = isReversed.value ? 0 : -1 * maxSlidingValue;
        const max = isReversed.value ? maxSlidingValue : 0;
        totalOffset = getNumberInRange({
          val: totalOffset,
          min,
          max
        });
      }
      return `translate${translateAxis}(${totalOffset}px)`;
    });
    const carouselStyle = computed(() => ({
      "--vc-carousel-height": toCssValue(config.height),
      "--vc-cloned-offset": toCssValue(clonedSlidesOffset.value),
      "--vc-slide-gap": toCssValue(config.gap),
      "--vc-transition-duration": isSliding.value ? toCssValue(config.transition, "ms") : void 0
    }));
    const nav = { slideTo, next, prev };
    const provided = reactive({
      activeSlide: activeSlideIndex,
      config,
      currentSlide: currentSlideIndex,
      isSliding,
      isVertical,
      maxSlide: maxSlideIndex,
      minSlide: minSlideIndex,
      nav,
      normalizedDir,
      slideRegistry,
      slideSize,
      slides,
      slidesCount,
      viewport,
      visibleRange
    });
    provide(injectCarousel, provided);
    const data = reactive({
      config,
      currentSlide: currentSlideIndex,
      maxSlide: maxSlideIndex,
      middleSlide: middleSlideIndex,
      minSlide: minSlideIndex,
      slideSize,
      slidesCount
    });
    expose(reactive(Object.assign({
      data,
      next,
      prev,
      restartCarousel,
      slideTo,
      updateBreakpointsConfig,
      updateSlideSize,
      updateSlidesData
    }, toRefs(provided))));
    return () => {
      var _a2;
      const slotSlides = slots.default || slots.slides;
      const outputSlides = (slotSlides === null || slotSlides === void 0 ? void 0 : slotSlides(data)) || [];
      const { before, after } = clonedSlidesCount.value;
      const slidesBefore = createCloneSlides({
        slides,
        position: "before",
        toShow: before
      });
      const slidesAfter = createCloneSlides({
        slides,
        position: "after",
        toShow: after
      });
      const output = [...slidesBefore, ...outputSlides, ...slidesAfter];
      if (!config.enabled || !output.length) {
        return h("section", {
          ref: root,
          class: ["carousel", "is-disabled"]
        }, output);
      }
      const addonsElements = ((_a2 = slots.addons) === null || _a2 === void 0 ? void 0 : _a2.call(slots, data)) || [];
      const trackEl = h("ol", {
        class: "carousel__track",
        onMousedownCapture: config.mouseDrag ? handleDragStart : null,
        onTouchstartPassiveCapture: config.touchDrag ? handleDragStart : null,
        onWheel: config.mouseWheel ? handleScroll : null,
        style: { transform: trackTransform.value }
      }, output);
      const viewPortEl = h("div", { class: "carousel__viewport", ref: viewport }, trackEl);
      return h("section", {
        ref: root,
        class: [
          "carousel",
          `is-${normalizedDir.value}`,
          `is-effect-${config.slideEffect}`,
          {
            "is-dragging": isDragging.value,
            "is-hover": isHover.value,
            "is-sliding": isSliding.value,
            "is-vertical": isVertical.value
          }
        ],
        dir: normalizedDir.value,
        style: carouselStyle.value,
        "aria-label": config.i18n["ariaGallery"],
        tabindex: "0",
        onBlur: handleBlur,
        onFocus: handleFocus,
        onMouseenter: handleMouseEnter,
        onMouseleave: handleMouseLeave
      }, [viewPortEl, addonsElements, h(ARIA)]);
    };
  }
});
var IconName;
(function(IconName2) {
  IconName2["arrowDown"] = "arrowDown";
  IconName2["arrowLeft"] = "arrowLeft";
  IconName2["arrowRight"] = "arrowRight";
  IconName2["arrowUp"] = "arrowUp";
})(IconName || (IconName = {}));
const Slide = /* @__PURE__ */ defineComponent({
  name: "CarouselSlide",
  props: {
    id: {
      type: String,
      default: (props) => props.isClone ? void 0 : useId()
    },
    index: {
      type: Number,
      default: void 0
    },
    isClone: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { attrs, slots, expose }) {
    const carousel = inject(injectCarousel);
    provide(injectCarousel, void 0);
    if (!carousel) {
      return () => "";
    }
    const currentIndex = ref(props.index);
    const setIndex = (newIndex) => {
      currentIndex.value = newIndex;
    };
    const instance = getCurrentInstance();
    const getBoundingRect = () => {
      const el = instance.vnode.el;
      return el ? el.getBoundingClientRect() : { width: 0, height: 0 };
    };
    expose({
      id: props.id,
      setIndex,
      getBoundingRect
    });
    const isActive = computed(() => currentIndex.value === carousel.activeSlide);
    const isPrev = computed(() => currentIndex.value === carousel.activeSlide - 1);
    const isNext = computed(() => currentIndex.value === carousel.activeSlide + 1);
    const isVisible = computed(() => currentIndex.value >= carousel.visibleRange.min && currentIndex.value <= carousel.visibleRange.max);
    const slideStyle = computed(() => {
      if (carousel.config.itemsToShow === "auto") {
        return;
      }
      const itemsToShow = carousel.config.itemsToShow;
      const dimension = carousel.config.gap > 0 && itemsToShow > 1 ? `calc(${100 / itemsToShow}% - ${carousel.config.gap * (itemsToShow - 1) / itemsToShow}px)` : `${100 / itemsToShow}%`;
      return carousel.isVertical ? { height: dimension } : { width: dimension };
    });
    carousel.slideRegistry.registerSlide(instance, props.index);
    onUnmounted(() => {
      carousel.slideRegistry.unregisterSlide(instance);
    });
    if (props.isClone) {
      onMounted(() => {
        disableChildrenTabbing(instance.vnode);
      });
      onUpdated(() => {
        disableChildrenTabbing(instance.vnode);
      });
    }
    return () => {
      var _a, _b;
      if (!carousel.config.enabled) {
        return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
      }
      return h("li", {
        style: [attrs.style, Object.assign({}, slideStyle.value)],
        class: {
          carousel__slide: true,
          "carousel__slide--clone": props.isClone,
          "carousel__slide--visible": isVisible.value,
          "carousel__slide--active": isActive.value,
          "carousel__slide--prev": isPrev.value,
          "carousel__slide--next": isNext.value,
          "carousel__slide--sliding": carousel.isSliding
        },
        onFocusin: () => {
          if (carousel.viewport) {
            carousel.viewport.scrollLeft = 0;
          }
          carousel.nav.slideTo(currentIndex.value);
        },
        id: props.isClone ? void 0 : props.id,
        "aria-hidden": props.isClone || void 0
      }, (_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots, {
        currentIndex: currentIndex.value,
        isActive: isActive.value,
        isClone: props.isClone,
        isPrev: isPrev.value,
        isNext: isNext.value,
        isSliding: carousel.isSliding,
        isVisible: isVisible.value
      }));
    };
  }
});
const _sfc_main$e = {
  name: "ProductMoreInfo",
  props: {
    imageIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isContentVisible: false,
      mediaThumbnails: null,
      MOBILE_BREAKPOINT: 900
    };
  },
  computed: {
    ...mapGetters({
      product: "getSelectionRelatedProduct",
      initalData: "getInitialData",
      currentProductImageSlide: "getCurrentProductImageSlide"
    }),
    moreInfo() {
      var _a, _b;
      return (_b = (_a = this.product) == null ? void 0 : _a.moreInfo) == null ? void 0 : _b[this.imageIndex];
    }
  },
  methods: {
    switchContentVisibility() {
      this.isContentVisible = !this.isContentVisible;
    },
    handleDocumentClick(e) {
      if (!this.isContentVisible) return;
      const contentEl = this.$refs.moreInfoContent;
      if (!contentEl) return;
      if (contentEl.contains(e.target)) return;
      if (e.target.closest("[data-more-info-toggle]")) return;
      this.isContentVisible = false;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleDocumentClick, true);
    this.mediaThumbnails = document.querySelector(".media-gallery .media-gallery__thumbnails");
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick, true);
  },
  watch: {
    isContentVisible(newValue) {
      if (!this.mediaThumbnails) return;
      this.mediaThumbnails.style.opacity = newValue && window.innerWidth <= this.MOBILE_BREAKPOINT ? "0" : "1";
    },
    currentProductImageSlide(newIndex) {
      this.isContentVisible = false;
    }
  }
};
const _hoisted_1$e = { class: "bundle-builder__more--info-left" };
const _hoisted_2$b = { class: "heading" };
const _hoisted_3$8 = { class: "bundle-builder__more--info-right" };
const _hoisted_4$6 = { class: "more-info-label" };
const _hoisted_5$6 = ["innerHTML"];
const _hoisted_6$5 = {
  ref: "moreInfoContent",
  class: "bundle-builder__more--info-content"
};
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  return ((_a = $options.moreInfo) == null ? void 0 : _a.title) && ((_b = $options.moreInfo) == null ? void 0 : _b.content) ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["bundle-builder__more--info", { active: $data.isContentVisible }])
  }, [
    createBaseVNode("div", _hoisted_1$e, [
      createBaseVNode("span", _hoisted_2$b, toDisplayString($options.moreInfo.title), 1)
    ]),
    createBaseVNode("div", _hoisted_3$8, [
      createBaseVNode("button", {
        onClick: _cache[0] || (_cache[0] = (...args) => $options.switchContentVisibility && $options.switchContentVisibility(...args))
      }, [
        createBaseVNode("span", _hoisted_4$6, toDisplayString(_ctx.initalData.translations.moreInfo), 1),
        createBaseVNode("span", {
          class: "more-info-icon",
          innerHTML: _ctx.initalData.htmlSnippets.icons.moreInfo
        }, null, 8, _hoisted_5$6)
      ])
    ]),
    withDirectives(createBaseVNode("div", _hoisted_6$5, [
      createBaseVNode("p", null, toDisplayString($options.moreInfo.content), 1)
    ], 512), [
      [vShow, $data.isContentVisible]
    ])
  ], 2)) : createCommentVNode("", true);
}
const ProductMoreInfo = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e]]);
const _sfc_main$d = {
  name: "ProductMedia",
  components: {
    Carousel,
    Slide,
    ProductMoreInfo
  },
  data() {
    return {
      currentSlide: 0
    };
  },
  computed: {
    ...mapGetters({
      product: "getSelectionRelatedProduct",
      nestedProductsImagesSrc: "getNestedProductsImagesSrc",
      additionalShakerImagesSrc: "getAdditionalShakerImagesSrc"
    }),
    images() {
      var _a, _b;
      const productImages = (_a = this.product) == null ? void 0 : _a.images;
      const images = ((_b = this.additionalShakerImagesSrc) == null ? void 0 : _b.length) ? [...this.additionalShakerImagesSrc] : [];
      if (productImages == null ? void 0 : productImages.length) {
        images.push(...productImages);
      }
      images.push(...this.nestedProductsImagesSrc);
      const uniqueImagesSet = new Set(images.map((img) => img.src || img));
      const imagesArray = Array.from(uniqueImagesSet).map((src) => {
        return typeof src === "string" ? src : src.src;
      });
      return imagesArray;
    },
    isMoreInfoImageSelected() {
      var _a, _b;
      return (_b = (_a = this.product) == null ? void 0 : _a.moreInfo) == null ? void 0 : _b[this.currentSlide];
    }
  },
  methods: {
    goTo(index) {
      this.currentSlide = index;
    },
    ...mapMutations({
      setCurrentProductSlide: "SET_CURRENT_PRODUCT_IMAGE_SLIDE"
    })
  },
  watch: {
    currentSlide(newIndex) {
      this.setCurrentProductSlide(newIndex);
    },
    // Show first image on product change
    product() {
      this.currentSlide = 0;
    }
  }
};
const _hoisted_1$d = { class: "media-gallery" };
const _hoisted_2$a = ["onClick"];
const _hoisted_3$7 = ["src", "alt"];
const _hoisted_4$5 = { class: "media-gallery__slide_content" };
const _hoisted_5$5 = { class: "media-gallery__image-wrapper" };
const _hoisted_6$4 = ["src", "alt"];
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ProductMoreInfo = resolveComponent("ProductMoreInfo");
  const _component_Slide = resolveComponent("Slide");
  const _component_Carousel = resolveComponent("Carousel");
  return openBlock(), createElementBlock("div", _hoisted_1$d, [
    createBaseVNode("div", {
      class: normalizeClass(["media-gallery__thumbnails", {
        "has-more-info-badge": !$options.isMoreInfoImageSelected
      }])
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($options.images, (img, index) => {
        var _a, _b;
        return openBlock(), createElementBlock("button", {
          key: index,
          onClick: ($event) => $options.goTo(index),
          class: normalizeClass([{
            active: $data.currentSlide === index,
            "has-more-info-badge--thumb": (_b = (_a = _ctx.product) == null ? void 0 : _a.moreInfo) == null ? void 0 : _b[index]
          }, "media-gallery__thumb"])
        }, [
          createBaseVNode("img", {
            src: img,
            alt: `Thumb ${index + 1}`
          }, null, 8, _hoisted_3$7)
        ], 10, _hoisted_2$a);
      }), 128))
    ], 2),
    createVNode(_component_Carousel, {
      ref: "carouselRef",
      modelValue: $data.currentSlide,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.currentSlide = $event),
      "wrap-around": true,
      "items-to-show": 1,
      transition: 0.3,
      class: "media-gallery__carousel"
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($options.images, (img, index) => {
          return openBlock(), createBlock(_component_Slide, { key: index }, {
            default: withCtx(() => {
              var _a, _b, _c, _d;
              return [
                createBaseVNode("div", _hoisted_4$5, [
                  createBaseVNode("div", _hoisted_5$5, [
                    createBaseVNode("img", {
                      class: normalizeClass(["media-gallery__image", {
                        "has-more-info-badge": (_b = (_a = _ctx.product) == null ? void 0 : _a.moreInfo) == null ? void 0 : _b[index]
                      }]),
                      src: img,
                      alt: `Image ${index + 1}`
                    }, null, 10, _hoisted_6$4),
                    ((_d = (_c = _ctx.product) == null ? void 0 : _c.moreInfo) == null ? void 0 : _d.length) ? (openBlock(), createBlock(_component_ProductMoreInfo, {
                      key: 0,
                      imageIndex: $data.currentSlide
                    }, null, 8, ["imageIndex"])) : createCommentVNode("", true)
                  ])
                ])
              ];
            }),
            _: 2
          }, 1024);
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]);
}
const ProductMedia = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d]]);
const _sfc_main$c = {
  name: "ProductMeta",
  computed: {
    ...mapGetters({
      product: "getSelectionRelatedProduct",
      initialData: "getInitialData"
    }),
    reviewsSku() {
      var _a, _b;
      return ((_b = (_a = this.initialData) == null ? void 0 : _a.config) == null ? void 0 : _b.reviewsSku) || "";
    }
  },
  mounted() {
    this.initReviews();
  },
  watch: {
    product() {
      this.$nextTick(this.renderReviewsSnippet);
    }
  },
  methods: {
    async initReviews() {
      await this.loadReviewsScript();
      this.renderReviewsSnippet();
    },
    loadReviewsScript() {
      return new Promise((resolve2, reject) => {
        if (document.getElementById("reviews-io-script")) return resolve2();
        const script = document.createElement("script");
        script.id = "reviews-io-script";
        script.src = "https://widget.reviews.io/rating-snippet/dist.js";
        script.async = true;
        script.onload = resolve2;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    },
    renderReviewsSnippet() {
      if (!this.$refs.reviewsSnippet || !this.reviewsSku) return;
      try {
        if (typeof window.ratingSnippet === "function") {
          window.ratingSnippet("ruk_rating_snippet", {
            store: "holy",
            mode: "default",
            color: "#0E1311",
            linebreak: false,
            usePolaris: true,
            showEmptyStars: false,
            singularText: "Review",
            text: "Reviews"
          });
        }
      } catch (e) {
        console.error("Reviews.io snippet init failed", e);
      }
    }
  }
};
const _hoisted_1$c = ["data-sku"];
const _hoisted_2$9 = { class: "product-meta__title heading heading-3" };
const _hoisted_3$6 = ["innerHTML"];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    $options.reviewsSku ? (openBlock(), createElementBlock("div", {
      key: 0,
      ref: "reviewsSnippet",
      class: "ruk_rating_snippet",
      "data-sku": $options.reviewsSku
    }, null, 8, _hoisted_1$c)) : createCommentVNode("", true),
    createBaseVNode("h1", _hoisted_2$9, toDisplayString(_ctx.product.title), 1),
    _ctx.product.bulletPointsHtml ? (openBlock(), createElementBlock("div", {
      key: 1,
      innerHTML: _ctx.product.bulletPointsHtml
    }, null, 8, _hoisted_3$6)) : createCommentVNode("", true)
  ]);
}
const ProductMeta = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c]]);
const _sfc_main$b = {
  name: "QuantitySelector",
  props: {
    productVariant: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      quantity: this.getInitialQuantityValue(),
      quantityInput: `${this.getInitialQuantityValue()}`
    };
  },
  computed: {
    ...mapGetters({
      initialData: "getInitialData"
    }),
    isSampleBox() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.initialData.config.variantAndProductIndex) == null ? void 0 : _a.variantsById) == null ? void 0 : _b[this.productVariant.id]) == null ? void 0 : _c.isSampleBox;
    }
  },
  methods: {
    ...mapMutations({
      setSampleBoxQuantity: "SET_SAMPLE_BOX_QUANTITY",
      setShakerQuantity: "SET_SHAKER_QUANTITY"
    }),
    increaseQuantity() {
      if (this.quantity < 5) {
        this.quantity++;
        this.quantityInput = String(this.quantity);
      }
    },
    decreaseQuantity() {
      if (this.quantity > 0) {
        this.quantity--;
        this.quantityInput = String(this.quantity);
      }
    },
    handleInput(event) {
      const raw = event.target.value;
      let numeric = raw.replace(/\D/g, "");
      let value = Number(numeric || 0);
      if (value > 5) value = 5;
      this.quantityInput = String(value);
      this.quantity = value;
    },
    sanitizeQuantity() {
      let value = Number(this.quantity || 0);
      if (value > 5) value = 5;
      this.quantityInput = String(value);
      this.quantity = value;
    },
    getInitialQuantityValue() {
      var _a;
      return ((_a = this.$store.state.selectedBoxesVariantsIds) == null ? void 0 : _a[this.productVariant.id]) || 0;
    }
  },
  watch: {
    quantity(newQuantity) {
      if (this.isSampleBox) {
        this.setSampleBoxQuantity({ variantId: this.productVariant.id, quantity: newQuantity });
      }
    }
  }
};
const _hoisted_1$b = ["innerHTML"];
const _hoisted_2$8 = ["innerHTML"];
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "quantity-selector",
    style: normalizeStyle({
      flexDirection: $data.quantity === 0 ? "row-reverse" : "row"
    })
  }, [
    withDirectives(createBaseVNode("button", {
      class: "qty-selector-btn",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.decreaseQuantity && $options.decreaseQuantity(...args)),
      innerHTML: _ctx.initialData.htmlSnippets.icons.minus
    }, null, 8, _hoisted_1$b), [
      [vShow, $data.quantity]
    ]),
    withDirectives(createBaseVNode("input", {
      class: "qty-selector-input",
      type: "text",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.quantityInput = $event),
      onInput: _cache[2] || (_cache[2] = (...args) => $options.handleInput && $options.handleInput(...args)),
      onBlur: _cache[3] || (_cache[3] = (...args) => $options.sanitizeQuantity && $options.sanitizeQuantity(...args)),
      inputmode: "numeric",
      pattern: "[0-9]*",
      maxlength: "1"
    }, null, 544), [
      [vShow, $data.quantity],
      [vModelText, $data.quantityInput]
    ]),
    createBaseVNode("button", {
      class: "qty-selector-btn qty-selector-btn__plus",
      onClick: _cache[4] || (_cache[4] = (...args) => $options.increaseQuantity && $options.increaseQuantity(...args)),
      innerHTML: _ctx.initialData.htmlSnippets.icons.plus
    }, null, 8, _hoisted_2$8)
  ], 4);
}
const QuantitySelector = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b]]);
const _sfc_main$a = {
  name: "SampleBox",
  props: {
    productVariant: {
      type: Object,
      required: true
    },
    hideQuantitySelector: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quantity: 0
    };
  },
  computed: {
    ...mapGetters({
      initalData: "getInitialData"
    }),
    product() {
      return this.initalData.config.variantAndProductIndex.productsById[this.productVariant.productId];
    },
    imageSrc() {
      var _a, _b, _c, _d;
      return ((_b = (_a = this.productVariant) == null ? void 0 : _a.featured_image) == null ? void 0 : _b.src) ? (_c = this.productVariant.featured_image) == null ? void 0 : _c.src : (_d = this.product.images) == null ? void 0 : _d[0];
    },
    title() {
      var _a, _b;
      return ((_a = this.product) == null ? void 0 : _a.customTitle) || ((_b = this.product) == null ? void 0 : _b.title);
    },
    subtitle() {
      var _a;
      return (_a = this.productVariant) == null ? void 0 : _a.sampleBoxSubtitle;
    }
  },
  components: {
    QuantitySelector
  }
};
const _hoisted_1$a = { class: "samplebox-line" };
const _hoisted_2$7 = ["src", "alt"];
const _hoisted_3$5 = { class: "samplebox-texts" };
const _hoisted_4$4 = { class: "samplebox-title" };
const _hoisted_5$4 = {
  key: 0,
  class: "samplebox-subtitle"
};
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_QuantitySelector = resolveComponent("QuantitySelector");
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    createBaseVNode("img", {
      class: "samplebox-image",
      src: $options.imageSrc,
      alt: $options.title
    }, null, 8, _hoisted_2$7),
    createBaseVNode("div", _hoisted_3$5, [
      createBaseVNode("span", _hoisted_4$4, toDisplayString($options.title), 1),
      $options.subtitle ? (openBlock(), createElementBlock("p", _hoisted_5$4, toDisplayString($options.subtitle), 1)) : createCommentVNode("", true)
    ]),
    !$props.hideQuantitySelector ? (openBlock(), createBlock(_component_QuantitySelector, {
      key: 0,
      productVariant: $props.productVariant
    }, null, 8, ["productVariant"])) : createCommentVNode("", true)
  ]);
}
const SampleBox = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a]]);
const _sfc_main$9 = {
  name: "ModalWindow",
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("update:modelValue", false);
    }
  },
  computed: {
    ...mapGetters({
      initalData: "getInitialData"
    })
  },
  watch: {
    modelValue(newValue) {
      if (newValue) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "initial";
      }
    }
  }
};
const _hoisted_1$9 = { class: "modal-window" };
const _hoisted_2$6 = ["innerHTML"];
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.modelValue ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "modal-overlay",
    onClick: _cache[1] || (_cache[1] = withModifiers((...args) => $options.close && $options.close(...args), ["self"]))
  }, [
    createBaseVNode("div", _hoisted_1$9, [
      renderSlot(_ctx.$slots, "default"),
      createBaseVNode("button", {
        class: "close-btn",
        onClick: _cache[0] || (_cache[0] = (...args) => $options.close && $options.close(...args)),
        innerHTML: _ctx.initalData.htmlSnippets.icons.close
      }, null, 8, _hoisted_2$6)
    ])
  ])) : createCommentVNode("", true);
}
const ModalWindow = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9]]);
const _sfc_main$8 = {
  name: "InfoIcon",
  props: {
    infoText: {
      type: String,
      default: ""
    },
    iconSvg: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showTooltip: false,
      isTouchDevice: false
    };
  },
  mounted() {
    this.isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    if (this.isTouchDevice) {
      document.addEventListener("click", this.handleOutsideClick);
    }
  },
  beforeUnmount() {
    if (this.isTouchDevice) {
      document.removeEventListener("click", this.handleOutsideClick);
    }
  },
  methods: {
    handleMouseEnter() {
      if (!this.isTouchDevice) {
        this.showTooltip = true;
      }
    },
    handleMouseLeave() {
      if (!this.isTouchDevice) {
        this.showTooltip = false;
      }
    },
    handleClick(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.isTouchDevice) {
        this.showTooltip = !this.showTooltip;
      }
    },
    handleTouchStart(event) {
      event.stopPropagation();
      event.preventDefault();
      if (this.isTouchDevice) {
        this.showTooltip = !this.showTooltip;
      }
    },
    handleOutsideClick(event) {
      if (this.showTooltip && this.isTouchDevice) {
        const wrapper = this.$el;
        const tooltip = wrapper == null ? void 0 : wrapper.querySelector(".info-tooltip");
        if (wrapper && !wrapper.contains(event.target) && tooltip && !tooltip.contains(event.target)) {
          this.showTooltip = false;
        }
      }
    }
  }
};
const _hoisted_1$8 = ["innerHTML"];
const _hoisted_2$5 = ["innerHTML"];
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.infoText ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "info-icon-wrapper",
    onClick: _cache[8] || (_cache[8] = withModifiers(() => {
    }, ["stop"]))
  }, [
    createBaseVNode("div", {
      class: "info-icon",
      onMouseenter: _cache[0] || (_cache[0] = (...args) => $options.handleMouseEnter && $options.handleMouseEnter(...args)),
      onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.handleMouseLeave && $options.handleMouseLeave(...args)),
      onClick: _cache[2] || (_cache[2] = (...args) => $options.handleClick && $options.handleClick(...args)),
      onTouchstart: _cache[3] || (_cache[3] = (...args) => $options.handleTouchStart && $options.handleTouchStart(...args)),
      innerHTML: $props.iconSvg
    }, null, 40, _hoisted_1$8),
    $data.showTooltip ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: "info-tooltip",
      onMouseenter: _cache[4] || (_cache[4] = (...args) => $options.handleMouseEnter && $options.handleMouseEnter(...args)),
      onMouseleave: _cache[5] || (_cache[5] = (...args) => $options.handleMouseLeave && $options.handleMouseLeave(...args)),
      onClick: _cache[6] || (_cache[6] = withModifiers(() => {
      }, ["stop"])),
      onTouchstart: _cache[7] || (_cache[7] = withModifiers(() => {
      }, ["stop"]))
    }, [
      _cache[9] || (_cache[9] = createBaseVNode("div", { class: "info-tooltip__arrow" }, null, -1)),
      createBaseVNode("div", {
        class: "info-tooltip__content",
        innerHTML: $props.infoText
      }, null, 8, _hoisted_2$5)
    ], 32)) : createCommentVNode("", true)
  ])) : createCommentVNode("", true);
}
const InfoIcon = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__scopeId", "data-v-a51bf6ac"]]);
const _sfc_main$7 = {
  name: "ShakerCard",
  components: {
    InfoIcon
  },
  props: {
    productVariant: {
      type: Array,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    getProductsById(productId) {
      const productsById = this.initialData.config.variantAndProductIndex.productsById;
      return productsById[productId];
    },
    formatMoney(cents, format) {
      if (typeof cents == "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format;
      function defaultOption(opt, def2) {
        return typeof opt == "undefined" ? def2 : opt;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = number.toFixed(precision);
        var parts = number.split("."), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), cents2 = parts[1] ? decimal + parts[1] : "";
        return dollars + cents2;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }
      let result = formatString.replace(placeholderRegex, value);
      if (result.includes(".00")) ;
      return formatString.replace(placeholderRegex, value);
    }
  },
  computed: {
    ...mapGetters({
      initialData: "getInitialData",
      discountForShakerProductById: "getDiscountForShakerProductById",
      getLvl2DiscountBadgeByShakerVariantId: "getLvl2DiscountBadgeByShakerVariantId"
    }),
    lvl2DiscountBadge() {
      return this.getLvl2DiscountBadgeByShakerVariantId(this.productVariant.id);
    },
    shakerDiscount() {
      var _a;
      return ((_a = this.discountForShakerProductById({
        productId: this.productVariant.productId,
        variantId: this.productVariant.id
      })) == null ? void 0 : _a.discountAmount) || 0;
    },
    shakerPrice() {
      const remainingShakerValue = (+this.initialData.config.remainingShakerValue || 0) * +window.Shopify.currency.rate;
      const discount = this.shakerDiscount * +window.Shopify.currency.rate + remainingShakerValue;
      const price = this.productVariant.price / 100;
      const finalPrice = Math.round((price - discount) * 100) / 100;
      const roundedFinalPrice = Math.abs(finalPrice) < 0.01 ? 0 : Math.floor(finalPrice);
      const plusSymbol = finalPrice < 0 ? "" : "+";
      const isUK = window.Shopify.country === "GB";
      if (isUK) {
        return `${plusSymbol}${this.initialData.currency}${roundedFinalPrice}`;
      } else {
        return `${plusSymbol}${roundedFinalPrice}${this.initialData.currency}`;
      }
    },
    product() {
      return this.getProductsById(this.productVariant.productId);
    },
    imageSrc() {
      var _a, _b, _c, _d, _e;
      return ((_b = (_a = this.productVariant) == null ? void 0 : _a.featured_image) == null ? void 0 : _b.src) ? (_c = this.productVariant.featured_image) == null ? void 0 : _c.src : (_e = (_d = this.product) == null ? void 0 : _d.images) == null ? void 0 : _e[0];
    },
    title() {
      var _a, _b, _c, _d;
      return ((_a = this.productVariant) == null ? void 0 : _a.title) && ((_b = this.productVariant) == null ? void 0 : _b.title) !== "Default Title" ? (_c = this.productVariant) == null ? void 0 : _c.title : (_d = this.product) == null ? void 0 : _d.title;
    },
    shakerInfoText() {
      const product = this.product;
      if (product && product.shakerTooltipText) {
        return product.shakerTooltipText;
      }
      return "";
    },
    infoIconSvg() {
      var _a, _b, _c;
      return ((_c = (_b = (_a = this.initialData) == null ? void 0 : _a.htmlSnippets) == null ? void 0 : _b.icons) == null ? void 0 : _c.info) || "";
    }
  }
};
const _hoisted_1$7 = ["selected"];
const _hoisted_2$4 = { class: "shaker-card__lvl2-badge_wrapper" };
const _hoisted_3$4 = {
  key: 0,
  class: "shaker-card__lvl2-badge"
};
const _hoisted_4$3 = { class: "shaker-card__info-icon-wrapper" };
const _hoisted_5$3 = { class: "shaker-image-wrapper" };
const _hoisted_6$3 = ["src", "alt"];
const _hoisted_7$2 = { class: "shaker-title" };
const _hoisted_8$2 = { class: "shaker-card__additional-info" };
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InfoIcon = resolveComponent("InfoIcon");
  return $options.imageSrc && $options.title && $props.productVariant.isHidden !== "true" ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["shaker-card", { "shaker-card--unavailable": !$props.productVariant.available }]),
    selected: $props.selected
  }, [
    createBaseVNode("div", _hoisted_2$4, [
      $options.lvl2DiscountBadge ? (openBlock(), createElementBlock("div", _hoisted_3$4, toDisplayString($options.lvl2DiscountBadge), 1)) : createCommentVNode("", true)
    ]),
    createBaseVNode("div", _hoisted_4$3, [
      createVNode(_component_InfoIcon, {
        infoText: $options.shakerInfoText,
        iconSvg: $options.infoIconSvg
      }, null, 8, ["infoText", "iconSvg"])
    ]),
    createBaseVNode("div", _hoisted_5$3, [
      createBaseVNode("img", {
        class: "shaker-image",
        src: $options.imageSrc,
        alt: $options.title
      }, null, 8, _hoisted_6$3)
    ]),
    createBaseVNode("span", _hoisted_7$2, toDisplayString($options.title), 1),
    createBaseVNode("span", _hoisted_8$2, toDisplayString($props.productVariant.available ? $options.shakerPrice : _ctx.initialData.translations.outOfStock), 1)
  ], 10, _hoisted_1$7)) : createCommentVNode("", true);
}
const ShakerCard = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7]]);
const _sfc_main$6 = {
  name: "Tabs",
  data() {
    return {
      tabs: [],
      activeIndex: 0
    };
  },
  provide() {
    return {
      registerTab: this.registerTab,
      getActiveIndex: () => this.activeIndex
    };
  },
  methods: {
    registerTab(tab) {
      this.tabs.push(tab);
    },
    selectTab(i) {
      this.activeIndex = i;
    }
  }
};
const _hoisted_1$6 = { class: "tabs-header" };
const _hoisted_2$3 = ["onClick"];
const _hoisted_3$3 = { class: "tabs-content" };
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createBaseVNode("div", _hoisted_1$6, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($data.tabs, (tab, i) => {
        return openBlock(), createElementBlock("button", {
          class: normalizeClass(["tabs-header__button", { active: $data.activeIndex === i }]),
          key: tab.title,
          onClick: ($event) => $options.selectTab(i),
          type: "button"
        }, toDisplayString(tab.title), 11, _hoisted_2$3);
      }), 128))
    ]),
    createBaseVNode("div", _hoisted_3$3, [
      renderSlot(_ctx.$slots, "default")
    ])
  ]);
}
const Tabs = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6]]);
const _sfc_main$5 = {
  name: "Tab",
  props: {
    title: { type: String, required: true }
  },
  inject: ["registerTab", "getActiveIndex"],
  data() {
    return {
      index: null
    };
  },
  computed: {
    isActive() {
      return this.getActiveIndex() === this.index;
    }
  },
  created() {
    this.index = this.$parent.tabs.length;
    this.registerTab({ title: this.title });
  }
};
const _hoisted_1$5 = { key: 0 };
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return $options.isActive ? (openBlock(), createElementBlock("div", _hoisted_1$5, [
    renderSlot(_ctx.$slots, "default")
  ])) : createCommentVNode("", true);
}
const Tab = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5]]);
const _sfc_main$4 = {
  name: "Shaker",
  data() {
    return {
      _selectedShaker: "",
      isModalOpen: false
    };
  },
  created() {
    var _a;
    let firstAvailableShaker = null;
    const collections = this.initalData.config.shakersCollections.filter((collection) => !collection.hidden);
    for (const collection of collections) {
      for (const product of collection.products || []) {
        for (const variant of product.variants || []) {
          if (variant.available) {
            firstAvailableShaker = variant;
            break;
          }
        }
        if (firstAvailableShaker) break;
      }
      if (firstAvailableShaker) break;
    }
    const preselectedShakerVairantId = (_a = Object.keys(this.selectedShakersVariantsIds)) == null ? void 0 : _a[0];
    const preselectedShakerVairant = this.getVariantById(preselectedShakerVairantId);
    const initialShaker = preselectedShakerVairant && preselectedShakerVairant.available ? preselectedShakerVairant : firstAvailableShaker;
    if (initialShaker) {
      this.selectShaker(initialShaker);
    }
  },
  methods: {
    ...mapMutations({
      setShakerQuantity: "SET_SHAKER_QUANTITY"
    }),
    selectShaker(shakerVariant) {
      this._selectedShaker = shakerVariant;
      this.setShakerQuantity({
        variantId: this._selectedShaker.id,
        quantity: 1
      });
      this.isModalOpen = false;
    },
    openModalWindow() {
      this.isModalOpen = true;
    },
    backToOverview() {
      this.isModalOpen = false;
    },
    getCollectionVariants(collection) {
      const result = [];
      collection.products.forEach((product) => {
        result.push(...product.variants);
      });
      return result;
    },
    getVariantById(variantId) {
      const variantsById = this.initalData.config.variantAndProductIndex.variantsById;
      return variantsById[variantId];
    },
    findProductById(productId) {
      return this.getProductById(productId);
    }
  },
  computed: {
    ...mapGetters({
      initalData: "getInitialData",
      prices: "getPrices",
      selectedShakersVariantsIds: "getSelectedShakersVariantsIds",
      getProductById: "getProductById"
    }),
    shakersCollections() {
      const notHidden = this.initalData.config.shakersCollections.filter((collection) => !collection.hidden);
      return notHidden;
    },
    product() {
      return this.initalData.config.variantAndProductIndex.productsById[this._selectedShaker.productId];
    },
    imageSrc() {
      var _a, _b, _c, _d, _e;
      return ((_b = (_a = this._selectedShaker) == null ? void 0 : _a.featured_image) == null ? void 0 : _b.src) ? (_c = this._selectedShaker.featured_image) == null ? void 0 : _c.src : (_e = (_d = this.product) == null ? void 0 : _d.images) == null ? void 0 : _e[0];
    },
    title() {
      var _a, _b, _c, _d;
      return ((_a = this.productVariant) == null ? void 0 : _a.title) && ((_b = this.productVariant) == null ? void 0 : _b.title) !== "Default Title" ? (_c = this.productVariant) == null ? void 0 : _c.title : (_d = this.product) == null ? void 0 : _d.title;
    },
    shakersVariants() {
      const shakerProducts = this.initalData.config.shakersProducts;
      const variantsOfShakers = shakerProducts.map((product) => product.variants);
      return variantsOfShakers == null ? void 0 : variantsOfShakers.flat();
    }
  },
  components: {
    QuantitySelector,
    ModalWindow,
    ShakerCard,
    Tabs,
    Tab
  }
};
const _hoisted_1$4 = { class: "shaker-selection" };
const _hoisted_2$2 = { class: "shaker-selection__clickable_header" };
const _hoisted_3$2 = { class: "shaker-selection__clickable_header__inner" };
const _hoisted_4$2 = ["src", "alt"];
const _hoisted_5$2 = { class: "selected-shaker-title" };
const _hoisted_6$2 = ["innerHTML"];
const _hoisted_7$1 = { class: "shaker-selection__clickable_footer" };
const _hoisted_8$1 = {
  key: 0,
  class: "shaker-selection__devider"
};
const _hoisted_9$1 = {
  key: 1,
  class: "shaker-selection__bottom-image-wrapper"
};
const _hoisted_10$1 = ["src"];
const _hoisted_11$1 = { class: "shaker-selection__more-shakers" };
const _hoisted_12$1 = { class: "shakers-modal-content" };
const _hoisted_13$1 = { class: "h3" };
const _hoisted_14$1 = { class: "shakers-container" };
const _hoisted_15$1 = { class: "shaker-selection__price-card_wrapper" };
const _hoisted_16$1 = { class: "shaker-selection__price-card" };
const _hoisted_17$1 = { class: "shaker-selection__price-card_text" };
const _hoisted_18$1 = { class: "shaker-selection__price-card_price" };
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ShakerCard = resolveComponent("ShakerCard");
  const _component_Tab = resolveComponent("Tab");
  const _component_Tabs = resolveComponent("Tabs");
  const _component_ModalWindow = resolveComponent("ModalWindow");
  return openBlock(), createElementBlock("div", _hoisted_1$4, [
    createBaseVNode("div", {
      class: "shaker-selection__clickable",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.openModalWindow && $options.openModalWindow(...args))
    }, [
      createBaseVNode("div", _hoisted_2$2, [
        createBaseVNode("div", _hoisted_3$2, [
          createBaseVNode("img", {
            class: "selected-shaker-image",
            src: $options.imageSrc,
            alt: $options.title
          }, null, 8, _hoisted_4$2)
        ]),
        createBaseVNode("span", _hoisted_5$2, toDisplayString($options.title), 1),
        createBaseVNode("div", {
          class: "shaker-selection__refresh-icon",
          innerHTML: _ctx.initalData.htmlSnippets.icons.refresh
        }, null, 8, _hoisted_6$2)
      ]),
      createBaseVNode("div", _hoisted_7$1, [
        _ctx.initalData.images.shakerBottom ? (openBlock(), createElementBlock("div", _hoisted_8$1)) : createCommentVNode("", true),
        _ctx.initalData.images.shakerBottom ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
          _ctx.initalData.images.shakerBottom ? (openBlock(), createElementBlock("img", {
            key: 0,
            class: "shaker-selection__bottom-image",
            src: _ctx.initalData.images.shakerBottom
          }, null, 8, _hoisted_10$1)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createBaseVNode("div", _hoisted_11$1, toDisplayString(_ctx.initalData.translations.moreShakers), 1)
      ])
    ]),
    createVNode(_component_ModalWindow, {
      modelValue: $data.isModalOpen,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.isModalOpen = $event)
    }, {
      default: withCtx(() => [
        createBaseVNode("div", _hoisted_12$1, [
          createBaseVNode("h3", _hoisted_13$1, toDisplayString(_ctx.initalData.translations.chooseYourShaker), 1),
          createVNode(_component_Tabs, null, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList($options.shakersCollections, (collection, idx) => {
                return openBlock(), createBlock(_component_Tab, {
                  title: collection.title,
                  key: idx
                }, {
                  default: withCtx(() => [
                    createBaseVNode("div", _hoisted_14$1, [
                      (openBlock(true), createElementBlock(Fragment, null, renderList($options.getCollectionVariants(collection), (shakerVariant, idx2) => {
                        return openBlock(), createBlock(_component_ShakerCard, {
                          key: idx2,
                          onClick: ($event) => shakerVariant.available ? $options.selectShaker(shakerVariant) : null,
                          productVariant: shakerVariant,
                          selected: $data._selectedShaker.id == shakerVariant.id
                        }, null, 8, ["onClick", "productVariant", "selected"]);
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1032, ["title"]);
              }), 128))
            ]),
            _: 1
          }),
          createBaseVNode("div", _hoisted_15$1, [
            createBaseVNode("div", _hoisted_16$1, [
              createBaseVNode("span", _hoisted_17$1, toDisplayString(_ctx.initalData.translations.currentTotal), 1),
              createBaseVNode("span", _hoisted_18$1, toDisplayString(_ctx.prices.formatted.discountTotal), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]);
}
const ShakerSelection = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4]]);
const _sfc_main$3 = {
  name: "Gift",
  props: {
    productVariant: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      initalData: "getInitialData",
      selectedGiftVariantId: "getSelectedGiftVariantId",
      giftsLocked: "areGiftsLocked"
    }),
    product() {
      return this.initalData.config.variantAndProductIndex.productsById[this.productVariant.productId];
    },
    isLocked() {
      return this.giftsLocked;
    },
    lockIconSrc() {
      var _a;
      return ((_a = this.initalData.images) == null ? void 0 : _a.giftLockIcon) || "";
    },
    imageSrc() {
      var _a, _b, _c, _d, _e;
      if ((_b = (_a = this.productVariant) == null ? void 0 : _a.featured_image) == null ? void 0 : _b.src) {
        return this.productVariant.featured_image.src;
      }
      if (((_c = this.productVariant) == null ? void 0 : _c.featured_image) && typeof this.productVariant.featured_image === "string") {
        return this.productVariant.featured_image;
      }
      return (_e = (_d = this.product) == null ? void 0 : _d.images) == null ? void 0 : _e[0];
    },
    displayImageSrc() {
      return this.isLocked ? this.lockIconSrc : this.imageSrc;
    },
    lockedMessage() {
      var _a, _b;
      return ((_b = (_a = this.initalData) == null ? void 0 : _a.translations) == null ? void 0 : _b.giftsLockedMessage) || "";
    },
    title() {
      var _a;
      return (_a = this.productVariant) == null ? void 0 : _a.title;
    },
    subtitle() {
      var _a;
      return (_a = this.product) == null ? void 0 : _a.title;
    },
    isAvailable() {
      return this.productVariant.available === true;
    },
    isSelected() {
      return this.selectedGiftVariantId === this.productVariant.id;
    }
  },
  methods: {
    selectGift() {
      if (!this.isAvailable || this.isLocked) return;
      this.$store.commit("SET_SELECTED_GIFT_VARIANT_ID", this.productVariant.id);
    }
  }
};
const _hoisted_1$3 = ["tabindex", "aria-disabled", "aria-pressed"];
const _hoisted_2$1 = ["src", "alt"];
const _hoisted_3$1 = { class: "samplebox-texts" };
const _hoisted_4$1 = { class: "samplebox-title" };
const _hoisted_5$1 = {
  key: 0,
  class: "samplebox-subtitle"
};
const _hoisted_6$1 = {
  key: 0,
  class: "gift-locked-message"
};
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["samplebox-line gift-line", {
      "gift-line--selected": $options.isSelected && $options.isAvailable && !$options.isLocked,
      "gift-line--disabled": !$options.isAvailable,
      "gift-line--locked": $options.isLocked
    }]),
    role: "button",
    tabindex: $options.isAvailable && !$options.isLocked ? 0 : -1,
    "aria-disabled": !$options.isAvailable || $options.isLocked,
    "aria-pressed": $options.isSelected && $options.isAvailable && !$options.isLocked,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.selectGift && $options.selectGift(...args)),
    onKeydown: [
      _cache[1] || (_cache[1] = withKeys(withModifiers((...args) => $options.selectGift && $options.selectGift(...args), ["prevent"]), ["enter"])),
      _cache[2] || (_cache[2] = withKeys(withModifiers((...args) => $options.selectGift && $options.selectGift(...args), ["prevent"]), ["space"]))
    ]
  }, [
    createBaseVNode("img", {
      class: normalizeClass(["samplebox-image", { "samplebox-image--lock": $options.isLocked }]),
      src: $options.displayImageSrc,
      alt: $options.isLocked ? "Locked" : $options.title
    }, null, 10, _hoisted_2$1),
    createBaseVNode("div", _hoisted_3$1, [
      createBaseVNode("span", _hoisted_4$1, toDisplayString($options.title), 1),
      $options.subtitle ? (openBlock(), createElementBlock("p", _hoisted_5$1, toDisplayString($options.subtitle), 1)) : createCommentVNode("", true)
    ]),
    $options.isLocked && $options.lockedMessage ? (openBlock(), createElementBlock("div", _hoisted_6$1, toDisplayString($options.lockedMessage), 1)) : createCommentVNode("", true)
  ], 42, _hoisted_1$3);
}
const Gift = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
const _sfc_main$2 = {
  name: "ProductUsp",
  computed: {
    ...mapGetters({
      initalData: "getInitialData"
    })
  },
  mounted() {
    this.initPaypalBadge();
  },
  methods: {
    initPaypalBadge() {
      const waitFor = (testFn, successFn, repeat = false, timeout = 1e4, interval = 25) => {
        if (timeout < 0) return;
        if (testFn()) {
          successFn();
        } else {
          setTimeout(() => {
            repeat ? waitFor(testFn, successFn, repeat, timeout, interval) : waitFor(testFn, successFn, repeat, timeout - interval, interval);
          }, interval);
        }
      };
      const q = (sel, scope = document) => scope.querySelector(sel);
      const insert = (target, position, element, exists) => {
        if (!target || exists) return;
        typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
      };
      const EXPID = "HLY-7";
      const VAR = "1";
      const testInfo = () => {
        window.runningExperiments = window.runningExperiments || {};
        window.runningExperiments[EXPID] = {
          name: "Add paypal badge to USP section on PDP",
          variation: `${VAR}`,
          logs: []
        };
        waitFor(
          () => q("body"),
          () => {
            q("body").classList.add(`${EXPID}`);
          }
        );
      };
      const insertPaypalSection = () => {
        const paypalSVG = `
          <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
            <path d="M15.1658 9.84595C14.9826 9.8461 14.8055 9.91158 14.6662 10.0306C14.5269 10.1497 14.4347 10.3145 14.406 10.4955L13.1436 18.5026C13.2024 18.1287 13.5246 17.8531 13.9034 17.8531H17.6028C21.3261 17.8531 24.4854 15.137 25.0627 11.4562C25.1057 11.1814 25.13 10.9041 25.1356 10.626C24.1894 10.1298 23.0779 9.84595 21.86 9.84595H15.1658Z" fill="#001C64"/>
            <path d="M25.1358 10.6265C25.1302 10.9045 25.1059 11.1819 25.0629 11.4567C24.4856 15.1375 21.326 17.8536 17.603 17.8536H13.9035C13.5251 17.8536 13.2026 18.1289 13.1437 18.5031L11.9829 25.861L11.2558 30.477C11.2416 30.5662 11.2469 30.6574 11.2714 30.7443C11.2959 30.8312 11.3389 30.9118 11.3976 30.9805C11.4562 31.0491 11.5291 31.1043 11.6111 31.1421C11.6931 31.1798 11.7823 31.1994 11.8726 31.1994H15.8881C16.0713 31.1992 16.2485 31.1337 16.3877 31.0147C16.527 30.8956 16.6193 30.7308 16.6479 30.5498L17.7056 23.8414C17.7342 23.6604 17.8266 23.4955 17.966 23.3764C18.1054 23.2573 18.2827 23.1919 18.466 23.1919H20.8301C24.5534 23.1919 27.7127 20.4758 28.29 16.795C28.7 14.1827 27.3843 11.8054 25.1358 10.6265Z" fill="#0070E0"/>
            <path d="M10.6041 4.50854C10.2257 4.50854 9.90319 4.78381 9.84433 5.15748L6.6933 25.1385C6.63355 25.5178 6.92666 25.8609 7.31073 25.8609H11.9835L13.1437 18.5029L14.4062 10.4958C14.4348 10.3148 14.5271 10.15 14.6663 10.0309C14.8056 9.91189 14.9828 9.8464 15.166 9.84625H21.8601C23.0783 9.84625 24.1895 10.1304 25.1357 10.6263C25.2005 7.2752 22.4353 4.50854 18.6336 4.50854H10.6041Z" fill="#003087"/>
          </svg>
        `;
        const paypalSection = `
          <div class="${EXPID}__paypal-container text_content text_content--usp text_content--full">
            <div class="${EXPID}__paypal-visible-section" style="display: flex;">
              <div class="${EXPID}__svg">${paypalSVG}</div>
              <div class="${EXPID}__paypal-text">Bezahle nach <br> 30 Tagen</div>
            </div>
            <div id="${EXPID}__paypal-section">
              <div style="text-align:center" 
                data-pp-message
                data-pp-buyerCountry="DE"
                data-pp-amount="10.99"
                data-pp-placement="cart"
                data-pp-style-layout="text"
                data-pp-style-logo-type="alternative"
                data-pp-style-text-color="black"
                data-pp-style-text-size="10"
                data-pp-style-text-align="right">
              </div>
            </div>
          </div>`;
        const script = document.createElement("script");
        script.setAttribute(
          "src",
          "https://www.paypal.com/sdk/js?client-id=AQMcCMPtGI5E_PtXfx-geaeFabK2E9Bd87VHtWjV4ryNgh8ZGvQ2B5_4DD0PZYsJAlQgrE-RBmE_tp2v&locale=de_DE&components=messages&enable-funding=paylater"
        );
        script.setAttribute("data-namespace", "paypal_sdk");
        waitFor(
          () => q("head") && q(".product-form .delivery_text"),
          () => {
            insert(q("head"), "beforeend", script, q('script[src*="paypal.com/sdk/js"]'));
            insert(q(".product-form .delivery_text"), "afterbegin", paypalSection, q(`.${EXPID}__paypal-container`));
          }
        );
      };
      waitFor(
        () => document.querySelector("[data-pay-pal-badge]"),
        () => {
          const el = document.querySelector("[data-pay-pal-badge]");
          if (el && el.getAttribute("data-pay-pal-badge") === "true") {
            testInfo();
            insertPaypalSection();
          }
        },
        true
      );
    }
  }
};
const _hoisted_1$2 = ["innerHTML"];
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    innerHTML: _ctx.initalData.htmlSnippets.usp
  }, null, 8, _hoisted_1$2);
}
const ProducUsp = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
const _sfc_main$1 = {
  name: "ProducAccordion",
  computed: {
    ...mapGetters({
      product: "getSelectionRelatedProduct"
    })
  }
};
const _hoisted_1$1 = ["innerHTML"];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b;
  return ((_a = _ctx.product) == null ? void 0 : _a.accordionHtml) ? (openBlock(), createElementBlock("div", {
    key: 0,
    innerHTML: (_b = _ctx.product) == null ? void 0 : _b.accordionHtml
  }, null, 8, _hoisted_1$1)) : createCommentVNode("", true);
}
const ProductAccordion = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
const _sfc_main = {
  name: "BundleBuilder",
  data() {
    return {
      originalDeliveryHtml: null
      // Store original HTML of the delivery message
    };
  },
  methods: {
    /**
     * 1. Gets line items from the cart
     * 2. Updates their properties with the '_bundle_index' property but starts from 1
     * 3. Line item with the _bundle_type: "starter_powder" is that what we are looking for
     */
    async setBundleIndexesForLineItems() {
      try {
        const cartResponse = await fetch("/cart.js");
        const cart = await cartResponse.json();
        const starterPowders = cart.items.filter(
          (item) => item.properties && item.properties._bundle_type === "starter_powder"
        );
        for (let i = 0; i < starterPowders.length; i++) {
          const item = starterPowders[i];
          const newProperties = {
            ...item.properties,
            _bundle_index: i + 1
          };
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: item.key,
              properties: newProperties,
              quantity: item.quantity
            })
          });
        }
        console.log(`✅ Updated ${starterPowders.length} starter_powder items with bundle indexes`);
      } catch (error) {
        console.error("❌ Error updating bundle indexes:", error);
      }
    },
    async addToCart() {
      if (this.atcDisabled) return;
      const orderTimestamp = (/* @__PURE__ */ new Date()).getTime();
      if (!this.prices.unformatted.total) {
        return;
      }
      const items = JSON.parse(JSON.stringify(this.atcPayload));
      items.forEach((item) => {
        item.properties = item.properties || {};
        item.properties._bundleBuilderTimestamp = orderTimestamp;
      });
      const formData = {
        "items": items
      };
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
      const responseJson = await response.json();
      if (response.ok) {
        try {
          this.setCookie("bundle_added", "true", 1);
          console.log("✅ Bundle added - cookie bundle_added set to true");
        } catch (error) {
          console.error("❌ Error setting bundle_added cookie:", error);
        }
        document.documentElement.dispatchEvent(new CustomEvent("variant:added", {
          bubbles: true,
          detail: {
            variant: responseJson.hasOwnProperty("items") ? responseJson["items"][0] : responseJson
          }
        }));
        await fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
          cartContent["sections"] = responseJson["sections"];
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: true
            }
          }));
        });
      }
      document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: response.ok ? "success" : "error",
          error: responseJson["description"] || ""
        }
      }));
      await this.setBundleIndexesForLineItems();
    },
    async instantCheckout() {
      if (this.atcDisabled) return;
      await this.addToCart();
      await this.setBundleIndexesForLineItems();
      window.location.href = "/checkout";
    },
    setCookie(key, value, daysToExpire = 1) {
      const expirationDate = /* @__PURE__ */ new Date();
      expirationDate.setTime(expirationDate.getTime() + daysToExpire * 24 * 60 * 60 * 1e3);
      const expires = "expires=" + expirationDate.toUTCString();
      document.cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
    },
    getCookie(key) {
      const name = key + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookieArray = decodedCookie.split(";");
      for (let i = 0; i < cookieArray.length; i++) {
        const cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
      return "";
    },
    updateDeliveryMessage() {
      const deliveryElement = this.$refs.deliveryMessage;
      if (!deliveryElement) {
        return;
      }
      if (!this.originalDeliveryHtml) {
        this.originalDeliveryHtml = deliveryElement.innerHTML;
      }
      const deliveryDays = this.selectedSampleBoxesDeliveryDays;
      if (!deliveryDays) {
        if (this.originalDeliveryHtml) {
          deliveryElement.innerHTML = this.originalDeliveryHtml;
        }
        return;
      }
      let html = this.originalDeliveryHtml || deliveryElement.innerHTML;
      const pattern = /\d+-\d+/g;
      if (pattern.test(html)) {
        pattern.lastIndex = 0;
        const newHtml = html.replace(pattern, String(deliveryDays));
        deliveryElement.innerHTML = newHtml;
      }
    }
  },
  computed: {
    ...mapGetters({
      initialData: "getInitialData",
      prices: "getPrices",
      atcPayload: "getAddToCartPayload",
      selectedSampleBoxesQuantity: "getSelectedBoxesCount",
      nextSbPrice: "getNextSbPrice",
      areGiftsLocked: "areGiftsLocked"
    }),
    sampleBoxesProducts() {
      return this.initialData.config.sampleBoxesProducts;
    },
    sampleBoxesVariants() {
      var _a;
      return (_a = this.sampleBoxesProducts.map((product) => {
        const variants = product.variants;
        const sampleBoxSubtitle = product == null ? void 0 : product.sampleBoxSubtitle;
        variants[0].sampleBoxSubtitle = sampleBoxSubtitle;
        return variants;
      })) == null ? void 0 : _a.flat();
    },
    hasGifts() {
      return this.initialData.config.gifts && this.initialData.config.gifts.length > 0;
    },
    giftsVariants() {
      if (!this.hasGifts) return [];
      return this.initialData.config.gifts;
    },
    giftsLabel() {
      return this.initialData.config.giftsLabel || this.initialData.translations.boxesHeading;
    },
    shakerHeading() {
      return this.initialData.translations.shakersHeading;
    },
    atcDisabled() {
      if (this.hasGifts) {
        if (this.$store.getters.areGiftsLocked) {
          return !this.selectedSampleBoxesQuantity;
        }
        return !this.$store.getters.getSelectedGiftVariantId;
      }
      return !this.selectedSampleBoxesQuantity;
    },
    pricePerDrinkMessage() {
      const price = this.prices.formatted.perPortionDiscounted || this.prices.formatted.perPortion;
      const message = this.initialData.translations.perDrink.replace("{{ price }}", price);
      return message;
    },
    selectedSampleBoxesDeliveryDays() {
      const selectedVariantIds = Object.keys(this.$store.state.selectedBoxesVariantsIds || {}).filter((variantId) => this.$store.state.selectedBoxesVariantsIds[variantId] > 0);
      if (selectedVariantIds.length === 0) return null;
      const deliveryDays = selectedVariantIds.map((variantId) => {
        const variant = this.$store.getters.getVariantById(variantId);
        if (!variant) return null;
        const product = this.$store.getters.getProductById(variant.productId);
        return (product == null ? void 0 : product.deliveryDays) || null;
      }).filter((days) => days !== null);
      if (deliveryDays.length === 0) return null;
      const stringDays = deliveryDays.filter((d) => typeof d === "string");
      if (stringDays.length > 0) {
        return stringDays[0];
      }
      const numberDays = deliveryDays.filter((d) => typeof d === "number");
      if (numberDays.length > 0) {
        return Math.max(...numberDays);
      }
      return null;
    },
    nextBoxPriceMessage() {
      var _a, _b, _c;
      const template2 = (_b = (_a = this.initialData) == null ? void 0 : _a.translations) == null ? void 0 : _b.nextBoxPriceTemplate;
      if (!template2 || typeof template2 !== "string") return null;
      const trimmed = template2.trim();
      if (!trimmed) return null;
      const price = (_c = this.nextSbPrice) == null ? void 0 : _c.formatted;
      if (!price) return null;
      return trimmed.split("{price}").join(String(price));
    }
  },
  watch: {
    areGiftsLocked(newLocked, oldLocked) {
      if (!this.hasGifts) return;
      if (newLocked === false && oldLocked === true && !this.$store.getters.getSelectedGiftVariantId) {
        const firstAvailable = this.giftsVariants.find((g) => g.available === true);
        if (firstAvailable) {
          this.$store.commit("SET_SELECTED_GIFT_VARIANT_ID", firstAvailable.id);
        }
      }
    },
    selectedSampleBoxesQuantity(newVal, oldVal) {
      this.$nextTick(() => {
        this.updateDeliveryMessage();
      });
      if (!this.hasGifts) return;
      if (this.$store.getters.areGiftsLocked) {
        if (this.$store.getters.getSelectedGiftVariantId) {
          this.$store.commit("SET_SELECTED_GIFT_VARIANT_ID", null);
        }
      } else if (!this.$store.getters.getSelectedGiftVariantId) {
        const firstAvailable = this.giftsVariants.find((g) => g.available === true);
        if (firstAvailable) {
          this.$store.commit("SET_SELECTED_GIFT_VARIANT_ID", firstAvailable.id);
        }
      }
    },
    "$store.state.selectedBoxesVariantsIds": {
      handler() {
        this.$nextTick(() => {
          this.updateDeliveryMessage();
        });
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateDeliveryMessage();
    });
  },
  components: {
    ProductMedia,
    ProductMeta,
    SampleBox,
    ShakerSelection,
    Gift,
    ProducUsp,
    ProductAccordion
  }
};
const _hoisted_1 = { class: "conatiner-inner" };
const _hoisted_2 = { class: "left-column" };
const _hoisted_3 = { class: "right-column" };
const _hoisted_4 = { class: "boxes-and-shakers-column" };
const _hoisted_5 = { class: "sample-boxes-wrapper" };
const _hoisted_6 = { class: "product-category-heading" };
const _hoisted_7 = { class: "sample-boxes-container" };
const _hoisted_8 = { class: "shaker-wrapper" };
const _hoisted_9 = { class: "product-category-heading" };
const _hoisted_10 = { class: "shaker-container" };
const _hoisted_11 = {
  key: 0,
  class: "gifts-wrapper"
};
const _hoisted_12 = { class: "product-category-heading" };
const _hoisted_13 = { class: "gifts-container" };
const _hoisted_14 = { class: "price-card" };
const _hoisted_15 = {
  key: 0,
  class: "price-card__next-sb-price show-on-desktop"
};
const _hoisted_16 = { class: "price-wrapper" };
const _hoisted_17 = { class: "price-wrapper__left-column" };
const _hoisted_18 = {
  key: 0,
  class: "price-card__next-sb-price show-on-mobile"
};
const _hoisted_19 = { class: "price-card__subheading show-on-desktop" };
const _hoisted_20 = { class: "price-wrapper__right-column" };
const _hoisted_21 = { class: "price-card__heading" };
const _hoisted_22 = { class: "price-card__buttons" };
const _hoisted_23 = ["disabled"];
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = { class: "price-card__atc_inner-" };
const _hoisted_26 = ["innerHTML", "disabled"];
const _hoisted_27 = ["innerHTML"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _a, _b, _c, _d;
  const _component_ProductMedia = resolveComponent("ProductMedia");
  const _component_ProductMeta = resolveComponent("ProductMeta");
  const _component_SampleBox = resolveComponent("SampleBox");
  const _component_ShakerSelection = resolveComponent("ShakerSelection");
  const _component_Gift = resolveComponent("Gift");
  const _component_ProducUsp = resolveComponent("ProducUsp");
  const _component_ProductAccordion = resolveComponent("ProductAccordion");
  return openBlock(), createElementBlock("div", _hoisted_1, [
    createBaseVNode("div", _hoisted_2, [
      createVNode(_component_ProductMedia)
    ]),
    createBaseVNode("div", _hoisted_3, [
      createVNode(_component_ProductMeta),
      createBaseVNode("div", _hoisted_4, [
        createBaseVNode("div", _hoisted_5, [
          createBaseVNode("h2", _hoisted_6, toDisplayString(_ctx.initialData.translations.boxesHeading), 1),
          createBaseVNode("div", _hoisted_7, [
            (openBlock(true), createElementBlock(Fragment, null, renderList($options.sampleBoxesVariants, (variant, idx) => {
              return openBlock(), createBlock(_component_SampleBox, {
                key: idx,
                productVariant: variant
              }, null, 8, ["productVariant"]);
            }), 128))
          ])
        ]),
        createBaseVNode("div", _hoisted_8, [
          createBaseVNode("h2", _hoisted_9, toDisplayString($options.shakerHeading), 1),
          createBaseVNode("div", _hoisted_10, [
            createVNode(_component_ShakerSelection)
          ])
        ])
      ]),
      $options.hasGifts ? (openBlock(), createElementBlock("div", _hoisted_11, [
        createBaseVNode("h2", _hoisted_12, toDisplayString($options.giftsLabel), 1),
        createBaseVNode("div", _hoisted_13, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($options.giftsVariants, (giftVariant, idx) => {
            return openBlock(), createBlock(_component_Gift, {
              key: idx,
              productVariant: giftVariant
            }, null, 8, ["productVariant"]);
          }), 128))
        ])
      ])) : createCommentVNode("", true),
      createVNode(_component_ProducUsp),
      createVNode(_component_ProductAccordion),
      createBaseVNode("div", _hoisted_14, [
        $options.nextBoxPriceMessage ? (openBlock(), createElementBlock("p", _hoisted_15, toDisplayString($options.nextBoxPriceMessage), 1)) : createCommentVNode("", true),
        createBaseVNode("div", _hoisted_16, [
          createBaseVNode("div", _hoisted_17, [
            $options.nextBoxPriceMessage ? (openBlock(), createElementBlock("p", _hoisted_18, toDisplayString($options.nextBoxPriceMessage), 1)) : createCommentVNode("", true),
            withDirectives(createBaseVNode("span", { class: "price-card__heading show-on-desktop" }, toDisplayString(_ctx.initialData.translations.youSave) + " " + toDisplayString(_ctx.prices.formatted.discountAmount), 513), [
              [vShow, _ctx.prices.unformatted.discountAmount > 0]
            ]),
            createBaseVNode("span", _hoisted_19, toDisplayString($options.pricePerDrinkMessage), 1)
          ]),
          createBaseVNode("div", _hoisted_20, [
            createBaseVNode("span", _hoisted_21, toDisplayString(_ctx.prices.formatted.discountTotal), 1),
            withDirectives(createBaseVNode("span", { class: "price-card__crossed price-card__subheading" }, toDisplayString(_ctx.prices.formatted.total), 513), [
              [vShow, _ctx.prices.unformatted.total > _ctx.prices.unformatted.discountTotal]
            ])
          ])
        ]),
        createBaseVNode("div", _hoisted_22, [
          createBaseVNode("button", {
            disabled: $options.atcDisabled,
            class: "price-card__atc",
            onClick: _cache[0] || (_cache[0] = (...args) => $options.addToCart && $options.addToCart(...args))
          }, [
            createBaseVNode("div", {
              class: "bb-box__checkout-button_svg-wrapper",
              innerHTML: _ctx.initialData.htmlSnippets.icons.cart
            }, null, 8, _hoisted_24),
            createBaseVNode("span", _hoisted_25, toDisplayString(_ctx.initialData.translations.atc), 1)
          ], 8, _hoisted_23),
          ((_b = (_a = _ctx.initialData) == null ? void 0 : _a.config) == null ? void 0 : _b.showPayWithPaypal) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "price-card__paypal",
            innerHTML: _ctx.initialData.htmlSnippets.paypal,
            disabled: $options.atcDisabled,
            onClick: _cache[1] || (_cache[1] = (...args) => $options.instantCheckout && $options.instantCheckout(...args))
          }, null, 8, _hoisted_26)) : createCommentVNode("", true),
          ((_d = (_c = _ctx.initialData) == null ? void 0 : _c.config) == null ? void 0 : _d.showGetItTomorrow) ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: "price-card__delivery",
            ref: "deliveryMessage",
            innerHTML: _ctx.initialData.htmlSnippets.getItTomorrow
          }, null, 8, _hoisted_27)) : createCommentVNode("", true)
        ])
      ])
    ])
  ]);
}
const App = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
function sortBySpecificShakersFirst(arr) {
  return arr.sort((a, b) => {
    var _a, _b, _c, _d, _e, _f;
    const aHasShakers = Array.isArray((_a = a.metafields) == null ? void 0 : _a.specificShakers) && a.metafields.specificShakers.length > 0;
    const bHasShakers = Array.isArray((_b = b.metafields) == null ? void 0 : _b.specificShakers) && b.metafields.specificShakers.length > 0;
    const aBoxesCount = Array.isArray((_d = (_c = a.metafields) == null ? void 0 : _c.children) == null ? void 0 : _d.boxesVariantsIds) ? a.metafields.children.boxesVariantsIds.length : 0;
    const bBoxesCount = Array.isArray((_f = (_e = b.metafields) == null ? void 0 : _e.children) == null ? void 0 : _f.boxesVariantsIds) ? b.metafields.children.boxesVariantsIds.length : 0;
    if (aHasShakers && !bHasShakers) return -1;
    if (!aHasShakers && bHasShakers) return 1;
    return bBoxesCount - aBoxesCount;
  });
}
function getPreselectedVariantsIds(data) {
  var _a, _b, _c, _d, _e;
  const urlParams = new URLSearchParams(window.location.search);
  const preselectParam = urlParams.get("preselect");
  const variantIds = preselectParam ? preselectParam.split(",").map((id) => id.trim()) : [];
  if (variantIds.length) return variantIds;
  const preselectProductId = data.preselectProductId;
  if (!preselectProductId) return variantIds;
  const preselectProduct = data.config.preselectProducts.find(({ product }) => product.id == preselectProductId);
  if (!preselectProduct) return variantIds;
  const preselectedBoxesVariantsIds = ((_b = (_a = preselectProduct.metafields) == null ? void 0 : _a.children) == null ? void 0 : _b.boxesVariantsIds) || [];
  const preselectedShakersVariantsIds = ((_d = (_c = preselectProduct.metafields) == null ? void 0 : _c.children) == null ? void 0 : _d.shakersVariantsIds) || [];
  const preselectedSpecificShakersVariantsIds = ((_e = preselectProduct.metafields) == null ? void 0 : _e.specificShakers) || [];
  variantIds.push(
    ...preselectedBoxesVariantsIds,
    ...preselectedShakersVariantsIds,
    ...preselectedSpecificShakersVariantsIds
  );
  const uniqueVariantIds = Array.from(new Set(variantIds));
  if (uniqueVariantIds.length) {
    urlParams.set("preselect", uniqueVariantIds.join(","));
    window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);
  }
  return uniqueVariantIds;
}
function buildVariantAndProductIndex(config) {
  const variantsById = {};
  const productsById = {};
  const allProducts = [...config.sampleBoxesProducts];
  const shakers = [];
  config.shakersCollections.forEach((collection) => {
    allProducts.push(...collection.products);
    shakers.push(...collection.products);
  });
  config.shakersProducts = shakers;
  if (config.gifts && config.gifts.length > 0) {
    config.gifts.forEach((giftVariant) => {
      var _a;
      if (!giftVariant.productId && ((_a = giftVariant.product) == null ? void 0 : _a.id)) {
        giftVariant.productId = giftVariant.product.id;
      }
      const giftPortions = giftVariant.portions;
      if (giftPortions != null && giftVariant.product) {
        giftVariant.product.portions = giftPortions;
      }
      variantsById[giftVariant.id] = giftVariant;
      if (giftVariant.productId && !productsById[giftVariant.productId]) {
        let giftProduct = allProducts.find((p2) => p2.id === giftVariant.productId);
        if (!giftProduct && giftVariant.product) {
          giftProduct = giftVariant.product;
          allProducts.push(giftProduct);
        }
        if (giftProduct) {
          if (giftPortions != null) {
            giftProduct.portions = giftPortions;
          }
          productsById[giftVariant.productId] = giftProduct;
        }
      } else if (giftVariant.productId && giftPortions != null) {
        const existing = productsById[giftVariant.productId];
        if (existing) existing.portions = giftPortions;
      }
    });
  }
  allProducts.forEach((product) => {
    productsById[product.id] = product;
    product.variants.forEach((variant) => {
      variant.productId = product.id;
      variant.isSampleBox = config.sampleBoxesProducts.some((p2) => p2.id === product.id);
      variant.isShaker = config.shakersProducts.some((p2) => p2.id === product.id);
      variantsById[variant.id] = variant;
    });
  });
  if (config.gifts && config.gifts.length > 0) {
    config.gifts.forEach((gv) => {
      const v = variantsById[gv.id];
      if (!v) return;
      if (gv.portions != null) {
        v.portions = gv.portions;
      }
    });
  }
  return { variantsById, productsById };
}
function formatDiscountsList(discounts) {
  var _a, _b;
  const sampleBoxesThresholds = [];
  const shakersDiscounts = [];
  (_a = discounts == null ? void 0 : discounts.sampleBoxesThresholds) == null ? void 0 : _a.forEach((discount) => {
    sampleBoxesThresholds.push({
      discountAmount: +discount.discount_amount,
      quantity: +discount.quantity
    });
  });
  (_b = discounts == null ? void 0 : discounts.shakerDiscounts) == null ? void 0 : _b.forEach((discount) => {
    var _a2, _b2;
    shakersDiscounts.push({
      discountAmount: +discount.discount_amount,
      collectionId: (_b2 = (_a2 = discount.collection) == null ? void 0 : _a2.split("/")) == null ? void 0 : _b2.pop()
    });
  });
  sampleBoxesThresholds.sort((a, b) => a.quantity - b.quantity);
  return {
    sampleBoxesThresholds,
    shakersDiscounts
  };
}
function formatShakersProducts(config) {
  config.shakersCollections.forEach((collection) => {
    collection.products.forEach((product) => {
      product.variants = product.variantsWithMetafields;
      delete product.variantsWithMetafields;
    });
  });
}
const bundleBuilderInit = (selectors2) => {
  var _a, _b;
  const jsonData = (_a = document.querySelector(selectors2.json)) == null ? void 0 : _a.textContent;
  let data;
  try {
    data = jsonData ? JSON.parse(jsonData) : null;
  } catch (error) {
    console.error("Error parsing JSON data for bundle builder:", error);
    return;
  }
  if (!data) return;
  data.config.preselectedVariantsIds = getPreselectedVariantsIds(data);
  data.config.preselectProducts = sortBySpecificShakersFirst(data.config.preselectProducts);
  formatShakersProducts(data.config);
  data.config.variantAndProductIndex = buildVariantAndProductIndex(data.config);
  const currncySymbol = {
    "holyenergypl.myshopify.com": "zł",
    "holyenergyfr.myshopify.com": "€",
    "holyenergy.myshopify.com": "€",
    "holy-uk.myshopify.com": "£"
  };
  const shop = (_b = window.Shopify) == null ? void 0 : _b.shop;
  const moneyFormat = {
    "holyenergypl.myshopify.com": `{{ amount_with_dot_separator }} ${currncySymbol[shop]}`,
    "holyenergyfr.myshopify.com": `${currncySymbol[shop]}{{ amount_with_dot_separator }}`,
    "holyenergy.myshopify.com": `${currncySymbol[shop]}{{ amount_with_dot_separator }}`,
    "holy-uk.myshopify.com": `${currncySymbol[shop]}{{ amount_with_comma_separator }}`
  };
  data.moneyFormat = moneyFormat[shop] || "€{{ amount_with_dot_separator }}";
  const {
    sampleBoxesThresholds,
    shakersDiscounts
  } = formatDiscountsList(data.config.discounts);
  data.config.sampleBoxesThresholds = sampleBoxesThresholds;
  data.config.shakersDiscounts = shakersDiscounts;
  console.log("Bundle Builder init data:", data);
  const vuexStore = store(data);
  const app = createApp(App);
  app.use(vuexStore);
  app.config.devtools = true;
  app.mount(selectors2.app);
};
const selectors$2 = {
  videoDesktop: "ds-hero-featured-video",
  videoMobile: "ds-hero-featured-video-mobile"
};
class FeaturedVideo {
  constructor(sectionEl) {
    __publicField(this, "handleResize", () => {
      const wasDesktop = this.isDesktop;
      const isNowDesktop = window.innerWidth >= this.mediaRules.desktop;
      if (isNowDesktop === wasDesktop) return;
      this.isDesktop = isNowDesktop;
      ["videoDesktop", "videoMobile"].forEach((key) => {
        const v = this.elements[key];
        if (v) v.pause();
      });
      this.initPlaybackTrigger();
    });
    this.section = sectionEl;
    this.elements = {
      videoDesktop: sectionEl.querySelector(`#${selectors$2.videoDesktop}`),
      videoMobile: sectionEl.querySelector(`#${selectors$2.videoMobile}`)
    };
    if (!this.elements.videoDesktop && !this.elements.videoMobile) return;
    this.videoTriggers = { hover: "hover", view: "view" };
    this.mediaRules = { desktop: 1e3 };
    this.isDesktop = window.innerWidth >= this.mediaRules.desktop;
    this.isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const triggerSource = this.elements.videoDesktop || this.elements.videoMobile;
    this.triggerDesktop = triggerSource ? triggerSource.getAttribute("data-trigger") : this.videoTriggers.view;
    this.initPlaybackTrigger();
    window.addEventListener("resize", this.handleResize);
  }
  // helper: currently active video given current breakpoint
  getActiveVideo() {
    if (this.isDesktop) {
      return this.elements.videoDesktop || this.elements.videoMobile;
    }
    return this.elements.videoMobile || this.elements.videoDesktop;
  }
  initPlaybackTrigger() {
    this.removeTriggerHandlers();
    if (this.isTouchDevice || !this.isDesktop) {
      this.launchVideoInView();
    } else {
      this.triggerDesktop === this.videoTriggers.hover ? this.launchVideoOnHover() : this.launchVideoInView();
    }
  }
  launchVideoOnHover() {
    const v = this.getActiveVideo();
    if (!v) return;
    this.hoverHandler = () => v.play().catch(() => {
    });
    this.leaveHandler = () => v.pause();
    v.addEventListener("mouseenter", this.hoverHandler);
    v.addEventListener("mouseleave", this.leaveHandler);
  }
  launchVideoInView() {
    const v = this.getActiveVideo();
    if (!v) return;
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target !== this.getActiveVideo()) return;
          const active = this.getActiveVideo();
          if (!active) return;
          if (entry.isIntersecting) {
            active.play().catch(() => {
            });
          } else {
            active.pause();
          }
        });
      },
      { threshold: 0.85 }
    );
    this.observer.observe(v);
  }
  removeTriggerHandlers() {
    ["videoDesktop", "videoMobile"].forEach((key) => {
      const v = this.elements[key];
      if (!v) return;
      if (this.hoverHandler) {
        v.removeEventListener("mouseenter", this.hoverHandler);
      }
      if (this.leaveHandler) {
        v.removeEventListener("mouseleave", this.leaveHandler);
      }
    });
    this.hoverHandler = null;
    this.leaveHandler = null;
    if (this.observer) {
      ["videoDesktop", "videoMobile"].forEach((key) => {
        const v = this.elements[key];
        if (v) this.observer.unobserve(v);
      });
      this.observer.disconnect();
      this.observer = null;
    }
  }
  removeAllEvents() {
    ["videoDesktop", "videoMobile"].forEach((key) => {
      const v = this.elements[key];
      if (v) v.pause();
    });
    this.removeTriggerHandlers();
    window.removeEventListener("resize", this.handleResize);
  }
}
function initializeFeaturedVideos() {
  const sections = document.querySelectorAll('[data-section-type="ds-main-hero-component"]');
  if (!sections.length) return;
  sections.forEach((section) => {
    new FeaturedVideo(section);
  });
}
initializeFeaturedVideos();
const selectors$1 = {
  imageLabelElement: ".image-label__wrapper",
  imageLabelContent: ".image-label",
  radioButton: ".collection-block-swatch__radio",
  productItem: ".product-item",
  primaryImage: ".product-item__primary-image",
  imageWrapper: ".product-item__image-wrapper > a",
  aspectRatio: ".product-item__aspect-ratio",
  variantLabelsContainer: ".ds-labels__variant-tags",
  descriptionContainer: ".product_info_description_",
  imageWrapperContainer: ".product-item__image-wrapper"
};
function decodeHtmlEntities(htmlString) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  return tempDiv.innerHTML || htmlString;
}
function decodeHtmlEntitiesToText(htmlString) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  return tempDiv.textContent || tempDiv.innerText || htmlString;
}
function generateSrcset(baseUrl, existingParams, sizes) {
  const srcsetParts = sizes.map((size) => {
    let url = `${baseUrl}?width=${size}`;
    if (existingParams) {
      const paramsWithoutWidth = existingParams.split("&").filter((param) => !param.startsWith("width=")).join("&");
      if (paramsWithoutWidth) {
        url += `&${paramsWithoutWidth}`;
      }
    }
    return `${url} ${size}w`;
  });
  return srcsetParts.join(", ");
}
function showLoadingPlaceholder(productImage, parentContainer) {
  if (!productImage || !parentContainer) return;
  const aspectRatio = productImage.closest(selectors$1.aspectRatio);
  if (aspectRatio) {
    aspectRatio.classList.add("is-loading");
  }
  const originalSrc = productImage.src;
  productImage.dataset.originalSrc = originalSrc;
  productImage.style.opacity = "0.5";
  productImage.style.filter = "blur(2px)";
  productImage.style.transition = "opacity 0.2s ease, filter 0.2s ease";
}
function hideLoadingPlaceholder(productImage, parentContainer) {
  if (!productImage || !parentContainer) return;
  const aspectRatio = productImage.closest(selectors$1.aspectRatio);
  if (aspectRatio) {
    aspectRatio.classList.remove("is-loading");
  }
  productImage.style.opacity = "1";
  productImage.style.filter = "none";
  productImage.style.transition = "opacity 0.3s ease, filter 0.3s ease";
}
function updateProductImage(productImage, variantImageUrl, parentContainer) {
  if (!productImage || !variantImageUrl) return;
  const originalSrc = productImage.src;
  productImage.dataset.originalSrc = originalSrc;
  const decodedUrl = decodeHtmlEntitiesToText(variantImageUrl);
  const urlParts = decodedUrl.split("?");
  const baseUrl = urlParts[0];
  const existingParams = urlParts[1] || "";
  const sizes = [200, 300, 400, 500, 600, 700, 800, 900, 1e3, 1100, 1200];
  const srcset = generateSrcset(baseUrl, existingParams, sizes);
  const handleImageLoad = () => {
    hideLoadingPlaceholder(productImage, parentContainer);
    productImage.removeEventListener("load", handleImageLoad);
    productImage.removeEventListener("error", handleImageError);
  };
  const handleImageError = () => {
    const storedOriginalSrc = productImage.dataset.originalSrc;
    if (storedOriginalSrc) {
      productImage.src = storedOriginalSrc;
    }
    hideLoadingPlaceholder(productImage, parentContainer);
    productImage.removeEventListener("load", handleImageLoad);
    productImage.removeEventListener("error", handleImageError);
  };
  productImage.removeEventListener("load", handleImageLoad);
  productImage.removeEventListener("error", handleImageError);
  productImage.addEventListener("load", handleImageLoad);
  productImage.addEventListener("error", handleImageError);
  showLoadingPlaceholder(productImage, parentContainer);
  productImage.src = decodedUrl;
  productImage.setAttribute("srcset", srcset);
  if (productImage.complete && productImage.naturalWidth > 0) {
    requestAnimationFrame(() => {
      hideLoadingPlaceholder(productImage, parentContainer);
    });
  }
}
function updateProductUrl(productUrl, variantUrl) {
  if (productUrl && variantUrl) {
    productUrl.setAttribute("href", variantUrl);
  }
}
function saveVariantToSession(radio, variantImageUrl) {
  const variantId = radio.getAttribute("data-variant");
  const variantPrice = radio.getAttribute("data-variant-price");
  const variantTitle = radio.getAttribute("data-variant-title");
  const productId = radio.getAttribute("data-product");
  const splitedVariantIndex = radio.getAttribute("data-splited-variant-index");
  if (!variantImageUrl || !variantId || !productId || !variantTitle) {
    return;
  }
  const selectedVariant = {
    featured_media: variantImageUrl,
    id: variantId,
    title: variantTitle,
    price: variantPrice,
    mainId: productId,
    splitedVariantIndex: splitedVariantIndex || null
  };
  sessionStorage.setItem("selectedVariant", JSON.stringify(selectedVariant));
}
function updateImageLabel(radio, parentContainer) {
  const imageLabelContent = radio.getAttribute("data-image-label");
  const imageLabelElement = parentContainer.querySelector(selectors$1.imageLabelElement);
  if (!imageLabelElement) return;
  if (imageLabelContent) {
    const labelContent = imageLabelElement.querySelector(selectors$1.imageLabelContent);
    if (labelContent) {
      labelContent.innerText = imageLabelContent;
    }
    imageLabelElement.classList.remove("hidden");
  } else {
    imageLabelElement.classList.add("hidden");
  }
}
function updateVariantLabels(radio, parentContainer) {
  const labelsContainer = parentContainer.querySelector(selectors$1.variantLabelsContainer);
  if (!labelsContainer) return;
  const labelsHtml = radio.getAttribute("data-variant-labels");
  if (labelsHtml) {
    labelsContainer.innerHTML = decodeHtmlEntities(labelsHtml);
  } else {
    labelsContainer.innerHTML = "";
  }
}
function updateVariantDescription(radio, parentContainer) {
  const descriptionContainer = parentContainer.querySelector(selectors$1.descriptionContainer);
  if (!descriptionContainer) return;
  const descriptionHtml = radio.getAttribute("data-variant-description");
  const defaultDescription = descriptionContainer.getAttribute("data-product-description");
  if (descriptionHtml) {
    const decodedDescription = decodeHtmlEntities(descriptionHtml);
    descriptionContainer.innerHTML = decodedDescription;
    descriptionContainer.classList.remove("hidden");
    return;
  }
  if (defaultDescription) {
    const decodedDefaultDescription = decodeHtmlEntities(defaultDescription);
    descriptionContainer.innerHTML = decodedDefaultDescription;
    descriptionContainer.classList.remove("hidden");
  } else {
    descriptionContainer.innerHTML = "";
    descriptionContainer.classList.add("hidden");
  }
}
function updateVariantBackground(radio, parentContainer) {
  const bgColor = (radio.getAttribute("data-variant-bg-color") || "").trim();
  const defaultBgColor = (parentContainer.getAttribute("data-product-bg-color") || "").trim();
  const imageWrapper = parentContainer.querySelector(selectors$1.imageWrapperContainer);
  const nextBgColor = bgColor && bgColor !== "null" ? bgColor : defaultBgColor && defaultBgColor !== "null" ? defaultBgColor : "";
  if (nextBgColor) {
    parentContainer.style.setProperty("--product-image-background-color", nextBgColor);
    parentContainer.classList.add("ds-product-item__image-background-color");
    if (imageWrapper) {
      imageWrapper.style.background = nextBgColor;
    }
  } else {
    parentContainer.style.removeProperty("--product-image-background-color");
    parentContainer.classList.remove("ds-product-item__image-background-color");
    if (imageWrapper) {
      imageWrapper.style.background = "";
    }
  }
}
function handleVariantChange(radio) {
  const parentContainer = radio.closest(selectors$1.productItem);
  if (!parentContainer) return;
  parentContainer.querySelectorAll(selectors$1.radioButton).forEach((otherRadio) => {
    if (otherRadio !== radio) {
      otherRadio.checked = false;
    }
  });
  radio.checked = true;
  const variantImageUrl = radio.getAttribute("variant-image");
  if (variantImageUrl) {
    const productImage = parentContainer.querySelector(selectors$1.primaryImage);
    updateProductImage(productImage, variantImageUrl, parentContainer);
  }
  const variantUrl = radio.getAttribute("data-variant-url");
  const productUrl = parentContainer.querySelector(selectors$1.imageWrapper);
  updateProductUrl(productUrl, variantUrl);
  if (variantImageUrl) {
    saveVariantToSession(radio, variantImageUrl);
  }
  updateImageLabel(radio, parentContainer);
  updateVariantLabels(radio, parentContainer);
  updateVariantDescription(radio, parentContainer);
  updateVariantBackground(radio, parentContainer);
}
function findRadioFromLabel(label) {
  const labelFor = label.getAttribute("for");
  if (labelFor) {
    const radio = document.getElementById(labelFor);
    if (radio && radio.classList.contains("collection-block-swatch__radio")) {
      return radio;
    }
  }
  let sibling = label.previousElementSibling;
  while (sibling) {
    if (sibling.classList.contains("collection-block-swatch__radio")) {
      return sibling;
    }
    sibling = sibling.previousElementSibling;
  }
  return null;
}
function initVariantSelector() {
  sessionStorage.removeItem("selectedVariant");
  document.addEventListener("change", (e) => {
    if (e.target.classList.contains("collection-block-swatch__radio")) {
      handleVariantChange(e.target);
    }
  });
  document.addEventListener("click", (e) => {
    const label = e.target.closest(".collection-block-swatch__item");
    if (label) {
      const radio = findRadioFromLabel(label);
      if (radio) {
        setTimeout(() => {
          if (radio.checked) {
            handleVariantChange(radio);
          }
        }, 0);
      }
    }
  });
  document.querySelectorAll(selectors$1.radioButton).forEach((radio) => {
    if (radio.checked) {
      handleVariantChange(radio);
    }
  });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initVariantSelector);
} else {
  initVariantSelector();
}
function applyDeliveryPromiseStyles() {
  const widget = document.querySelector("delivery-promise-widget");
  if (!widget) return false;
  const shadowRoot = widget.shadowRoot;
  if (!shadowRoot) return false;
  const textElement = shadowRoot.querySelector("delivery-promise-text");
  if (!textElement) return false;
  const marginSpacing = window.innerWidth <= 1e3 ? "var(--spacing-600)" : "var(--spacing-800)";
  textElement.style.setProperty("--delivery-promise-widget-color", "#008B59");
  textElement.style.setProperty("background", "#F5F5F5");
  textElement.style.setProperty("margin-left", `calc(-1 * ${marginSpacing})`);
  textElement.style.setProperty("margin-right", `calc(-1 * ${marginSpacing})`);
  textElement.style.setProperty("margin-bottom", "0");
  textElement.style.setProperty("margin-top", "0");
  textElement.style.setProperty("top", "0");
  textElement.style.setProperty("padding", "var(--spacing-800) var(--spacing-800) 0");
  textElement.style.setProperty("text-align", "center");
  return true;
}
function applyMainTextContainerStyles() {
  try {
    const widget = document.querySelector("delivery-promise-widget");
    if (!widget) return false;
    const shadowRoot = widget.shadowRoot;
    if (!shadowRoot) return false;
    const textElement = shadowRoot.querySelector("delivery-promise-text");
    if (!textElement) return false;
    const textElementShadowRoot = textElement.shadowRoot;
    if (!textElementShadowRoot) return false;
    const mainTextContainer = textElementShadowRoot.querySelector(".main-text__container");
    if (!mainTextContainer) return false;
    mainTextContainer.style.setProperty("max-width", "477px");
    const boldTextElements = textElementShadowRoot.querySelectorAll(".bold-text.main-text");
    boldTextElements.forEach((element) => {
      element.style.setProperty("font-weight", "700");
    });
    return true;
  } catch (error) {
    return false;
  }
}
function initDeliveryPromiseStyles() {
  let observer = null;
  let textElementStylesApplied = false;
  let mainTextContainerStylesApplied = false;
  function tryApplyStyles() {
    if (!textElementStylesApplied) {
      const success = applyDeliveryPromiseStyles();
      if (success) {
        textElementStylesApplied = true;
      }
    }
    if (!mainTextContainerStylesApplied) {
      const success = applyMainTextContainerStyles();
      if (success) {
        mainTextContainerStylesApplied = true;
      }
    }
    if (textElementStylesApplied && mainTextContainerStylesApplied && observer) {
      observer.disconnect();
      observer = null;
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryApplyStyles);
  } else {
    tryApplyStyles();
  }
  setTimeout(tryApplyStyles, 500);
  setTimeout(tryApplyStyles, 1e3);
  setTimeout(tryApplyStyles, 2e3);
  setTimeout(tryApplyStyles, 3e3);
  setTimeout(() => {
    tryApplyStyles();
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }, 4e3);
  observer = new MutationObserver(function(mutations) {
    tryApplyStyles();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => applyDeliveryPromiseStyles(), 100);
  });
}
initDeliveryPromiseStyles();
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".bb-header.bb-steps-big");
  if (!header) return;
  const getStickyOffset = () => {
    if (typeof window.getStickyHeaderOffset === "function") {
      return window.getStickyHeaderOffset();
    }
    const rootStyles = getComputedStyle(document.documentElement);
    const headerHeight = parseFloat(rootStyles.getPropertyValue("--header-height")) || 0;
    const announcementBarHeight = parseFloat(rootStyles.getPropertyValue("--announcement-bar-height")) || 0;
    return headerHeight + announcementBarHeight - 40;
  };
  const onScroll = () => {
    const rect = header.getBoundingClientRect();
    const stickyOffset = getStickyOffset();
    if (rect.top <= stickyOffset) {
      header.classList.add("bb-sticky-active");
    } else {
      header.classList.remove("bb-sticky-active");
    }
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  window.addEventListener("load", onScroll);
  onScroll();
});
(function() {
  let originalDeliveryTexts = /* @__PURE__ */ new WeakMap();
  function getDeliveryDays(variantId) {
    var _a;
    if (!variantId) {
      return null;
    }
    try {
      const productDataScript = document.getElementById("product-delivery-data");
      if (!productDataScript) {
        return null;
      }
      const productData = JSON.parse(productDataScript.textContent);
      const variant = (_a = productData.variants) == null ? void 0 : _a.find((v) => v.id === variantId);
      if (variant && variant.deliveryDays) {
        return variant.deliveryDays;
      }
      if (productData.deliveryDays) {
        return productData.deliveryDays;
      }
    } catch (error) {
    }
    return null;
  }
  function getElementText(element) {
    if (!element) return "";
    if (element.shadowRoot) {
      const textWrapper = element.shadowRoot.querySelector('[part="text-wrapper"]') || element.shadowRoot.querySelector(".text-wrapper") || element.shadowRoot.querySelector("span") || element.shadowRoot.firstElementChild;
      if (textWrapper) {
        return textWrapper.textContent || textWrapper.innerText || "";
      }
    }
    return element.textContent || element.innerText || "";
  }
  function setElementText(element, text) {
    if (!element) return;
    if (element.shadowRoot) {
      const textWrapper = element.shadowRoot.querySelector('[part="text-wrapper"]') || element.shadowRoot.querySelector(".text-wrapper") || element.shadowRoot.querySelector("span") || element.shadowRoot.firstElementChild;
      if (textWrapper) {
        textWrapper.textContent = text;
        return;
      }
    }
    element.textContent = text;
  }
  function updateDeliveryWidget(widget, deliveryDays) {
    if (!widget) {
      return;
    }
    const shadowRoot = widget.shadowRoot;
    if (!shadowRoot) {
      return;
    }
    const deliveryTextElement = shadowRoot.querySelector("delivery-promise-text");
    if (!deliveryTextElement) {
      return;
    }
    const textContent = getElementText(deliveryTextElement);
    if (!originalDeliveryTexts.has(deliveryTextElement)) {
      originalDeliveryTexts.set(deliveryTextElement, textContent);
    }
    const originalText = originalDeliveryTexts.get(deliveryTextElement);
    if (!deliveryDays) {
      if (originalText) {
        setElementText(deliveryTextElement, originalText);
      }
      return;
    }
    const pattern = /\d+-\d+/g;
    if (pattern.test(originalText)) {
      pattern.lastIndex = 0;
      const newText = originalText.replace(pattern, String(deliveryDays));
      setElementText(deliveryTextElement, newText);
    }
  }
  function updateAllDeliveryWidgets(variantId) {
    const widgets = document.querySelectorAll("delivery-promise-widget");
    if (widgets.length === 0) {
      return;
    }
    const deliveryDays = variantId ? getDeliveryDays(variantId) : null;
    widgets.forEach((widget) => {
      updateDeliveryWidget(widget, deliveryDays);
    });
  }
  function waitForDeliveryWidget() {
    return new Promise((resolve2) => {
      const widget = document.querySelector("delivery-promise-widget");
      if (widget && widget.shadowRoot) {
        const textElement = widget.shadowRoot.querySelector("delivery-promise-text");
        if (textElement) {
          resolve2(widget);
          return;
        }
      }
      const observer = new MutationObserver((mutations, obs) => {
        const widget2 = document.querySelector("delivery-promise-widget");
        if (widget2 && widget2.shadowRoot) {
          const textElement = widget2.shadowRoot.querySelector("delivery-promise-text");
          if (textElement) {
            obs.disconnect();
            resolve2(widget2);
          }
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      setTimeout(() => {
        observer.disconnect();
        resolve2(null);
      }, 5e3);
    });
  }
  function observeWidgetChanges(widget) {
    if (!widget) {
      return;
    }
    if (widget.shadowRoot) {
      const shadowObserver = new MutationObserver(() => {
        const variantId = widget.getAttribute("variant-id");
        if (variantId) {
          setTimeout(() => {
            updateDeliveryWidget(widget, getDeliveryDays(parseInt(variantId)));
          }, 50);
        }
      });
      shadowObserver.observe(widget.shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    const attributeObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "variant-id") {
          const variantId = widget.getAttribute("variant-id");
          if (variantId) {
            setTimeout(() => {
              updateDeliveryWidget(widget, getDeliveryDays(parseInt(variantId)));
            }, 100);
          } else {
            updateDeliveryWidget(widget, null);
          }
        }
      });
    });
    attributeObserver.observe(widget, {
      attributes: true,
      attributeFilter: ["variant-id"]
    });
  }
  async function init2() {
    await waitForDeliveryWidget();
    const widgets = document.querySelectorAll("delivery-promise-widget");
    widgets.forEach((widget) => {
      observeWidgetChanges(widget);
      const variantId = widget.getAttribute("variant-id");
      if (variantId) {
        setTimeout(() => {
          updateAllDeliveryWidgets(parseInt(variantId));
        }, 200);
      }
    });
  }
  document.addEventListener("variant:changed", (event) => {
    var _a;
    const variant = (_a = event.detail) == null ? void 0 : _a.variant;
    if (!variant) {
      updateAllDeliveryWidgets(null);
      return;
    }
    setTimeout(() => {
      updateAllDeliveryWidgets(variant.id);
    }, 100);
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init2);
  } else {
    init2();
  }
})();
function initBundleScrollControls() {
  const inputs = document.querySelectorAll(".scroll-custom-id");
  if (!inputs.length) return;
  inputs.forEach((customInput) => {
    var _a;
    const SCROLL_AREA_ID = customInput.value;
    const scroller = document.getElementById(SCROLL_AREA_ID);
    if (!scroller) return;
    const prevBtn = document.querySelector(
      `[data-scroll-prev][aria-controls="${SCROLL_AREA_ID}"]`
    );
    const nextBtn = document.querySelector(
      `[data-scroll-next][aria-controls="${SCROLL_AREA_ID}"]`
    );
    const dotsNav = (_a = prevBtn == null ? void 0 : prevBtn.parentElement) == null ? void 0 : _a.querySelector(".dots-nav");
    const dots = dotsNav ? Array.from(dotsNav.querySelectorAll("button")) : [];
    if (!prevBtn || !nextBtn) return;
    if (scroller.__scrollInit) return;
    scroller.__scrollInit = true;
    const getItems = () => Array.from(scroller.querySelectorAll(".multi-column__item--redesign"));
    const scrollToItem = (el, index) => {
      if (!el) return;
      const targetLeft = el.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
      scroller.scrollTo({ left: targetLeft, behavior: "smooth" });
      if (dots[index]) setActiveDot(index);
    };
    const getCurrentIndex = () => {
      const items = getItems();
      let currentIndex = 0;
      let minDelta = Infinity;
      items.forEach((el, i) => {
        const delta = Math.abs(el.getBoundingClientRect().left - scroller.getBoundingClientRect().left);
        if (delta < minDelta) {
          minDelta = delta;
          currentIndex = i;
        }
      });
      return currentIndex;
    };
    const setActiveDot = (index) => {
      dots.forEach((dot, i) => {
        if (i === index) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };
    const getNextItem = () => {
      const items = getItems();
      if (!items.length) return null;
      const leftEdge = scroller.scrollLeft + 1;
      for (let i = 0; i < items.length; i++) {
        if (items[i].offsetLeft > leftEdge) return { el: items[i], index: i };
      }
      return { el: items[items.length - 1], index: items.length - 1 };
    };
    const getPrevItem = () => {
      const items = getItems();
      if (!items.length) return null;
      const leftEdge = scroller.scrollLeft - 1;
      for (let i = items.length - 1; i >= 0; i--) {
        if (items[i].offsetLeft < leftEdge) return { el: items[i], index: i };
      }
      return { el: items[0], index: 0 };
    };
    const updateButtonsAndDots = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      const left = scroller.scrollLeft;
      const eps = 2;
      prevBtn.disabled = left <= eps;
      nextBtn.disabled = left >= maxScroll - eps;
      if (dots.length) {
        const idx = getCurrentIndex();
        setActiveDot(idx);
      }
    };
    prevBtn.addEventListener("click", () => {
      const prev = getPrevItem();
      if (prev) scrollToItem(prev.el, prev.index);
    });
    nextBtn.addEventListener("click", () => {
      const next = getNextItem();
      if (next) scrollToItem(next.el, next.index);
    });
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        const items = getItems();
        if (items[i]) scrollToItem(items[i], i);
      });
    });
    scroller.addEventListener("scroll", updateButtonsAndDots, { passive: true });
    const ro = new ResizeObserver(updateButtonsAndDots);
    ro.observe(scroller);
    updateButtonsAndDots();
  });
}
document.addEventListener("DOMContentLoaded", initBundleScrollControls);
if (window.location.href.includes("holyfrance")) {
  window.location.href = "https://holyenergyfr.myshopify.com/";
}
window.theme.customEvents = customEvents;
const template = window.theme ? window.theme.template : null;
const pageType = window.theme ? window.theme.pageType : null;
const isCheckout = Shopify ? Shopify.Checkout : null;
console.log({
  template,
  pageType,
  isCheckout
});
if (template.includes("bundle-builder")) {
  const selectors2 = {
    json: "#bundle-builder-json",
    app: "#bundle-builder-app"
  };
  bundleBuilderInit(selectors2);
}
const selectors = {
  json: "#box-builder-json",
  app: "#box-builder"
};
boxBuilderMain(selectors);
